webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	__webpack_require__(2);
	__webpack_require__(323);
	__webpack_require__(1475);
	__webpack_require__(322);
	__webpack_require__(188);
	__webpack_require__(324);
	__webpack_require__(108);
	__webpack_require__(230);
	module.exports = __webpack_require__(229);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.4.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2019-05-01T21:04Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var document = window.document;
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
	      // Support: Chrome <=57, Firefox <=52
	      // In some browsers, typeof returns "function" for HTML <object> elements
	      // (i.e., `typeof document.createElement( "object" ) === "function"`).
	      // We don't want to classify *any* DOM node as a function.
	      return typeof obj === "function" && typeof obj.nodeType !== "number";
	  };
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.4.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code, options ) {
			DOMEval( code, { nonce: options && options.nonce } );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.4
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://js.foundation/
	 *
	 * Date: 2019-04-08
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rhtml = /HTML$/i,
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!nonnativeSelectorCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) &&
	
					// Support: IE 8 only
					// Exclude object elements
					(nodeType !== 1 || context.nodeName.toLowerCase() !== "object") ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 && rdescend.test( selector ) ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
							inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		var namespace = elem.namespaceURI,
			docElem = (elem.ownerDocument || elem).documentElement;
	
		// Support: IE <=8
		// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
		// https://bugs.jquery.com/ticket/4833
		return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( (elem = elems[i++]) ) {
							node = elem.getAttributeNode("id");
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		if ( support.matchesSelector && documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ?
					argument + length :
					argument > length ?
						length :
						argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	};
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( typeof elem.contentDocument !== "undefined" ) {
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 - 11+
	// focus() and blur() are asynchronous, except when they are no-op.
	// So expect focus to be synchronous when the element is already active,
	// and blur to be synchronous when the element is not already active.
	// (focus and blur are always synchronous in other supported browsers,
	// this just defines when we can count on it).
	function expectSync( elem, type ) {
		return ( elem === safeActiveElement() ) === ( type === "focus" );
	}
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", returnTrue );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, expectSync ) {
	
		// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
		if ( !expectSync ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var notAsync, result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					// Saved data should be false in such cases, but might be a leftover capture object
					// from an async native handler (gh-4350)
					if ( !saved.length ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						// Support: IE <=9 - 11+
						// focus() and blur() are asynchronous
						notAsync = expectSync( this, type );
						this[ type ]();
						result = dataPriv.get( this, type );
						if ( saved !== result || notAsync ) {
							dataPriv.set( this, type, false );
						} else {
							result = {};
						}
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
							return result.value;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering the
					// native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved.length ) {
	
					// ...and capture the result
					dataPriv.set( this, type, {
						value: jQuery.event.trigger(
	
							// Support: IE <=9 - 11+
							// Extend with the prototype to reset the above stopImmediatePropagation()
							jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
							saved.slice( 1 ),
							this
						)
					} );
	
					// Abort handling of the native event
					event.stopImmediatePropagation();
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, expectSync );
	
				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			delegateType: delegateType
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									} );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		// Support: IE 9-11 only
		// Also use offsetWidth/offsetHeight for when box sizing is unreliable
		// We use getClientRects() to check for hidden/disconnected.
		// In those cases, the computed value can be trusted to be border-box
		if ( ( !support.boxSizingReliable() && isBorderBox ||
			val === "auto" ||
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"gridArea": true,
			"gridColumn": true,
			"gridColumnEnd": true,
			"gridColumnStart": true,
			"gridRow": true,
			"gridRowEnd": true,
			"gridRowStart": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, dimension, extra );
							} ) :
							getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
						jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( isValidValue ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	support.focusin = "onfocusin" in window;
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = Date.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url, options ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
	//     http://underscorejs.org
	//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind,
	    nativeCreate       = Object.create;
	
	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function(){};
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.8.3';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value)) return _.matcher(value);
	    return _.property(value);
	  };
	  _.iteratee = function(value, context) {
	    return cb(value, context, Infinity);
	  };
	
	  // An internal function for creating assigner functions.
	  var createAssigner = function(keysFunc, undefinedOnly) {
	    return function(obj) {
	      var length = arguments.length;
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };
	
	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function(prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  };
	
	  var property = function(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = property('length');
	  var isArrayLike = function(collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Create a reducing function iterating left or right.
	  function createReduce(dir) {
	    // Optimized iterator function as using arguments.length
	    // in the main function will deoptimize the, see #1991.
	    function iterator(obj, iteratee, memo, keys, index, length) {
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    }
	
	    return function(obj, iteratee, memo, context) {
	      iteratee = optimizeCb(iteratee, context, 4);
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      // Determine the initial value if none is provided.
	      if (arguments.length < 3) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      return iterator(obj, iteratee, memo, keys, index, length);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var key;
	    if (isArrayLike(obj)) {
	      key = _.findIndex(obj, predicate, context);
	    } else {
	      key = _.findKey(obj, predicate, context);
	    }
	    if (key !== void 0 && key !== -1) return obj[key];
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given item (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return _.indexOf(obj, item, fromIndex) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      var func = isFunc ? method : value[method];
	      return func == null ? func : func.apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var set = isArrayLike(obj) ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iteratee, context) {
	      var result = {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var pass = [], fail = [];
	    _.each(obj, function(value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, startIndex) {
	    var output = [], idx = 0;
	    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        //flatten current level of array or arguments object
	        if (!shallow) value = flatten(value, shallow, strict);
	        var j = 0, len = value.length;
	        output.length += len;
	        while (j < len) {
	          output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(flatten(arguments, true, true));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = flatten(arguments, true, true, 1);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    return _.unzip(arguments);
	  };
	
	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices
	  _.unzip = function(array) {
	    var length = array && _.max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Generator function to create the findIndex and findLastIndex functions
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a predicate test
	  _.findIndex = createPredicateIndexFinder(1);
	  _.findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };
	
	  // Generator function to create the indexOf and lastIndexOf functions
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	            i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), _.isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments
	  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var args = slice.call(arguments, 2);
	    var bound = function() {
	      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
	    };
	    return bound;
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var i, length = arguments.length, key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){
	      return func.apply(null, args);
	    }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function() {
	      var last = _.now() - timestamp;
	
	      if (last < wait && last >= 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };
	
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  function collectNonEnumProps(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve all the property names of an object.
	  _.allKeys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Returns the results of applying the iteratee to each element of the object
	  // In contrast to _.map it returns an object
	  _.mapObject = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys =  _.keys(obj),
	          length = keys.length,
	          results = {},
	          currentKey;
	      for (var index = 0; index < length; index++) {
	        currentKey = keys[index];
	        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	      }
	      return results;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in object(s)
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = _.assign = createAssigner(_.keys);
	
	  // Returns the first key on an object that passes a predicate test
	  _.findKey = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj), key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(object, oiteratee, context) {
	    var result = {}, obj = object, iteratee, keys;
	    if (obj == null) return result;
	    if (_.isFunction(oiteratee)) {
	      keys = _.allKeys(obj);
	      iteratee = optimizeCb(oiteratee, context);
	    } else {
	      keys = flatten(arguments, false, false, 1);
	      iteratee = function(value, key, obj) { return key in obj; };
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(flatten(arguments, false, false, 1), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  _.create = function(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) _.extendOwn(result, props);
	    return result;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function(object, attrs) {
	    var keys = _.keys(attrs), length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };
	
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	                               _.isFunction(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return _.has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), and in Safari 8 (#1929).
	  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };
	
	  _.noop = function(){};
	
	  _.property = property;
	
	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function(obj) {
	    return obj == null ? function(){} : function(key) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  _.matcher = _.matches = function(attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function(obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	   // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property, fallback) {
	    var value = object == null ? void 0 : object[property];
	    if (value === void 0) {
	      value = fallback;
	    }
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	  _.prototype.toString = function() {
	    return '' + this._wrapped;
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}.call(this));


/***/ },
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13);
	var core = __webpack_require__(49);
	var hide = __webpack_require__(39);
	var redefine = __webpack_require__(40);
	var ctx = __webpack_require__(50);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 13 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 18 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(103)('wks');
	var uid = __webpack_require__(82);
	var Symbol = __webpack_require__(13).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 24 */,
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(52);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 26 */,
/* 27 */,
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(17)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(12);
	var IE8_DOM_DEFINE = __webpack_require__(241);
	var toPrimitive = __webpack_require__(60);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(28) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 30 */,
/* 31 */,
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(58);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 38 */,
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(29);
	var createDesc = __webpack_require__(78);
	module.exports = __webpack_require__(28) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13);
	var hide = __webpack_require__(39);
	var has = __webpack_require__(42);
	var SRC = __webpack_require__(82)('src');
	var $toString = __webpack_require__(858);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(49).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var fails = __webpack_require__(17);
	var defined = __webpack_require__(58);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ },
/* 42 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(102);
	var createDesc = __webpack_require__(78);
	var toIObject = __webpack_require__(45);
	var toPrimitive = __webpack_require__(60);
	var has = __webpack_require__(42);
	var IE8_DOM_DEFINE = __webpack_require__(241);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(28) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(42);
	var toObject = __webpack_require__(32);
	var IE_PROTO = __webpack_require__(169)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(101);
	var defined = __webpack_require__(58);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 46 */,
/* 47 */,
/* 48 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 49 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(37);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(17);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ },
/* 52 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(50);
	var IObject = __webpack_require__(101);
	var toObject = __webpack_require__(32);
	var toLength = __webpack_require__(25);
	var asc = __webpack_require__(153);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },
/* 58 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(8);
	var core = __webpack_require__(49);
	var fails = __webpack_require__(17);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(18);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(263);
	var $export = __webpack_require__(8);
	var shared = __webpack_require__(103)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(267))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(28)) {
	  var LIBRARY = __webpack_require__(68);
	  var global = __webpack_require__(13);
	  var fails = __webpack_require__(17);
	  var $export = __webpack_require__(8);
	  var $typed = __webpack_require__(128);
	  var $buffer = __webpack_require__(174);
	  var ctx = __webpack_require__(50);
	  var anInstance = __webpack_require__(73);
	  var propertyDesc = __webpack_require__(78);
	  var hide = __webpack_require__(39);
	  var redefineAll = __webpack_require__(79);
	  var toInteger = __webpack_require__(52);
	  var toLength = __webpack_require__(25);
	  var toIndex = __webpack_require__(261);
	  var toAbsoluteIndex = __webpack_require__(81);
	  var toPrimitive = __webpack_require__(60);
	  var has = __webpack_require__(42);
	  var classof = __webpack_require__(88);
	  var isObject = __webpack_require__(18);
	  var toObject = __webpack_require__(32);
	  var isArrayIter = __webpack_require__(160);
	  var create = __webpack_require__(75);
	  var getPrototypeOf = __webpack_require__(44);
	  var gOPN = __webpack_require__(76).f;
	  var getIterFn = __webpack_require__(176);
	  var uid = __webpack_require__(82);
	  var wks = __webpack_require__(23);
	  var createArrayMethod = __webpack_require__(57);
	  var createArrayIncludes = __webpack_require__(116);
	  var speciesConstructor = __webpack_require__(104);
	  var ArrayIterators = __webpack_require__(177);
	  var Iterators = __webpack_require__(89);
	  var $iterDetect = __webpack_require__(121);
	  var setSpecies = __webpack_require__(80);
	  var arrayFill = __webpack_require__(152);
	  var arrayCopyWithin = __webpack_require__(233);
	  var $DP = __webpack_require__(29);
	  var $GOPD = __webpack_require__(43);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ },
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(23)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(39)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ },
/* 68 */
/***/ function(module, exports) {

	module.exports = false;


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(82)('meta');
	var isObject = __webpack_require__(18);
	var has = __webpack_require__(42);
	var setDesc = __webpack_require__(29).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(17)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(50);
	var call = __webpack_require__(244);
	var isArrayIter = __webpack_require__(160);
	var anObject = __webpack_require__(12);
	var toLength = __webpack_require__(25);
	var getIterFn = __webpack_require__(176);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(12);
	var dPs = __webpack_require__(250);
	var enumBugKeys = __webpack_require__(156);
	var IE_PROTO = __webpack_require__(169)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(155)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(158).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(252);
	var hiddenKeys = __webpack_require__(156).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(252);
	var enumBugKeys = __webpack_require__(156);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 78 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(40);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(13);
	var dP = __webpack_require__(29);
	var DESCRIPTORS = __webpack_require__(28);
	var SPECIES = __webpack_require__(23)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(52);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 82 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ },
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(48);
	var TAG = __webpack_require__(23)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 89 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(29).f;
	var has = __webpack_require__(42);
	var TAG = __webpack_require__(23)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var defined = __webpack_require__(58);
	var fails = __webpack_require__(17);
	var spaces = __webpack_require__(172);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ },
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(12);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(48);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 102 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var core = __webpack_require__(49);
	var global = __webpack_require__(13);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(68) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(12);
	var aFunction = __webpack_require__(37);
	var SPECIES = __webpack_require__(23)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*! DataTables 1.10.4
	 * ©2008-2014 SpryMedia Ltd - datatables.net/license
	 */
	
	/**
	 * @summary     DataTables
	 * @description Paginate, search and order HTML tables
	 * @version     1.10.4
	 * @file        jquery.dataTables.js
	 * @author      SpryMedia Ltd (www.sprymedia.co.uk)
	 * @contact     www.sprymedia.co.uk/contact
	 * @copyright   Copyright 2008-2014 SpryMedia Ltd.
	 *
	 * This source file is free software, available under the following license:
	 *   MIT license - http://datatables.net/license
	 *
	 * This source file is distributed in the hope that it will be useful, but
	 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
	 * or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.
	 *
	 * For details please refer to: http://www.datatables.net
	 */
	
	/*jslint evil: true, undef: true, browser: true */
	/*globals $,require,jQuery,define,_selector_run,_selector_opts,_selector_first,_selector_row_indexes,_ext,_Api,_api_register,_api_registerPlural,_re_new_lines,_re_html,_re_formatted_numeric,_re_escape_regex,_empty,_intVal,_numToDecimal,_isNumber,_isHtml,_htmlNumeric,_pluck,_pluck_order,_range,_stripHtml,_unique,_fnBuildAjax,_fnAjaxUpdate,_fnAjaxParameters,_fnAjaxUpdateDraw,_fnAjaxDataSrc,_fnAddColumn,_fnColumnOptions,_fnAdjustColumnSizing,_fnVisibleToColumnIndex,_fnColumnIndexToVisible,_fnVisbleColumns,_fnGetColumns,_fnColumnTypes,_fnApplyColumnDefs,_fnHungarianMap,_fnCamelToHungarian,_fnLanguageCompat,_fnBrowserDetect,_fnAddData,_fnAddTr,_fnNodeToDataIndex,_fnNodeToColumnIndex,_fnGetCellData,_fnSetCellData,_fnSplitObjNotation,_fnGetObjectDataFn,_fnSetObjectDataFn,_fnGetDataMaster,_fnClearTable,_fnDeleteIndex,_fnInvalidate,_fnGetRowElements,_fnCreateTr,_fnBuildHead,_fnDrawHead,_fnDraw,_fnReDraw,_fnAddOptionsHtml,_fnDetectHeader,_fnGetUniqueThs,_fnFeatureHtmlFilter,_fnFilterComplete,_fnFilterCustom,_fnFilterColumn,_fnFilter,_fnFilterCreateSearch,_fnEscapeRegex,_fnFilterData,_fnFeatureHtmlInfo,_fnUpdateInfo,_fnInfoMacros,_fnInitialise,_fnInitComplete,_fnLengthChange,_fnFeatureHtmlLength,_fnFeatureHtmlPaginate,_fnPageChange,_fnFeatureHtmlProcessing,_fnProcessingDisplay,_fnFeatureHtmlTable,_fnScrollDraw,_fnApplyToChildren,_fnCalculateColumnWidths,_fnThrottle,_fnConvertToWidth,_fnScrollingWidthAdjust,_fnGetWidestNode,_fnGetMaxLenString,_fnStringToCss,_fnScrollBarWidth,_fnSortFlatten,_fnSort,_fnSortAria,_fnSortListener,_fnSortAttachListener,_fnSortingClasses,_fnSortData,_fnSaveState,_fnLoadState,_fnSettingsFromNode,_fnLog,_fnMap,_fnBindAction,_fnCallbackReg,_fnCallbackFire,_fnLengthOverflow,_fnRenderer,_fnDataSource,_fnRowAttributes*/
	
	/** @lends <global> */(function (window, document, undefined) {
	
		(function (factory) {
			"use strict";
	
			if (true) {
				// Define as an AMD module if possible
				!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			} else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
				// Node/CommonJS
				factory(require('jquery'));
			} else if (jQuery && !jQuery.fn.dataTable) {
				// Define using browser globals otherwise
				// Prevent multiple instantiations if the script is loaded twice
				factory(jQuery);
			}
		})( /** @lends <global> */function ($) {
			"use strict";
	
			/**
	   * DataTables is a plug-in for the jQuery Javascript library. It is a highly
	   * flexible tool, based upon the foundations of progressive enhancement,
	   * which will add advanced interaction controls to any HTML table. For a
	   * full list of features please refer to
	   * [DataTables.net](href="http://datatables.net).
	   *
	   * Note that the `DataTable` object is not a global variable but is aliased
	   * to `jQuery.fn.DataTable` and `jQuery.fn.dataTable` through which it may
	   * be  accessed.
	   *
	   *  @class
	   *  @param {object} [init={}] Configuration object for DataTables. Options
	   *    are defined by {@link DataTable.defaults}
	   *  @requires jQuery 1.7+
	   *
	   *  @example
	   *    // Basic initialisation
	   *    $(document).ready( function {
	   *      $('#example').dataTable();
	   *    } );
	   *
	   *  @example
	   *    // Initialisation with configuration options - in this case, disable
	   *    // pagination and sorting.
	   *    $(document).ready( function {
	   *      $('#example').dataTable( {
	   *        "paginate": false,
	   *        "sort": false
	   *      } );
	   *    } );
	   */
	
			var _DataTable;
	
			/*
	   * It is useful to have variables which are scoped locally so only the
	   * DataTables functions can access them and they don't leak into global space.
	   * At the same time these functions are often useful over multiple files in the
	   * core and API, so we list, or at least document, all variables which are used
	   * by DataTables as private variables here. This also ensures that there is no
	   * clashing of variable names and that they can easily referenced for reuse.
	   */
	
			// Defined else where
			//  _selector_run
			//  _selector_opts
			//  _selector_first
			//  _selector_row_indexes
	
			var _ext; // DataTable.ext
			var _Api2; // DataTable.Api
			var _api_register; // DataTable.Api.register
			var _api_registerPlural; // DataTable.Api.registerPlural
	
			var _re_dic = {};
			var _re_new_lines = /[\r\n]/g;
			var _re_html = /<.*?>/g;
			var _re_date_start = /^[\w\+\-]/;
			var _re_date_end = /[\w\+\-]$/;
	
			// Escape regular expression special characters
			var _re_escape_regex = new RegExp('(\\' + ['/', '.', '*', '+', '?', '|', '(', ')', '[', ']', '{', '}', '\\', '$', '^', '-'].join('|\\') + ')', 'g');
	
			// U+2009 is thin space and U+202F is narrow no-break space, both used in many
			// standards as thousands separators
			var _re_formatted_numeric = /[',$£€¥%\u2009\u202F]/g;
	
			var _empty = function _empty(d) {
				return !d || d === true || d === '-' ? true : false;
			};
	
			var _intVal = function _intVal(s) {
				var integer = parseInt(s, 10);
				return !isNaN(integer) && isFinite(s) ? integer : null;
			};
	
			// Convert from a formatted number with characters other than `.` as the
			// decimal place, to a Javascript number
			var _numToDecimal = function _numToDecimal(num, decimalPoint) {
				// Cache created regular expressions for speed as this function is called often
				if (!_re_dic[decimalPoint]) {
					_re_dic[decimalPoint] = new RegExp(_fnEscapeRegex(decimalPoint), 'g');
				}
				return typeof num === 'string' && decimalPoint !== '.' ? num.replace(/\./g, '').replace(_re_dic[decimalPoint], '.') : num;
			};
	
			var _isNumber = function _isNumber(d, decimalPoint, formatted) {
				var strType = typeof d === 'string';
	
				if (decimalPoint && strType) {
					d = _numToDecimal(d, decimalPoint);
				}
	
				if (formatted && strType) {
					d = d.replace(_re_formatted_numeric, '');
				}
	
				return _empty(d) || !isNaN(parseFloat(d)) && isFinite(d);
			};
	
			// A string without HTML in it can be considered to be HTML still
			var _isHtml = function _isHtml(d) {
				return _empty(d) || typeof d === 'string';
			};
	
			var _htmlNumeric = function _htmlNumeric(d, decimalPoint, formatted) {
				if (_empty(d)) {
					return true;
				}
	
				var html = _isHtml(d);
				return !html ? null : _isNumber(_stripHtml(d), decimalPoint, formatted) ? true : null;
			};
	
			var _pluck = function _pluck(a, prop, prop2) {
				var out = [];
				var i = 0,
				    ien = a.length;
	
				// Could have the test in the loop for slightly smaller code, but speed
				// is essential here
				if (prop2 !== undefined) {
					for (; i < ien; i++) {
						if (a[i] && a[i][prop]) {
							out.push(a[i][prop][prop2]);
						}
					}
				} else {
					for (; i < ien; i++) {
						if (a[i]) {
							out.push(a[i][prop]);
						}
					}
				}
	
				return out;
			};
	
			// Basically the same as _pluck, but rather than looping over `a` we use `order`
			// as the indexes to pick from `a`
			var _pluck_order = function _pluck_order(a, order, prop, prop2) {
				var out = [];
				var i = 0,
				    ien = order.length;
	
				// Could have the test in the loop for slightly smaller code, but speed
				// is essential here
				if (prop2 !== undefined) {
					for (; i < ien; i++) {
						if (a[order[i]][prop]) {
							out.push(a[order[i]][prop][prop2]);
						}
					}
				} else {
					for (; i < ien; i++) {
						out.push(a[order[i]][prop]);
					}
				}
	
				return out;
			};
	
			var _range = function _range(len, start) {
				var out = [];
				var end;
	
				if (start === undefined) {
					start = 0;
					end = len;
				} else {
					end = start;
					start = len;
				}
	
				for (var i = start; i < end; i++) {
					out.push(i);
				}
	
				return out;
			};
	
			var _removeEmpty = function _removeEmpty(a) {
				var out = [];
	
				for (var i = 0, ien = a.length; i < ien; i++) {
					if (a[i]) {
						// careful - will remove all falsy values!
						out.push(a[i]);
					}
				}
	
				return out;
			};
	
			var _stripHtml = function _stripHtml(d) {
				return d.replace(_re_html, '');
			};
	
			/**
	   * Find the unique elements in a source array.
	   *
	   * @param  {array} src Source array
	   * @return {array} Array of unique items
	   * @ignore
	   */
			var _unique = function _unique(src) {
				// A faster unique method is to use object keys to identify used values,
				// but this doesn't work with arrays or objects, which we must also
				// consider. See jsperf.com/compare-array-unique-versions/4 for more
				// information.
				var out = [],
				    val,
				    i,
				    ien = src.length,
				    j,
				    k = 0;
	
				again: for (i = 0; i < ien; i++) {
					val = src[i];
	
					for (j = 0; j < k; j++) {
						if (out[j] === val) {
							continue again;
						}
					}
	
					out.push(val);
					k++;
				}
	
				return out;
			};
	
			/**
	   * Create a mapping object that allows camel case parameters to be looked up
	   * for their Hungarian counterparts. The mapping is stored in a private
	   * parameter called `_hungarianMap` which can be accessed on the source object.
	   *  @param {object} o
	   *  @memberof DataTable#oApi
	   */
			function _fnHungarianMap(o) {
				var hungarian = 'a aa ai ao as b fn i m o s ',
				    match,
				    newKey,
				    map = {};
	
				$.each(o, function (key, val) {
					match = key.match(/^([^A-Z]+?)([A-Z])/);
	
					if (match && hungarian.indexOf(match[1] + ' ') !== -1) {
						newKey = key.replace(match[0], match[2].toLowerCase());
						map[newKey] = key;
	
						if (match[1] === 'o') {
							_fnHungarianMap(o[key]);
						}
					}
				});
	
				o._hungarianMap = map;
			}
	
			/**
	   * Convert from camel case parameters to Hungarian, based on a Hungarian map
	   * created by _fnHungarianMap.
	   *  @param {object} src The model object which holds all parameters that can be
	   *    mapped.
	   *  @param {object} user The object to convert from camel case to Hungarian.
	   *  @param {boolean} force When set to `true`, properties which already have a
	   *    Hungarian value in the `user` object will be overwritten. Otherwise they
	   *    won't be.
	   *  @memberof DataTable#oApi
	   */
			function _fnCamelToHungarian(src, user, force) {
				if (!src._hungarianMap) {
					_fnHungarianMap(src);
				}
	
				var hungarianKey;
	
				$.each(user, function (key, val) {
					hungarianKey = src._hungarianMap[key];
	
					if (hungarianKey !== undefined && (force || user[hungarianKey] === undefined)) {
						// For objects, we need to buzz down into the object to copy parameters
						if (hungarianKey.charAt(0) === 'o') {
							// Copy the camelCase options over to the hungarian
							if (!user[hungarianKey]) {
								user[hungarianKey] = {};
							}
							$.extend(true, user[hungarianKey], user[key]);
	
							_fnCamelToHungarian(src[hungarianKey], user[hungarianKey], force);
						} else {
							user[hungarianKey] = user[key];
						}
					}
				});
			}
	
			/**
	   * Language compatibility - when certain options are given, and others aren't, we
	   * need to duplicate the values over, in order to provide backwards compatibility
	   * with older language files.
	   *  @param {object} oSettings dataTables settings object
	   *  @memberof DataTable#oApi
	   */
			function _fnLanguageCompat(lang) {
				var defaults = _DataTable.defaults.oLanguage;
				var zeroRecords = lang.sZeroRecords;
	
				/* Backwards compatibility - if there is no sEmptyTable given, then use the same as
	    * sZeroRecords - assuming that is given.
	    */
				if (!lang.sEmptyTable && zeroRecords && defaults.sEmptyTable === "No data available in table") {
					_fnMap(lang, lang, 'sZeroRecords', 'sEmptyTable');
				}
	
				/* Likewise with loading records */
				if (!lang.sLoadingRecords && zeroRecords && defaults.sLoadingRecords === "Loading...") {
					_fnMap(lang, lang, 'sZeroRecords', 'sLoadingRecords');
				}
	
				// Old parameter name of the thousands separator mapped onto the new
				if (lang.sInfoThousands) {
					lang.sThousands = lang.sInfoThousands;
				}
	
				var decimal = lang.sDecimal;
				if (decimal) {
					_addNumericSort(decimal);
				}
			}
	
			/**
	   * Map one parameter onto another
	   *  @param {object} o Object to map
	   *  @param {*} knew The new parameter name
	   *  @param {*} old The old parameter name
	   */
			var _fnCompatMap = function _fnCompatMap(o, knew, old) {
				if (o[knew] !== undefined) {
					o[old] = o[knew];
				}
			};
	
			/**
	   * Provide backwards compatibility for the main DT options. Note that the new
	   * options are mapped onto the old parameters, so this is an external interface
	   * change only.
	   *  @param {object} init Object to map
	   */
			function _fnCompatOpts(init) {
				_fnCompatMap(init, 'ordering', 'bSort');
				_fnCompatMap(init, 'orderMulti', 'bSortMulti');
				_fnCompatMap(init, 'orderClasses', 'bSortClasses');
				_fnCompatMap(init, 'orderCellsTop', 'bSortCellsTop');
				_fnCompatMap(init, 'order', 'aaSorting');
				_fnCompatMap(init, 'orderFixed', 'aaSortingFixed');
				_fnCompatMap(init, 'paging', 'bPaginate');
				_fnCompatMap(init, 'pagingType', 'sPaginationType');
				_fnCompatMap(init, 'pageLength', 'iDisplayLength');
				_fnCompatMap(init, 'searching', 'bFilter');
	
				// Column search objects are in an array, so it needs to be converted
				// element by element
				var searchCols = init.aoSearchCols;
	
				if (searchCols) {
					for (var i = 0, ien = searchCols.length; i < ien; i++) {
						if (searchCols[i]) {
							_fnCamelToHungarian(_DataTable.models.oSearch, searchCols[i]);
						}
					}
				}
			}
	
			/**
	   * Provide backwards compatibility for column options. Note that the new options
	   * are mapped onto the old parameters, so this is an external interface change
	   * only.
	   *  @param {object} init Object to map
	   */
			function _fnCompatCols(init) {
				_fnCompatMap(init, 'orderable', 'bSortable');
				_fnCompatMap(init, 'orderData', 'aDataSort');
				_fnCompatMap(init, 'orderSequence', 'asSorting');
				_fnCompatMap(init, 'orderDataType', 'sortDataType');
			}
	
			/**
	   * Browser feature detection for capabilities, quirks
	   *  @param {object} settings dataTables settings object
	   *  @memberof DataTable#oApi
	   */
			function _fnBrowserDetect(settings) {
				var browser = settings.oBrowser;
	
				// Scrolling feature / quirks detection
				var n = $('<div/>').css({
					position: 'absolute',
					top: 0,
					left: 0,
					height: 1,
					width: 1,
					overflow: 'hidden'
				}).append($('<div/>').css({
					position: 'absolute',
					top: 1,
					left: 1,
					width: 100,
					overflow: 'scroll'
				}).append($('<div class="test"/>').css({
					width: '100%',
					height: 10
				}))).appendTo('body');
	
				var test = n.find('.test');
	
				// IE6/7 will oversize a width 100% element inside a scrolling element, to
				// include the width of the scrollbar, while other browsers ensure the inner
				// element is contained without forcing scrolling
				browser.bScrollOversize = test[0].offsetWidth === 100;
	
				// In rtl text layout, some browsers (most, but not all) will place the
				// scrollbar on the left, rather than the right.
				browser.bScrollbarLeft = test.offset().left !== 1;
	
				n.remove();
			}
	
			/**
	   * Array.prototype reduce[Right] method, used for browsers which don't support
	   * JS 1.6. Done this way to reduce code size, since we iterate either way
	   *  @param {object} settings dataTables settings object
	   *  @memberof DataTable#oApi
	   */
			function _fnReduce(that, fn, init, start, end, inc) {
				var i = start,
				    value,
				    isSet = false;
	
				if (init !== undefined) {
					value = init;
					isSet = true;
				}
	
				while (i !== end) {
					if (!that.hasOwnProperty(i)) {
						continue;
					}
	
					value = isSet ? fn(value, that[i], i, that) : that[i];
	
					isSet = true;
					i += inc;
				}
	
				return value;
			}
	
			/**
	   * Add a column to the list used for the table with default values
	   *  @param {object} oSettings dataTables settings object
	   *  @param {node} nTh The th element for this column
	   *  @memberof DataTable#oApi
	   */
			function _fnAddColumn(oSettings, nTh) {
				// Add column to aoColumns array
				var oDefaults = _DataTable.defaults.column;
				var iCol = oSettings.aoColumns.length;
				var oCol = $.extend({}, _DataTable.models.oColumn, oDefaults, {
					"nTh": nTh ? nTh : document.createElement('th'),
					"sTitle": oDefaults.sTitle ? oDefaults.sTitle : nTh ? nTh.innerHTML : '',
					"aDataSort": oDefaults.aDataSort ? oDefaults.aDataSort : [iCol],
					"mData": oDefaults.mData ? oDefaults.mData : iCol,
					idx: iCol
				});
				oSettings.aoColumns.push(oCol);
	
				// Add search object for column specific search. Note that the `searchCols[ iCol ]`
				// passed into extend can be undefined. This allows the user to give a default
				// with only some of the parameters defined, and also not give a default
				var searchCols = oSettings.aoPreSearchCols;
				searchCols[iCol] = $.extend({}, _DataTable.models.oSearch, searchCols[iCol]);
	
				// Use the default column options function to initialise classes etc
				_fnColumnOptions(oSettings, iCol, null);
			}
	
			/**
	   * Apply options for a column
	   *  @param {object} oSettings dataTables settings object
	   *  @param {int} iCol column index to consider
	   *  @param {object} oOptions object with sType, bVisible and bSearchable etc
	   *  @memberof DataTable#oApi
	   */
			function _fnColumnOptions(oSettings, iCol, oOptions) {
				var oCol = oSettings.aoColumns[iCol];
				var oClasses = oSettings.oClasses;
				var th = $(oCol.nTh);
	
				// Try to get width information from the DOM. We can't get it from CSS
				// as we'd need to parse the CSS stylesheet. `width` option can override
				if (!oCol.sWidthOrig) {
					// Width attribute
					oCol.sWidthOrig = th.attr('width') || null;
	
					// Style attribute
					var t = (th.attr('style') || '').match(/width:\s*(\d+[pxem%]+)/);
					if (t) {
						oCol.sWidthOrig = t[1];
					}
				}
	
				/* User specified column options */
				if (oOptions !== undefined && oOptions !== null) {
					// Backwards compatibility
					_fnCompatCols(oOptions);
	
					// Map camel case parameters to their Hungarian counterparts
					_fnCamelToHungarian(_DataTable.defaults.column, oOptions);
	
					/* Backwards compatibility for mDataProp */
					if (oOptions.mDataProp !== undefined && !oOptions.mData) {
						oOptions.mData = oOptions.mDataProp;
					}
	
					if (oOptions.sType) {
						oCol._sManualType = oOptions.sType;
					}
	
					// `class` is a reserved word in Javascript, so we need to provide
					// the ability to use a valid name for the camel case input
					if (oOptions.className && !oOptions.sClass) {
						oOptions.sClass = oOptions.className;
					}
	
					$.extend(oCol, oOptions);
					_fnMap(oCol, oOptions, "sWidth", "sWidthOrig");
	
					/* iDataSort to be applied (backwards compatibility), but aDataSort will take
	     * priority if defined
	     */
					if (typeof oOptions.iDataSort === 'number') {
						oCol.aDataSort = [oOptions.iDataSort];
					}
					_fnMap(oCol, oOptions, "aDataSort");
				}
	
				/* Cache the data get and set functions for speed */
				var mDataSrc = oCol.mData;
				var mData = _fnGetObjectDataFn(mDataSrc);
				var mRender = oCol.mRender ? _fnGetObjectDataFn(oCol.mRender) : null;
	
				var attrTest = function attrTest(src) {
					return typeof src === 'string' && src.indexOf('@') !== -1;
				};
				oCol._bAttrSrc = $.isPlainObject(mDataSrc) && (attrTest(mDataSrc.sort) || attrTest(mDataSrc.type) || attrTest(mDataSrc.filter));
	
				oCol.fnGetData = function (rowData, type, meta) {
					var innerData = mData(rowData, type, undefined, meta);
	
					return mRender && type ? mRender(innerData, type, rowData, meta) : innerData;
				};
				oCol.fnSetData = function (rowData, val, meta) {
					return _fnSetObjectDataFn(mDataSrc)(rowData, val, meta);
				};
	
				// Indicate if DataTables should read DOM data as an object or array
				// Used in _fnGetRowElements
				if (typeof mDataSrc !== 'number') {
					oSettings._rowReadObject = true;
				}
	
				/* Feature sorting overrides column specific when off */
				if (!oSettings.oFeatures.bSort) {
					oCol.bSortable = false;
					th.addClass(oClasses.sSortableNone); // Have to add class here as order event isn't called
				}
	
				/* Check that the class assignment is correct for sorting */
				var bAsc = $.inArray('asc', oCol.asSorting) !== -1;
				var bDesc = $.inArray('desc', oCol.asSorting) !== -1;
				if (!oCol.bSortable || !bAsc && !bDesc) {
					oCol.sSortingClass = oClasses.sSortableNone;
					oCol.sSortingClassJUI = "";
				} else if (bAsc && !bDesc) {
					oCol.sSortingClass = oClasses.sSortableAsc;
					oCol.sSortingClassJUI = oClasses.sSortJUIAscAllowed;
				} else if (!bAsc && bDesc) {
					oCol.sSortingClass = oClasses.sSortableDesc;
					oCol.sSortingClassJUI = oClasses.sSortJUIDescAllowed;
				} else {
					oCol.sSortingClass = oClasses.sSortable;
					oCol.sSortingClassJUI = oClasses.sSortJUI;
				}
			}
	
			/**
	   * Adjust the table column widths for new data. Note: you would probably want to
	   * do a redraw after calling this function!
	   *  @param {object} settings dataTables settings object
	   *  @memberof DataTable#oApi
	   */
			function _fnAdjustColumnSizing(settings) {
				/* Not interested in doing column width calculation if auto-width is disabled */
				if (settings.oFeatures.bAutoWidth !== false) {
					var columns = settings.aoColumns;
	
					_fnCalculateColumnWidths(settings);
					for (var i = 0, iLen = columns.length; i < iLen; i++) {
						columns[i].nTh.style.width = columns[i].sWidth;
					}
				}
	
				var scroll = settings.oScroll;
				if (scroll.sY !== '' || scroll.sX !== '') {
					_fnScrollDraw(settings);
				}
	
				_fnCallbackFire(settings, null, 'column-sizing', [settings]);
			}
	
			/**
	   * Covert the index of a visible column to the index in the data array (take account
	   * of hidden columns)
	   *  @param {object} oSettings dataTables settings object
	   *  @param {int} iMatch Visible column index to lookup
	   *  @returns {int} i the data index
	   *  @memberof DataTable#oApi
	   */
			function _fnVisibleToColumnIndex(oSettings, iMatch) {
				var aiVis = _fnGetColumns(oSettings, 'bVisible');
	
				return typeof aiVis[iMatch] === 'number' ? aiVis[iMatch] : null;
			}
	
			/**
	   * Covert the index of an index in the data array and convert it to the visible
	   *   column index (take account of hidden columns)
	   *  @param {int} iMatch Column index to lookup
	   *  @param {object} oSettings dataTables settings object
	   *  @returns {int} i the data index
	   *  @memberof DataTable#oApi
	   */
			function _fnColumnIndexToVisible(oSettings, iMatch) {
				var aiVis = _fnGetColumns(oSettings, 'bVisible');
				var iPos = $.inArray(iMatch, aiVis);
	
				return iPos !== -1 ? iPos : null;
			}
	
			/**
	   * Get the number of visible columns
	   *  @param {object} oSettings dataTables settings object
	   *  @returns {int} i the number of visible columns
	   *  @memberof DataTable#oApi
	   */
			function _fnVisbleColumns(oSettings) {
				return _fnGetColumns(oSettings, 'bVisible').length;
			}
	
			/**
	   * Get an array of column indexes that match a given property
	   *  @param {object} oSettings dataTables settings object
	   *  @param {string} sParam Parameter in aoColumns to look for - typically
	   *    bVisible or bSearchable
	   *  @returns {array} Array of indexes with matched properties
	   *  @memberof DataTable#oApi
	   */
			function _fnGetColumns(oSettings, sParam) {
				var a = [];
	
				$.map(oSettings.aoColumns, function (val, i) {
					if (val[sParam]) {
						a.push(i);
					}
				});
	
				return a;
			}
	
			/**
	   * Calculate the 'type' of a column
	   *  @param {object} settings dataTables settings object
	   *  @memberof DataTable#oApi
	   */
			function _fnColumnTypes(settings) {
				var columns = settings.aoColumns;
				var data = settings.aoData;
				var types = _DataTable.ext.type.detect;
				var i, ien, j, jen, k, ken;
				var col, cell, detectedType, cache;
	
				// For each column, spin over the 
				for (i = 0, ien = columns.length; i < ien; i++) {
					col = columns[i];
					cache = [];
	
					if (!col.sType && col._sManualType) {
						col.sType = col._sManualType;
					} else if (!col.sType) {
						for (j = 0, jen = types.length; j < jen; j++) {
							for (k = 0, ken = data.length; k < ken; k++) {
								// Use a cache array so we only need to get the type data
								// from the formatter once (when using multiple detectors)
								if (cache[k] === undefined) {
									cache[k] = _fnGetCellData(settings, k, i, 'type');
								}
	
								detectedType = types[j](cache[k], settings);
	
								// If null, then this type can't apply to this column, so
								// rather than testing all cells, break out. There is an
								// exception for the last type which is `html`. We need to
								// scan all rows since it is possible to mix string and HTML
								// types
								if (!detectedType && j !== types.length - 1) {
									break;
								}
	
								// Only a single match is needed for html type since it is
								// bottom of the pile and very similar to string
								if (detectedType === 'html') {
									break;
								}
							}
	
							// Type is valid for all data points in the column - use this
							// type
							if (detectedType) {
								col.sType = detectedType;
								break;
							}
						}
	
						// Fall back - if no type was detected, always use string
						if (!col.sType) {
							col.sType = 'string';
						}
					}
				}
			}
	
			/**
	   * Take the column definitions and static columns arrays and calculate how
	   * they relate to column indexes. The callback function will then apply the
	   * definition found for a column to a suitable configuration object.
	   *  @param {object} oSettings dataTables settings object
	   *  @param {array} aoColDefs The aoColumnDefs array that is to be applied
	   *  @param {array} aoCols The aoColumns array that defines columns individually
	   *  @param {function} fn Callback function - takes two parameters, the calculated
	   *    column index and the definition for that column.
	   *  @memberof DataTable#oApi
	   */
			function _fnApplyColumnDefs(oSettings, aoColDefs, aoCols, fn) {
				var i, iLen, j, jLen, k, kLen, def;
				var columns = oSettings.aoColumns;
	
				// Column definitions with aTargets
				if (aoColDefs) {
					/* Loop over the definitions array - loop in reverse so first instance has priority */
					for (i = aoColDefs.length - 1; i >= 0; i--) {
						def = aoColDefs[i];
	
						/* Each definition can target multiple columns, as it is an array */
						var aTargets = def.targets !== undefined ? def.targets : def.aTargets;
	
						if (!$.isArray(aTargets)) {
							aTargets = [aTargets];
						}
	
						for (j = 0, jLen = aTargets.length; j < jLen; j++) {
							if (typeof aTargets[j] === 'number' && aTargets[j] >= 0) {
								/* Add columns that we don't yet know about */
								while (columns.length <= aTargets[j]) {
									_fnAddColumn(oSettings);
								}
	
								/* Integer, basic index */
								fn(aTargets[j], def);
							} else if (typeof aTargets[j] === 'number' && aTargets[j] < 0) {
								/* Negative integer, right to left column counting */
								fn(columns.length + aTargets[j], def);
							} else if (typeof aTargets[j] === 'string') {
								/* Class name matching on TH element */
								for (k = 0, kLen = columns.length; k < kLen; k++) {
									if (aTargets[j] == "_all" || $(columns[k].nTh).hasClass(aTargets[j])) {
										fn(k, def);
									}
								}
							}
						}
					}
				}
	
				// Statically defined columns array
				if (aoCols) {
					for (i = 0, iLen = aoCols.length; i < iLen; i++) {
						fn(i, aoCols[i]);
					}
				}
			}
	
			/**
	   * Add a data array to the table, creating DOM node etc. This is the parallel to
	   * _fnGatherData, but for adding rows from a Javascript source, rather than a
	   * DOM source.
	   *  @param {object} oSettings dataTables settings object
	   *  @param {array} aData data array to be added
	   *  @param {node} [nTr] TR element to add to the table - optional. If not given,
	   *    DataTables will create a row automatically
	   *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
	   *    if nTr is.
	   *  @returns {int} >=0 if successful (index of new aoData entry), -1 if failed
	   *  @memberof DataTable#oApi
	   */
			function _fnAddData(oSettings, aDataIn, nTr, anTds) {
				/* Create the object for storing information about this new row */
				var iRow = oSettings.aoData.length;
				var oData = $.extend(true, {}, _DataTable.models.oRow, {
					src: nTr ? 'dom' : 'data'
				});
	
				oData._aData = aDataIn;
				oSettings.aoData.push(oData);
	
				/* Create the cells */
				var nTd, sThisType;
				var columns = oSettings.aoColumns;
				for (var i = 0, iLen = columns.length; i < iLen; i++) {
					// When working with a row, the data source object must be populated. In
					// all other cases, the data source object is already populated, so we
					// don't overwrite it, which might break bindings etc
					if (nTr) {
						_fnSetCellData(oSettings, iRow, i, _fnGetCellData(oSettings, iRow, i));
					}
					columns[i].sType = null;
				}
	
				/* Add to the display array */
				oSettings.aiDisplayMaster.push(iRow);
	
				/* Create the DOM information, or register it if already present */
				if (nTr || !oSettings.oFeatures.bDeferRender) {
					_fnCreateTr(oSettings, iRow, nTr, anTds);
				}
	
				return iRow;
			}
	
			/**
	   * Add one or more TR elements to the table. Generally we'd expect to
	   * use this for reading data from a DOM sourced table, but it could be
	   * used for an TR element. Note that if a TR is given, it is used (i.e.
	   * it is not cloned).
	   *  @param {object} settings dataTables settings object
	   *  @param {array|node|jQuery} trs The TR element(s) to add to the table
	   *  @returns {array} Array of indexes for the added rows
	   *  @memberof DataTable#oApi
	   */
			function _fnAddTr(settings, trs) {
				var row;
	
				// Allow an individual node to be passed in
				if (!(trs instanceof $)) {
					trs = $(trs);
				}
	
				return trs.map(function (i, el) {
					row = _fnGetRowElements(settings, el);
					return _fnAddData(settings, row.data, el, row.cells);
				});
			}
	
			/**
	   * Take a TR element and convert it to an index in aoData
	   *  @param {object} oSettings dataTables settings object
	   *  @param {node} n the TR element to find
	   *  @returns {int} index if the node is found, null if not
	   *  @memberof DataTable#oApi
	   */
			function _fnNodeToDataIndex(oSettings, n) {
				return n._DT_RowIndex !== undefined ? n._DT_RowIndex : null;
			}
	
			/**
	   * Take a TD element and convert it into a column data index (not the visible index)
	   *  @param {object} oSettings dataTables settings object
	   *  @param {int} iRow The row number the TD/TH can be found in
	   *  @param {node} n The TD/TH element to find
	   *  @returns {int} index if the node is found, -1 if not
	   *  @memberof DataTable#oApi
	   */
			function _fnNodeToColumnIndex(oSettings, iRow, n) {
				return $.inArray(n, oSettings.aoData[iRow].anCells);
			}
	
			/**
	   * Get the data for a given cell from the internal cache, taking into account data mapping
	   *  @param {object} settings dataTables settings object
	   *  @param {int} rowIdx aoData row id
	   *  @param {int} colIdx Column index
	   *  @param {string} type data get type ('display', 'type' 'filter' 'sort')
	   *  @returns {*} Cell data
	   *  @memberof DataTable#oApi
	   */
			function _fnGetCellData(settings, rowIdx, colIdx, type) {
				var draw = settings.iDraw;
				var col = settings.aoColumns[colIdx];
				var rowData = settings.aoData[rowIdx]._aData;
				var defaultContent = col.sDefaultContent;
				var cellData = col.fnGetData(rowData, type, {
					settings: settings,
					row: rowIdx,
					col: colIdx
				});
	
				if (cellData === undefined) {
					if (settings.iDrawError != draw && defaultContent === null) {
						_fnLog(settings, 0, "Requested unknown parameter " + (typeof col.mData == 'function' ? '{function}' : "'" + col.mData + "'") + " for row " + rowIdx, 4);
						settings.iDrawError = draw;
					}
					return defaultContent;
				}
	
				/* When the data source is null, we can use default column data */
				if ((cellData === rowData || cellData === null) && defaultContent !== null) {
					cellData = defaultContent;
				} else if (typeof cellData === 'function') {
					// If the data source is a function, then we run it and use the return,
					// executing in the scope of the data object (for instances)
					return cellData.call(rowData);
				}
	
				if (cellData === null && type == 'display') {
					return '';
				}
				return cellData;
			}
	
			/**
	   * Set the value for a specific cell, into the internal data cache
	   *  @param {object} settings dataTables settings object
	   *  @param {int} rowIdx aoData row id
	   *  @param {int} colIdx Column index
	   *  @param {*} val Value to set
	   *  @memberof DataTable#oApi
	   */
			function _fnSetCellData(settings, rowIdx, colIdx, val) {
				var col = settings.aoColumns[colIdx];
				var rowData = settings.aoData[rowIdx]._aData;
	
				col.fnSetData(rowData, val, {
					settings: settings,
					row: rowIdx,
					col: colIdx
				});
			}
	
			// Private variable that is used to match action syntax in the data property object
			var __reArray = /\[.*?\]$/;
			var __reFn = /\(\)$/;
	
			/**
	   * Split string on periods, taking into account escaped periods
	   * @param  {string} str String to split
	   * @return {array} Split string
	   */
			function _fnSplitObjNotation(str) {
				return $.map(str.match(/(\\.|[^\.])+/g), function (s) {
					return s.replace(/\\./g, '.');
				});
			}
	
			/**
	   * Return a function that can be used to get data from a source object, taking
	   * into account the ability to use nested objects as a source
	   *  @param {string|int|function} mSource The data source for the object
	   *  @returns {function} Data get function
	   *  @memberof DataTable#oApi
	   */
			function _fnGetObjectDataFn(mSource) {
				if ($.isPlainObject(mSource)) {
					/* Build an object of get functions, and wrap them in a single call */
					var o = {};
					$.each(mSource, function (key, val) {
						if (val) {
							o[key] = _fnGetObjectDataFn(val);
						}
					});
	
					return function (data, type, row, meta) {
						var t = o[type] || o._;
						return t !== undefined ? t(data, type, row, meta) : data;
					};
				} else if (mSource === null) {
					/* Give an empty string for rendering / sorting etc */
					return function (data) {
						// type, row and meta also passed, but not used
						return data;
					};
				} else if (typeof mSource === 'function') {
					return function (data, type, row, meta) {
						return mSource(data, type, row, meta);
					};
				} else if (typeof mSource === 'string' && (mSource.indexOf('.') !== -1 || mSource.indexOf('[') !== -1 || mSource.indexOf('(') !== -1)) {
					/* If there is a . in the source string then the data source is in a
	     * nested object so we loop over the data for each level to get the next
	     * level down. On each loop we test for undefined, and if found immediately
	     * return. This allows entire objects to be missing and sDefaultContent to
	     * be used if defined, rather than throwing an error
	     */
					var fetchData = function fetchData(data, type, src) {
						var arrayNotation, funcNotation, out, innerSrc;
	
						if (src !== "") {
							var a = _fnSplitObjNotation(src);
	
							for (var i = 0, iLen = a.length; i < iLen; i++) {
								// Check if we are dealing with special notation
								arrayNotation = a[i].match(__reArray);
								funcNotation = a[i].match(__reFn);
	
								if (arrayNotation) {
									// Array notation
									a[i] = a[i].replace(__reArray, '');
	
									// Condition allows simply [] to be passed in
									if (a[i] !== "") {
										data = data[a[i]];
									}
									out = [];
	
									// Get the remainder of the nested object to get
									a.splice(0, i + 1);
									innerSrc = a.join('.');
	
									// Traverse each entry in the array getting the properties requested
									for (var j = 0, jLen = data.length; j < jLen; j++) {
										out.push(fetchData(data[j], type, innerSrc));
									}
	
									// If a string is given in between the array notation indicators, that
									// is used to join the strings together, otherwise an array is returned
									var join = arrayNotation[0].substring(1, arrayNotation[0].length - 1);
									data = join === "" ? out : out.join(join);
	
									// The inner call to fetchData has already traversed through the remainder
									// of the source requested, so we exit from the loop
									break;
								} else if (funcNotation) {
									// Function call
									a[i] = a[i].replace(__reFn, '');
									data = data[a[i]]();
									continue;
								}
	
								if (data === null || data[a[i]] === undefined) {
									return undefined;
								}
								data = data[a[i]];
							}
						}
	
						return data;
					};
	
					return function (data, type) {
						// row and meta also passed, but not used
						return fetchData(data, type, mSource);
					};
				} else {
					/* Array or flat object mapping */
					return function (data, type) {
						// row and meta also passed, but not used
						return data[mSource];
					};
				}
			}
	
			/**
	   * Return a function that can be used to set data from a source object, taking
	   * into account the ability to use nested objects as a source
	   *  @param {string|int|function} mSource The data source for the object
	   *  @returns {function} Data set function
	   *  @memberof DataTable#oApi
	   */
			function _fnSetObjectDataFn(mSource) {
				if ($.isPlainObject(mSource)) {
					/* Unlike get, only the underscore (global) option is used for for
	     * setting data since we don't know the type here. This is why an object
	     * option is not documented for `mData` (which is read/write), but it is
	     * for `mRender` which is read only.
	     */
					return _fnSetObjectDataFn(mSource._);
				} else if (mSource === null) {
					/* Nothing to do when the data source is null */
					return function () {};
				} else if (typeof mSource === 'function') {
					return function (data, val, meta) {
						mSource(data, 'set', val, meta);
					};
				} else if (typeof mSource === 'string' && (mSource.indexOf('.') !== -1 || mSource.indexOf('[') !== -1 || mSource.indexOf('(') !== -1)) {
					/* Like the get, we need to get data from a nested object */
					var setData = function setData(data, val, src) {
						var a = _fnSplitObjNotation(src),
						    b;
						var aLast = a[a.length - 1];
						var arrayNotation, funcNotation, o, innerSrc;
	
						for (var i = 0, iLen = a.length - 1; i < iLen; i++) {
							// Check if we are dealing with an array notation request
							arrayNotation = a[i].match(__reArray);
							funcNotation = a[i].match(__reFn);
	
							if (arrayNotation) {
								a[i] = a[i].replace(__reArray, '');
								data[a[i]] = [];
	
								// Get the remainder of the nested object to set so we can recurse
								b = a.slice();
								b.splice(0, i + 1);
								innerSrc = b.join('.');
	
								// Traverse each entry in the array setting the properties requested
								for (var j = 0, jLen = val.length; j < jLen; j++) {
									o = {};
									setData(o, val[j], innerSrc);
									data[a[i]].push(o);
								}
	
								// The inner call to setData has already traversed through the remainder
								// of the source and has set the data, thus we can exit here
								return;
							} else if (funcNotation) {
								// Function call
								a[i] = a[i].replace(__reFn, '');
								data = data[a[i]](val);
							}
	
							// If the nested object doesn't currently exist - since we are
							// trying to set the value - create it
							if (data[a[i]] === null || data[a[i]] === undefined) {
								data[a[i]] = {};
							}
							data = data[a[i]];
						}
	
						// Last item in the input - i.e, the actual set
						if (aLast.match(__reFn)) {
							// Function call
							data = data[aLast.replace(__reFn, '')](val);
						} else {
							// If array notation is used, we just want to strip it and use the property name
							// and assign the value. If it isn't used, then we get the result we want anyway
							data[aLast.replace(__reArray, '')] = val;
						}
					};
	
					return function (data, val) {
						// meta is also passed in, but not used
						return setData(data, val, mSource);
					};
				} else {
					/* Array or flat object mapping */
					return function (data, val) {
						// meta is also passed in, but not used
						data[mSource] = val;
					};
				}
			}
	
			/**
	   * Return an array with the full table data
	   *  @param {object} oSettings dataTables settings object
	   *  @returns array {array} aData Master data array
	   *  @memberof DataTable#oApi
	   */
			function _fnGetDataMaster(settings) {
				return _pluck(settings.aoData, '_aData');
			}
	
			/**
	   * Nuke the table
	   *  @param {object} oSettings dataTables settings object
	   *  @memberof DataTable#oApi
	   */
			function _fnClearTable(settings) {
				settings.aoData.length = 0;
				settings.aiDisplayMaster.length = 0;
				settings.aiDisplay.length = 0;
			}
	
			/**
	  * Take an array of integers (index array) and remove a target integer (value - not
	  * the key!)
	  *  @param {array} a Index array to target
	  *  @param {int} iTarget value to find
	  *  @memberof DataTable#oApi
	  */
			function _fnDeleteIndex(a, iTarget, splice) {
				var iTargetIndex = -1;
	
				for (var i = 0, iLen = a.length; i < iLen; i++) {
					if (a[i] == iTarget) {
						iTargetIndex = i;
					} else if (a[i] > iTarget) {
						a[i]--;
					}
				}
	
				if (iTargetIndex != -1 && splice === undefined) {
					a.splice(iTargetIndex, 1);
				}
			}
	
			/**
	   * Mark cached data as invalid such that a re-read of the data will occur when
	   * the cached data is next requested. Also update from the data source object.
	   *
	   * @param {object} settings DataTables settings object
	   * @param {int}    rowIdx   Row index to invalidate
	   * @param {string} [src]    Source to invalidate from: undefined, 'auto', 'dom'
	   *     or 'data'
	   * @param {int}    [colIdx] Column index to invalidate. If undefined the whole
	   *     row will be invalidated
	   * @memberof DataTable#oApi
	   *
	   * @todo For the modularisation of v1.11 this will need to become a callback, so
	   *   the sort and filter methods can subscribe to it. That will required
	   *   initialisation options for sorting, which is why it is not already baked in
	   */
			function _fnInvalidate(settings, rowIdx, src, colIdx) {
				var row = settings.aoData[rowIdx];
				var i, ien;
				var cellWrite = function cellWrite(cell, col) {
					// This is very frustrating, but in IE if you just write directly
					// to innerHTML, and elements that are overwritten are GC'ed,
					// even if there is a reference to them elsewhere
					while (cell.childNodes.length) {
						cell.removeChild(cell.firstChild);
					}
	
					cell.innerHTML = _fnGetCellData(settings, rowIdx, col, 'display');
				};
	
				// Are we reading last data from DOM or the data object?
				if (src === 'dom' || (!src || src === 'auto') && row.src === 'dom') {
					// Read the data from the DOM
					row._aData = _fnGetRowElements(settings, row, colIdx, colIdx === undefined ? undefined : row._aData).data;
				} else {
					// Reading from data object, update the DOM
					var cells = row.anCells;
	
					if (cells) {
						if (colIdx !== undefined) {
							cellWrite(cells[colIdx], colIdx);
						} else {
							for (i = 0, ien = cells.length; i < ien; i++) {
								cellWrite(cells[i], i);
							}
						}
					}
				}
	
				// For both row and cell invalidation, the cached data for sorting and
				// filtering is nulled out
				row._aSortData = null;
				row._aFilterData = null;
	
				// Invalidate the type for a specific column (if given) or all columns since
				// the data might have changed
				var cols = settings.aoColumns;
				if (colIdx !== undefined) {
					cols[colIdx].sType = null;
				} else {
					for (i = 0, ien = cols.length; i < ien; i++) {
						cols[i].sType = null;
					}
	
					// Update DataTables special `DT_*` attributes for the row
					_fnRowAttributes(row);
				}
			}
	
			/**
	   * Build a data source object from an HTML row, reading the contents of the
	   * cells that are in the row.
	   *
	   * @param {object} settings DataTables settings object
	   * @param {node|object} TR element from which to read data or existing row
	   *   object from which to re-read the data from the cells
	   * @param {int} [colIdx] Optional column index
	   * @param {array|object} [d] Data source object. If `colIdx` is given then this
	   *   parameter should also be given and will be used to write the data into.
	   *   Only the column in question will be written
	   * @returns {object} Object with two parameters: `data` the data read, in
	   *   document order, and `cells` and array of nodes (they can be useful to the
	   *   caller, so rather than needing a second traversal to get them, just return
	   *   them from here).
	   * @memberof DataTable#oApi
	   */
			function _fnGetRowElements(settings, row, colIdx, d) {
				var tds = [],
				    td = row.firstChild,
				    name,
				    col,
				    o,
				    i = 0,
				    contents,
				    columns = settings.aoColumns,
				    objectRead = settings._rowReadObject;
	
				// Allow the data object to be passed in, or construct
				d = d || objectRead ? {} : [];
	
				var attr = function attr(str, td) {
					if (typeof str === 'string') {
						var idx = str.indexOf('@');
	
						if (idx !== -1) {
							var attr = str.substring(idx + 1);
							var setter = _fnSetObjectDataFn(str);
							setter(d, td.getAttribute(attr));
						}
					}
				};
	
				// Read data from a cell and store into the data object
				var cellProcess = function cellProcess(cell) {
					if (colIdx === undefined || colIdx === i) {
						col = columns[i];
						contents = $.trim(cell.innerHTML);
	
						if (col && col._bAttrSrc) {
							var setter = _fnSetObjectDataFn(col.mData._);
							setter(d, contents);
	
							attr(col.mData.sort, cell);
							attr(col.mData.type, cell);
							attr(col.mData.filter, cell);
						} else {
							// Depending on the `data` option for the columns the data can
							// be read to either an object or an array.
							if (objectRead) {
								if (!col._setter) {
									// Cache the setter function
									col._setter = _fnSetObjectDataFn(col.mData);
								}
								col._setter(d, contents);
							} else {
								d[i] = contents;
							}
						}
					}
	
					i++;
				};
	
				if (td) {
					// `tr` element was passed in
					while (td) {
						name = td.nodeName.toUpperCase();
	
						if (name == "TD" || name == "TH") {
							cellProcess(td);
							tds.push(td);
						}
	
						td = td.nextSibling;
					}
				} else {
					// Existing row object passed in
					tds = row.anCells;
	
					for (var j = 0, jen = tds.length; j < jen; j++) {
						cellProcess(tds[j]);
					}
				}
	
				return {
					data: d,
					cells: tds
				};
			}
			/**
	   * Create a new TR element (and it's TD children) for a row
	   *  @param {object} oSettings dataTables settings object
	   *  @param {int} iRow Row to consider
	   *  @param {node} [nTrIn] TR element to add to the table - optional. If not given,
	   *    DataTables will create a row automatically
	   *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
	   *    if nTr is.
	   *  @memberof DataTable#oApi
	   */
			function _fnCreateTr(oSettings, iRow, nTrIn, anTds) {
				var row = oSettings.aoData[iRow],
				    rowData = row._aData,
				    cells = [],
				    nTr,
				    nTd,
				    oCol,
				    i,
				    iLen;
	
				if (row.nTr === null) {
					nTr = nTrIn || document.createElement('tr');
	
					row.nTr = nTr;
					row.anCells = cells;
	
					/* Use a private property on the node to allow reserve mapping from the node
	     * to the aoData array for fast look up
	     */
					nTr._DT_RowIndex = iRow;
	
					/* Special parameters can be given by the data source to be used on the row */
					_fnRowAttributes(row);
	
					/* Process each column */
					for (i = 0, iLen = oSettings.aoColumns.length; i < iLen; i++) {
						oCol = oSettings.aoColumns[i];
	
						nTd = nTrIn ? anTds[i] : document.createElement(oCol.sCellType);
						cells.push(nTd);
	
						// Need to create the HTML if new, or if a rendering function is defined
						if (!nTrIn || oCol.mRender || oCol.mData !== i) {
							nTd.innerHTML = _fnGetCellData(oSettings, iRow, i, 'display');
						}
	
						/* Add user defined class */
						if (oCol.sClass) {
							nTd.className += ' ' + oCol.sClass;
						}
	
						// Visibility - add or remove as required
						if (oCol.bVisible && !nTrIn) {
							nTr.appendChild(nTd);
						} else if (!oCol.bVisible && nTrIn) {
							nTd.parentNode.removeChild(nTd);
						}
	
						if (oCol.fnCreatedCell) {
							oCol.fnCreatedCell.call(oSettings.oInstance, nTd, _fnGetCellData(oSettings, iRow, i), rowData, iRow, i);
						}
					}
	
					_fnCallbackFire(oSettings, 'aoRowCreatedCallback', null, [nTr, rowData, iRow]);
				}
	
				// Remove once webkit bug 131819 and Chromium bug 365619 have been resolved
				// and deployed
				row.nTr.setAttribute('role', 'row');
			}
	
			/**
	   * Add attributes to a row based on the special `DT_*` parameters in a data
	   * source object.
	   *  @param {object} DataTables row object for the row to be modified
	   *  @memberof DataTable#oApi
	   */
			function _fnRowAttributes(row) {
				var tr = row.nTr;
				var data = row._aData;
	
				if (tr) {
					if (data.DT_RowId) {
						tr.id = data.DT_RowId;
					}
	
					if (data.DT_RowClass) {
						// Remove any classes added by DT_RowClass before
						var a = data.DT_RowClass.split(' ');
						row.__rowc = row.__rowc ? _unique(row.__rowc.concat(a)) : a;
	
						$(tr).removeClass(row.__rowc.join(' ')).addClass(data.DT_RowClass);
					}
	
					if (data.DT_RowData) {
						$(tr).data(data.DT_RowData);
					}
				}
			}
	
			/**
	   * Create the HTML header for the table
	   *  @param {object} oSettings dataTables settings object
	   *  @memberof DataTable#oApi
	   */
			function _fnBuildHead(oSettings) {
				var i, ien, cell, row, column;
				var thead = oSettings.nTHead;
				var tfoot = oSettings.nTFoot;
				var createHeader = $('th, td', thead).length === 0;
				var classes = oSettings.oClasses;
				var columns = oSettings.aoColumns;
	
				if (createHeader) {
					row = $('<tr/>').appendTo(thead);
				}
	
				for (i = 0, ien = columns.length; i < ien; i++) {
					column = columns[i];
					cell = $(column.nTh).addClass(column.sClass);
	
					if (createHeader) {
						cell.appendTo(row);
					}
	
					// 1.11 move into sorting
					if (oSettings.oFeatures.bSort) {
						cell.addClass(column.sSortingClass);
	
						if (column.bSortable !== false) {
							cell.attr('tabindex', oSettings.iTabIndex).attr('aria-controls', oSettings.sTableId);
	
							_fnSortAttachListener(oSettings, column.nTh, i);
						}
					}
	
					if (column.sTitle != cell.html()) {
						cell.html(column.sTitle);
					}
	
					_fnRenderer(oSettings, 'header')(oSettings, cell, column, classes);
				}
	
				if (createHeader) {
					_fnDetectHeader(oSettings.aoHeader, thead);
				}
	
				/* ARIA role for the rows */
				$(thead).find('>tr').attr('role', 'row');
	
				/* Deal with the footer - add classes if required */
				$(thead).find('>tr>th, >tr>td').addClass(classes.sHeaderTH);
				$(tfoot).find('>tr>th, >tr>td').addClass(classes.sFooterTH);
	
				// Cache the footer cells. Note that we only take the cells from the first
				// row in the footer. If there is more than one row the user wants to
				// interact with, they need to use the table().foot() method. Note also this
				// allows cells to be used for multiple columns using colspan
				if (tfoot !== null) {
					var cells = oSettings.aoFooter[0];
	
					for (i = 0, ien = cells.length; i < ien; i++) {
						column = columns[i];
						column.nTf = cells[i].cell;
	
						if (column.sClass) {
							$(column.nTf).addClass(column.sClass);
						}
					}
				}
			}
	
			/**
	   * Draw the header (or footer) element based on the column visibility states. The
	   * methodology here is to use the layout array from _fnDetectHeader, modified for
	   * the instantaneous column visibility, to construct the new layout. The grid is
	   * traversed over cell at a time in a rows x columns grid fashion, although each
	   * cell insert can cover multiple elements in the grid - which is tracks using the
	   * aApplied array. Cell inserts in the grid will only occur where there isn't
	   * already a cell in that position.
	   *  @param {object} oSettings dataTables settings object
	   *  @param array {objects} aoSource Layout array from _fnDetectHeader
	   *  @param {boolean} [bIncludeHidden=false] If true then include the hidden columns in the calc,
	   *  @memberof DataTable#oApi
	   */
			function _fnDrawHead(oSettings, aoSource, bIncludeHidden) {
				var i, iLen, j, jLen, k, kLen, n, nLocalTr;
				var aoLocal = [];
				var aApplied = [];
				var iColumns = oSettings.aoColumns.length;
				var iRowspan, iColspan;
	
				if (!aoSource) {
					return;
				}
	
				if (bIncludeHidden === undefined) {
					bIncludeHidden = false;
				}
	
				/* Make a copy of the master layout array, but without the visible columns in it */
				for (i = 0, iLen = aoSource.length; i < iLen; i++) {
					aoLocal[i] = aoSource[i].slice();
					aoLocal[i].nTr = aoSource[i].nTr;
	
					/* Remove any columns which are currently hidden */
					for (j = iColumns - 1; j >= 0; j--) {
						if (!oSettings.aoColumns[j].bVisible && !bIncludeHidden) {
							aoLocal[i].splice(j, 1);
						}
					}
	
					/* Prep the applied array - it needs an element for each row */
					aApplied.push([]);
				}
	
				for (i = 0, iLen = aoLocal.length; i < iLen; i++) {
					nLocalTr = aoLocal[i].nTr;
	
					/* All cells are going to be replaced, so empty out the row */
					if (nLocalTr) {
						while (n = nLocalTr.firstChild) {
							nLocalTr.removeChild(n);
						}
					}
	
					for (j = 0, jLen = aoLocal[i].length; j < jLen; j++) {
						iRowspan = 1;
						iColspan = 1;
	
						/* Check to see if there is already a cell (row/colspan) covering our target
	      * insert point. If there is, then there is nothing to do.
	      */
						if (aApplied[i][j] === undefined) {
							nLocalTr.appendChild(aoLocal[i][j].cell);
							aApplied[i][j] = 1;
	
							/* Expand the cell to cover as many rows as needed */
							while (aoLocal[i + iRowspan] !== undefined && aoLocal[i][j].cell == aoLocal[i + iRowspan][j].cell) {
								aApplied[i + iRowspan][j] = 1;
								iRowspan++;
							}
	
							/* Expand the cell to cover as many columns as needed */
							while (aoLocal[i][j + iColspan] !== undefined && aoLocal[i][j].cell == aoLocal[i][j + iColspan].cell) {
								/* Must update the applied array over the rows for the columns */
								for (k = 0; k < iRowspan; k++) {
									aApplied[i + k][j + iColspan] = 1;
								}
								iColspan++;
							}
	
							/* Do the actual expansion in the DOM */
							$(aoLocal[i][j].cell).attr('rowspan', iRowspan).attr('colspan', iColspan);
						}
					}
				}
			}
	
			/**
	   * Insert the required TR nodes into the table for display
	   *  @param {object} oSettings dataTables settings object
	   *  @memberof DataTable#oApi
	   */
			function _fnDraw(oSettings) {
				/* Provide a pre-callback function which can be used to cancel the draw is false is returned */
				var aPreDraw = _fnCallbackFire(oSettings, 'aoPreDrawCallback', 'preDraw', [oSettings]);
				if ($.inArray(false, aPreDraw) !== -1) {
					_fnProcessingDisplay(oSettings, false);
					return;
				}
	
				var i, iLen, n;
				var anRows = [];
				var iRowCount = 0;
				var asStripeClasses = oSettings.asStripeClasses;
				var iStripes = asStripeClasses.length;
				var iOpenRows = oSettings.aoOpenRows.length;
				var oLang = oSettings.oLanguage;
				var iInitDisplayStart = oSettings.iInitDisplayStart;
				var bServerSide = _fnDataSource(oSettings) == 'ssp';
				var aiDisplay = oSettings.aiDisplay;
	
				oSettings.bDrawing = true;
	
				/* Check and see if we have an initial draw position from state saving */
				if (iInitDisplayStart !== undefined && iInitDisplayStart !== -1) {
					oSettings._iDisplayStart = bServerSide ? iInitDisplayStart : iInitDisplayStart >= oSettings.fnRecordsDisplay() ? 0 : iInitDisplayStart;
	
					oSettings.iInitDisplayStart = -1;
				}
	
				var iDisplayStart = oSettings._iDisplayStart;
				var iDisplayEnd = oSettings.fnDisplayEnd();
	
				/* Server-side processing draw intercept */
				if (oSettings.bDeferLoading) {
					oSettings.bDeferLoading = false;
					oSettings.iDraw++;
					_fnProcessingDisplay(oSettings, false);
				} else if (!bServerSide) {
					oSettings.iDraw++;
				} else if (!oSettings.bDestroying && !_fnAjaxUpdate(oSettings)) {
					return;
				}
	
				if (aiDisplay.length !== 0) {
					var iStart = bServerSide ? 0 : iDisplayStart;
					var iEnd = bServerSide ? oSettings.aoData.length : iDisplayEnd;
	
					for (var j = iStart; j < iEnd; j++) {
						var iDataIndex = aiDisplay[j];
						var aoData = oSettings.aoData[iDataIndex];
						if (aoData.nTr === null) {
							_fnCreateTr(oSettings, iDataIndex);
						}
	
						var nRow = aoData.nTr;
	
						/* Remove the old striping classes and then add the new one */
						if (iStripes !== 0) {
							var sStripe = asStripeClasses[iRowCount % iStripes];
							if (aoData._sRowStripe != sStripe) {
								$(nRow).removeClass(aoData._sRowStripe).addClass(sStripe);
								aoData._sRowStripe = sStripe;
							}
						}
	
						// Row callback functions - might want to manipulate the row
						// iRowCount and j are not currently documented. Are they at all
						// useful?
						_fnCallbackFire(oSettings, 'aoRowCallback', null, [nRow, aoData._aData, iRowCount, j]);
	
						anRows.push(nRow);
						iRowCount++;
					}
				} else {
					/* Table is empty - create a row with an empty message in it */
					var sZero = oLang.sZeroRecords;
					if (oSettings.iDraw == 1 && _fnDataSource(oSettings) == 'ajax') {
						sZero = oLang.sLoadingRecords;
					} else if (oLang.sEmptyTable && oSettings.fnRecordsTotal() === 0) {
						sZero = oLang.sEmptyTable;
					}
	
					anRows[0] = $('<tr/>', { 'class': iStripes ? asStripeClasses[0] : '' }).append($('<td />', {
						'valign': 'top',
						'colSpan': _fnVisbleColumns(oSettings),
						'class': oSettings.oClasses.sRowEmpty
					}).html(sZero))[0];
				}
	
				/* Header and footer callbacks */
				_fnCallbackFire(oSettings, 'aoHeaderCallback', 'header', [$(oSettings.nTHead).children('tr')[0], _fnGetDataMaster(oSettings), iDisplayStart, iDisplayEnd, aiDisplay]);
	
				_fnCallbackFire(oSettings, 'aoFooterCallback', 'footer', [$(oSettings.nTFoot).children('tr')[0], _fnGetDataMaster(oSettings), iDisplayStart, iDisplayEnd, aiDisplay]);
	
				var body = $(oSettings.nTBody);
	
				body.children().detach();
				body.append($(anRows));
	
				/* Call all required callback functions for the end of a draw */
				_fnCallbackFire(oSettings, 'aoDrawCallback', 'draw', [oSettings]);
	
				/* Draw is complete, sorting and filtering must be as well */
				oSettings.bSorted = false;
				oSettings.bFiltered = false;
				oSettings.bDrawing = false;
			}
	
			/**
	   * Redraw the table - taking account of the various features which are enabled
	   *  @param {object} oSettings dataTables settings object
	   *  @param {boolean} [holdPosition] Keep the current paging position. By default
	   *    the paging is reset to the first page
	   *  @memberof DataTable#oApi
	   */
			function _fnReDraw(settings, holdPosition) {
				var features = settings.oFeatures,
				    sort = features.bSort,
				    filter = features.bFilter;
	
				if (sort) {
					_fnSort(settings);
				}
	
				if (filter) {
					_fnFilterComplete(settings, settings.oPreviousSearch);
				} else {
					// No filtering, so we want to just use the display master
					settings.aiDisplay = settings.aiDisplayMaster.slice();
				}
	
				if (holdPosition !== true) {
					settings._iDisplayStart = 0;
				}
	
				// Let any modules know about the draw hold position state (used by
				// scrolling internally)
				settings._drawHold = holdPosition;
	
				_fnDraw(settings);
	
				settings._drawHold = false;
			}
	
			/**
	   * Add the options to the page HTML for the table
	   *  @param {object} oSettings dataTables settings object
	   *  @memberof DataTable#oApi
	   */
			function _fnAddOptionsHtml(oSettings) {
				var classes = oSettings.oClasses;
				var table = $(oSettings.nTable);
				var holding = $('<div/>').insertBefore(table); // Holding element for speed
				var features = oSettings.oFeatures;
	
				// All DataTables are wrapped in a div
				var insert = $('<div/>', {
					id: oSettings.sTableId + '_wrapper',
					'class': classes.sWrapper + (oSettings.nTFoot ? '' : ' ' + classes.sNoFooter)
				});
	
				oSettings.nHolding = holding[0];
				oSettings.nTableWrapper = insert[0];
				oSettings.nTableReinsertBefore = oSettings.nTable.nextSibling;
	
				/* Loop over the user set positioning and place the elements as needed */
				var aDom = oSettings.sDom.split('');
				var featureNode, cOption, nNewNode, cNext, sAttr, j;
				for (var i = 0; i < aDom.length; i++) {
					featureNode = null;
					cOption = aDom[i];
	
					if (cOption == '<') {
						/* New container div */
						nNewNode = $('<div/>')[0];
	
						/* Check to see if we should append an id and/or a class name to the container */
						cNext = aDom[i + 1];
						if (cNext == "'" || cNext == '"') {
							sAttr = "";
							j = 2;
							while (aDom[i + j] != cNext) {
								sAttr += aDom[i + j];
								j++;
							}
	
							/* Replace jQuery UI constants @todo depreciated */
							if (sAttr == "H") {
								sAttr = classes.sJUIHeader;
							} else if (sAttr == "F") {
								sAttr = classes.sJUIFooter;
							}
	
							/* The attribute can be in the format of "#id.class", "#id" or "class" This logic
	       * breaks the string into parts and applies them as needed
	       */
							if (sAttr.indexOf('.') != -1) {
								var aSplit = sAttr.split('.');
								nNewNode.id = aSplit[0].substr(1, aSplit[0].length - 1);
								nNewNode.className = aSplit[1];
							} else if (sAttr.charAt(0) == "#") {
								nNewNode.id = sAttr.substr(1, sAttr.length - 1);
							} else {
								nNewNode.className = sAttr;
							}
	
							i += j; /* Move along the position array */
						}
	
						insert.append(nNewNode);
						insert = $(nNewNode);
					} else if (cOption == '>') {
						/* End container div */
						insert = insert.parent();
					}
					// @todo Move options into their own plugins?
					else if (cOption == 'l' && features.bPaginate && features.bLengthChange) {
							/* Length */
							featureNode = _fnFeatureHtmlLength(oSettings);
						} else if (cOption == 'f' && features.bFilter) {
							/* Filter */
							featureNode = _fnFeatureHtmlFilter(oSettings);
						} else if (cOption == 'r' && features.bProcessing) {
							/* pRocessing */
							featureNode = _fnFeatureHtmlProcessing(oSettings);
						} else if (cOption == 't') {
							/* Table */
							featureNode = _fnFeatureHtmlTable(oSettings);
						} else if (cOption == 'i' && features.bInfo) {
							/* Info */
							featureNode = _fnFeatureHtmlInfo(oSettings);
						} else if (cOption == 'p' && features.bPaginate) {
							/* Pagination */
							featureNode = _fnFeatureHtmlPaginate(oSettings);
						} else if (_DataTable.ext.feature.length !== 0) {
							/* Plug-in features */
							var aoFeatures = _DataTable.ext.feature;
							for (var k = 0, kLen = aoFeatures.length; k < kLen; k++) {
								if (cOption == aoFeatures[k].cFeature) {
									featureNode = aoFeatures[k].fnInit(oSettings);
									break;
								}
							}
						}
	
					/* Add to the 2D features array */
					if (featureNode) {
						var aanFeatures = oSettings.aanFeatures;
	
						if (!aanFeatures[cOption]) {
							aanFeatures[cOption] = [];
						}
	
						aanFeatures[cOption].push(featureNode);
						insert.append(featureNode);
					}
				}
	
				/* Built our DOM structure - replace the holding div with what we want */
				holding.replaceWith(insert);
			}
	
			/**
	   * Use the DOM source to create up an array of header cells. The idea here is to
	   * create a layout grid (array) of rows x columns, which contains a reference
	   * to the cell that that point in the grid (regardless of col/rowspan), such that
	   * any column / row could be removed and the new grid constructed
	   *  @param array {object} aLayout Array to store the calculated layout in
	   *  @param {node} nThead The header/footer element for the table
	   *  @memberof DataTable#oApi
	   */
			function _fnDetectHeader(aLayout, nThead) {
				var nTrs = $(nThead).children('tr');
				var nTr, nCell;
				var i, k, l, iLen, jLen, iColShifted, iColumn, iColspan, iRowspan;
				var bUnique;
				var fnShiftCol = function fnShiftCol(a, i, j) {
					var k = a[i];
					while (k[j]) {
						j++;
					}
					return j;
				};
	
				aLayout.splice(0, aLayout.length);
	
				/* We know how many rows there are in the layout - so prep it */
				for (i = 0, iLen = nTrs.length; i < iLen; i++) {
					aLayout.push([]);
				}
	
				/* Calculate a layout array */
				for (i = 0, iLen = nTrs.length; i < iLen; i++) {
					nTr = nTrs[i];
					iColumn = 0;
	
					/* For every cell in the row... */
					nCell = nTr.firstChild;
					while (nCell) {
						if (nCell.nodeName.toUpperCase() == "TD" || nCell.nodeName.toUpperCase() == "TH") {
							/* Get the col and rowspan attributes from the DOM and sanitise them */
							iColspan = nCell.getAttribute('colspan') * 1;
							iRowspan = nCell.getAttribute('rowspan') * 1;
							iColspan = !iColspan || iColspan === 0 || iColspan === 1 ? 1 : iColspan;
							iRowspan = !iRowspan || iRowspan === 0 || iRowspan === 1 ? 1 : iRowspan;
	
							/* There might be colspan cells already in this row, so shift our target
	       * accordingly
	       */
							iColShifted = fnShiftCol(aLayout, i, iColumn);
	
							/* Cache calculation for unique columns */
							bUnique = iColspan === 1 ? true : false;
	
							/* If there is col / rowspan, copy the information into the layout grid */
							for (l = 0; l < iColspan; l++) {
								for (k = 0; k < iRowspan; k++) {
									aLayout[i + k][iColShifted + l] = {
										"cell": nCell,
										"unique": bUnique
									};
									aLayout[i + k].nTr = nTr;
								}
							}
						}
						nCell = nCell.nextSibling;
					}
				}
			}
	
			/**
	   * Get an array of unique th elements, one for each column
	   *  @param {object} oSettings dataTables settings object
	   *  @param {node} nHeader automatically detect the layout from this node - optional
	   *  @param {array} aLayout thead/tfoot layout from _fnDetectHeader - optional
	   *  @returns array {node} aReturn list of unique th's
	   *  @memberof DataTable#oApi
	   */
			function _fnGetUniqueThs(oSettings, nHeader, aLayout) {
				var aReturn = [];
				if (!aLayout) {
					aLayout = oSettings.aoHeader;
					if (nHeader) {
						aLayout = [];
						_fnDetectHeader(aLayout, nHeader);
					}
				}
	
				for (var i = 0, iLen = aLayout.length; i < iLen; i++) {
					for (var j = 0, jLen = aLayout[i].length; j < jLen; j++) {
						if (aLayout[i][j].unique && (!aReturn[j] || !oSettings.bSortCellsTop)) {
							aReturn[j] = aLayout[i][j].cell;
						}
					}
				}
	
				return aReturn;
			}
	
			/**
	   * Create an Ajax call based on the table's settings, taking into account that
	   * parameters can have multiple forms, and backwards compatibility.
	   *
	   * @param {object} oSettings dataTables settings object
	   * @param {array} data Data to send to the server, required by
	   *     DataTables - may be augmented by developer callbacks
	   * @param {function} fn Callback function to run when data is obtained
	   */
			function _fnBuildAjax(oSettings, data, fn) {
				// Compatibility with 1.9-, allow fnServerData and event to manipulate
				_fnCallbackFire(oSettings, 'aoServerParams', 'serverParams', [data]);
	
				// Convert to object based for 1.10+ if using the old array scheme which can
				// come from server-side processing or serverParams
				if (data && $.isArray(data)) {
					var tmp = {};
					var rbracket = /(.*?)\[\]$/;
	
					$.each(data, function (key, val) {
						var match = val.name.match(rbracket);
	
						if (match) {
							// Support for arrays
							var name = match[0];
	
							if (!tmp[name]) {
								tmp[name] = [];
							}
							tmp[name].push(val.value);
						} else {
							tmp[val.name] = val.value;
						}
					});
					data = tmp;
				}
	
				var ajaxData;
				var ajax = oSettings.ajax;
				var instance = oSettings.oInstance;
	
				if ($.isPlainObject(ajax) && ajax.data) {
					ajaxData = ajax.data;
	
					var newData = $.isFunction(ajaxData) ? ajaxData(data) : // fn can manipulate data or return an object
					ajaxData; // object or array to merge
	
					// If the function returned an object, use that alone
					data = $.isFunction(ajaxData) && newData ? newData : $.extend(true, data, newData);
	
					// Remove the data property as we've resolved it already and don't want
					// jQuery to do it again (it is restored at the end of the function)
					delete ajax.data;
				}
	
				var baseAjax = {
					"data": data,
					"success": function success(json) {
						var error = json.error || json.sError;
						if (error) {
							oSettings.oApi._fnLog(oSettings, 0, error);
						}
	
						oSettings.json = json;
						_fnCallbackFire(oSettings, null, 'xhr', [oSettings, json]);
						fn(json);
					},
					"dataType": "json",
					"cache": false,
					"type": oSettings.sServerMethod,
					"error": function error(xhr, _error, thrown) {
						var log = oSettings.oApi._fnLog;
	
						if (_error == "parsererror") {
							log(oSettings, 0, 'Invalid JSON response', 1);
						} else if (xhr.readyState === 4) {
							log(oSettings, 0, 'Ajax error', 7);
						}
	
						_fnProcessingDisplay(oSettings, false);
					}
				};
	
				// Store the data submitted for the API
				oSettings.oAjaxData = data;
	
				// Allow plug-ins and external processes to modify the data
				_fnCallbackFire(oSettings, null, 'preXhr', [oSettings, data]);
	
				if (oSettings.fnServerData) {
					// DataTables 1.9- compatibility
					oSettings.fnServerData.call(instance, oSettings.sAjaxSource, $.map(data, function (val, key) {
						// Need to convert back to 1.9 trad format
						return { name: key, value: val };
					}), fn, oSettings);
				} else if (oSettings.sAjaxSource || typeof ajax === 'string') {
					// DataTables 1.9- compatibility
					oSettings.jqXHR = $.ajax($.extend(baseAjax, {
						url: ajax || oSettings.sAjaxSource
					}));
				} else if ($.isFunction(ajax)) {
					// Is a function - let the caller define what needs to be done
					oSettings.jqXHR = ajax.call(instance, data, fn, oSettings);
				} else {
					// Object to extend the base settings
					oSettings.jqXHR = $.ajax($.extend(baseAjax, ajax));
	
					// Restore for next time around
					ajax.data = ajaxData;
				}
			}
	
			/**
	   * Update the table using an Ajax call
	   *  @param {object} settings dataTables settings object
	   *  @returns {boolean} Block the table drawing or not
	   *  @memberof DataTable#oApi
	   */
			function _fnAjaxUpdate(settings) {
				if (settings.bAjaxDataGet) {
					settings.iDraw++;
					_fnProcessingDisplay(settings, true);
	
					_fnBuildAjax(settings, _fnAjaxParameters(settings), function (json) {
						_fnAjaxUpdateDraw(settings, json);
					});
	
					return false;
				}
				return true;
			}
	
			/**
	   * Build up the parameters in an object needed for a server-side processing
	   * request. Note that this is basically done twice, is different ways - a modern
	   * method which is used by default in DataTables 1.10 which uses objects and
	   * arrays, or the 1.9- method with is name / value pairs. 1.9 method is used if
	   * the sAjaxSource option is used in the initialisation, or the legacyAjax
	   * option is set.
	   *  @param {object} oSettings dataTables settings object
	   *  @returns {bool} block the table drawing or not
	   *  @memberof DataTable#oApi
	   */
			function _fnAjaxParameters(settings) {
				var columns = settings.aoColumns,
				    columnCount = columns.length,
				    features = settings.oFeatures,
				    preSearch = settings.oPreviousSearch,
				    preColSearch = settings.aoPreSearchCols,
				    i,
				    data = [],
				    dataProp,
				    column,
				    columnSearch,
				    sort = _fnSortFlatten(settings),
				    displayStart = settings._iDisplayStart,
				    displayLength = features.bPaginate !== false ? settings._iDisplayLength : -1;
	
				var param = function param(name, value) {
					data.push({ 'name': name, 'value': value });
				};
	
				// DataTables 1.9- compatible method
				param('sEcho', settings.iDraw);
				param('iColumns', columnCount);
				param('sColumns', _pluck(columns, 'sName').join(','));
				param('iDisplayStart', displayStart);
				param('iDisplayLength', displayLength);
	
				// DataTables 1.10+ method
				var d = {
					draw: settings.iDraw,
					columns: [],
					order: [],
					start: displayStart,
					length: displayLength,
					search: {
						value: preSearch.sSearch,
						regex: preSearch.bRegex
					}
				};
	
				for (i = 0; i < columnCount; i++) {
					column = columns[i];
					columnSearch = preColSearch[i];
					dataProp = typeof column.mData == "function" ? 'function' : column.mData;
	
					d.columns.push({
						data: dataProp,
						name: column.sName,
						searchable: column.bSearchable,
						orderable: column.bSortable,
						search: {
							value: columnSearch.sSearch,
							regex: columnSearch.bRegex
						}
					});
	
					param("mDataProp_" + i, dataProp);
	
					if (features.bFilter) {
						param('sSearch_' + i, columnSearch.sSearch);
						param('bRegex_' + i, columnSearch.bRegex);
						param('bSearchable_' + i, column.bSearchable);
					}
	
					if (features.bSort) {
						param('bSortable_' + i, column.bSortable);
					}
				}
	
				if (features.bFilter) {
					param('sSearch', preSearch.sSearch);
					param('bRegex', preSearch.bRegex);
				}
	
				if (features.bSort) {
					$.each(sort, function (i, val) {
						d.order.push({ column: val.col, dir: val.dir });
	
						param('iSortCol_' + i, val.col);
						param('sSortDir_' + i, val.dir);
					});
	
					param('iSortingCols', sort.length);
				}
	
				// If the legacy.ajax parameter is null, then we automatically decide which
				// form to use, based on sAjaxSource
				var legacy = _DataTable.ext.legacy.ajax;
				if (legacy === null) {
					return settings.sAjaxSource ? data : d;
				}
	
				// Otherwise, if legacy has been specified then we use that to decide on the
				// form
				return legacy ? data : d;
			}
	
			/**
	   * Data the data from the server (nuking the old) and redraw the table
	   *  @param {object} oSettings dataTables settings object
	   *  @param {object} json json data return from the server.
	   *  @param {string} json.sEcho Tracking flag for DataTables to match requests
	   *  @param {int} json.iTotalRecords Number of records in the data set, not accounting for filtering
	   *  @param {int} json.iTotalDisplayRecords Number of records in the data set, accounting for filtering
	   *  @param {array} json.aaData The data to display on this page
	   *  @param {string} [json.sColumns] Column ordering (sName, comma separated)
	   *  @memberof DataTable#oApi
	   */
			function _fnAjaxUpdateDraw(settings, json) {
				// v1.10 uses camelCase variables, while 1.9 uses Hungarian notation.
				// Support both
				var compat = function compat(old, modern) {
					return json[old] !== undefined ? json[old] : json[modern];
				};
	
				var draw = compat('sEcho', 'draw');
				var recordsTotal = compat('iTotalRecords', 'recordsTotal');
				var recordsFiltered = compat('iTotalDisplayRecords', 'recordsFiltered');
	
				if (draw) {
					// Protect against out of sequence returns
					if (draw * 1 < settings.iDraw) {
						return;
					}
					settings.iDraw = draw * 1;
				}
	
				_fnClearTable(settings);
				settings._iRecordsTotal = parseInt(recordsTotal, 10);
				settings._iRecordsDisplay = parseInt(recordsFiltered, 10);
	
				var data = _fnAjaxDataSrc(settings, json);
				for (var i = 0, ien = data.length; i < ien; i++) {
					_fnAddData(settings, data[i]);
				}
				settings.aiDisplay = settings.aiDisplayMaster.slice();
	
				settings.bAjaxDataGet = false;
				_fnDraw(settings);
	
				if (!settings._bInitComplete) {
					_fnInitComplete(settings, json);
				}
	
				settings.bAjaxDataGet = true;
				_fnProcessingDisplay(settings, false);
			}
	
			/**
	   * Get the data from the JSON data source to use for drawing a table. Using
	   * `_fnGetObjectDataFn` allows the data to be sourced from a property of the
	   * source object, or from a processing function.
	   *  @param {object} oSettings dataTables settings object
	   *  @param  {object} json Data source object / array from the server
	   *  @return {array} Array of data to use
	   */
			function _fnAjaxDataSrc(oSettings, json) {
				var dataSrc = $.isPlainObject(oSettings.ajax) && oSettings.ajax.dataSrc !== undefined ? oSettings.ajax.dataSrc : oSettings.sAjaxDataProp; // Compatibility with 1.9-.
	
				// Compatibility with 1.9-. In order to read from aaData, check if the
				// default has been changed, if not, check for aaData
				if (dataSrc === 'data') {
					return json.aaData || json[dataSrc];
				}
	
				return dataSrc !== "" ? _fnGetObjectDataFn(dataSrc)(json) : json;
			}
	
			/**
	   * Generate the node required for filtering text
	   *  @returns {node} Filter control element
	   *  @param {object} oSettings dataTables settings object
	   *  @memberof DataTable#oApi
	   */
			function _fnFeatureHtmlFilter(settings) {
				var classes = settings.oClasses;
				var tableId = settings.sTableId;
				var language = settings.oLanguage;
				var previousSearch = settings.oPreviousSearch;
				var features = settings.aanFeatures;
				var input = '<input type="search" class="' + classes.sFilterInput + '"/>';
	
				var str = language.sSearch;
				str = str.match(/_INPUT_/) ? str.replace('_INPUT_', input) : str + input;
	
				var filter = $('<div/>', {
					'id': !features.f ? tableId + '_filter' : null,
					'class': classes.sFilter
				}).append($('<label/>').append(str));
	
				var searchFn = function searchFn() {
					/* Update all other filter input elements for the new display */
					var n = features.f;
					var val = !this.value ? "" : this.value; // mental IE8 fix :-(
	
					/* Now do the filter */
					if (val != previousSearch.sSearch) {
						_fnFilterComplete(settings, {
							"sSearch": val,
							"bRegex": previousSearch.bRegex,
							"bSmart": previousSearch.bSmart,
							"bCaseInsensitive": previousSearch.bCaseInsensitive
						});
	
						// Need to redraw, without resorting
						settings._iDisplayStart = 0;
						_fnDraw(settings);
					}
				};
	
				var searchDelay = settings.searchDelay !== null ? settings.searchDelay : _fnDataSource(settings) === 'ssp' ? 400 : 0;
	
				var jqFilter = $('input', filter).val(previousSearch.sSearch).attr('placeholder', language.sSearchPlaceholder).bind('keyup.DT search.DT input.DT paste.DT cut.DT', searchDelay ? _fnThrottle(searchFn, searchDelay) : searchFn).bind('keypress.DT', function (e) {
					/* Prevent form submission */
					if (e.keyCode == 13) {
						return false;
					}
				}).attr('aria-controls', tableId);
	
				// Update the input elements whenever the table is filtered
				$(settings.nTable).on('search.dt.DT', function (ev, s) {
					if (settings === s) {
						// IE9 throws an 'unknown error' if document.activeElement is used
						// inside an iframe or frame...
						try {
							if (jqFilter[0] !== document.activeElement) {
								jqFilter.val(previousSearch.sSearch);
							}
						} catch (e) {}
					}
				});
	
				return filter[0];
			}
	
			/**
	   * Filter the table using both the global filter and column based filtering
	   *  @param {object} oSettings dataTables settings object
	   *  @param {object} oSearch search information
	   *  @param {int} [iForce] force a research of the master array (1) or not (undefined or 0)
	   *  @memberof DataTable#oApi
	   */
			function _fnFilterComplete(oSettings, oInput, iForce) {
				var oPrevSearch = oSettings.oPreviousSearch;
				var aoPrevSearch = oSettings.aoPreSearchCols;
				var fnSaveFilter = function fnSaveFilter(oFilter) {
					/* Save the filtering values */
					oPrevSearch.sSearch = oFilter.sSearch;
					oPrevSearch.bRegex = oFilter.bRegex;
					oPrevSearch.bSmart = oFilter.bSmart;
					oPrevSearch.bCaseInsensitive = oFilter.bCaseInsensitive;
				};
				var fnRegex = function fnRegex(o) {
					// Backwards compatibility with the bEscapeRegex option
					return o.bEscapeRegex !== undefined ? !o.bEscapeRegex : o.bRegex;
				};
	
				// Resolve any column types that are unknown due to addition or invalidation
				// @todo As per sort - can this be moved into an event handler?
				_fnColumnTypes(oSettings);
	
				/* In server-side processing all filtering is done by the server, so no point hanging around here */
				if (_fnDataSource(oSettings) != 'ssp') {
					/* Global filter */
					_fnFilter(oSettings, oInput.sSearch, iForce, fnRegex(oInput), oInput.bSmart, oInput.bCaseInsensitive);
					fnSaveFilter(oInput);
	
					/* Now do the individual column filter */
					for (var i = 0; i < aoPrevSearch.length; i++) {
						_fnFilterColumn(oSettings, aoPrevSearch[i].sSearch, i, fnRegex(aoPrevSearch[i]), aoPrevSearch[i].bSmart, aoPrevSearch[i].bCaseInsensitive);
					}
	
					/* Custom filtering */
					_fnFilterCustom(oSettings);
				} else {
					fnSaveFilter(oInput);
				}
	
				/* Tell the draw function we have been filtering */
				oSettings.bFiltered = true;
				_fnCallbackFire(oSettings, null, 'search', [oSettings]);
			}
	
			/**
	   * Apply custom filtering functions
	   *  @param {object} oSettings dataTables settings object
	   *  @memberof DataTable#oApi
	   */
			function _fnFilterCustom(settings) {
				var filters = _DataTable.ext.search;
				var displayRows = settings.aiDisplay;
				var row, rowIdx;
	
				for (var i = 0, ien = filters.length; i < ien; i++) {
					var rows = [];
	
					// Loop over each row and see if it should be included
					for (var j = 0, jen = displayRows.length; j < jen; j++) {
						rowIdx = displayRows[j];
						row = settings.aoData[rowIdx];
	
						if (filters[i](settings, row._aFilterData, rowIdx, row._aData, j)) {
							rows.push(rowIdx);
						}
					}
	
					// So the array reference doesn't break set the results into the
					// existing array
					displayRows.length = 0;
					displayRows.push.apply(displayRows, rows);
				}
			}
	
			/**
	   * Filter the table on a per-column basis
	   *  @param {object} oSettings dataTables settings object
	   *  @param {string} sInput string to filter on
	   *  @param {int} iColumn column to filter
	   *  @param {bool} bRegex treat search string as a regular expression or not
	   *  @param {bool} bSmart use smart filtering or not
	   *  @param {bool} bCaseInsensitive Do case insenstive matching or not
	   *  @memberof DataTable#oApi
	   */
			function _fnFilterColumn(settings, searchStr, colIdx, regex, smart, caseInsensitive) {
				if (searchStr === '') {
					return;
				}
	
				var data;
				var display = settings.aiDisplay;
				var rpSearch = _fnFilterCreateSearch(searchStr, regex, smart, caseInsensitive);
	
				for (var i = display.length - 1; i >= 0; i--) {
					data = settings.aoData[display[i]]._aFilterData[colIdx];
	
					if (!rpSearch.test(data)) {
						display.splice(i, 1);
					}
				}
			}
	
			/**
	   * Filter the data table based on user input and draw the table
	   *  @param {object} settings dataTables settings object
	   *  @param {string} input string to filter on
	   *  @param {int} force optional - force a research of the master array (1) or not (undefined or 0)
	   *  @param {bool} regex treat as a regular expression or not
	   *  @param {bool} smart perform smart filtering or not
	   *  @param {bool} caseInsensitive Do case insenstive matching or not
	   *  @memberof DataTable#oApi
	   */
			function _fnFilter(settings, input, force, regex, smart, caseInsensitive) {
				var rpSearch = _fnFilterCreateSearch(input, regex, smart, caseInsensitive);
				var prevSearch = settings.oPreviousSearch.sSearch;
				var displayMaster = settings.aiDisplayMaster;
				var display, invalidated, i;
	
				// Need to take account of custom filtering functions - always filter
				if (_DataTable.ext.search.length !== 0) {
					force = true;
				}
	
				// Check if any of the rows were invalidated
				invalidated = _fnFilterData(settings);
	
				// If the input is blank - we just want the full data set
				if (input.length <= 0) {
					settings.aiDisplay = displayMaster.slice();
				} else {
					// New search - start from the master array
					if (invalidated || force || prevSearch.length > input.length || input.indexOf(prevSearch) !== 0 || settings.bSorted // On resort, the display master needs to be
					// re-filtered since indexes will have changed
					) {
							settings.aiDisplay = displayMaster.slice();
						}
	
					// Search the display array
					display = settings.aiDisplay;
	
					for (i = display.length - 1; i >= 0; i--) {
						if (!rpSearch.test(settings.aoData[display[i]]._sFilterRow)) {
							display.splice(i, 1);
						}
					}
				}
			}
	
			/**
	   * Build a regular expression object suitable for searching a table
	   *  @param {string} sSearch string to search for
	   *  @param {bool} bRegex treat as a regular expression or not
	   *  @param {bool} bSmart perform smart filtering or not
	   *  @param {bool} bCaseInsensitive Do case insensitive matching or not
	   *  @returns {RegExp} constructed object
	   *  @memberof DataTable#oApi
	   */
			function _fnFilterCreateSearch(search, regex, smart, caseInsensitive) {
				search = regex ? search : _fnEscapeRegex(search);
	
				if (smart) {
					/* For smart filtering we want to allow the search to work regardless of
	     * word order. We also want double quoted text to be preserved, so word
	     * order is important - a la google. So this is what we want to
	     * generate:
	     * 
	     * ^(?=.*?\bone\b)(?=.*?\btwo three\b)(?=.*?\bfour\b).*$
	     */
					var a = $.map(search.match(/"[^"]+"|[^ ]+/g) || '', function (word) {
						if (word.charAt(0) === '"') {
							var m = word.match(/^"(.*)"$/);
							word = m ? m[1] : word;
						}
	
						return word.replace('"', '');
					});
	
					search = '^(?=.*?' + a.join(')(?=.*?') + ').*$';
				}
	
				return new RegExp(search, caseInsensitive ? 'i' : '');
			}
	
			/**
	   * Escape a string such that it can be used in a regular expression
	   *  @param {string} sVal string to escape
	   *  @returns {string} escaped string
	   *  @memberof DataTable#oApi
	   */
			function _fnEscapeRegex(sVal) {
				return sVal.replace(_re_escape_regex, '\\$1');
			}
	
			var __filter_div = $('<div>')[0];
			var __filter_div_textContent = __filter_div.textContent !== undefined;
	
			// Update the filtering data for each row if needed (by invalidation or first run)
			function _fnFilterData(settings) {
				var columns = settings.aoColumns;
				var column;
				var i, j, ien, jen, filterData, cellData, row;
				var fomatters = _DataTable.ext.type.search;
				var wasInvalidated = false;
	
				for (i = 0, ien = settings.aoData.length; i < ien; i++) {
					row = settings.aoData[i];
	
					if (!row._aFilterData) {
						filterData = [];
	
						for (j = 0, jen = columns.length; j < jen; j++) {
							column = columns[j];
	
							if (column.bSearchable) {
								cellData = _fnGetCellData(settings, i, j, 'filter');
	
								if (fomatters[column.sType]) {
									cellData = fomatters[column.sType](cellData);
								}
	
								// Search in DataTables 1.10 is string based. In 1.11 this
								// should be altered to also allow strict type checking.
								if (cellData === null) {
									cellData = '';
								}
	
								if (typeof cellData !== 'string' && cellData.toString) {
									cellData = cellData.toString();
								}
							} else {
								cellData = '';
							}
	
							// If it looks like there is an HTML entity in the string,
							// attempt to decode it so sorting works as expected. Note that
							// we could use a single line of jQuery to do this, but the DOM
							// method used here is much faster http://jsperf.com/html-decode
							if (cellData.indexOf && cellData.indexOf('&') !== -1) {
								__filter_div.innerHTML = cellData;
								cellData = __filter_div_textContent ? __filter_div.textContent : __filter_div.innerText;
							}
	
							if (cellData.replace) {
								cellData = cellData.replace(/[\r\n]/g, '');
							}
	
							filterData.push(cellData);
						}
	
						row._aFilterData = filterData;
						row._sFilterRow = filterData.join('  ');
						wasInvalidated = true;
					}
				}
	
				return wasInvalidated;
			}
	
			/**
	   * Convert from the internal Hungarian notation to camelCase for external
	   * interaction
	   *  @param {object} obj Object to convert
	   *  @returns {object} Inverted object
	   *  @memberof DataTable#oApi
	   */
			function _fnSearchToCamel(obj) {
				return {
					search: obj.sSearch,
					smart: obj.bSmart,
					regex: obj.bRegex,
					caseInsensitive: obj.bCaseInsensitive
				};
			}
	
			/**
	   * Convert from camelCase notation to the internal Hungarian. We could use the
	   * Hungarian convert function here, but this is cleaner
	   *  @param {object} obj Object to convert
	   *  @returns {object} Inverted object
	   *  @memberof DataTable#oApi
	   */
			function _fnSearchToHung(obj) {
				return {
					sSearch: obj.search,
					bSmart: obj.smart,
					bRegex: obj.regex,
					bCaseInsensitive: obj.caseInsensitive
				};
			}
	
			/**
	   * Generate the node required for the info display
	   *  @param {object} oSettings dataTables settings object
	   *  @returns {node} Information element
	   *  @memberof DataTable#oApi
	   */
			function _fnFeatureHtmlInfo(settings) {
				var tid = settings.sTableId,
				    nodes = settings.aanFeatures.i,
				    n = $('<div/>', {
					'class': settings.oClasses.sInfo,
					'id': !nodes ? tid + '_info' : null
				});
	
				if (!nodes) {
					// Update display on each draw
					settings.aoDrawCallback.push({
						"fn": _fnUpdateInfo,
						"sName": "information"
					});
	
					n.attr('role', 'status').attr('aria-live', 'polite');
	
					// Table is described by our info div
					$(settings.nTable).attr('aria-describedby', tid + '_info');
				}
	
				return n[0];
			}
	
			/**
	   * Update the information elements in the display
	   *  @param {object} settings dataTables settings object
	   *  @memberof DataTable#oApi
	   */
			function _fnUpdateInfo(settings) {
				/* Show information about the table */
				var nodes = settings.aanFeatures.i;
				if (nodes.length === 0) {
					return;
				}
	
				var lang = settings.oLanguage,
				    start = settings._iDisplayStart + 1,
				    end = settings.fnDisplayEnd(),
				    max = settings.fnRecordsTotal(),
				    total = settings.fnRecordsDisplay(),
				    out = total ? lang.sInfo : lang.sInfoEmpty;
	
				if (total !== max) {
					/* Record set after filtering */
					out += ' ' + lang.sInfoFiltered;
				}
	
				// Convert the macros
				out += lang.sInfoPostFix;
				out = _fnInfoMacros(settings, out);
	
				var callback = lang.fnInfoCallback;
				if (callback !== null) {
					out = callback.call(settings.oInstance, settings, start, end, max, total, out);
				}
	
				$(nodes).html(out);
			}
	
			function _fnInfoMacros(settings, str) {
				// When infinite scrolling, we are always starting at 1. _iDisplayStart is used only
				// internally
				var formatter = settings.fnFormatNumber,
				    start = settings._iDisplayStart + 1,
				    len = settings._iDisplayLength,
				    vis = settings.fnRecordsDisplay(),
				    all = len === -1;
	
				return str.replace(/_START_/g, formatter.call(settings, start)).replace(/_END_/g, formatter.call(settings, settings.fnDisplayEnd())).replace(/_MAX_/g, formatter.call(settings, settings.fnRecordsTotal())).replace(/_TOTAL_/g, formatter.call(settings, vis)).replace(/_PAGE_/g, formatter.call(settings, all ? 1 : Math.ceil(start / len))).replace(/_PAGES_/g, formatter.call(settings, all ? 1 : Math.ceil(vis / len)));
			}
	
			/**
	   * Draw the table for the first time, adding all required features
	   *  @param {object} settings dataTables settings object
	   *  @memberof DataTable#oApi
	   */
			function _fnInitialise(settings) {
				var i,
				    iLen,
				    iAjaxStart = settings.iInitDisplayStart;
				var columns = settings.aoColumns,
				    column;
				var features = settings.oFeatures;
	
				/* Ensure that the table data is fully initialised */
				if (!settings.bInitialised) {
					setTimeout(function () {
						_fnInitialise(settings);
					}, 200);
					return;
				}
	
				/* Show the display HTML options */
				_fnAddOptionsHtml(settings);
	
				/* Build and draw the header / footer for the table */
				_fnBuildHead(settings);
				_fnDrawHead(settings, settings.aoHeader);
				_fnDrawHead(settings, settings.aoFooter);
	
				/* Okay to show that something is going on now */
				_fnProcessingDisplay(settings, true);
	
				/* Calculate sizes for columns */
				if (features.bAutoWidth) {
					_fnCalculateColumnWidths(settings);
				}
	
				for (i = 0, iLen = columns.length; i < iLen; i++) {
					column = columns[i];
	
					if (column.sWidth) {
						column.nTh.style.width = _fnStringToCss(column.sWidth);
					}
				}
	
				// If there is default sorting required - let's do it. The sort function
				// will do the drawing for us. Otherwise we draw the table regardless of the
				// Ajax source - this allows the table to look initialised for Ajax sourcing
				// data (show 'loading' message possibly)
				_fnReDraw(settings);
	
				// Server-side processing init complete is done by _fnAjaxUpdateDraw
				var dataSrc = _fnDataSource(settings);
				if (dataSrc != 'ssp') {
					// if there is an ajax source load the data
					if (dataSrc == 'ajax') {
						_fnBuildAjax(settings, [], function (json) {
							var aData = _fnAjaxDataSrc(settings, json);
	
							// Got the data - add it to the table
							for (i = 0; i < aData.length; i++) {
								_fnAddData(settings, aData[i]);
							}
	
							// Reset the init display for cookie saving. We've already done
							// a filter, and therefore cleared it before. So we need to make
							// it appear 'fresh'
							settings.iInitDisplayStart = iAjaxStart;
	
							_fnReDraw(settings);
	
							_fnProcessingDisplay(settings, false);
							_fnInitComplete(settings, json);
						}, settings);
					} else {
						_fnProcessingDisplay(settings, false);
						_fnInitComplete(settings);
					}
				}
			}
	
			/**
	   * Draw the table for the first time, adding all required features
	   *  @param {object} oSettings dataTables settings object
	   *  @param {object} [json] JSON from the server that completed the table, if using Ajax source
	   *    with client-side processing (optional)
	   *  @memberof DataTable#oApi
	   */
			function _fnInitComplete(settings, json) {
				settings._bInitComplete = true;
	
				// On an Ajax load we now have data and therefore want to apply the column
				// sizing
				if (json) {
					_fnAdjustColumnSizing(settings);
				}
	
				_fnCallbackFire(settings, 'aoInitComplete', 'init', [settings, json]);
			}
	
			function _fnLengthChange(settings, val) {
				var len = parseInt(val, 10);
				settings._iDisplayLength = len;
	
				_fnLengthOverflow(settings);
	
				// Fire length change event
				_fnCallbackFire(settings, null, 'length', [settings, len]);
			}
	
			/**
	   * Generate the node required for user display length changing
	   *  @param {object} settings dataTables settings object
	   *  @returns {node} Display length feature node
	   *  @memberof DataTable#oApi
	   */
			function _fnFeatureHtmlLength(settings) {
				var classes = settings.oClasses,
				    tableId = settings.sTableId,
				    menu = settings.aLengthMenu,
				    d2 = $.isArray(menu[0]),
				    lengths = d2 ? menu[0] : menu,
				    language = d2 ? menu[1] : menu;
	
				var select = $('<select/>', {
					'name': tableId + '_length',
					'aria-controls': tableId,
					'class': classes.sLengthSelect
				});
	
				for (var i = 0, ien = lengths.length; i < ien; i++) {
					select[0][i] = new Option(language[i], lengths[i]);
				}
	
				var div = $('<div><label/></div>').addClass(classes.sLength);
				if (!settings.aanFeatures.l) {
					div[0].id = tableId + '_length';
				}
	
				div.children().append(settings.oLanguage.sLengthMenu.replace('_MENU_', select[0].outerHTML));
	
				// Can't use `select` variable as user might provide their own and the
				// reference is broken by the use of outerHTML
				$('select', div).val(settings._iDisplayLength).bind('change.DT', function (e) {
					_fnLengthChange(settings, $(this).val());
					_fnDraw(settings);
				});
	
				// Update node value whenever anything changes the table's length
				$(settings.nTable).bind('length.dt.DT', function (e, s, len) {
					if (settings === s) {
						$('select', div).val(len);
					}
				});
	
				return div[0];
			}
	
			/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	   * Note that most of the paging logic is done in
	   * DataTable.ext.pager
	   */
	
			/**
	   * Generate the node required for default pagination
	   *  @param {object} oSettings dataTables settings object
	   *  @returns {node} Pagination feature node
	   *  @memberof DataTable#oApi
	   */
			function _fnFeatureHtmlPaginate(settings) {
				var type = settings.sPaginationType,
				    plugin = _DataTable.ext.pager[type],
				    modern = typeof plugin === 'function',
				    redraw = function redraw(settings) {
					_fnDraw(settings);
				},
				    node = $('<div/>').addClass(settings.oClasses.sPaging + type)[0],
				    features = settings.aanFeatures;
	
				if (!modern) {
					plugin.fnInit(settings, node, redraw);
				}
	
				/* Add a draw callback for the pagination on first instance, to update the paging display */
				if (!features.p) {
					node.id = settings.sTableId + '_paginate';
	
					settings.aoDrawCallback.push({
						"fn": function fn(settings) {
							if (modern) {
								var start = settings._iDisplayStart,
								    len = settings._iDisplayLength,
								    visRecords = settings.fnRecordsDisplay(),
								    all = len === -1,
								    page = all ? 0 : Math.ceil(start / len),
								    pages = all ? 1 : Math.ceil(visRecords / len),
								    buttons = plugin(page, pages),
								    i,
								    ien;
	
								for (i = 0, ien = features.p.length; i < ien; i++) {
									_fnRenderer(settings, 'pageButton')(settings, features.p[i], i, buttons, page, pages);
								}
							} else {
								plugin.fnUpdate(settings, redraw);
							}
						},
						"sName": "pagination"
					});
				}
	
				return node;
			}
	
			/**
	   * Alter the display settings to change the page
	   *  @param {object} settings DataTables settings object
	   *  @param {string|int} action Paging action to take: "first", "previous",
	   *    "next" or "last" or page number to jump to (integer)
	   *  @param [bool] redraw Automatically draw the update or not
	   *  @returns {bool} true page has changed, false - no change
	   *  @memberof DataTable#oApi
	   */
			function _fnPageChange(settings, action, redraw) {
				var start = settings._iDisplayStart,
				    len = settings._iDisplayLength,
				    records = settings.fnRecordsDisplay();
	
				if (records === 0 || len === -1) {
					start = 0;
				} else if (typeof action === "number") {
					start = action * len;
	
					if (start > records) {
						start = 0;
					}
				} else if (action == "first") {
					start = 0;
				} else if (action == "previous") {
					start = len >= 0 ? start - len : 0;
	
					if (start < 0) {
						start = 0;
					}
				} else if (action == "next") {
					if (start + len < records) {
						start += len;
					}
				} else if (action == "last") {
					start = Math.floor((records - 1) / len) * len;
				} else {
					_fnLog(settings, 0, "Unknown paging action: " + action, 5);
				}
	
				var changed = settings._iDisplayStart !== start;
				settings._iDisplayStart = start;
	
				if (changed) {
					_fnCallbackFire(settings, null, 'page', [settings]);
	
					if (redraw) {
						_fnDraw(settings);
					}
				}
	
				return changed;
			}
	
			/**
	   * Generate the node required for the processing node
	   *  @param {object} settings dataTables settings object
	   *  @returns {node} Processing element
	   *  @memberof DataTable#oApi
	   */
			function _fnFeatureHtmlProcessing(settings) {
				return $('<div/>', {
					'id': !settings.aanFeatures.r ? settings.sTableId + '_processing' : null,
					'class': settings.oClasses.sProcessing
				}).html(settings.oLanguage.sProcessing).insertBefore(settings.nTable)[0];
			}
	
			/**
	   * Display or hide the processing indicator
	   *  @param {object} settings dataTables settings object
	   *  @param {bool} show Show the processing indicator (true) or not (false)
	   *  @memberof DataTable#oApi
	   */
			function _fnProcessingDisplay(settings, show) {
				if (settings.oFeatures.bProcessing) {
					$(settings.aanFeatures.r).css('display', show ? 'block' : 'none');
				}
	
				_fnCallbackFire(settings, null, 'processing', [settings, show]);
			}
	
			/**
	   * Add any control elements for the table - specifically scrolling
	   *  @param {object} settings dataTables settings object
	   *  @returns {node} Node to add to the DOM
	   *  @memberof DataTable#oApi
	   */
			function _fnFeatureHtmlTable(settings) {
				var table = $(settings.nTable);
	
				// Add the ARIA grid role to the table
				table.attr('role', 'grid');
	
				// Scrolling from here on in
				var scroll = settings.oScroll;
	
				if (scroll.sX === '' && scroll.sY === '') {
					return settings.nTable;
				}
	
				var scrollX = scroll.sX;
				var scrollY = scroll.sY;
				var classes = settings.oClasses;
				var caption = table.children('caption');
				var captionSide = caption.length ? caption[0]._captionSide : null;
				var headerClone = $(table[0].cloneNode(false));
				var footerClone = $(table[0].cloneNode(false));
				var footer = table.children('tfoot');
				var _div = '<div/>';
				var size = function size(s) {
					return !s ? null : _fnStringToCss(s);
				};
	
				// This is fairly messy, but with x scrolling enabled, if the table has a
				// width attribute, regardless of any width applied using the column width
				// options, the browser will shrink or grow the table as needed to fit into
				// that 100%. That would make the width options useless. So we remove it.
				// This is okay, under the assumption that width:100% is applied to the
				// table in CSS (it is in the default stylesheet) which will set the table
				// width as appropriate (the attribute and css behave differently...)
				if (scroll.sX && table.attr('width') === '100%') {
					table.removeAttr('width');
				}
	
				if (!footer.length) {
					footer = null;
				}
	
				/*
	    * The HTML structure that we want to generate in this function is:
	    *  div - scroller
	    *    div - scroll head
	    *      div - scroll head inner
	    *        table - scroll head table
	    *          thead - thead
	    *    div - scroll body
	    *      table - table (master table)
	    *        thead - thead clone for sizing
	    *        tbody - tbody
	    *    div - scroll foot
	    *      div - scroll foot inner
	    *        table - scroll foot table
	    *          tfoot - tfoot
	    */
				var scroller = $(_div, { 'class': classes.sScrollWrapper }).append($(_div, { 'class': classes.sScrollHead }).css({
					overflow: 'hidden',
					position: 'relative',
					border: 0,
					width: scrollX ? size(scrollX) : '100%'
				}).append($(_div, { 'class': classes.sScrollHeadInner }).css({
					'box-sizing': 'content-box',
					width: scroll.sXInner || '100%'
				}).append(headerClone.removeAttr('id').css('margin-left', 0).append(captionSide === 'top' ? caption : null).append(table.children('thead'))))).append($(_div, { 'class': classes.sScrollBody }).css({
					overflow: 'auto',
					height: size(scrollY),
					width: size(scrollX)
				}).append(table));
	
				if (footer) {
					scroller.append($(_div, { 'class': classes.sScrollFoot }).css({
						overflow: 'hidden',
						border: 0,
						width: scrollX ? size(scrollX) : '100%'
					}).append($(_div, { 'class': classes.sScrollFootInner }).append(footerClone.removeAttr('id').css('margin-left', 0).append(captionSide === 'bottom' ? caption : null).append(table.children('tfoot')))));
				}
	
				var children = scroller.children();
				var scrollHead = children[0];
				var scrollBody = children[1];
				var scrollFoot = footer ? children[2] : null;
	
				// When the body is scrolled, then we also want to scroll the headers
				if (scrollX) {
					$(scrollBody).scroll(function (e) {
						var scrollLeft = this.scrollLeft;
	
						scrollHead.scrollLeft = scrollLeft;
	
						if (footer) {
							scrollFoot.scrollLeft = scrollLeft;
						}
					});
				}
	
				settings.nScrollHead = scrollHead;
				settings.nScrollBody = scrollBody;
				settings.nScrollFoot = scrollFoot;
	
				// On redraw - align columns
				settings.aoDrawCallback.push({
					"fn": _fnScrollDraw,
					"sName": "scrolling"
				});
	
				return scroller[0];
			}
	
			/**
	   * Update the header, footer and body tables for resizing - i.e. column
	   * alignment.
	   *
	   * Welcome to the most horrible function DataTables. The process that this
	   * function follows is basically:
	   *   1. Re-create the table inside the scrolling div
	   *   2. Take live measurements from the DOM
	   *   3. Apply the measurements to align the columns
	   *   4. Clean up
	   *
	   *  @param {object} settings dataTables settings object
	   *  @memberof DataTable#oApi
	   */
			function _fnScrollDraw(settings) {
				// Given that this is such a monster function, a lot of variables are use
				// to try and keep the minimised size as small as possible
				var scroll = settings.oScroll,
				    scrollX = scroll.sX,
				    scrollXInner = scroll.sXInner,
				    scrollY = scroll.sY,
				    barWidth = scroll.iBarWidth,
				    divHeader = $(settings.nScrollHead),
				    divHeaderStyle = divHeader[0].style,
				    divHeaderInner = divHeader.children('div'),
				    divHeaderInnerStyle = divHeaderInner[0].style,
				    divHeaderTable = divHeaderInner.children('table'),
				    divBodyEl = settings.nScrollBody,
				    divBody = $(divBodyEl),
				    divBodyStyle = divBodyEl.style,
				    divFooter = $(settings.nScrollFoot),
				    divFooterInner = divFooter.children('div'),
				    divFooterTable = divFooterInner.children('table'),
				    header = $(settings.nTHead),
				    table = $(settings.nTable),
				    tableEl = table[0],
				    tableStyle = tableEl.style,
				    footer = settings.nTFoot ? $(settings.nTFoot) : null,
				    browser = settings.oBrowser,
				    ie67 = browser.bScrollOversize,
				    headerTrgEls,
				    footerTrgEls,
				    headerSrcEls,
				    footerSrcEls,
				    headerCopy,
				    footerCopy,
				    headerWidths = [],
				    footerWidths = [],
				    headerContent = [],
				    idx,
				    correction,
				    sanityWidth,
				    zeroOut = function zeroOut(nSizer) {
					var style = nSizer.style;
					style.paddingTop = "0";
					style.paddingBottom = "0";
					style.borderTopWidth = "0";
					style.borderBottomWidth = "0";
					style.height = 0;
				};
	
				/*
	    * 1. Re-create the table inside the scrolling div
	    */
	
				// Remove the old minimised thead and tfoot elements in the inner table
				table.children('thead, tfoot').remove();
	
				// Clone the current header and footer elements and then place it into the inner table
				headerCopy = header.clone().prependTo(table);
				headerTrgEls = header.find('tr'); // original header is in its own table
				headerSrcEls = headerCopy.find('tr');
				headerCopy.find('th, td').removeAttr('tabindex');
	
				if (footer) {
					footerCopy = footer.clone().prependTo(table);
					footerTrgEls = footer.find('tr'); // the original tfoot is in its own table and must be sized
					footerSrcEls = footerCopy.find('tr');
				}
	
				/*
	    * 2. Take live measurements from the DOM - do not alter the DOM itself!
	    */
	
				// Remove old sizing and apply the calculated column widths
				// Get the unique column headers in the newly created (cloned) header. We want to apply the
				// calculated sizes to this header
				if (!scrollX) {
					divBodyStyle.width = '100%';
					divHeader[0].style.width = '100%';
				}
	
				$.each(_fnGetUniqueThs(settings, headerCopy), function (i, el) {
					idx = _fnVisibleToColumnIndex(settings, i);
					el.style.width = settings.aoColumns[idx].sWidth;
				});
	
				if (footer) {
					_fnApplyToChildren(function (n) {
						n.style.width = "";
					}, footerSrcEls);
				}
	
				// If scroll collapse is enabled, when we put the headers back into the body for sizing, we
				// will end up forcing the scrollbar to appear, making our measurements wrong for when we
				// then hide it (end of this function), so add the header height to the body scroller.
				if (scroll.bCollapse && scrollY !== "") {
					divBodyStyle.height = divBody[0].offsetHeight + header[0].offsetHeight + "px";
				}
	
				// Size the table as a whole
				sanityWidth = table.outerWidth();
				if (scrollX === "") {
					// No x scrolling
					tableStyle.width = "100%";
	
					// IE7 will make the width of the table when 100% include the scrollbar
					// - which is shouldn't. When there is a scrollbar we need to take this
					// into account.
					if (ie67 && (table.find('tbody').height() > divBodyEl.offsetHeight || divBody.css('overflow-y') == "scroll")) {
						tableStyle.width = _fnStringToCss(table.outerWidth() - barWidth);
					}
				} else {
					// x scrolling
					if (scrollXInner !== "") {
						// x scroll inner has been given - use it
						tableStyle.width = _fnStringToCss(scrollXInner);
					} else if (sanityWidth == divBody.width() && divBody.height() < table.height()) {
						// There is y-scrolling - try to take account of the y scroll bar
						tableStyle.width = _fnStringToCss(sanityWidth - barWidth);
						if (table.outerWidth() > sanityWidth - barWidth) {
							// Not possible to take account of it
							tableStyle.width = _fnStringToCss(sanityWidth);
						}
					} else {
						// When all else fails
						tableStyle.width = _fnStringToCss(sanityWidth);
					}
				}
	
				// Recalculate the sanity width - now that we've applied the required width,
				// before it was a temporary variable. This is required because the column
				// width calculation is done before this table DOM is created.
				sanityWidth = table.outerWidth();
	
				// Hidden header should have zero height, so remove padding and borders. Then
				// set the width based on the real headers
	
				// Apply all styles in one pass
				_fnApplyToChildren(zeroOut, headerSrcEls);
	
				// Read all widths in next pass
				_fnApplyToChildren(function (nSizer) {
					headerContent.push(nSizer.innerHTML);
					headerWidths.push(_fnStringToCss($(nSizer).css('width')));
				}, headerSrcEls);
	
				// Apply all widths in final pass
				_fnApplyToChildren(function (nToSize, i) {
					nToSize.style.width = headerWidths[i];
				}, headerTrgEls);
	
				$(headerSrcEls).height(0);
	
				/* Same again with the footer if we have one */
				if (footer) {
					_fnApplyToChildren(zeroOut, footerSrcEls);
	
					_fnApplyToChildren(function (nSizer) {
						footerWidths.push(_fnStringToCss($(nSizer).css('width')));
					}, footerSrcEls);
	
					_fnApplyToChildren(function (nToSize, i) {
						nToSize.style.width = footerWidths[i];
					}, footerTrgEls);
	
					$(footerSrcEls).height(0);
				}
	
				/*
	    * 3. Apply the measurements
	    */
	
				// "Hide" the header and footer that we used for the sizing. We need to keep
				// the content of the cell so that the width applied to the header and body
				// both match, but we want to hide it completely. We want to also fix their
				// width to what they currently are
				_fnApplyToChildren(function (nSizer, i) {
					nSizer.innerHTML = '<div class="dataTables_sizing" style="height:0;overflow:hidden;">' + headerContent[i] + '</div>';
					nSizer.style.width = headerWidths[i];
				}, headerSrcEls);
	
				if (footer) {
					_fnApplyToChildren(function (nSizer, i) {
						nSizer.innerHTML = "";
						nSizer.style.width = footerWidths[i];
					}, footerSrcEls);
				}
	
				// Sanity check that the table is of a sensible width. If not then we are going to get
				// misalignment - try to prevent this by not allowing the table to shrink below its min width
				if (table.outerWidth() < sanityWidth) {
					// The min width depends upon if we have a vertical scrollbar visible or not */
					correction = divBodyEl.scrollHeight > divBodyEl.offsetHeight || divBody.css('overflow-y') == "scroll" ? sanityWidth + barWidth : sanityWidth;
	
					// IE6/7 are a law unto themselves...
					if (ie67 && (divBodyEl.scrollHeight > divBodyEl.offsetHeight || divBody.css('overflow-y') == "scroll")) {
						tableStyle.width = _fnStringToCss(correction - barWidth);
					}
	
					// And give the user a warning that we've stopped the table getting too small
					if (scrollX === "" || scrollXInner !== "") {
						_fnLog(settings, 1, 'Possible column misalignment', 6);
					}
				} else {
					correction = '100%';
				}
	
				// Apply to the container elements
				divBodyStyle.width = _fnStringToCss(correction);
				divHeaderStyle.width = _fnStringToCss(correction);
	
				if (footer) {
					settings.nScrollFoot.style.width = _fnStringToCss(correction);
				}
	
				/*
	    * 4. Clean up
	    */
				if (!scrollY) {
					/* IE7< puts a vertical scrollbar in place (when it shouldn't be) due to subtracting
	     * the scrollbar height from the visible display, rather than adding it on. We need to
	     * set the height in order to sort this. Don't want to do it in any other browsers.
	     */
					if (ie67) {
						divBodyStyle.height = _fnStringToCss(tableEl.offsetHeight + barWidth);
					}
				}
	
				if (scrollY && scroll.bCollapse) {
					divBodyStyle.height = _fnStringToCss(scrollY);
	
					var iExtra = scrollX && tableEl.offsetWidth > divBodyEl.offsetWidth ? barWidth : 0;
	
					if (tableEl.offsetHeight < divBodyEl.offsetHeight) {
						divBodyStyle.height = _fnStringToCss(tableEl.offsetHeight + iExtra);
					}
				}
	
				/* Finally set the width's of the header and footer tables */
				var iOuterWidth = table.outerWidth();
				divHeaderTable[0].style.width = _fnStringToCss(iOuterWidth);
				divHeaderInnerStyle.width = _fnStringToCss(iOuterWidth);
	
				// Figure out if there are scrollbar present - if so then we need a the header and footer to
				// provide a bit more space to allow "overflow" scrolling (i.e. past the scrollbar)
				var bScrolling = table.height() > divBodyEl.clientHeight || divBody.css('overflow-y') == "scroll";
				var padding = 'padding' + (browser.bScrollbarLeft ? 'Left' : 'Right');
				divHeaderInnerStyle[padding] = bScrolling ? barWidth + "px" : "0px";
	
				if (footer) {
					divFooterTable[0].style.width = _fnStringToCss(iOuterWidth);
					divFooterInner[0].style.width = _fnStringToCss(iOuterWidth);
					divFooterInner[0].style[padding] = bScrolling ? barWidth + "px" : "0px";
				}
	
				/* Adjust the position of the header in case we loose the y-scrollbar */
				divBody.scroll();
	
				// If sorting or filtering has occurred, jump the scrolling back to the top
				// only if we aren't holding the position
				if ((settings.bSorted || settings.bFiltered) && !settings._drawHold) {
					divBodyEl.scrollTop = 0;
				}
			}
	
			/**
	   * Apply a given function to the display child nodes of an element array (typically
	   * TD children of TR rows
	   *  @param {function} fn Method to apply to the objects
	   *  @param array {nodes} an1 List of elements to look through for display children
	   *  @param array {nodes} an2 Another list (identical structure to the first) - optional
	   *  @memberof DataTable#oApi
	   */
			function _fnApplyToChildren(fn, an1, an2) {
				var index = 0,
				    i = 0,
				    iLen = an1.length;
				var nNode1, nNode2;
	
				while (i < iLen) {
					nNode1 = an1[i].firstChild;
					nNode2 = an2 ? an2[i].firstChild : null;
	
					while (nNode1) {
						if (nNode1.nodeType === 1) {
							if (an2) {
								fn(nNode1, nNode2, index);
							} else {
								fn(nNode1, index);
							}
	
							index++;
						}
	
						nNode1 = nNode1.nextSibling;
						nNode2 = an2 ? nNode2.nextSibling : null;
					}
	
					i++;
				}
			}
	
			var __re_html_remove = /<.*?>/g;
	
			/**
	   * Calculate the width of columns for the table
	   *  @param {object} oSettings dataTables settings object
	   *  @memberof DataTable#oApi
	   */
			function _fnCalculateColumnWidths(oSettings) {
				var table = oSettings.nTable,
				    columns = oSettings.aoColumns,
				    scroll = oSettings.oScroll,
				    scrollY = scroll.sY,
				    scrollX = scroll.sX,
				    scrollXInner = scroll.sXInner,
				    columnCount = columns.length,
				    visibleColumns = _fnGetColumns(oSettings, 'bVisible'),
				    headerCells = $('th', oSettings.nTHead),
				    tableWidthAttr = table.getAttribute('width'),
				    tableContainer = table.parentNode,
				    userInputs = false,
				    i,
				    column,
				    columnIdx,
				    width,
				    outerWidth;
	
				/* Convert any user input sizes into pixel sizes */
				for (i = 0; i < visibleColumns.length; i++) {
					column = columns[visibleColumns[i]];
	
					if (column.sWidth !== null) {
						column.sWidth = _fnConvertToWidth(column.sWidthOrig, tableContainer);
	
						userInputs = true;
					}
				}
	
				/* If the number of columns in the DOM equals the number that we have to
	    * process in DataTables, then we can use the offsets that are created by
	    * the web- browser. No custom sizes can be set in order for this to happen,
	    * nor scrolling used
	    */
				if (!userInputs && !scrollX && !scrollY && columnCount == _fnVisbleColumns(oSettings) && columnCount == headerCells.length) {
					for (i = 0; i < columnCount; i++) {
						columns[i].sWidth = _fnStringToCss(headerCells.eq(i).width());
					}
				} else {
					// Otherwise construct a single row table with the widest node in the
					// data, assign any user defined widths, then insert it into the DOM and
					// allow the browser to do all the hard work of calculating table widths
					var tmpTable = $(table).clone() // don't use cloneNode - IE8 will remove events on the main table
					.empty().css('visibility', 'hidden').removeAttr('id').append($(oSettings.nTHead).clone(false)).append($(oSettings.nTFoot).clone(false)).append($('<tbody><tr/></tbody>'));
	
					// Remove any assigned widths from the footer (from scrolling)
					tmpTable.find('tfoot th, tfoot td').css('width', '');
	
					var tr = tmpTable.find('tbody tr');
	
					// Apply custom sizing to the cloned header
					headerCells = _fnGetUniqueThs(oSettings, tmpTable.find('thead')[0]);
	
					for (i = 0; i < visibleColumns.length; i++) {
						column = columns[visibleColumns[i]];
	
						headerCells[i].style.width = column.sWidthOrig !== null && column.sWidthOrig !== '' ? _fnStringToCss(column.sWidthOrig) : '';
					}
	
					// Find the widest cell for each column and put it into the table
					if (oSettings.aoData.length) {
						for (i = 0; i < visibleColumns.length; i++) {
							columnIdx = visibleColumns[i];
							column = columns[columnIdx];
	
							$(_fnGetWidestNode(oSettings, columnIdx)).clone(false).append(column.sContentPadding).appendTo(tr);
						}
					}
	
					// Table has been built, attach to the document so we can work with it
					tmpTable.appendTo(tableContainer);
	
					// When scrolling (X or Y) we want to set the width of the table as 
					// appropriate. However, when not scrolling leave the table width as it
					// is. This results in slightly different, but I think correct behaviour
					if (scrollX && scrollXInner) {
						tmpTable.width(scrollXInner);
					} else if (scrollX) {
						tmpTable.css('width', 'auto');
	
						if (tmpTable.width() < tableContainer.offsetWidth) {
							tmpTable.width(tableContainer.offsetWidth);
						}
					} else if (scrollY) {
						tmpTable.width(tableContainer.offsetWidth);
					} else if (tableWidthAttr) {
						tmpTable.width(tableWidthAttr);
					}
	
					// Take into account the y scrollbar
					_fnScrollingWidthAdjust(oSettings, tmpTable[0]);
	
					// Browsers need a bit of a hand when a width is assigned to any columns
					// when x-scrolling as they tend to collapse the table to the min-width,
					// even if we sent the column widths. So we need to keep track of what
					// the table width should be by summing the user given values, and the
					// automatic values
					if (scrollX) {
						var total = 0;
	
						for (i = 0; i < visibleColumns.length; i++) {
							column = columns[visibleColumns[i]];
							outerWidth = $(headerCells[i]).outerWidth();
	
							total += column.sWidthOrig === null ? outerWidth : parseInt(column.sWidth, 10) + outerWidth - $(headerCells[i]).width();
						}
	
						tmpTable.width(_fnStringToCss(total));
						table.style.width = _fnStringToCss(total);
					}
	
					// Get the width of each column in the constructed table
					for (i = 0; i < visibleColumns.length; i++) {
						column = columns[visibleColumns[i]];
						width = $(headerCells[i]).width();
	
						if (width) {
							column.sWidth = _fnStringToCss(width);
						}
					}
	
					table.style.width = _fnStringToCss(tmpTable.css('width'));
	
					// Finished with the table - ditch it
					tmpTable.remove();
				}
	
				// If there is a width attr, we want to attach an event listener which
				// allows the table sizing to automatically adjust when the window is
				// resized. Use the width attr rather than CSS, since we can't know if the
				// CSS is a relative value or absolute - DOM read is always px.
				if (tableWidthAttr) {
					table.style.width = _fnStringToCss(tableWidthAttr);
				}
	
				if ((tableWidthAttr || scrollX) && !oSettings._reszEvt) {
					$(window).bind('resize.DT-' + oSettings.sInstance, _fnThrottle(function () {
						_fnAdjustColumnSizing(oSettings);
					}));
	
					oSettings._reszEvt = true;
				}
			}
	
			/**
	   * Throttle the calls to a function. Arguments and context are maintained for
	   * the throttled function
	   *  @param {function} fn Function to be called
	   *  @param {int} [freq=200] call frequency in mS
	   *  @returns {function} wrapped function
	   *  @memberof DataTable#oApi
	   */
			function _fnThrottle(fn, freq) {
				var frequency = freq !== undefined ? freq : 200,
				    last,
				    timer;
	
				return function () {
					var that = this,
					    now = +new Date(),
					    args = arguments;
	
					if (last && now < last + frequency) {
						clearTimeout(timer);
	
						timer = setTimeout(function () {
							last = undefined;
							fn.apply(that, args);
						}, frequency);
					} else if (last) {
						last = now;
						fn.apply(that, args);
					} else {
						last = now;
					}
				};
			}
	
			/**
	   * Convert a CSS unit width to pixels (e.g. 2em)
	   *  @param {string} width width to be converted
	   *  @param {node} parent parent to get the with for (required for relative widths) - optional
	   *  @returns {int} width in pixels
	   *  @memberof DataTable#oApi
	   */
			function _fnConvertToWidth(width, parent) {
				if (!width) {
					return 0;
				}
	
				var n = $('<div/>').css('width', _fnStringToCss(width)).appendTo(parent || document.body);
	
				var val = n[0].offsetWidth;
				n.remove();
	
				return val;
			}
	
			/**
	   * Adjust a table's width to take account of vertical scroll bar
	   *  @param {object} oSettings dataTables settings object
	   *  @param {node} n table node
	   *  @memberof DataTable#oApi
	   */
	
			function _fnScrollingWidthAdjust(settings, n) {
				var scroll = settings.oScroll;
	
				if (scroll.sX || scroll.sY) {
					// When y-scrolling only, we want to remove the width of the scroll bar
					// so the table + scroll bar will fit into the area available, otherwise
					// we fix the table at its current size with no adjustment
					var correction = !scroll.sX ? scroll.iBarWidth : 0;
					n.style.width = _fnStringToCss($(n).outerWidth() - correction);
				}
			}
	
			/**
	   * Get the widest node
	   *  @param {object} settings dataTables settings object
	   *  @param {int} colIdx column of interest
	   *  @returns {node} widest table node
	   *  @memberof DataTable#oApi
	   */
			function _fnGetWidestNode(settings, colIdx) {
				var idx = _fnGetMaxLenString(settings, colIdx);
				if (idx < 0) {
					return null;
				}
	
				var data = settings.aoData[idx];
				return !data.nTr ? // Might not have been created when deferred rendering
				$('<td/>').html(_fnGetCellData(settings, idx, colIdx, 'display'))[0] : data.anCells[colIdx];
			}
	
			/**
	   * Get the maximum strlen for each data column
	   *  @param {object} settings dataTables settings object
	   *  @param {int} colIdx column of interest
	   *  @returns {string} max string length for each column
	   *  @memberof DataTable#oApi
	   */
			function _fnGetMaxLenString(settings, colIdx) {
				var s,
				    max = -1,
				    maxIdx = -1;
	
				for (var i = 0, ien = settings.aoData.length; i < ien; i++) {
					s = _fnGetCellData(settings, i, colIdx, 'display') + '';
					s = s.replace(__re_html_remove, '');
	
					if (s.length > max) {
						max = s.length;
						maxIdx = i;
					}
				}
	
				return maxIdx;
			}
	
			/**
	   * Append a CSS unit (only if required) to a string
	   *  @param {string} value to css-ify
	   *  @returns {string} value with css unit
	   *  @memberof DataTable#oApi
	   */
			function _fnStringToCss(s) {
				if (s === null) {
					return '0px';
				}
	
				if (typeof s == 'number') {
					return s < 0 ? '0px' : s + 'px';
				}
	
				// Check it has a unit character already
				return s.match(/\d$/) ? s + 'px' : s;
			}
	
			/**
	   * Get the width of a scroll bar in this browser being used
	   *  @returns {int} width in pixels
	   *  @memberof DataTable#oApi
	   */
			function _fnScrollBarWidth() {
				// On first run a static variable is set, since this is only needed once.
				// Subsequent runs will just use the previously calculated value
				if (!_DataTable.__scrollbarWidth) {
					var inner = $('<p/>').css({
						width: '100%',
						height: 200,
						padding: 0
					})[0];
	
					var outer = $('<div/>').css({
						position: 'absolute',
						top: 0,
						left: 0,
						width: 200,
						height: 150,
						padding: 0,
						overflow: 'hidden',
						visibility: 'hidden'
					}).append(inner).appendTo('body');
	
					var w1 = inner.offsetWidth;
					outer.css('overflow', 'scroll');
					var w2 = inner.offsetWidth;
	
					if (w1 === w2) {
						w2 = outer[0].clientWidth;
					}
	
					outer.remove();
	
					_DataTable.__scrollbarWidth = w1 - w2;
				}
	
				return _DataTable.__scrollbarWidth;
			}
	
			function _fnSortFlatten(settings) {
				var i,
				    iLen,
				    k,
				    kLen,
				    aSort = [],
				    aiOrig = [],
				    aoColumns = settings.aoColumns,
				    aDataSort,
				    iCol,
				    sType,
				    srcCol,
				    fixed = settings.aaSortingFixed,
				    fixedObj = $.isPlainObject(fixed),
				    nestedSort = [],
				    add = function add(a) {
					if (a.length && !$.isArray(a[0])) {
						// 1D array
						nestedSort.push(a);
					} else {
						// 2D array
						nestedSort.push.apply(nestedSort, a);
					}
				};
	
				// Build the sort array, with pre-fix and post-fix options if they have been
				// specified
				if ($.isArray(fixed)) {
					add(fixed);
				}
	
				if (fixedObj && fixed.pre) {
					add(fixed.pre);
				}
	
				add(settings.aaSorting);
	
				if (fixedObj && fixed.post) {
					add(fixed.post);
				}
	
				for (i = 0; i < nestedSort.length; i++) {
					srcCol = nestedSort[i][0];
					aDataSort = aoColumns[srcCol].aDataSort;
	
					for (k = 0, kLen = aDataSort.length; k < kLen; k++) {
						iCol = aDataSort[k];
						sType = aoColumns[iCol].sType || 'string';
	
						if (nestedSort[i]._idx === undefined) {
							nestedSort[i]._idx = $.inArray(nestedSort[i][1], aoColumns[iCol].asSorting);
						}
	
						aSort.push({
							src: srcCol,
							col: iCol,
							dir: nestedSort[i][1],
							index: nestedSort[i]._idx,
							type: sType,
							formatter: _DataTable.ext.type.order[sType + "-pre"]
						});
					}
				}
	
				return aSort;
			}
	
			/**
	   * Change the order of the table
	   *  @param {object} oSettings dataTables settings object
	   *  @memberof DataTable#oApi
	   *  @todo This really needs split up!
	   */
			function _fnSort(oSettings) {
				var i,
				    ien,
				    iLen,
				    j,
				    jLen,
				    k,
				    kLen,
				    sDataType,
				    nTh,
				    aiOrig = [],
				    oExtSort = _DataTable.ext.type.order,
				    aoData = oSettings.aoData,
				    aoColumns = oSettings.aoColumns,
				    aDataSort,
				    data,
				    iCol,
				    sType,
				    oSort,
				    formatters = 0,
				    sortCol,
				    displayMaster = oSettings.aiDisplayMaster,
				    aSort;
	
				// Resolve any column types that are unknown due to addition or invalidation
				// @todo Can this be moved into a 'data-ready' handler which is called when
				//   data is going to be used in the table?
				_fnColumnTypes(oSettings);
	
				aSort = _fnSortFlatten(oSettings);
	
				for (i = 0, ien = aSort.length; i < ien; i++) {
					sortCol = aSort[i];
	
					// Track if we can use the fast sort algorithm
					if (sortCol.formatter) {
						formatters++;
					}
	
					// Load the data needed for the sort, for each cell
					_fnSortData(oSettings, sortCol.col);
				}
	
				/* No sorting required if server-side or no sorting array */
				if (_fnDataSource(oSettings) != 'ssp' && aSort.length !== 0) {
					// Create a value - key array of the current row positions such that we can use their
					// current position during the sort, if values match, in order to perform stable sorting
					for (i = 0, iLen = displayMaster.length; i < iLen; i++) {
						aiOrig[displayMaster[i]] = i;
					}
	
					/* Do the sort - here we want multi-column sorting based on a given data source (column)
	     * and sorting function (from oSort) in a certain direction. It's reasonably complex to
	     * follow on it's own, but this is what we want (example two column sorting):
	     *  fnLocalSorting = function(a,b){
	     *    var iTest;
	     *    iTest = oSort['string-asc']('data11', 'data12');
	     *      if (iTest !== 0)
	     *        return iTest;
	     *    iTest = oSort['numeric-desc']('data21', 'data22');
	     *    if (iTest !== 0)
	     *      return iTest;
	     *    return oSort['numeric-asc']( aiOrig[a], aiOrig[b] );
	     *  }
	     * Basically we have a test for each sorting column, if the data in that column is equal,
	     * test the next column. If all columns match, then we use a numeric sort on the row
	     * positions in the original data array to provide a stable sort.
	     *
	     * Note - I know it seems excessive to have two sorting methods, but the first is around
	     * 15% faster, so the second is only maintained for backwards compatibility with sorting
	     * methods which do not have a pre-sort formatting function.
	     */
					if (formatters === aSort.length) {
						// All sort types have formatting functions
						displayMaster.sort(function (a, b) {
							var x,
							    y,
							    k,
							    test,
							    sort,
							    len = aSort.length,
							    dataA = aoData[a]._aSortData,
							    dataB = aoData[b]._aSortData;
	
							for (k = 0; k < len; k++) {
								sort = aSort[k];
	
								x = dataA[sort.col];
								y = dataB[sort.col];
	
								test = x < y ? -1 : x > y ? 1 : 0;
								if (test !== 0) {
									return sort.dir === 'asc' ? test : -test;
								}
							}
	
							x = aiOrig[a];
							y = aiOrig[b];
							return x < y ? -1 : x > y ? 1 : 0;
						});
					} else {
						// Depreciated - remove in 1.11 (providing a plug-in option)
						// Not all sort types have formatting methods, so we have to call their sorting
						// methods.
						displayMaster.sort(function (a, b) {
							var x,
							    y,
							    k,
							    l,
							    test,
							    sort,
							    fn,
							    len = aSort.length,
							    dataA = aoData[a]._aSortData,
							    dataB = aoData[b]._aSortData;
	
							for (k = 0; k < len; k++) {
								sort = aSort[k];
	
								x = dataA[sort.col];
								y = dataB[sort.col];
	
								fn = oExtSort[sort.type + "-" + sort.dir] || oExtSort["string-" + sort.dir];
								test = fn(x, y);
								if (test !== 0) {
									return test;
								}
							}
	
							x = aiOrig[a];
							y = aiOrig[b];
							return x < y ? -1 : x > y ? 1 : 0;
						});
					}
				}
	
				/* Tell the draw function that we have sorted the data */
				oSettings.bSorted = true;
			}
	
			function _fnSortAria(settings) {
				var label;
				var nextSort;
				var columns = settings.aoColumns;
				var aSort = _fnSortFlatten(settings);
				var oAria = settings.oLanguage.oAria;
	
				// ARIA attributes - need to loop all columns, to update all (removing old
				// attributes as needed)
				for (var i = 0, iLen = columns.length; i < iLen; i++) {
					var col = columns[i];
					var asSorting = col.asSorting;
					var sTitle = col.sTitle.replace(/<.*?>/g, "");
					var th = col.nTh;
	
					// IE7 is throwing an error when setting these properties with jQuery's
					// attr() and removeAttr() methods...
					th.removeAttribute('aria-sort');
	
					/* In ARIA only the first sorting column can be marked as sorting - no multi-sort option */
					if (col.bSortable) {
						if (aSort.length > 0 && aSort[0].col == i) {
							th.setAttribute('aria-sort', aSort[0].dir == "asc" ? "ascending" : "descending");
							nextSort = asSorting[aSort[0].index + 1] || asSorting[0];
						} else {
							nextSort = asSorting[0];
						}
	
						label = sTitle + (nextSort === "asc" ? oAria.sSortAscending : oAria.sSortDescending);
					} else {
						label = sTitle;
					}
	
					th.setAttribute('aria-label', label);
				}
			}
	
			/**
	   * Function to run on user sort request
	   *  @param {object} settings dataTables settings object
	   *  @param {node} attachTo node to attach the handler to
	   *  @param {int} colIdx column sorting index
	   *  @param {boolean} [append=false] Append the requested sort to the existing
	   *    sort if true (i.e. multi-column sort)
	   *  @param {function} [callback] callback function
	   *  @memberof DataTable#oApi
	   */
			function _fnSortListener(settings, colIdx, append, callback) {
				var col = settings.aoColumns[colIdx];
				var sorting = settings.aaSorting;
				var asSorting = col.asSorting;
				var nextSortIdx;
				var next = function next(a, overflow) {
					var idx = a._idx;
					if (idx === undefined) {
						idx = $.inArray(a[1], asSorting);
					}
	
					return idx + 1 < asSorting.length ? idx + 1 : overflow ? null : 0;
				};
	
				// Convert to 2D array if needed
				if (typeof sorting[0] === 'number') {
					sorting = settings.aaSorting = [sorting];
				}
	
				// If appending the sort then we are multi-column sorting
				if (append && settings.oFeatures.bSortMulti) {
					// Are we already doing some kind of sort on this column?
					var sortIdx = $.inArray(colIdx, _pluck(sorting, '0'));
	
					if (sortIdx !== -1) {
						// Yes, modify the sort
						nextSortIdx = next(sorting[sortIdx], true);
	
						if (nextSortIdx === null) {
							sorting.splice(sortIdx, 1);
						} else {
							sorting[sortIdx][1] = asSorting[nextSortIdx];
							sorting[sortIdx]._idx = nextSortIdx;
						}
					} else {
						// No sort on this column yet
						sorting.push([colIdx, asSorting[0], 0]);
						sorting[sorting.length - 1]._idx = 0;
					}
				} else if (sorting.length && sorting[0][0] == colIdx) {
					// Single column - already sorting on this column, modify the sort
					nextSortIdx = next(sorting[0]);
	
					sorting.length = 1;
					sorting[0][1] = asSorting[nextSortIdx];
					sorting[0]._idx = nextSortIdx;
				} else {
					// Single column - sort only on this column
					sorting.length = 0;
					sorting.push([colIdx, asSorting[0]]);
					sorting[0]._idx = 0;
				}
	
				// Run the sort by calling a full redraw
				_fnReDraw(settings);
	
				// callback used for async user interaction
				if (typeof callback == 'function') {
					callback(settings);
				}
			}
	
			/**
	   * Attach a sort handler (click) to a node
	   *  @param {object} settings dataTables settings object
	   *  @param {node} attachTo node to attach the handler to
	   *  @param {int} colIdx column sorting index
	   *  @param {function} [callback] callback function
	   *  @memberof DataTable#oApi
	   */
			function _fnSortAttachListener(settings, attachTo, colIdx, callback) {
				var col = settings.aoColumns[colIdx];
	
				_fnBindAction(attachTo, {}, function (e) {
					/* If the column is not sortable - don't to anything */
					if (col.bSortable === false) {
						return;
					}
	
					// If processing is enabled use a timeout to allow the processing
					// display to be shown - otherwise to it synchronously
					if (settings.oFeatures.bProcessing) {
						_fnProcessingDisplay(settings, true);
	
						setTimeout(function () {
							_fnSortListener(settings, colIdx, e.shiftKey, callback);
	
							// In server-side processing, the draw callback will remove the
							// processing display
							if (_fnDataSource(settings) !== 'ssp') {
								_fnProcessingDisplay(settings, false);
							}
						}, 0);
					} else {
						_fnSortListener(settings, colIdx, e.shiftKey, callback);
					}
				});
			}
	
			/**
	   * Set the sorting classes on table's body, Note: it is safe to call this function
	   * when bSort and bSortClasses are false
	   *  @param {object} oSettings dataTables settings object
	   *  @memberof DataTable#oApi
	   */
			function _fnSortingClasses(settings) {
				var oldSort = settings.aLastSort;
				var sortClass = settings.oClasses.sSortColumn;
				var sort = _fnSortFlatten(settings);
				var features = settings.oFeatures;
				var i, ien, colIdx;
	
				if (features.bSort && features.bSortClasses) {
					// Remove old sorting classes
					for (i = 0, ien = oldSort.length; i < ien; i++) {
						colIdx = oldSort[i].src;
	
						// Remove column sorting
						$(_pluck(settings.aoData, 'anCells', colIdx)).removeClass(sortClass + (i < 2 ? i + 1 : 3));
					}
	
					// Add new column sorting
					for (i = 0, ien = sort.length; i < ien; i++) {
						colIdx = sort[i].src;
	
						$(_pluck(settings.aoData, 'anCells', colIdx)).addClass(sortClass + (i < 2 ? i + 1 : 3));
					}
				}
	
				settings.aLastSort = sort;
			}
	
			// Get the data to sort a column, be it from cache, fresh (populating the
			// cache), or from a sort formatter
			function _fnSortData(settings, idx) {
				// Custom sorting function - provided by the sort data type
				var column = settings.aoColumns[idx];
				var customSort = _DataTable.ext.order[column.sSortDataType];
				var customData;
	
				if (customSort) {
					customData = customSort.call(settings.oInstance, settings, idx, _fnColumnIndexToVisible(settings, idx));
				}
	
				// Use / populate cache
				var row, cellData;
				var formatter = _DataTable.ext.type.order[column.sType + "-pre"];
	
				for (var i = 0, ien = settings.aoData.length; i < ien; i++) {
					row = settings.aoData[i];
	
					if (!row._aSortData) {
						row._aSortData = [];
					}
	
					if (!row._aSortData[idx] || customSort) {
						cellData = customSort ? customData[i] : // If there was a custom sort function, use data from there
						_fnGetCellData(settings, i, idx, 'sort');
	
						row._aSortData[idx] = formatter ? formatter(cellData) : cellData;
					}
				}
			}
	
			/**
	   * Save the state of a table
	   *  @param {object} oSettings dataTables settings object
	   *  @memberof DataTable#oApi
	   */
			function _fnSaveState(settings) {
				if (!settings.oFeatures.bStateSave || settings.bDestroying) {
					return;
				}
	
				/* Store the interesting variables */
				var state = {
					time: +new Date(),
					start: settings._iDisplayStart,
					length: settings._iDisplayLength,
					order: $.extend(true, [], settings.aaSorting),
					search: _fnSearchToCamel(settings.oPreviousSearch),
					columns: $.map(settings.aoColumns, function (col, i) {
						return {
							visible: col.bVisible,
							search: _fnSearchToCamel(settings.aoPreSearchCols[i])
						};
					})
				};
	
				_fnCallbackFire(settings, "aoStateSaveParams", 'stateSaveParams', [settings, state]);
	
				settings.oSavedState = state;
				settings.fnStateSaveCallback.call(settings.oInstance, settings, state);
			}
	
			/**
	   * Attempt to load a saved table state
	   *  @param {object} oSettings dataTables settings object
	   *  @param {object} oInit DataTables init object so we can override settings
	   *  @memberof DataTable#oApi
	   */
			function _fnLoadState(settings, oInit) {
				var i, ien;
				var columns = settings.aoColumns;
	
				if (!settings.oFeatures.bStateSave) {
					return;
				}
	
				var state = settings.fnStateLoadCallback.call(settings.oInstance, settings);
				if (!state || !state.time) {
					return;
				}
	
				/* Allow custom and plug-in manipulation functions to alter the saved data set and
	    * cancelling of loading by returning false
	    */
				var abStateLoad = _fnCallbackFire(settings, 'aoStateLoadParams', 'stateLoadParams', [settings, state]);
				if ($.inArray(false, abStateLoad) !== -1) {
					return;
				}
	
				/* Reject old data */
				var duration = settings.iStateDuration;
				if (duration > 0 && state.time < +new Date() - duration * 1000) {
					return;
				}
	
				// Number of columns have changed - all bets are off, no restore of settings
				if (columns.length !== state.columns.length) {
					return;
				}
	
				// Store the saved state so it might be accessed at any time
				settings.oLoadedState = $.extend(true, {}, state);
	
				// Restore key features - todo - for 1.11 this needs to be done by
				// subscribed events
				settings._iDisplayStart = state.start;
				settings.iInitDisplayStart = state.start;
				settings._iDisplayLength = state.length;
				settings.aaSorting = [];
	
				// Order
				$.each(state.order, function (i, col) {
					settings.aaSorting.push(col[0] >= columns.length ? [0, col[1]] : col);
				});
	
				// Search
				$.extend(settings.oPreviousSearch, _fnSearchToHung(state.search));
	
				// Columns
				for (i = 0, ien = state.columns.length; i < ien; i++) {
					var col = state.columns[i];
	
					// Visibility
					columns[i].bVisible = col.visible;
	
					// Search
					$.extend(settings.aoPreSearchCols[i], _fnSearchToHung(col.search));
				}
	
				_fnCallbackFire(settings, 'aoStateLoaded', 'stateLoaded', [settings, state]);
			}
	
			/**
	   * Return the settings object for a particular table
	   *  @param {node} table table we are using as a dataTable
	   *  @returns {object} Settings object - or null if not found
	   *  @memberof DataTable#oApi
	   */
			function _fnSettingsFromNode(table) {
				var settings = _DataTable.settings;
				var idx = $.inArray(table, _pluck(settings, 'nTable'));
	
				return idx !== -1 ? settings[idx] : null;
			}
	
			/**
	   * Log an error message
	   *  @param {object} settings dataTables settings object
	   *  @param {int} level log error messages, or display them to the user
	   *  @param {string} msg error message
	   *  @param {int} tn Technical note id to get more information about the error.
	   *  @memberof DataTable#oApi
	   */
			function _fnLog(settings, level, msg, tn) {
				msg = 'DataTables warning: ' + (settings !== null ? 'table id=' + settings.sTableId + ' - ' : '') + msg;
	
				if (tn) {
					msg += '. For more information about this error, please see ' + 'http://datatables.net/tn/' + tn;
				}
	
				if (!level) {
					// Backwards compatibility pre 1.10
					var ext = _DataTable.ext;
					var type = ext.sErrMode || ext.errMode;
	
					if (type == 'alert') {
						alert(msg);
					} else {
						throw new Error(msg);
					}
				} else if (window.console && console.log) {
					console.log(msg);
				}
			}
	
			/**
	   * See if a property is defined on one object, if so assign it to the other object
	   *  @param {object} ret target object
	   *  @param {object} src source object
	   *  @param {string} name property
	   *  @param {string} [mappedName] name to map too - optional, name used if not given
	   *  @memberof DataTable#oApi
	   */
			function _fnMap(ret, src, name, mappedName) {
				if ($.isArray(name)) {
					$.each(name, function (i, val) {
						if ($.isArray(val)) {
							_fnMap(ret, src, val[0], val[1]);
						} else {
							_fnMap(ret, src, val);
						}
					});
	
					return;
				}
	
				if (mappedName === undefined) {
					mappedName = name;
				}
	
				if (src[name] !== undefined) {
					ret[mappedName] = src[name];
				}
			}
	
			/**
	   * Extend objects - very similar to jQuery.extend, but deep copy objects, and
	   * shallow copy arrays. The reason we need to do this, is that we don't want to
	   * deep copy array init values (such as aaSorting) since the dev wouldn't be
	   * able to override them, but we do want to deep copy arrays.
	   *  @param {object} out Object to extend
	   *  @param {object} extender Object from which the properties will be applied to
	   *      out
	   *  @param {boolean} breakRefs If true, then arrays will be sliced to take an
	   *      independent copy with the exception of the `data` or `aaData` parameters
	   *      if they are present. This is so you can pass in a collection to
	   *      DataTables and have that used as your data source without breaking the
	   *      references
	   *  @returns {object} out Reference, just for convenience - out === the return.
	   *  @memberof DataTable#oApi
	   *  @todo This doesn't take account of arrays inside the deep copied objects.
	   */
			function _fnExtend(out, extender, breakRefs) {
				var val;
	
				for (var prop in extender) {
					if (extender.hasOwnProperty(prop)) {
						val = extender[prop];
	
						if ($.isPlainObject(val)) {
							if (!$.isPlainObject(out[prop])) {
								out[prop] = {};
							}
							$.extend(true, out[prop], val);
						} else if (breakRefs && prop !== 'data' && prop !== 'aaData' && $.isArray(val)) {
							out[prop] = val.slice();
						} else {
							out[prop] = val;
						}
					}
				}
	
				return out;
			}
	
			/**
	   * Bind an event handers to allow a click or return key to activate the callback.
	   * This is good for accessibility since a return on the keyboard will have the
	   * same effect as a click, if the element has focus.
	   *  @param {element} n Element to bind the action to
	   *  @param {object} oData Data object to pass to the triggered function
	   *  @param {function} fn Callback function for when the event is triggered
	   *  @memberof DataTable#oApi
	   */
			function _fnBindAction(n, oData, fn) {
				$(n).bind('click.DT', oData, function (e) {
					n.blur(); // Remove focus outline for mouse users
					fn(e);
				}).bind('keypress.DT', oData, function (e) {
					if (e.which === 13) {
						e.preventDefault();
						fn(e);
					}
				}).bind('selectstart.DT', function () {
					/* Take the brutal approach to cancelling text selection */
					return false;
				});
			}
	
			/**
	   * Register a callback function. Easily allows a callback function to be added to
	   * an array store of callback functions that can then all be called together.
	   *  @param {object} oSettings dataTables settings object
	   *  @param {string} sStore Name of the array storage for the callbacks in oSettings
	   *  @param {function} fn Function to be called back
	   *  @param {string} sName Identifying name for the callback (i.e. a label)
	   *  @memberof DataTable#oApi
	   */
			function _fnCallbackReg(oSettings, sStore, fn, sName) {
				if (fn) {
					oSettings[sStore].push({
						"fn": fn,
						"sName": sName
					});
				}
			}
	
			/**
	   * Fire callback functions and trigger events. Note that the loop over the
	   * callback array store is done backwards! Further note that you do not want to
	   * fire off triggers in time sensitive applications (for example cell creation)
	   * as its slow.
	   *  @param {object} settings dataTables settings object
	   *  @param {string} callbackArr Name of the array storage for the callbacks in
	   *      oSettings
	   *  @param {string} event Name of the jQuery custom event to trigger. If null no
	   *      trigger is fired
	   *  @param {array} args Array of arguments to pass to the callback function /
	   *      trigger
	   *  @memberof DataTable#oApi
	   */
			function _fnCallbackFire(settings, callbackArr, e, args) {
				var ret = [];
	
				if (callbackArr) {
					ret = $.map(settings[callbackArr].slice().reverse(), function (val, i) {
						return val.fn.apply(settings.oInstance, args);
					});
				}
	
				if (e !== null) {
					$(settings.nTable).trigger(e + '.dt', args);
				}
	
				return ret;
			}
	
			function _fnLengthOverflow(settings) {
				var start = settings._iDisplayStart,
				    end = settings.fnDisplayEnd(),
				    len = settings._iDisplayLength;
	
				/* If we have space to show extra rows (backing up from the end point - then do so */
				if (start >= end) {
					start = end - len;
				}
	
				// Keep the start record on the current page
				start -= start % len;
	
				if (len === -1 || start < 0) {
					start = 0;
				}
	
				settings._iDisplayStart = start;
			}
	
			function _fnRenderer(settings, type) {
				var renderer = settings.renderer;
				var host = _DataTable.ext.renderer[type];
	
				if ($.isPlainObject(renderer) && renderer[type]) {
					// Specific renderer for this type. If available use it, otherwise use
					// the default.
					return host[renderer[type]] || host._;
				} else if (typeof renderer === 'string') {
					// Common renderer - if there is one available for this type use it,
					// otherwise use the default
					return host[renderer] || host._;
				}
	
				// Use the default
				return host._;
			}
	
			/**
	   * Detect the data source being used for the table. Used to simplify the code
	   * a little (ajax) and to make it compress a little smaller.
	   *
	   *  @param {object} settings dataTables settings object
	   *  @returns {string} Data source
	   *  @memberof DataTable#oApi
	   */
			function _fnDataSource(settings) {
				if (settings.oFeatures.bServerSide) {
					return 'ssp';
				} else if (settings.ajax || settings.sAjaxSource) {
					return 'ajax';
				}
				return 'dom';
			}
	
			_DataTable = function DataTable(options) {
				/**
	    * Perform a jQuery selector action on the table's TR elements (from the tbody) and
	    * return the resulting jQuery object.
	    *  @param {string|node|jQuery} sSelector jQuery selector or node collection to act on
	    *  @param {object} [oOpts] Optional parameters for modifying the rows to be included
	    *  @param {string} [oOpts.filter=none] Select TR elements that meet the current filter
	    *    criterion ("applied") or all TR elements (i.e. no filter).
	    *  @param {string} [oOpts.order=current] Order of the TR elements in the processed array.
	    *    Can be either 'current', whereby the current sorting of the table is used, or
	    *    'original' whereby the original order the data was read into the table is used.
	    *  @param {string} [oOpts.page=all] Limit the selection to the currently displayed page
	    *    ("current") or not ("all"). If 'current' is given, then order is assumed to be
	    *    'current' and filter is 'applied', regardless of what they might be given as.
	    *  @returns {object} jQuery object, filtered by the given selector.
	    *  @dtopt API
	    *  @deprecated Since v1.10
	    *
	    *  @example
	    *    $(document).ready(function() {
	    *      var oTable = $('#example').dataTable();
	    *
	    *      // Highlight every second row
	    *      oTable.$('tr:odd').css('backgroundColor', 'blue');
	    *    } );
	    *
	    *  @example
	    *    $(document).ready(function() {
	    *      var oTable = $('#example').dataTable();
	    *
	    *      // Filter to rows with 'Webkit' in them, add a background colour and then
	    *      // remove the filter, thus highlighting the 'Webkit' rows only.
	    *      oTable.fnFilter('Webkit');
	    *      oTable.$('tr', {"search": "applied"}).css('backgroundColor', 'blue');
	    *      oTable.fnFilter('');
	    *    } );
	    */
				this.$ = function (sSelector, oOpts) {
					return this.api(true).$(sSelector, oOpts);
				};
	
				/**
	    * Almost identical to $ in operation, but in this case returns the data for the matched
	    * rows - as such, the jQuery selector used should match TR row nodes or TD/TH cell nodes
	    * rather than any descendants, so the data can be obtained for the row/cell. If matching
	    * rows are found, the data returned is the original data array/object that was used to
	    * create the row (or a generated array if from a DOM source).
	    *
	    * This method is often useful in-combination with $ where both functions are given the
	    * same parameters and the array indexes will match identically.
	    *  @param {string|node|jQuery} sSelector jQuery selector or node collection to act on
	    *  @param {object} [oOpts] Optional parameters for modifying the rows to be included
	    *  @param {string} [oOpts.filter=none] Select elements that meet the current filter
	    *    criterion ("applied") or all elements (i.e. no filter).
	    *  @param {string} [oOpts.order=current] Order of the data in the processed array.
	    *    Can be either 'current', whereby the current sorting of the table is used, or
	    *    'original' whereby the original order the data was read into the table is used.
	    *  @param {string} [oOpts.page=all] Limit the selection to the currently displayed page
	    *    ("current") or not ("all"). If 'current' is given, then order is assumed to be
	    *    'current' and filter is 'applied', regardless of what they might be given as.
	    *  @returns {array} Data for the matched elements. If any elements, as a result of the
	    *    selector, were not TR, TD or TH elements in the DataTable, they will have a null
	    *    entry in the array.
	    *  @dtopt API
	    *  @deprecated Since v1.10
	    *
	    *  @example
	    *    $(document).ready(function() {
	    *      var oTable = $('#example').dataTable();
	    *
	    *      // Get the data from the first row in the table
	    *      var data = oTable._('tr:first');
	    *
	    *      // Do something useful with the data
	    *      alert( "First cell is: "+data[0] );
	    *    } );
	    *
	    *  @example
	    *    $(document).ready(function() {
	    *      var oTable = $('#example').dataTable();
	    *
	    *      // Filter to 'Webkit' and get all data for
	    *      oTable.fnFilter('Webkit');
	    *      var data = oTable._('tr', {"search": "applied"});
	    *
	    *      // Do something with the data
	    *      alert( data.length+" rows matched the search" );
	    *    } );
	    */
				this._ = function (sSelector, oOpts) {
					return this.api(true).rows(sSelector, oOpts).data();
				};
	
				/**
	    * Create a DataTables Api instance, with the currently selected tables for
	    * the Api's context.
	    * @param {boolean} [traditional=false] Set the API instance's context to be
	    *   only the table referred to by the `DataTable.ext.iApiIndex` option, as was
	    *   used in the API presented by DataTables 1.9- (i.e. the traditional mode),
	    *   or if all tables captured in the jQuery object should be used.
	    * @return {DataTables.Api}
	    */
				this.api = function (traditional) {
					return traditional ? new _Api2(_fnSettingsFromNode(this[_ext.iApiIndex])) : new _Api2(this);
				};
	
				/**
	    * Add a single new row or multiple rows of data to the table. Please note
	    * that this is suitable for client-side processing only - if you are using
	    * server-side processing (i.e. "bServerSide": true), then to add data, you
	    * must add it to the data source, i.e. the server-side, through an Ajax call.
	    *  @param {array|object} data The data to be added to the table. This can be:
	    *    <ul>
	    *      <li>1D array of data - add a single row with the data provided</li>
	    *      <li>2D array of arrays - add multiple rows in a single call</li>
	    *      <li>object - data object when using <i>mData</i></li>
	    *      <li>array of objects - multiple data objects when using <i>mData</i></li>
	    *    </ul>
	    *  @param {bool} [redraw=true] redraw the table or not
	    *  @returns {array} An array of integers, representing the list of indexes in
	    *    <i>aoData</i> ({@link DataTable.models.oSettings}) that have been added to
	    *    the table.
	    *  @dtopt API
	    *  @deprecated Since v1.10
	    *
	    *  @example
	    *    // Global var for counter
	    *    var giCount = 2;
	    *
	    *    $(document).ready(function() {
	    *      $('#example').dataTable();
	    *    } );
	    *
	    *    function fnClickAddRow() {
	    *      $('#example').dataTable().fnAddData( [
	    *        giCount+".1",
	    *        giCount+".2",
	    *        giCount+".3",
	    *        giCount+".4" ]
	    *      );
	    *
	    *      giCount++;
	    *    }
	    */
				this.fnAddData = function (data, redraw) {
					var api = this.api(true);
	
					/* Check if we want to add multiple rows or not */
					var rows = $.isArray(data) && ($.isArray(data[0]) || $.isPlainObject(data[0])) ? api.rows.add(data) : api.row.add(data);
	
					if (redraw === undefined || redraw) {
						api.draw();
					}
	
					return rows.flatten().toArray();
				};
	
				/**
	    * This function will make DataTables recalculate the column sizes, based on the data
	    * contained in the table and the sizes applied to the columns (in the DOM, CSS or
	    * through the sWidth parameter). This can be useful when the width of the table's
	    * parent element changes (for example a window resize).
	    *  @param {boolean} [bRedraw=true] Redraw the table or not, you will typically want to
	    *  @dtopt API
	    *  @deprecated Since v1.10
	    *
	    *  @example
	    *    $(document).ready(function() {
	    *      var oTable = $('#example').dataTable( {
	    *        "sScrollY": "200px",
	    *        "bPaginate": false
	    *      } );
	    *
	    *      $(window).bind('resize', function () {
	    *        oTable.fnAdjustColumnSizing();
	    *      } );
	    *    } );
	    */
				this.fnAdjustColumnSizing = function (bRedraw) {
					var api = this.api(true).columns.adjust();
					var settings = api.settings()[0];
					var scroll = settings.oScroll;
	
					if (bRedraw === undefined || bRedraw) {
						api.draw(false);
					} else if (scroll.sX !== "" || scroll.sY !== "") {
						/* If not redrawing, but scrolling, we want to apply the new column sizes anyway */
						_fnScrollDraw(settings);
					}
				};
	
				/**
	    * Quickly and simply clear a table
	    *  @param {bool} [bRedraw=true] redraw the table or not
	    *  @dtopt API
	    *  @deprecated Since v1.10
	    *
	    *  @example
	    *    $(document).ready(function() {
	    *      var oTable = $('#example').dataTable();
	    *
	    *      // Immediately 'nuke' the current rows (perhaps waiting for an Ajax callback...)
	    *      oTable.fnClearTable();
	    *    } );
	    */
				this.fnClearTable = function (bRedraw) {
					var api = this.api(true).clear();
	
					if (bRedraw === undefined || bRedraw) {
						api.draw();
					}
				};
	
				/**
	    * The exact opposite of 'opening' a row, this function will close any rows which
	    * are currently 'open'.
	    *  @param {node} nTr the table row to 'close'
	    *  @returns {int} 0 on success, or 1 if failed (can't find the row)
	    *  @dtopt API
	    *  @deprecated Since v1.10
	    *
	    *  @example
	    *    $(document).ready(function() {
	    *      var oTable;
	    *
	    *      // 'open' an information row when a row is clicked on
	    *      $('#example tbody tr').click( function () {
	    *        if ( oTable.fnIsOpen(this) ) {
	    *          oTable.fnClose( this );
	    *        } else {
	    *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
	    *        }
	    *      } );
	    *
	    *      oTable = $('#example').dataTable();
	    *    } );
	    */
				this.fnClose = function (nTr) {
					this.api(true).row(nTr).child.hide();
				};
	
				/**
	    * Remove a row for the table
	    *  @param {mixed} target The index of the row from aoData to be deleted, or
	    *    the TR element you want to delete
	    *  @param {function|null} [callBack] Callback function
	    *  @param {bool} [redraw=true] Redraw the table or not
	    *  @returns {array} The row that was deleted
	    *  @dtopt API
	    *  @deprecated Since v1.10
	    *
	    *  @example
	    *    $(document).ready(function() {
	    *      var oTable = $('#example').dataTable();
	    *
	    *      // Immediately remove the first row
	    *      oTable.fnDeleteRow( 0 );
	    *    } );
	    */
				this.fnDeleteRow = function (target, callback, redraw) {
					var api = this.api(true);
					var rows = api.rows(target);
					var settings = rows.settings()[0];
					var data = settings.aoData[rows[0][0]];
	
					rows.remove();
	
					if (callback) {
						callback.call(this, settings, data);
					}
	
					if (redraw === undefined || redraw) {
						api.draw();
					}
	
					return data;
				};
	
				/**
	    * Restore the table to it's original state in the DOM by removing all of DataTables
	    * enhancements, alterations to the DOM structure of the table and event listeners.
	    *  @param {boolean} [remove=false] Completely remove the table from the DOM
	    *  @dtopt API
	    *  @deprecated Since v1.10
	    *
	    *  @example
	    *    $(document).ready(function() {
	    *      // This example is fairly pointless in reality, but shows how fnDestroy can be used
	    *      var oTable = $('#example').dataTable();
	    *      oTable.fnDestroy();
	    *    } );
	    */
				this.fnDestroy = function (remove) {
					this.api(true).destroy(remove);
				};
	
				/**
	    * Redraw the table
	    *  @param {bool} [complete=true] Re-filter and resort (if enabled) the table before the draw.
	    *  @dtopt API
	    *  @deprecated Since v1.10
	    *
	    *  @example
	    *    $(document).ready(function() {
	    *      var oTable = $('#example').dataTable();
	    *
	    *      // Re-draw the table - you wouldn't want to do it here, but it's an example :-)
	    *      oTable.fnDraw();
	    *    } );
	    */
				this.fnDraw = function (complete) {
					// Note that this isn't an exact match to the old call to _fnDraw - it takes
					// into account the new data, but can old position.
					this.api(true).draw(!complete);
				};
	
				/**
	    * Filter the input based on data
	    *  @param {string} sInput String to filter the table on
	    *  @param {int|null} [iColumn] Column to limit filtering to
	    *  @param {bool} [bRegex=false] Treat as regular expression or not
	    *  @param {bool} [bSmart=true] Perform smart filtering or not
	    *  @param {bool} [bShowGlobal=true] Show the input global filter in it's input box(es)
	    *  @param {bool} [bCaseInsensitive=true] Do case-insensitive matching (true) or not (false)
	    *  @dtopt API
	    *  @deprecated Since v1.10
	    *
	    *  @example
	    *    $(document).ready(function() {
	    *      var oTable = $('#example').dataTable();
	    *
	    *      // Sometime later - filter...
	    *      oTable.fnFilter( 'test string' );
	    *    } );
	    */
				this.fnFilter = function (sInput, iColumn, bRegex, bSmart, bShowGlobal, bCaseInsensitive) {
					var api = this.api(true);
	
					if (iColumn === null || iColumn === undefined) {
						api.search(sInput, bRegex, bSmart, bCaseInsensitive);
					} else {
						api.column(iColumn).search(sInput, bRegex, bSmart, bCaseInsensitive);
					}
	
					api.draw();
				};
	
				/**
	    * Get the data for the whole table, an individual row or an individual cell based on the
	    * provided parameters.
	    *  @param {int|node} [src] A TR row node, TD/TH cell node or an integer. If given as
	    *    a TR node then the data source for the whole row will be returned. If given as a
	    *    TD/TH cell node then iCol will be automatically calculated and the data for the
	    *    cell returned. If given as an integer, then this is treated as the aoData internal
	    *    data index for the row (see fnGetPosition) and the data for that row used.
	    *  @param {int} [col] Optional column index that you want the data of.
	    *  @returns {array|object|string} If mRow is undefined, then the data for all rows is
	    *    returned. If mRow is defined, just data for that row, and is iCol is
	    *    defined, only data for the designated cell is returned.
	    *  @dtopt API
	    *  @deprecated Since v1.10
	    *
	    *  @example
	    *    // Row data
	    *    $(document).ready(function() {
	    *      oTable = $('#example').dataTable();
	    *
	    *      oTable.$('tr').click( function () {
	    *        var data = oTable.fnGetData( this );
	    *        // ... do something with the array / object of data for the row
	    *      } );
	    *    } );
	    *
	    *  @example
	    *    // Individual cell data
	    *    $(document).ready(function() {
	    *      oTable = $('#example').dataTable();
	    *
	    *      oTable.$('td').click( function () {
	    *        var sData = oTable.fnGetData( this );
	    *        alert( 'The cell clicked on had the value of '+sData );
	    *      } );
	    *    } );
	    */
				this.fnGetData = function (src, col) {
					var api = this.api(true);
	
					if (src !== undefined) {
						var type = src.nodeName ? src.nodeName.toLowerCase() : '';
	
						return col !== undefined || type == 'td' || type == 'th' ? api.cell(src, col).data() : api.row(src).data() || null;
					}
	
					return api.data().toArray();
				};
	
				/**
	    * Get an array of the TR nodes that are used in the table's body. Note that you will
	    * typically want to use the '$' API method in preference to this as it is more
	    * flexible.
	    *  @param {int} [iRow] Optional row index for the TR element you want
	    *  @returns {array|node} If iRow is undefined, returns an array of all TR elements
	    *    in the table's body, or iRow is defined, just the TR element requested.
	    *  @dtopt API
	    *  @deprecated Since v1.10
	    *
	    *  @example
	    *    $(document).ready(function() {
	    *      var oTable = $('#example').dataTable();
	    *
	    *      // Get the nodes from the table
	    *      var nNodes = oTable.fnGetNodes( );
	    *    } );
	    */
				this.fnGetNodes = function (iRow) {
					var api = this.api(true);
	
					return iRow !== undefined ? api.row(iRow).node() : api.rows().nodes().flatten().toArray();
				};
	
				/**
	    * Get the array indexes of a particular cell from it's DOM element
	    * and column index including hidden columns
	    *  @param {node} node this can either be a TR, TD or TH in the table's body
	    *  @returns {int} If nNode is given as a TR, then a single index is returned, or
	    *    if given as a cell, an array of [row index, column index (visible),
	    *    column index (all)] is given.
	    *  @dtopt API
	    *  @deprecated Since v1.10
	    *
	    *  @example
	    *    $(document).ready(function() {
	    *      $('#example tbody td').click( function () {
	    *        // Get the position of the current data from the node
	    *        var aPos = oTable.fnGetPosition( this );
	    *
	    *        // Get the data array for this row
	    *        var aData = oTable.fnGetData( aPos[0] );
	    *
	    *        // Update the data array and return the value
	    *        aData[ aPos[1] ] = 'clicked';
	    *        this.innerHTML = 'clicked';
	    *      } );
	    *
	    *      // Init DataTables
	    *      oTable = $('#example').dataTable();
	    *    } );
	    */
				this.fnGetPosition = function (node) {
					var api = this.api(true);
					var nodeName = node.nodeName.toUpperCase();
	
					if (nodeName == 'TR') {
						return api.row(node).index();
					} else if (nodeName == 'TD' || nodeName == 'TH') {
						var cell = api.cell(node).index();
	
						return [cell.row, cell.columnVisible, cell.column];
					}
					return null;
				};
	
				/**
	    * Check to see if a row is 'open' or not.
	    *  @param {node} nTr the table row to check
	    *  @returns {boolean} true if the row is currently open, false otherwise
	    *  @dtopt API
	    *  @deprecated Since v1.10
	    *
	    *  @example
	    *    $(document).ready(function() {
	    *      var oTable;
	    *
	    *      // 'open' an information row when a row is clicked on
	    *      $('#example tbody tr').click( function () {
	    *        if ( oTable.fnIsOpen(this) ) {
	    *          oTable.fnClose( this );
	    *        } else {
	    *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
	    *        }
	    *      } );
	    *
	    *      oTable = $('#example').dataTable();
	    *    } );
	    */
				this.fnIsOpen = function (nTr) {
					return this.api(true).row(nTr).child.isShown();
				};
	
				/**
	    * This function will place a new row directly after a row which is currently
	    * on display on the page, with the HTML contents that is passed into the
	    * function. This can be used, for example, to ask for confirmation that a
	    * particular record should be deleted.
	    *  @param {node} nTr The table row to 'open'
	    *  @param {string|node|jQuery} mHtml The HTML to put into the row
	    *  @param {string} sClass Class to give the new TD cell
	    *  @returns {node} The row opened. Note that if the table row passed in as the
	    *    first parameter, is not found in the table, this method will silently
	    *    return.
	    *  @dtopt API
	    *  @deprecated Since v1.10
	    *
	    *  @example
	    *    $(document).ready(function() {
	    *      var oTable;
	    *
	    *      // 'open' an information row when a row is clicked on
	    *      $('#example tbody tr').click( function () {
	    *        if ( oTable.fnIsOpen(this) ) {
	    *          oTable.fnClose( this );
	    *        } else {
	    *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
	    *        }
	    *      } );
	    *
	    *      oTable = $('#example').dataTable();
	    *    } );
	    */
				this.fnOpen = function (nTr, mHtml, sClass) {
					return this.api(true).row(nTr).child(mHtml, sClass).show().child()[0];
				};
	
				/**
	    * Change the pagination - provides the internal logic for pagination in a simple API
	    * function. With this function you can have a DataTables table go to the next,
	    * previous, first or last pages.
	    *  @param {string|int} mAction Paging action to take: "first", "previous", "next" or "last"
	    *    or page number to jump to (integer), note that page 0 is the first page.
	    *  @param {bool} [bRedraw=true] Redraw the table or not
	    *  @dtopt API
	    *  @deprecated Since v1.10
	    *
	    *  @example
	    *    $(document).ready(function() {
	    *      var oTable = $('#example').dataTable();
	    *      oTable.fnPageChange( 'next' );
	    *    } );
	    */
				this.fnPageChange = function (mAction, bRedraw) {
					var api = this.api(true).page(mAction);
	
					if (bRedraw === undefined || bRedraw) {
						api.draw(false);
					}
				};
	
				/**
	    * Show a particular column
	    *  @param {int} iCol The column whose display should be changed
	    *  @param {bool} bShow Show (true) or hide (false) the column
	    *  @param {bool} [bRedraw=true] Redraw the table or not
	    *  @dtopt API
	    *  @deprecated Since v1.10
	    *
	    *  @example
	    *    $(document).ready(function() {
	    *      var oTable = $('#example').dataTable();
	    *
	    *      // Hide the second column after initialisation
	    *      oTable.fnSetColumnVis( 1, false );
	    *    } );
	    */
				this.fnSetColumnVis = function (iCol, bShow, bRedraw) {
					var api = this.api(true).column(iCol).visible(bShow);
	
					if (bRedraw === undefined || bRedraw) {
						api.columns.adjust().draw();
					}
				};
	
				/**
	    * Get the settings for a particular table for external manipulation
	    *  @returns {object} DataTables settings object. See
	    *    {@link DataTable.models.oSettings}
	    *  @dtopt API
	    *  @deprecated Since v1.10
	    *
	    *  @example
	    *    $(document).ready(function() {
	    *      var oTable = $('#example').dataTable();
	    *      var oSettings = oTable.fnSettings();
	    *
	    *      // Show an example parameter from the settings
	    *      alert( oSettings._iDisplayStart );
	    *    } );
	    */
				this.fnSettings = function () {
					return _fnSettingsFromNode(this[_ext.iApiIndex]);
				};
	
				/**
	    * Sort the table by a particular column
	    *  @param {int} iCol the data index to sort on. Note that this will not match the
	    *    'display index' if you have hidden data entries
	    *  @dtopt API
	    *  @deprecated Since v1.10
	    *
	    *  @example
	    *    $(document).ready(function() {
	    *      var oTable = $('#example').dataTable();
	    *
	    *      // Sort immediately with columns 0 and 1
	    *      oTable.fnSort( [ [0,'asc'], [1,'asc'] ] );
	    *    } );
	    */
				this.fnSort = function (aaSort) {
					this.api(true).order(aaSort).draw();
				};
	
				/**
	    * Attach a sort listener to an element for a given column
	    *  @param {node} nNode the element to attach the sort listener to
	    *  @param {int} iColumn the column that a click on this node will sort on
	    *  @param {function} [fnCallback] callback function when sort is run
	    *  @dtopt API
	    *  @deprecated Since v1.10
	    *
	    *  @example
	    *    $(document).ready(function() {
	    *      var oTable = $('#example').dataTable();
	    *
	    *      // Sort on column 1, when 'sorter' is clicked on
	    *      oTable.fnSortListener( document.getElementById('sorter'), 1 );
	    *    } );
	    */
				this.fnSortListener = function (nNode, iColumn, fnCallback) {
					this.api(true).order.listener(nNode, iColumn, fnCallback);
				};
	
				/**
	    * Update a table cell or row - this method will accept either a single value to
	    * update the cell with, an array of values with one element for each column or
	    * an object in the same format as the original data source. The function is
	    * self-referencing in order to make the multi column updates easier.
	    *  @param {object|array|string} mData Data to update the cell/row with
	    *  @param {node|int} mRow TR element you want to update or the aoData index
	    *  @param {int} [iColumn] The column to update, give as null or undefined to
	    *    update a whole row.
	    *  @param {bool} [bRedraw=true] Redraw the table or not
	    *  @param {bool} [bAction=true] Perform pre-draw actions or not
	    *  @returns {int} 0 on success, 1 on error
	    *  @dtopt API
	    *  @deprecated Since v1.10
	    *
	    *  @example
	    *    $(document).ready(function() {
	    *      var oTable = $('#example').dataTable();
	    *      oTable.fnUpdate( 'Example update', 0, 0 ); // Single cell
	    *      oTable.fnUpdate( ['a', 'b', 'c', 'd', 'e'], $('tbody tr')[0] ); // Row
	    *    } );
	    */
				this.fnUpdate = function (mData, mRow, iColumn, bRedraw, bAction) {
					var api = this.api(true);
	
					if (iColumn === undefined || iColumn === null) {
						api.row(mRow).data(mData);
					} else {
						api.cell(mRow, iColumn).data(mData);
					}
	
					if (bAction === undefined || bAction) {
						api.columns.adjust();
					}
	
					if (bRedraw === undefined || bRedraw) {
						api.draw();
					}
					return 0;
				};
	
				/**
	    * Provide a common method for plug-ins to check the version of DataTables being used, in order
	    * to ensure compatibility.
	    *  @param {string} sVersion Version string to check for, in the format "X.Y.Z". Note that the
	    *    formats "X" and "X.Y" are also acceptable.
	    *  @returns {boolean} true if this version of DataTables is greater or equal to the required
	    *    version, or false if this version of DataTales is not suitable
	    *  @method
	    *  @dtopt API
	    *  @deprecated Since v1.10
	    *
	    *  @example
	    *    $(document).ready(function() {
	    *      var oTable = $('#example').dataTable();
	    *      alert( oTable.fnVersionCheck( '1.9.0' ) );
	    *    } );
	    */
				this.fnVersionCheck = _ext.fnVersionCheck;
	
				var _that = this;
				var emptyInit = options === undefined;
				var len = this.length;
	
				if (emptyInit) {
					options = {};
				}
	
				this.oApi = this.internal = _ext.internal;
	
				// Extend with old style plug-in API methods
				for (var fn in _DataTable.ext.internal) {
					if (fn) {
						this[fn] = _fnExternApiFunc(fn);
					}
				}
	
				this.each(function () {
					// For each initialisation we want to give it a clean initialisation
					// object that can be bashed around
					var o = {};
					var oInit = len > 1 ? // optimisation for single table case
					_fnExtend(o, options, true) : options;
	
					/*global oInit,_that,emptyInit*/
					var i = 0,
					    iLen,
					    j,
					    jLen,
					    k,
					    kLen;
					var sId = this.getAttribute('id');
					var bInitHandedOff = false;
					var defaults = _DataTable.defaults;
	
					/* Sanity check */
					if (this.nodeName.toLowerCase() != 'table') {
						_fnLog(null, 0, 'Non-table node initialisation (' + this.nodeName + ')', 2);
						return;
					}
	
					/* Backwards compatibility for the defaults */
					_fnCompatOpts(defaults);
					_fnCompatCols(defaults.column);
	
					/* Convert the camel-case defaults to Hungarian */
					_fnCamelToHungarian(defaults, defaults, true);
					_fnCamelToHungarian(defaults.column, defaults.column, true);
	
					/* Setting up the initialisation object */
					_fnCamelToHungarian(defaults, oInit);
	
					/* Check to see if we are re-initialising a table */
					var allSettings = _DataTable.settings;
					for (i = 0, iLen = allSettings.length; i < iLen; i++) {
						/* Base check on table node */
						if (allSettings[i].nTable == this) {
							var bRetrieve = oInit.bRetrieve !== undefined ? oInit.bRetrieve : defaults.bRetrieve;
							var bDestroy = oInit.bDestroy !== undefined ? oInit.bDestroy : defaults.bDestroy;
	
							if (emptyInit || bRetrieve) {
								return allSettings[i].oInstance;
							} else if (bDestroy) {
								allSettings[i].oInstance.fnDestroy();
								break;
							} else {
								_fnLog(allSettings[i], 0, 'Cannot reinitialise DataTable', 3);
								return;
							}
						}
	
						/* If the element we are initialising has the same ID as a table which was previously
	      * initialised, but the table nodes don't match (from before) then we destroy the old
	      * instance by simply deleting it. This is under the assumption that the table has been
	      * destroyed by other methods. Anyone using non-id selectors will need to do this manually
	      */
						if (allSettings[i].sTableId == this.id) {
							allSettings.splice(i, 1);
							break;
						}
					}
	
					/* Ensure the table has an ID - required for accessibility */
					if (sId === null || sId === "") {
						sId = "DataTables_Table_" + _DataTable.ext._unique++;
						this.id = sId;
					}
	
					/* Create the settings object for this table and set some of the default parameters */
					var oSettings = $.extend(true, {}, _DataTable.models.oSettings, {
						"nTable": this,
						"oApi": _that.internal,
						"oInit": oInit,
						"sDestroyWidth": $(this)[0].style.width,
						"sInstance": sId,
						"sTableId": sId
					});
					allSettings.push(oSettings);
	
					// Need to add the instance after the instance after the settings object has been added
					// to the settings array, so we can self reference the table instance if more than one
					oSettings.oInstance = _that.length === 1 ? _that : $(this).dataTable();
	
					// Backwards compatibility, before we apply all the defaults
					_fnCompatOpts(oInit);
	
					if (oInit.oLanguage) {
						_fnLanguageCompat(oInit.oLanguage);
					}
	
					// If the length menu is given, but the init display length is not, use the length menu
					if (oInit.aLengthMenu && !oInit.iDisplayLength) {
						oInit.iDisplayLength = $.isArray(oInit.aLengthMenu[0]) ? oInit.aLengthMenu[0][0] : oInit.aLengthMenu[0];
					}
	
					// Apply the defaults and init options to make a single init object will all
					// options defined from defaults and instance options.
					oInit = _fnExtend($.extend(true, {}, defaults), oInit);
	
					// Map the initialisation options onto the settings object
					_fnMap(oSettings.oFeatures, oInit, ["bPaginate", "bLengthChange", "bFilter", "bSort", "bSortMulti", "bInfo", "bProcessing", "bAutoWidth", "bSortClasses", "bServerSide", "bDeferRender"]);
					_fnMap(oSettings, oInit, ["asStripeClasses", "ajax", "fnServerData", "fnFormatNumber", "sServerMethod", "aaSorting", "aaSortingFixed", "aLengthMenu", "sPaginationType", "sAjaxSource", "sAjaxDataProp", "iStateDuration", "sDom", "bSortCellsTop", "iTabIndex", "fnStateLoadCallback", "fnStateSaveCallback", "renderer", "searchDelay", ["iCookieDuration", "iStateDuration"], // backwards compat
					["oSearch", "oPreviousSearch"], ["aoSearchCols", "aoPreSearchCols"], ["iDisplayLength", "_iDisplayLength"], ["bJQueryUI", "bJUI"]]);
					_fnMap(oSettings.oScroll, oInit, [["sScrollX", "sX"], ["sScrollXInner", "sXInner"], ["sScrollY", "sY"], ["bScrollCollapse", "bCollapse"]]);
					_fnMap(oSettings.oLanguage, oInit, "fnInfoCallback");
	
					/* Callback functions which are array driven */
					_fnCallbackReg(oSettings, 'aoDrawCallback', oInit.fnDrawCallback, 'user');
					_fnCallbackReg(oSettings, 'aoServerParams', oInit.fnServerParams, 'user');
					_fnCallbackReg(oSettings, 'aoStateSaveParams', oInit.fnStateSaveParams, 'user');
					_fnCallbackReg(oSettings, 'aoStateLoadParams', oInit.fnStateLoadParams, 'user');
					_fnCallbackReg(oSettings, 'aoStateLoaded', oInit.fnStateLoaded, 'user');
					_fnCallbackReg(oSettings, 'aoRowCallback', oInit.fnRowCallback, 'user');
					_fnCallbackReg(oSettings, 'aoRowCreatedCallback', oInit.fnCreatedRow, 'user');
					_fnCallbackReg(oSettings, 'aoHeaderCallback', oInit.fnHeaderCallback, 'user');
					_fnCallbackReg(oSettings, 'aoFooterCallback', oInit.fnFooterCallback, 'user');
					_fnCallbackReg(oSettings, 'aoInitComplete', oInit.fnInitComplete, 'user');
					_fnCallbackReg(oSettings, 'aoPreDrawCallback', oInit.fnPreDrawCallback, 'user');
	
					var oClasses = oSettings.oClasses;
	
					// @todo Remove in 1.11
					if (oInit.bJQueryUI) {
						/* Use the JUI classes object for display. You could clone the oStdClasses object if
	      * you want to have multiple tables with multiple independent classes
	      */
						$.extend(oClasses, _DataTable.ext.oJUIClasses, oInit.oClasses);
	
						if (oInit.sDom === defaults.sDom && defaults.sDom === "lfrtip") {
							/* Set the DOM to use a layout suitable for jQuery UI's theming */
							oSettings.sDom = '<"H"lfr>t<"F"ip>';
						}
	
						if (!oSettings.renderer) {
							oSettings.renderer = 'jqueryui';
						} else if ($.isPlainObject(oSettings.renderer) && !oSettings.renderer.header) {
							oSettings.renderer.header = 'jqueryui';
						}
					} else {
						$.extend(oClasses, _DataTable.ext.classes, oInit.oClasses);
					}
					$(this).addClass(oClasses.sTable);
	
					/* Calculate the scroll bar width and cache it for use later on */
					if (oSettings.oScroll.sX !== "" || oSettings.oScroll.sY !== "") {
						oSettings.oScroll.iBarWidth = _fnScrollBarWidth();
					}
					if (oSettings.oScroll.sX === true) {
						// Easy initialisation of x-scrolling
						oSettings.oScroll.sX = '100%';
					}
	
					if (oSettings.iInitDisplayStart === undefined) {
						/* Display start point, taking into account the save saving */
						oSettings.iInitDisplayStart = oInit.iDisplayStart;
						oSettings._iDisplayStart = oInit.iDisplayStart;
					}
	
					if (oInit.iDeferLoading !== null) {
						oSettings.bDeferLoading = true;
						var tmp = $.isArray(oInit.iDeferLoading);
						oSettings._iRecordsDisplay = tmp ? oInit.iDeferLoading[0] : oInit.iDeferLoading;
						oSettings._iRecordsTotal = tmp ? oInit.iDeferLoading[1] : oInit.iDeferLoading;
					}
	
					/* Language definitions */
					var oLanguage = oSettings.oLanguage;
					$.extend(true, oLanguage, oInit.oLanguage);
	
					if (oLanguage.sUrl !== "") {
						/* Get the language definitions from a file - because this Ajax call makes the language
	      * get async to the remainder of this function we use bInitHandedOff to indicate that
	      * _fnInitialise will be fired by the returned Ajax handler, rather than the constructor
	      */
						$.ajax({
							dataType: 'json',
							url: oLanguage.sUrl,
							success: function success(json) {
								_fnLanguageCompat(json);
								_fnCamelToHungarian(defaults.oLanguage, json);
								$.extend(true, oLanguage, json);
								_fnInitialise(oSettings);
							},
							error: function error() {
								// Error occurred loading language file, continue on as best we can
								_fnInitialise(oSettings);
							}
						});
						bInitHandedOff = true;
					}
	
					/*
	     * Stripes
	     */
					if (oInit.asStripeClasses === null) {
						oSettings.asStripeClasses = [oClasses.sStripeOdd, oClasses.sStripeEven];
					}
	
					/* Remove row stripe classes if they are already on the table row */
					var stripeClasses = oSettings.asStripeClasses;
					var rowOne = $('tbody tr:eq(0)', this);
					if ($.inArray(true, $.map(stripeClasses, function (el, i) {
						return rowOne.hasClass(el);
					})) !== -1) {
						$('tbody tr', this).removeClass(stripeClasses.join(' '));
						oSettings.asDestroyStripes = stripeClasses.slice();
					}
	
					/*
	     * Columns
	     * See if we should load columns automatically or use defined ones
	     */
					var anThs = [];
					var aoColumnsInit;
					var nThead = this.getElementsByTagName('thead');
					if (nThead.length !== 0) {
						_fnDetectHeader(oSettings.aoHeader, nThead[0]);
						anThs = _fnGetUniqueThs(oSettings);
					}
	
					/* If not given a column array, generate one with nulls */
					if (oInit.aoColumns === null) {
						aoColumnsInit = [];
						for (i = 0, iLen = anThs.length; i < iLen; i++) {
							aoColumnsInit.push(null);
						}
					} else {
						aoColumnsInit = oInit.aoColumns;
					}
	
					/* Add the columns */
					for (i = 0, iLen = aoColumnsInit.length; i < iLen; i++) {
						_fnAddColumn(oSettings, anThs ? anThs[i] : null);
					}
	
					/* Apply the column definitions */
					_fnApplyColumnDefs(oSettings, oInit.aoColumnDefs, aoColumnsInit, function (iCol, oDef) {
						_fnColumnOptions(oSettings, iCol, oDef);
					});
	
					/* HTML5 attribute detection - build an mData object automatically if the
	     * attributes are found
	     */
					if (rowOne.length) {
						var a = function a(cell, name) {
							return cell.getAttribute('data-' + name) ? name : null;
						};
	
						$.each(_fnGetRowElements(oSettings, rowOne[0]).cells, function (i, cell) {
							var col = oSettings.aoColumns[i];
	
							if (col.mData === i) {
								var sort = a(cell, 'sort') || a(cell, 'order');
								var filter = a(cell, 'filter') || a(cell, 'search');
	
								if (sort !== null || filter !== null) {
									col.mData = {
										_: i + '.display',
										sort: sort !== null ? i + '.@data-' + sort : undefined,
										type: sort !== null ? i + '.@data-' + sort : undefined,
										filter: filter !== null ? i + '.@data-' + filter : undefined
									};
	
									_fnColumnOptions(oSettings, i);
								}
							}
						});
					}
	
					var features = oSettings.oFeatures;
	
					/* Must be done after everything which can be overridden by the state saving! */
					if (oInit.bStateSave) {
						features.bStateSave = true;
						_fnLoadState(oSettings, oInit);
						_fnCallbackReg(oSettings, 'aoDrawCallback', _fnSaveState, 'state_save');
					}
	
					/*
	     * Sorting
	     * @todo For modularisation (1.11) this needs to do into a sort start up handler
	     */
	
					// If aaSorting is not defined, then we use the first indicator in asSorting
					// in case that has been altered, so the default sort reflects that option
					if (oInit.aaSorting === undefined) {
						var sorting = oSettings.aaSorting;
						for (i = 0, iLen = sorting.length; i < iLen; i++) {
							sorting[i][1] = oSettings.aoColumns[i].asSorting[0];
						}
					}
	
					/* Do a first pass on the sorting classes (allows any size changes to be taken into
	     * account, and also will apply sorting disabled classes if disabled
	     */
					_fnSortingClasses(oSettings);
	
					if (features.bSort) {
						_fnCallbackReg(oSettings, 'aoDrawCallback', function () {
							if (oSettings.bSorted) {
								var aSort = _fnSortFlatten(oSettings);
								var sortedColumns = {};
	
								$.each(aSort, function (i, val) {
									sortedColumns[val.src] = val.dir;
								});
	
								_fnCallbackFire(oSettings, null, 'order', [oSettings, aSort, sortedColumns]);
								_fnSortAria(oSettings);
							}
						});
					}
	
					_fnCallbackReg(oSettings, 'aoDrawCallback', function () {
						if (oSettings.bSorted || _fnDataSource(oSettings) === 'ssp' || features.bDeferRender) {
							_fnSortingClasses(oSettings);
						}
					}, 'sc');
	
					/*
	     * Final init
	     * Cache the header, body and footer as required, creating them if needed
	     */
	
					/* Browser support detection */
					_fnBrowserDetect(oSettings);
	
					// Work around for Webkit bug 83867 - store the caption-side before removing from doc
					var captions = $(this).children('caption').each(function () {
						this._captionSide = $(this).css('caption-side');
					});
	
					var thead = $(this).children('thead');
					if (thead.length === 0) {
						thead = $('<thead/>').appendTo(this);
					}
					oSettings.nTHead = thead[0];
	
					var tbody = $(this).children('tbody');
					if (tbody.length === 0) {
						tbody = $('<tbody/>').appendTo(this);
					}
					oSettings.nTBody = tbody[0];
	
					var tfoot = $(this).children('tfoot');
					if (tfoot.length === 0 && captions.length > 0 && (oSettings.oScroll.sX !== "" || oSettings.oScroll.sY !== "")) {
						// If we are a scrolling table, and no footer has been given, then we need to create
						// a tfoot element for the caption element to be appended to
						tfoot = $('<tfoot/>').appendTo(this);
					}
	
					if (tfoot.length === 0 || tfoot.children().length === 0) {
						$(this).addClass(oClasses.sNoFooter);
					} else if (tfoot.length > 0) {
						oSettings.nTFoot = tfoot[0];
						_fnDetectHeader(oSettings.aoFooter, oSettings.nTFoot);
					}
	
					/* Check if there is data passing into the constructor */
					if (oInit.aaData) {
						for (i = 0; i < oInit.aaData.length; i++) {
							_fnAddData(oSettings, oInit.aaData[i]);
						}
					} else if (oSettings.bDeferLoading || _fnDataSource(oSettings) == 'dom') {
						/* Grab the data from the page - only do this when deferred loading or no Ajax
	      * source since there is no point in reading the DOM data if we are then going
	      * to replace it with Ajax data
	      */
						_fnAddTr(oSettings, $(oSettings.nTBody).children('tr'));
					}
	
					/* Copy the data index array */
					oSettings.aiDisplay = oSettings.aiDisplayMaster.slice();
	
					/* Initialisation complete - table can be drawn */
					oSettings.bInitialised = true;
	
					/* Check if we need to initialise the table (it might not have been handed off to the
	     * language processor)
	     */
					if (bInitHandedOff === false) {
						_fnInitialise(oSettings);
					}
				});
				_that = null;
				return this;
			};
	
			/**
	   * Computed structure of the DataTables API, defined by the options passed to
	   * `DataTable.Api.register()` when building the API.
	   *
	   * The structure is built in order to speed creation and extension of the Api
	   * objects since the extensions are effectively pre-parsed.
	   *
	   * The array is an array of objects with the following structure, where this
	   * base array represents the Api prototype base:
	   *
	   *     [
	   *       {
	   *         name:      'data'                -- string   - Property name
	   *         val:       function () {},       -- function - Api method (or undefined if just an object
	   *         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
	   *         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
	   *       },
	   *       {
	   *         name:     'row'
	   *         val:       {},
	   *         methodExt: [ ... ],
	   *         propExt:   [
	   *           {
	   *             name:      'data'
	   *             val:       function () {},
	   *             methodExt: [ ... ],
	   *             propExt:   [ ... ]
	   *           },
	   *           ...
	   *         ]
	   *       }
	   *     ]
	   *
	   * @type {Array}
	   * @ignore
	   */
			var __apiStruct = [];
	
			/**
	   * `Array.prototype` reference.
	   *
	   * @type object
	   * @ignore
	   */
			var __arrayProto = Array.prototype;
	
			/**
	   * Abstraction for `context` parameter of the `Api` constructor to allow it to
	   * take several different forms for ease of use.
	   *
	   * Each of the input parameter types will be converted to a DataTables settings
	   * object where possible.
	   *
	   * @param  {string|node|jQuery|object} mixed DataTable identifier. Can be one
	   *   of:
	   *
	   *   * `string` - jQuery selector. Any DataTables' matching the given selector
	   *     with be found and used.
	   *   * `node` - `TABLE` node which has already been formed into a DataTable.
	   *   * `jQuery` - A jQuery object of `TABLE` nodes.
	   *   * `object` - DataTables settings object
	   *   * `DataTables.Api` - API instance
	   * @return {array|null} Matching DataTables settings objects. `null` or
	   *   `undefined` is returned if no matching DataTable is found.
	   * @ignore
	   */
			var _toSettings = function _toSettings(mixed) {
				var idx, jq;
				var settings = _DataTable.settings;
				var tables = $.map(settings, function (el, i) {
					return el.nTable;
				});
	
				if (!mixed) {
					return [];
				} else if (mixed.nTable && mixed.oApi) {
					// DataTables settings object
					return [mixed];
				} else if (mixed.nodeName && mixed.nodeName.toLowerCase() === 'table') {
					// Table node
					idx = $.inArray(mixed, tables);
					return idx !== -1 ? [settings[idx]] : null;
				} else if (mixed && typeof mixed.settings === 'function') {
					return mixed.settings().toArray();
				} else if (typeof mixed === 'string') {
					// jQuery selector
					jq = $(mixed);
				} else if (mixed instanceof $) {
					// jQuery object (also DataTables instance)
					jq = mixed;
				}
	
				if (jq) {
					return jq.map(function (i) {
						idx = $.inArray(this, tables);
						return idx !== -1 ? settings[idx] : null;
					}).toArray();
				}
			};
	
			/**
	   * DataTables API class - used to control and interface with  one or more
	   * DataTables enhanced tables.
	   *
	   * The API class is heavily based on jQuery, presenting a chainable interface
	   * that you can use to interact with tables. Each instance of the API class has
	   * a "context" - i.e. the tables that it will operate on. This could be a single
	   * table, all tables on a page or a sub-set thereof.
	   *
	   * Additionally the API is designed to allow you to easily work with the data in
	   * the tables, retrieving and manipulating it as required. This is done by
	   * presenting the API class as an array like interface. The contents of the
	   * array depend upon the actions requested by each method (for example
	   * `rows().nodes()` will return an array of nodes, while `rows().data()` will
	   * return an array of objects or arrays depending upon your table's
	   * configuration). The API object has a number of array like methods (`push`,
	   * `pop`, `reverse` etc) as well as additional helper methods (`each`, `pluck`,
	   * `unique` etc) to assist your working with the data held in a table.
	   *
	   * Most methods (those which return an Api instance) are chainable, which means
	   * the return from a method call also has all of the methods available that the
	   * top level object had. For example, these two calls are equivalent:
	   *
	   *     // Not chained
	   *     api.row.add( {...} );
	   *     api.draw();
	   *
	   *     // Chained
	   *     api.row.add( {...} ).draw();
	   *
	   * @class DataTable.Api
	   * @param {array|object|string|jQuery} context DataTable identifier. This is
	   *   used to define which DataTables enhanced tables this API will operate on.
	   *   Can be one of:
	   *
	   *   * `string` - jQuery selector. Any DataTables' matching the given selector
	   *     with be found and used.
	   *   * `node` - `TABLE` node which has already been formed into a DataTable.
	   *   * `jQuery` - A jQuery object of `TABLE` nodes.
	   *   * `object` - DataTables settings object
	   * @param {array} [data] Data to initialise the Api instance with.
	   *
	   * @example
	   *   // Direct initialisation during DataTables construction
	   *   var api = $('#example').DataTable();
	   *
	   * @example
	   *   // Initialisation using a DataTables jQuery object
	   *   var api = $('#example').dataTable().api();
	   *
	   * @example
	   *   // Initialisation as a constructor
	   *   var api = new $.fn.DataTable.Api( 'table.dataTable' );
	   */
			_Api2 = function _Api(context, data) {
				if (!this instanceof _Api2) {
					throw 'DT API must be constructed as a new object';
					// or should it do the 'new' for the caller?
					// return new _Api.apply( this, arguments );
				}
	
				var settings = [];
				var ctxSettings = function ctxSettings(o) {
					var a = _toSettings(o);
					if (a) {
						settings.push.apply(settings, a);
					}
				};
	
				if ($.isArray(context)) {
					for (var i = 0, ien = context.length; i < ien; i++) {
						ctxSettings(context[i]);
					}
				} else {
					ctxSettings(context);
				}
	
				// Remove duplicates
				this.context = _unique(settings);
	
				// Initial data
				if (data) {
					this.push.apply(this, data.toArray ? data.toArray() : data);
				}
	
				// selector
				this.selector = {
					rows: null,
					cols: null,
					opts: null
				};
	
				_Api2.extend(this, this, __apiStruct);
			};
	
			_DataTable.Api = _Api2;
	
			_Api2.prototype = /** @lends DataTables.Api */{
				/**
	    * Return a new Api instance, comprised of the data held in the current
	    * instance, join with the other array(s) and/or value(s).
	    *
	    * An alias for `Array.prototype.concat`.
	    *
	    * @type method
	    * @param {*} value1 Arrays and/or values to concatenate.
	    * @param {*} [...] Additional arrays and/or values to concatenate.
	    * @returns {DataTables.Api} New API instance, comprising of the combined
	    *   array.
	    */
				concat: __arrayProto.concat,
	
				context: [], // array of table settings objects
	
	
				each: function each(fn) {
					for (var i = 0, ien = this.length; i < ien; i++) {
						fn.call(this, this[i], i, this);
					}
	
					return this;
				},
	
				eq: function eq(idx) {
					var ctx = this.context;
	
					return ctx.length > idx ? new _Api2(ctx[idx], this[idx]) : null;
				},
	
				filter: function filter(fn) {
					var a = [];
	
					if (__arrayProto.filter) {
						a = __arrayProto.filter.call(this, fn, this);
					} else {
						// Compatibility for browsers without EMCA-252-5 (JS 1.6)
						for (var i = 0, ien = this.length; i < ien; i++) {
							if (fn.call(this, this[i], i, this)) {
								a.push(this[i]);
							}
						}
					}
	
					return new _Api2(this.context, a);
				},
	
				flatten: function flatten() {
					var a = [];
					return new _Api2(this.context, a.concat.apply(a, this.toArray()));
				},
	
				join: __arrayProto.join,
	
				indexOf: __arrayProto.indexOf || function (obj, start) {
					for (var i = start || 0, ien = this.length; i < ien; i++) {
						if (this[i] === obj) {
							return i;
						}
					}
					return -1;
				},
	
				// Note that `alwaysNew` is internal - use iteratorNew externally
				iterator: function iterator(flatten, type, fn, alwaysNew) {
					var a = [],
					    ret,
					    i,
					    ien,
					    j,
					    jen,
					    context = this.context,
					    rows,
					    items,
					    item,
					    selector = this.selector;
	
					// Argument shifting
					if (typeof flatten === 'string') {
						alwaysNew = fn;
						fn = type;
						type = flatten;
						flatten = false;
					}
	
					for (i = 0, ien = context.length; i < ien; i++) {
						var apiInst = new _Api2(context[i]);
	
						if (type === 'table') {
							ret = fn.call(apiInst, context[i], i);
	
							if (ret !== undefined) {
								a.push(ret);
							}
						} else if (type === 'columns' || type === 'rows') {
							// this has same length as context - one entry for each table
							ret = fn.call(apiInst, context[i], this[i], i);
	
							if (ret !== undefined) {
								a.push(ret);
							}
						} else if (type === 'column' || type === 'column-rows' || type === 'row' || type === 'cell') {
							// columns and rows share the same structure.
							// 'this' is an array of column indexes for each context
							items = this[i];
	
							if (type === 'column-rows') {
								rows = _selector_row_indexes(context[i], selector.opts);
							}
	
							for (j = 0, jen = items.length; j < jen; j++) {
								item = items[j];
	
								if (type === 'cell') {
									ret = fn.call(apiInst, context[i], item.row, item.column, i, j);
								} else {
									ret = fn.call(apiInst, context[i], item, i, j, rows);
								}
	
								if (ret !== undefined) {
									a.push(ret);
								}
							}
						}
					}
	
					if (a.length || alwaysNew) {
						var api = new _Api2(context, flatten ? a.concat.apply([], a) : a);
						var apiSelector = api.selector;
						apiSelector.rows = selector.rows;
						apiSelector.cols = selector.cols;
						apiSelector.opts = selector.opts;
						return api;
					}
					return this;
				},
	
				lastIndexOf: __arrayProto.lastIndexOf || function (obj, start) {
					// Bit cheeky...
					return this.indexOf.apply(this.toArray.reverse(), arguments);
				},
	
				length: 0,
	
				map: function map(fn) {
					var a = [];
	
					if (__arrayProto.map) {
						a = __arrayProto.map.call(this, fn, this);
					} else {
						// Compatibility for browsers without EMCA-252-5 (JS 1.6)
						for (var i = 0, ien = this.length; i < ien; i++) {
							a.push(fn.call(this, this[i], i));
						}
					}
	
					return new _Api2(this.context, a);
				},
	
				pluck: function pluck(prop) {
					return this.map(function (el) {
						return el[prop];
					});
				},
	
				pop: __arrayProto.pop,
	
				push: __arrayProto.push,
	
				// Does not return an API instance
				reduce: __arrayProto.reduce || function (fn, init) {
					return _fnReduce(this, fn, init, 0, this.length, 1);
				},
	
				reduceRight: __arrayProto.reduceRight || function (fn, init) {
					return _fnReduce(this, fn, init, this.length - 1, -1, -1);
				},
	
				reverse: __arrayProto.reverse,
	
				// Object with rows, columns and opts
				selector: null,
	
				shift: __arrayProto.shift,
	
				sort: __arrayProto.sort, // ? name - order?
	
	
				splice: __arrayProto.splice,
	
				toArray: function toArray() {
					return __arrayProto.slice.call(this);
				},
	
				to$: function to$() {
					return $(this);
				},
	
				toJQuery: function toJQuery() {
					return $(this);
				},
	
				unique: function unique() {
					return new _Api2(this.context, _unique(this));
				},
	
				unshift: __arrayProto.unshift
			};
	
			_Api2.extend = function (scope, obj, ext) {
				// Only extend API instances and static properties of the API
				if (!obj || !(obj instanceof _Api2) && !obj.__dt_wrapper) {
					return;
				}
	
				var i,
				    ien,
				    j,
				    jen,
				    struct,
				    inner,
				    methodScoping = function methodScoping(scope, fn, struc) {
					return function () {
						var ret = fn.apply(scope, arguments);
	
						// Method extension
						_Api2.extend(ret, ret, struc.methodExt);
						return ret;
					};
				};
	
				for (i = 0, ien = ext.length; i < ien; i++) {
					struct = ext[i];
	
					// Value
					obj[struct.name] = typeof struct.val === 'function' ? methodScoping(scope, struct.val, struct) : $.isPlainObject(struct.val) ? {} : struct.val;
	
					obj[struct.name].__dt_wrapper = true;
	
					// Property extension
					_Api2.extend(scope, obj[struct.name], struct.propExt);
				}
			};
	
			// @todo - Is there need for an augment function?
			// _Api.augment = function ( inst, name )
			// {
			// 	// Find src object in the structure from the name
			// 	var parts = name.split('.');
	
			// 	_Api.extend( inst, obj );
			// };
	
	
			//     [
			//       {
			//         name:      'data'                -- string   - Property name
			//         val:       function () {},       -- function - Api method (or undefined if just an object
			//         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
			//         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
			//       },
			//       {
			//         name:     'row'
			//         val:       {},
			//         methodExt: [ ... ],
			//         propExt:   [
			//           {
			//             name:      'data'
			//             val:       function () {},
			//             methodExt: [ ... ],
			//             propExt:   [ ... ]
			//           },
			//           ...
			//         ]
			//       }
			//     ]
	
			_Api2.register = _api_register = function _api_register(name, val) {
				if ($.isArray(name)) {
					for (var j = 0, jen = name.length; j < jen; j++) {
						_Api2.register(name[j], val);
					}
					return;
				}
	
				var i,
				    ien,
				    heir = name.split('.'),
				    struct = __apiStruct,
				    key,
				    method;
	
				var find = function find(src, name) {
					for (var i = 0, ien = src.length; i < ien; i++) {
						if (src[i].name === name) {
							return src[i];
						}
					}
					return null;
				};
	
				for (i = 0, ien = heir.length; i < ien; i++) {
					method = heir[i].indexOf('()') !== -1;
					key = method ? heir[i].replace('()', '') : heir[i];
	
					var src = find(struct, key);
					if (!src) {
						src = {
							name: key,
							val: {},
							methodExt: [],
							propExt: []
						};
						struct.push(src);
					}
	
					if (i === ien - 1) {
						src.val = val;
					} else {
						struct = method ? src.methodExt : src.propExt;
					}
				}
			};
	
			_Api2.registerPlural = _api_registerPlural = function _api_registerPlural(pluralName, singularName, val) {
				_Api2.register(pluralName, val);
	
				_Api2.register(singularName, function () {
					var ret = val.apply(this, arguments);
	
					if (ret === this) {
						// Returned item is the API instance that was passed in, return it
						return this;
					} else if (ret instanceof _Api2) {
						// New API instance returned, want the value from the first item
						// in the returned array for the singular result.
						return ret.length ? $.isArray(ret[0]) ? new _Api2(ret.context, ret[0]) : // Array results are 'enhanced'
						ret[0] : undefined;
					}
	
					// Non-API return - just fire it back
					return ret;
				});
			};
	
			/**
	   * Selector for HTML tables. Apply the given selector to the give array of
	   * DataTables settings objects.
	   *
	   * @param {string|integer} [selector] jQuery selector string or integer
	   * @param  {array} Array of DataTables settings objects to be filtered
	   * @return {array}
	   * @ignore
	   */
			var __table_selector = function __table_selector(selector, a) {
				// Integer is used to pick out a table by index
				if (typeof selector === 'number') {
					return [a[selector]];
				}
	
				// Perform a jQuery selector on the table nodes
				var nodes = $.map(a, function (el, i) {
					return el.nTable;
				});
	
				return $(nodes).filter(selector).map(function (i) {
					// Need to translate back from the table node to the settings
					var idx = $.inArray(this, nodes);
					return a[idx];
				}).toArray();
			};
	
			/**
	   * Context selector for the API's context (i.e. the tables the API instance
	   * refers to.
	   *
	   * @name    DataTable.Api#tables
	   * @param {string|integer} [selector] Selector to pick which tables the iterator
	   *   should operate on. If not given, all tables in the current context are
	   *   used. This can be given as a jQuery selector (for example `':gt(0)'`) to
	   *   select multiple tables or as an integer to select a single table.
	   * @returns {DataTable.Api} Returns a new API instance if a selector is given.
	   */
			_api_register('tables()', function (selector) {
				// A new instance is created if there was a selector specified
				return selector ? new _Api2(__table_selector(selector, this.context)) : this;
			});
	
			_api_register('table()', function (selector) {
				var tables = this.tables(selector);
				var ctx = tables.context;
	
				// Truncate to the first matched table
				return ctx.length ? new _Api2(ctx[0]) : tables;
			});
	
			_api_registerPlural('tables().nodes()', 'table().node()', function () {
				return this.iterator('table', function (ctx) {
					return ctx.nTable;
				}, 1);
			});
	
			_api_registerPlural('tables().body()', 'table().body()', function () {
				return this.iterator('table', function (ctx) {
					return ctx.nTBody;
				}, 1);
			});
	
			_api_registerPlural('tables().header()', 'table().header()', function () {
				return this.iterator('table', function (ctx) {
					return ctx.nTHead;
				}, 1);
			});
	
			_api_registerPlural('tables().footer()', 'table().footer()', function () {
				return this.iterator('table', function (ctx) {
					return ctx.nTFoot;
				}, 1);
			});
	
			_api_registerPlural('tables().containers()', 'table().container()', function () {
				return this.iterator('table', function (ctx) {
					return ctx.nTableWrapper;
				}, 1);
			});
	
			/**
	   * Redraw the tables in the current context.
	   *
	   * @param {boolean} [reset=true] Reset (default) or hold the current paging
	   *   position. A full re-sort and re-filter is performed when this method is
	   *   called, which is why the pagination reset is the default action.
	   * @returns {DataTables.Api} this
	   */
			_api_register('draw()', function (resetPaging) {
				return this.iterator('table', function (settings) {
					_fnReDraw(settings, resetPaging === false);
				});
			});
	
			/**
	   * Get the current page index.
	   *
	   * @return {integer} Current page index (zero based)
	   */ /**
	      * Set the current page.
	      *
	      * Note that if you attempt to show a page which does not exist, DataTables will
	      * not throw an error, but rather reset the paging.
	      *
	      * @param {integer|string} action The paging action to take. This can be one of:
	      *  * `integer` - The page index to jump to
	      *  * `string` - An action to take:
	      *    * `first` - Jump to first page.
	      *    * `next` - Jump to the next page
	      *    * `previous` - Jump to previous page
	      *    * `last` - Jump to the last page.
	      * @returns {DataTables.Api} this
	      */
			_api_register('page()', function (action) {
				if (action === undefined) {
					return this.page.info().page; // not an expensive call
				}
	
				// else, have an action to take on all tables
				return this.iterator('table', function (settings) {
					_fnPageChange(settings, action);
				});
			});
	
			/**
	   * Paging information for the first table in the current context.
	   *
	   * If you require paging information for another table, use the `table()` method
	   * with a suitable selector.
	   *
	   * @return {object} Object with the following properties set:
	   *  * `page` - Current page index (zero based - i.e. the first page is `0`)
	   *  * `pages` - Total number of pages
	   *  * `start` - Display index for the first record shown on the current page
	   *  * `end` - Display index for the last record shown on the current page
	   *  * `length` - Display length (number of records). Note that generally `start
	   *    + length = end`, but this is not always true, for example if there are
	   *    only 2 records to show on the final page, with a length of 10.
	   *  * `recordsTotal` - Full data set length
	   *  * `recordsDisplay` - Data set length once the current filtering criterion
	   *    are applied.
	   */
			_api_register('page.info()', function (action) {
				if (this.context.length === 0) {
					return undefined;
				}
	
				var settings = this.context[0],
				    start = settings._iDisplayStart,
				    len = settings._iDisplayLength,
				    visRecords = settings.fnRecordsDisplay(),
				    all = len === -1;
	
				return {
					"page": all ? 0 : Math.floor(start / len),
					"pages": all ? 1 : Math.ceil(visRecords / len),
					"start": start,
					"end": settings.fnDisplayEnd(),
					"length": len,
					"recordsTotal": settings.fnRecordsTotal(),
					"recordsDisplay": visRecords
				};
			});
	
			/**
	   * Get the current page length.
	   *
	   * @return {integer} Current page length. Note `-1` indicates that all records
	   *   are to be shown.
	   */ /**
	      * Set the current page length.
	      *
	      * @param {integer} Page length to set. Use `-1` to show all records.
	      * @returns {DataTables.Api} this
	      */
			_api_register('page.len()', function (len) {
				// Note that we can't call this function 'length()' because `length`
				// is a Javascript property of functions which defines how many arguments
				// the function expects.
				if (len === undefined) {
					return this.context.length !== 0 ? this.context[0]._iDisplayLength : undefined;
				}
	
				// else, set the page length
				return this.iterator('table', function (settings) {
					_fnLengthChange(settings, len);
				});
			});
	
			var __reload = function __reload(settings, holdPosition, callback) {
				if (_fnDataSource(settings) == 'ssp') {
					_fnReDraw(settings, holdPosition);
				} else {
					// Trigger xhr
					_fnProcessingDisplay(settings, true);
	
					_fnBuildAjax(settings, [], function (json) {
						_fnClearTable(settings);
	
						var data = _fnAjaxDataSrc(settings, json);
						for (var i = 0, ien = data.length; i < ien; i++) {
							_fnAddData(settings, data[i]);
						}
	
						_fnReDraw(settings, holdPosition);
						_fnProcessingDisplay(settings, false);
					});
				}
	
				// Use the draw event to trigger a callback, regardless of if it is an async
				// or sync draw
				if (callback) {
					var api = new _Api2(settings);
	
					api.one('draw', function () {
						callback(api.ajax.json());
					});
				}
			};
	
			/**
	   * Get the JSON response from the last Ajax request that DataTables made to the
	   * server. Note that this returns the JSON from the first table in the current
	   * context.
	   *
	   * @return {object} JSON received from the server.
	   */
			_api_register('ajax.json()', function () {
				var ctx = this.context;
	
				if (ctx.length > 0) {
					return ctx[0].json;
				}
	
				// else return undefined;
			});
	
			/**
	   * Get the data submitted in the last Ajax request
	   */
			_api_register('ajax.params()', function () {
				var ctx = this.context;
	
				if (ctx.length > 0) {
					return ctx[0].oAjaxData;
				}
	
				// else return undefined;
			});
	
			/**
	   * Reload tables from the Ajax data source. Note that this function will
	   * automatically re-draw the table when the remote data has been loaded.
	   *
	   * @param {boolean} [reset=true] Reset (default) or hold the current paging
	   *   position. A full re-sort and re-filter is performed when this method is
	   *   called, which is why the pagination reset is the default action.
	   * @returns {DataTables.Api} this
	   */
			_api_register('ajax.reload()', function (callback, resetPaging) {
				return this.iterator('table', function (settings) {
					__reload(settings, resetPaging === false, callback);
				});
			});
	
			/**
	   * Get the current Ajax URL. Note that this returns the URL from the first
	   * table in the current context.
	   *
	   * @return {string} Current Ajax source URL
	   */ /**
	      * Set the Ajax URL. Note that this will set the URL for all tables in the
	      * current context.
	      *
	      * @param {string} url URL to set.
	      * @returns {DataTables.Api} this
	      */
			_api_register('ajax.url()', function (url) {
				var ctx = this.context;
	
				if (url === undefined) {
					// get
					if (ctx.length === 0) {
						return undefined;
					}
					ctx = ctx[0];
	
					return ctx.ajax ? $.isPlainObject(ctx.ajax) ? ctx.ajax.url : ctx.ajax : ctx.sAjaxSource;
				}
	
				// set
				return this.iterator('table', function (settings) {
					if ($.isPlainObject(settings.ajax)) {
						settings.ajax.url = url;
					} else {
						settings.ajax = url;
					}
					// No need to consider sAjaxSource here since DataTables gives priority
					// to `ajax` over `sAjaxSource`. So setting `ajax` here, renders any
					// value of `sAjaxSource` redundant.
				});
			});
	
			/**
	   * Load data from the newly set Ajax URL. Note that this method is only
	   * available when `ajax.url()` is used to set a URL. Additionally, this method
	   * has the same effect as calling `ajax.reload()` but is provided for
	   * convenience when setting a new URL. Like `ajax.reload()` it will
	   * automatically redraw the table once the remote data has been loaded.
	   *
	   * @returns {DataTables.Api} this
	   */
			_api_register('ajax.url().load()', function (callback, resetPaging) {
				// Same as a reload, but makes sense to present it for easy access after a
				// url change
				return this.iterator('table', function (ctx) {
					__reload(ctx, resetPaging === false, callback);
				});
			});
	
			var _selector_run = function _selector_run(selector, select) {
				var out = [],
				    res,
				    a,
				    i,
				    ien,
				    j,
				    jen,
				    selectorType = typeof selector === 'undefined' ? 'undefined' : _typeof(selector);
	
				// Can't just check for isArray here, as an API or jQuery instance might be
				// given with their array like look
				if (!selector || selectorType === 'string' || selectorType === 'function' || selector.length === undefined) {
					selector = [selector];
				}
	
				for (i = 0, ien = selector.length; i < ien; i++) {
					a = selector[i] && selector[i].split ? selector[i].split(',') : [selector[i]];
	
					for (j = 0, jen = a.length; j < jen; j++) {
						res = select(typeof a[j] === 'string' ? $.trim(a[j]) : a[j]);
	
						if (res && res.length) {
							out.push.apply(out, res);
						}
					}
				}
	
				return out;
			};
	
			var _selector_opts = function _selector_opts(opts) {
				if (!opts) {
					opts = {};
				}
	
				// Backwards compatibility for 1.9- which used the terminology filter rather
				// than search
				if (opts.filter && !opts.search) {
					opts.search = opts.filter;
				}
	
				return {
					search: opts.search || 'none',
					order: opts.order || 'current',
					page: opts.page || 'all'
				};
			};
	
			var _selector_first = function _selector_first(inst) {
				// Reduce the API instance to the first item found
				for (var i = 0, ien = inst.length; i < ien; i++) {
					if (inst[i].length > 0) {
						// Assign the first element to the first item in the instance
						// and truncate the instance and context
						inst[0] = inst[i];
						inst.length = 1;
						inst.context = [inst.context[i]];
	
						return inst;
					}
				}
	
				// Not found - return an empty instance
				inst.length = 0;
				return inst;
			};
	
			var _selector_row_indexes = function _selector_row_indexes(settings, opts) {
				var i,
				    ien,
				    tmp,
				    a = [],
				    displayFiltered = settings.aiDisplay,
				    displayMaster = settings.aiDisplayMaster;
	
				var search = opts.search,
				    // none, applied, removed
				order = opts.order,
				    // applied, current, index (original - compatibility with 1.9)
				page = opts.page; // all, current
	
				if (_fnDataSource(settings) == 'ssp') {
					// In server-side processing mode, most options are irrelevant since
					// rows not shown don't exist and the index order is the applied order
					// Removed is a special case - for consistency just return an empty
					// array
					return search === 'removed' ? [] : _range(0, displayMaster.length);
				} else if (page == 'current') {
					// Current page implies that order=current and fitler=applied, since it is
					// fairly senseless otherwise, regardless of what order and search actually
					// are
					for (i = settings._iDisplayStart, ien = settings.fnDisplayEnd(); i < ien; i++) {
						a.push(displayFiltered[i]);
					}
				} else if (order == 'current' || order == 'applied') {
					a = search == 'none' ? displayMaster.slice() : // no search
					search == 'applied' ? displayFiltered.slice() : // applied search
					$.map(displayMaster, function (el, i) {
						// removed search
						return $.inArray(el, displayFiltered) === -1 ? el : null;
					});
				} else if (order == 'index' || order == 'original') {
					for (i = 0, ien = settings.aoData.length; i < ien; i++) {
						if (search == 'none') {
							a.push(i);
						} else {
							// applied | removed
							tmp = $.inArray(i, displayFiltered);
	
							if (tmp === -1 && search == 'removed' || tmp >= 0 && search == 'applied') {
								a.push(i);
							}
						}
					}
				}
	
				return a;
			};
	
			/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	   * Rows
	   *
	   * {}          - no selector - use all available rows
	   * {integer}   - row aoData index
	   * {node}      - TR node
	   * {string}    - jQuery selector to apply to the TR elements
	   * {array}     - jQuery array of nodes, or simply an array of TR nodes
	   *
	   */
	
			var __row_selector = function __row_selector(settings, selector, opts) {
				return _selector_run(selector, function (sel) {
					var selInt = _intVal(sel);
					var i, ien;
	
					// Short cut - selector is a number and no options provided (default is
					// all records, so no need to check if the index is in there, since it
					// must be - dev error if the index doesn't exist).
					if (selInt !== null && !opts) {
						return [selInt];
					}
	
					var rows = _selector_row_indexes(settings, opts);
	
					if (selInt !== null && $.inArray(selInt, rows) !== -1) {
						// Selector - integer
						return [selInt];
					} else if (!sel) {
						// Selector - none
						return rows;
					}
	
					// Selector - function
					if (typeof sel === 'function') {
						return $.map(rows, function (idx) {
							var row = settings.aoData[idx];
							return sel(idx, row._aData, row.nTr) ? idx : null;
						});
					}
	
					// Get nodes in the order from the `rows` array with null values removed
					var nodes = _removeEmpty(_pluck_order(settings.aoData, rows, 'nTr'));
	
					// Selector - node
					if (sel.nodeName) {
						if ($.inArray(sel, nodes) !== -1) {
							return [sel._DT_RowIndex]; // sel is a TR node that is in the table
							// and DataTables adds a prop for fast lookup
						}
					}
	
					// Selector - jQuery selector string, array of nodes or jQuery object/
					// As jQuery's .filter() allows jQuery objects to be passed in filter,
					// it also allows arrays, so this will cope with all three options
					return $(nodes).filter(sel).map(function () {
						return this._DT_RowIndex;
					}).toArray();
				});
			};
	
			/**
	   *
	   */
			_api_register('rows()', function (selector, opts) {
				// argument shifting
				if (selector === undefined) {
					selector = '';
				} else if ($.isPlainObject(selector)) {
					opts = selector;
					selector = '';
				}
	
				opts = _selector_opts(opts);
	
				var inst = this.iterator('table', function (settings) {
					return __row_selector(settings, selector, opts);
				}, 1);
	
				// Want argument shifting here and in __row_selector?
				inst.selector.rows = selector;
				inst.selector.opts = opts;
	
				return inst;
			});
	
			_api_register('rows().nodes()', function () {
				return this.iterator('row', function (settings, row) {
					return settings.aoData[row].nTr || undefined;
				}, 1);
			});
	
			_api_register('rows().data()', function () {
				return this.iterator(true, 'rows', function (settings, rows) {
					return _pluck_order(settings.aoData, rows, '_aData');
				}, 1);
			});
	
			_api_registerPlural('rows().cache()', 'row().cache()', function (type) {
				return this.iterator('row', function (settings, row) {
					var r = settings.aoData[row];
					return type === 'search' ? r._aFilterData : r._aSortData;
				}, 1);
			});
	
			_api_registerPlural('rows().invalidate()', 'row().invalidate()', function (src) {
				return this.iterator('row', function (settings, row) {
					_fnInvalidate(settings, row, src);
				});
			});
	
			_api_registerPlural('rows().indexes()', 'row().index()', function () {
				return this.iterator('row', function (settings, row) {
					return row;
				}, 1);
			});
	
			_api_registerPlural('rows().remove()', 'row().remove()', function () {
				var that = this;
	
				return this.iterator('row', function (settings, row, thatIdx) {
					var data = settings.aoData;
	
					data.splice(row, 1);
	
					// Update the _DT_RowIndex parameter on all rows in the table
					for (var i = 0, ien = data.length; i < ien; i++) {
						if (data[i].nTr !== null) {
							data[i].nTr._DT_RowIndex = i;
						}
					}
	
					// Remove the target row from the search array
					var displayIndex = $.inArray(row, settings.aiDisplay);
	
					// Delete from the display arrays
					_fnDeleteIndex(settings.aiDisplayMaster, row);
					_fnDeleteIndex(settings.aiDisplay, row);
					_fnDeleteIndex(that[thatIdx], row, false); // maintain local indexes
	
					// Check for an 'overflow' they case for displaying the table
					_fnLengthOverflow(settings);
				});
			});
	
			_api_register('rows.add()', function (rows) {
				var newRows = this.iterator('table', function (settings) {
					var row, i, ien;
					var out = [];
	
					for (i = 0, ien = rows.length; i < ien; i++) {
						row = rows[i];
	
						if (row.nodeName && row.nodeName.toUpperCase() === 'TR') {
							out.push(_fnAddTr(settings, row)[0]);
						} else {
							out.push(_fnAddData(settings, row));
						}
					}
	
					return out;
				}, 1);
	
				// Return an Api.rows() extended instance, so rows().nodes() etc can be used
				var modRows = this.rows(-1);
				modRows.pop();
				modRows.push.apply(modRows, newRows.toArray());
	
				return modRows;
			});
	
			/**
	   *
	   */
			_api_register('row()', function (selector, opts) {
				return _selector_first(this.rows(selector, opts));
			});
	
			_api_register('row().data()', function (data) {
				var ctx = this.context;
	
				if (data === undefined) {
					// Get
					return ctx.length && this.length ? ctx[0].aoData[this[0]]._aData : undefined;
				}
	
				// Set
				ctx[0].aoData[this[0]]._aData = data;
	
				// Automatically invalidate
				_fnInvalidate(ctx[0], this[0], 'data');
	
				return this;
			});
	
			_api_register('row().node()', function () {
				var ctx = this.context;
	
				return ctx.length && this.length ? ctx[0].aoData[this[0]].nTr || null : null;
			});
	
			_api_register('row.add()', function (row) {
				// Allow a jQuery object to be passed in - only a single row is added from
				// it though - the first element in the set
				if (row instanceof $ && row.length) {
					row = row[0];
				}
	
				var rows = this.iterator('table', function (settings) {
					if (row.nodeName && row.nodeName.toUpperCase() === 'TR') {
						return _fnAddTr(settings, row)[0];
					}
					return _fnAddData(settings, row);
				});
	
				// Return an Api.rows() extended instance, with the newly added row selected
				return this.row(rows[0]);
			});
	
			var __details_add = function __details_add(ctx, row, data, klass) {
				// Convert to array of TR elements
				var rows = [];
				var addRow = function addRow(r, k) {
					// If we get a TR element, then just add it directly - up to the dev
					// to add the correct number of columns etc
					if (r.nodeName && r.nodeName.toLowerCase() === 'tr') {
						rows.push(r);
					} else {
						// Otherwise create a row with a wrapper
						var created = $('<tr><td/></tr>').addClass(k);
						$('td', created).addClass(k).html(r)[0].colSpan = _fnVisbleColumns(ctx);
	
						rows.push(created[0]);
					}
				};
	
				if ($.isArray(data) || data instanceof $) {
					for (var i = 0, ien = data.length; i < ien; i++) {
						addRow(data[i], klass);
					}
				} else {
					addRow(data, klass);
				}
	
				if (row._details) {
					row._details.remove();
				}
	
				row._details = $(rows);
	
				// If the children were already shown, that state should be retained
				if (row._detailsShow) {
					row._details.insertAfter(row.nTr);
				}
			};
	
			var __details_remove = function __details_remove(api, idx) {
				var ctx = api.context;
	
				if (ctx.length) {
					var row = ctx[0].aoData[idx !== undefined ? idx : api[0]];
	
					if (row._details) {
						row._details.remove();
	
						row._detailsShow = undefined;
						row._details = undefined;
					}
				}
			};
	
			var __details_display = function __details_display(api, show) {
				var ctx = api.context;
	
				if (ctx.length && api.length) {
					var row = ctx[0].aoData[api[0]];
	
					if (row._details) {
						row._detailsShow = show;
	
						if (show) {
							row._details.insertAfter(row.nTr);
						} else {
							row._details.detach();
						}
	
						__details_events(ctx[0]);
					}
				}
			};
	
			var __details_events = function __details_events(settings) {
				var api = new _Api2(settings);
				var namespace = '.dt.DT_details';
				var drawEvent = 'draw' + namespace;
				var colvisEvent = 'column-visibility' + namespace;
				var destroyEvent = 'destroy' + namespace;
				var data = settings.aoData;
	
				api.off(drawEvent + ' ' + colvisEvent + ' ' + destroyEvent);
	
				if (_pluck(data, '_details').length > 0) {
					// On each draw, insert the required elements into the document
					api.on(drawEvent, function (e, ctx) {
						if (settings !== ctx) {
							return;
						}
	
						api.rows({ page: 'current' }).eq(0).each(function (idx) {
							// Internal data grab
							var row = data[idx];
	
							if (row._detailsShow) {
								row._details.insertAfter(row.nTr);
							}
						});
					});
	
					// Column visibility change - update the colspan
					api.on(colvisEvent, function (e, ctx, idx, vis) {
						if (settings !== ctx) {
							return;
						}
	
						// Update the colspan for the details rows (note, only if it already has
						// a colspan)
						var row,
						    visible = _fnVisbleColumns(ctx);
	
						for (var i = 0, ien = data.length; i < ien; i++) {
							row = data[i];
	
							if (row._details) {
								row._details.children('td[colspan]').attr('colspan', visible);
							}
						}
					});
	
					// Table destroyed - nuke any child rows
					api.on(destroyEvent, function (e, ctx) {
						if (settings !== ctx) {
							return;
						}
	
						for (var i = 0, ien = data.length; i < ien; i++) {
							if (data[i]._details) {
								__details_remove(api, i);
							}
						}
					});
				}
			};
	
			// Strings for the method names to help minification
			var _emp = '';
			var _child_obj = _emp + 'row().child';
			var _child_mth = _child_obj + '()';
	
			// data can be:
			//  tr
			//  string
			//  jQuery or array of any of the above
			_api_register(_child_mth, function (data, klass) {
				var ctx = this.context;
	
				if (data === undefined) {
					// get
					return ctx.length && this.length ? ctx[0].aoData[this[0]]._details : undefined;
				} else if (data === true) {
					// show
					this.child.show();
				} else if (data === false) {
					// remove
					__details_remove(this);
				} else if (ctx.length && this.length) {
					// set
					__details_add(ctx[0], ctx[0].aoData[this[0]], data, klass);
				}
	
				return this;
			});
	
			_api_register([_child_obj + '.show()', _child_mth + '.show()' // only when `child()` was called with parameters (without
			], function (show) {
				// it returns an object and this method is not executed)
				__details_display(this, true);
				return this;
			});
	
			_api_register([_child_obj + '.hide()', _child_mth + '.hide()' // only when `child()` was called with parameters (without
			], function () {
				// it returns an object and this method is not executed)
				__details_display(this, false);
				return this;
			});
	
			_api_register([_child_obj + '.remove()', _child_mth + '.remove()' // only when `child()` was called with parameters (without
			], function () {
				// it returns an object and this method is not executed)
				__details_remove(this);
				return this;
			});
	
			_api_register(_child_obj + '.isShown()', function () {
				var ctx = this.context;
	
				if (ctx.length && this.length) {
					// _detailsShown as false or undefined will fall through to return false
					return ctx[0].aoData[this[0]]._detailsShow || false;
				}
				return false;
			});
	
			/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	   * Columns
	   *
	   * {integer}           - column index (>=0 count from left, <0 count from right)
	   * "{integer}:visIdx"  - visible column index (i.e. translate to column index)  (>=0 count from left, <0 count from right)
	   * "{integer}:visible" - alias for {integer}:visIdx  (>=0 count from left, <0 count from right)
	   * "{string}:name"     - column name
	   * "{string}"          - jQuery selector on column header nodes
	   *
	   */
	
			// can be an array of these items, comma separated list, or an array of comma
			// separated lists
	
			var __re_column_selector = /^(.+):(name|visIdx|visible)$/;
	
			// r1 and r2 are redundant - but it means that the parameters match for the
			// iterator callback in columns().data()
			var __columnData = function __columnData(settings, column, r1, r2, rows) {
				var a = [];
				for (var row = 0, ien = rows.length; row < ien; row++) {
					a.push(_fnGetCellData(settings, rows[row], column));
				}
				return a;
			};
	
			var __column_selector = function __column_selector(settings, selector, opts) {
				var columns = settings.aoColumns,
				    names = _pluck(columns, 'sName'),
				    nodes = _pluck(columns, 'nTh');
	
				return _selector_run(selector, function (s) {
					var selInt = _intVal(s);
	
					// Selector - all
					if (s === '') {
						return _range(columns.length);
					}
	
					// Selector - index
					if (selInt !== null) {
						return [selInt >= 0 ? selInt : // Count from left
						columns.length + selInt // Count from right (+ because its a negative value)
						];
					}
	
					// Selector = function
					if (typeof s === 'function') {
						var rows = _selector_row_indexes(settings, opts);
	
						return $.map(columns, function (col, idx) {
							return s(idx, __columnData(settings, idx, 0, 0, rows), nodes[idx]) ? idx : null;
						});
					}
	
					// jQuery or string selector
					var match = typeof s === 'string' ? s.match(__re_column_selector) : '';
	
					if (match) {
						switch (match[2]) {
							case 'visIdx':
							case 'visible':
								var idx = parseInt(match[1], 10);
								// Visible index given, convert to column index
								if (idx < 0) {
									// Counting from the right
									var visColumns = $.map(columns, function (col, i) {
										return col.bVisible ? i : null;
									});
									return [visColumns[visColumns.length + idx]];
								}
								// Counting from the left
								return [_fnVisibleToColumnIndex(settings, idx)];
	
							case 'name':
								// match by name. `names` is column index complete and in order
								return $.map(names, function (name, i) {
									return name === match[1] ? i : null;
								});
						}
					} else {
						// jQuery selector on the TH elements for the columns
						return $(nodes).filter(s).map(function () {
							return $.inArray(this, nodes); // `nodes` is column index complete and in order
						}).toArray();
					}
				});
			};
	
			var __setColumnVis = function __setColumnVis(settings, column, vis, recalc) {
				var cols = settings.aoColumns,
				    col = cols[column],
				    data = settings.aoData,
				    row,
				    cells,
				    i,
				    ien,
				    tr;
	
				// Get
				if (vis === undefined) {
					return col.bVisible;
				}
	
				// Set
				// No change
				if (col.bVisible === vis) {
					return;
				}
	
				if (vis) {
					// Insert column
					// Need to decide if we should use appendChild or insertBefore
					var insertBefore = $.inArray(true, _pluck(cols, 'bVisible'), column + 1);
	
					for (i = 0, ien = data.length; i < ien; i++) {
						tr = data[i].nTr;
						cells = data[i].anCells;
	
						if (tr) {
							// insertBefore can act like appendChild if 2nd arg is null
							tr.insertBefore(cells[column], cells[insertBefore] || null);
						}
					}
				} else {
					// Remove column
					$(_pluck(settings.aoData, 'anCells', column)).detach();
				}
	
				// Common actions
				col.bVisible = vis;
				_fnDrawHead(settings, settings.aoHeader);
				_fnDrawHead(settings, settings.aoFooter);
	
				if (recalc === undefined || recalc) {
					// Automatically adjust column sizing
					_fnAdjustColumnSizing(settings);
	
					// Realign columns for scrolling
					if (settings.oScroll.sX || settings.oScroll.sY) {
						_fnScrollDraw(settings);
					}
				}
	
				_fnCallbackFire(settings, null, 'column-visibility', [settings, column, vis]);
	
				_fnSaveState(settings);
			};
	
			/**
	   *
	   */
			_api_register('columns()', function (selector, opts) {
				// argument shifting
				if (selector === undefined) {
					selector = '';
				} else if ($.isPlainObject(selector)) {
					opts = selector;
					selector = '';
				}
	
				opts = _selector_opts(opts);
	
				var inst = this.iterator('table', function (settings) {
					return __column_selector(settings, selector, opts);
				}, 1);
	
				// Want argument shifting here and in _row_selector?
				inst.selector.cols = selector;
				inst.selector.opts = opts;
	
				return inst;
			});
	
			/**
	   *
	   */
			_api_registerPlural('columns().header()', 'column().header()', function (selector, opts) {
				return this.iterator('column', function (settings, column) {
					return settings.aoColumns[column].nTh;
				}, 1);
			});
	
			/**
	   *
	   */
			_api_registerPlural('columns().footer()', 'column().footer()', function (selector, opts) {
				return this.iterator('column', function (settings, column) {
					return settings.aoColumns[column].nTf;
				}, 1);
			});
	
			/**
	   *
	   */
			_api_registerPlural('columns().data()', 'column().data()', function () {
				return this.iterator('column-rows', __columnData, 1);
			});
	
			_api_registerPlural('columns().dataSrc()', 'column().dataSrc()', function () {
				return this.iterator('column', function (settings, column) {
					return settings.aoColumns[column].mData;
				}, 1);
			});
	
			_api_registerPlural('columns().cache()', 'column().cache()', function (type) {
				return this.iterator('column-rows', function (settings, column, i, j, rows) {
					return _pluck_order(settings.aoData, rows, type === 'search' ? '_aFilterData' : '_aSortData', column);
				}, 1);
			});
	
			_api_registerPlural('columns().nodes()', 'column().nodes()', function () {
				return this.iterator('column-rows', function (settings, column, i, j, rows) {
					return _pluck_order(settings.aoData, rows, 'anCells', column);
				}, 1);
			});
	
			_api_registerPlural('columns().visible()', 'column().visible()', function (vis, calc) {
				return this.iterator('column', function (settings, column) {
					if (vis === undefined) {
						return settings.aoColumns[column].bVisible;
					} // else
					__setColumnVis(settings, column, vis, calc);
				});
			});
	
			_api_registerPlural('columns().indexes()', 'column().index()', function (type) {
				return this.iterator('column', function (settings, column) {
					return type === 'visible' ? _fnColumnIndexToVisible(settings, column) : column;
				}, 1);
			});
	
			// _api_register( 'columns().show()', function () {
			// 	var selector = this.selector;
			// 	return this.columns( selector.cols, selector.opts ).visible( true );
			// } );
	
	
			// _api_register( 'columns().hide()', function () {
			// 	var selector = this.selector;
			// 	return this.columns( selector.cols, selector.opts ).visible( false );
			// } );
	
	
			_api_register('columns.adjust()', function () {
				return this.iterator('table', function (settings) {
					_fnAdjustColumnSizing(settings);
				}, 1);
			});
	
			// Convert from one column index type, to another type
			_api_register('column.index()', function (type, idx) {
				if (this.context.length !== 0) {
					var ctx = this.context[0];
	
					if (type === 'fromVisible' || type === 'toData') {
						return _fnVisibleToColumnIndex(ctx, idx);
					} else if (type === 'fromData' || type === 'toVisible') {
						return _fnColumnIndexToVisible(ctx, idx);
					}
				}
			});
	
			_api_register('column()', function (selector, opts) {
				return _selector_first(this.columns(selector, opts));
			});
	
			var __cell_selector = function __cell_selector(settings, selector, opts) {
				var data = settings.aoData;
				var rows = _selector_row_indexes(settings, opts);
				var cells = _removeEmpty(_pluck_order(data, rows, 'anCells'));
				var allCells = $([].concat.apply([], cells));
				var row;
				var columns = settings.aoColumns.length;
				var a, i, ien, j, o, host;
	
				return _selector_run(selector, function (s) {
					var fnSelector = typeof s === 'function';
	
					if (s === null || s === undefined || fnSelector) {
						// All cells and function selectors
						a = [];
	
						for (i = 0, ien = rows.length; i < ien; i++) {
							row = rows[i];
	
							for (j = 0; j < columns; j++) {
								o = {
									row: row,
									column: j
								};
	
								if (fnSelector) {
									// Selector - function
									host = settings.aoData[row];
	
									if (s(o, _fnGetCellData(settings, row, j), host.anCells[j])) {
										a.push(o);
									}
								} else {
									// Selector - all
									a.push(o);
								}
							}
						}
	
						return a;
					}
	
					// Selector - index
					if ($.isPlainObject(s)) {
						return [s];
					}
	
					// Selector - jQuery filtered cells
					return allCells.filter(s).map(function (i, el) {
						row = el.parentNode._DT_RowIndex;
	
						return {
							row: row,
							column: $.inArray(el, data[row].anCells)
						};
					}).toArray();
				});
			};
	
			_api_register('cells()', function (rowSelector, columnSelector, opts) {
				// Argument shifting
				if ($.isPlainObject(rowSelector)) {
					// Indexes
					if (_typeof(rowSelector.row) !== undefined) {
						opts = columnSelector;
						columnSelector = null;
					} else {
						opts = rowSelector;
						rowSelector = null;
					}
				}
				if ($.isPlainObject(columnSelector)) {
					opts = columnSelector;
					columnSelector = null;
				}
	
				// Cell selector
				if (columnSelector === null || columnSelector === undefined) {
					return this.iterator('table', function (settings) {
						return __cell_selector(settings, rowSelector, _selector_opts(opts));
					});
				}
	
				// Row + column selector
				var columns = this.columns(columnSelector, opts);
				var rows = this.rows(rowSelector, opts);
				var a, i, ien, j, jen;
	
				var cells = this.iterator('table', function (settings, idx) {
					a = [];
	
					for (i = 0, ien = rows[idx].length; i < ien; i++) {
						for (j = 0, jen = columns[idx].length; j < jen; j++) {
							a.push({
								row: rows[idx][i],
								column: columns[idx][j]
							});
						}
					}
	
					return a;
				}, 1);
	
				$.extend(cells.selector, {
					cols: columnSelector,
					rows: rowSelector,
					opts: opts
				});
	
				return cells;
			});
	
			_api_registerPlural('cells().nodes()', 'cell().node()', function () {
				return this.iterator('cell', function (settings, row, column) {
					var cells = settings.aoData[row].anCells;
					return cells ? cells[column] : undefined;
				}, 1);
			});
	
			_api_register('cells().data()', function () {
				return this.iterator('cell', function (settings, row, column) {
					return _fnGetCellData(settings, row, column);
				}, 1);
			});
	
			_api_registerPlural('cells().cache()', 'cell().cache()', function (type) {
				type = type === 'search' ? '_aFilterData' : '_aSortData';
	
				return this.iterator('cell', function (settings, row, column) {
					return settings.aoData[row][type][column];
				}, 1);
			});
	
			_api_registerPlural('cells().render()', 'cell().render()', function (type) {
				return this.iterator('cell', function (settings, row, column) {
					return _fnGetCellData(settings, row, column, type);
				}, 1);
			});
	
			_api_registerPlural('cells().indexes()', 'cell().index()', function () {
				return this.iterator('cell', function (settings, row, column) {
					return {
						row: row,
						column: column,
						columnVisible: _fnColumnIndexToVisible(settings, column)
					};
				}, 1);
			});
	
			_api_registerPlural('cells().invalidate()', 'cell().invalidate()', function (src) {
				return this.iterator('cell', function (settings, row, column) {
					_fnInvalidate(settings, row, src, column);
				});
			});
	
			_api_register('cell()', function (rowSelector, columnSelector, opts) {
				return _selector_first(this.cells(rowSelector, columnSelector, opts));
			});
	
			_api_register('cell().data()', function (data) {
				var ctx = this.context;
				var cell = this[0];
	
				if (data === undefined) {
					// Get
					return ctx.length && cell.length ? _fnGetCellData(ctx[0], cell[0].row, cell[0].column) : undefined;
				}
	
				// Set
				_fnSetCellData(ctx[0], cell[0].row, cell[0].column, data);
				_fnInvalidate(ctx[0], cell[0].row, 'data', cell[0].column);
	
				return this;
			});
	
			/**
	   * Get current ordering (sorting) that has been applied to the table.
	   *
	   * @returns {array} 2D array containing the sorting information for the first
	   *   table in the current context. Each element in the parent array represents
	   *   a column being sorted upon (i.e. multi-sorting with two columns would have
	   *   2 inner arrays). The inner arrays may have 2 or 3 elements. The first is
	   *   the column index that the sorting condition applies to, the second is the
	   *   direction of the sort (`desc` or `asc`) and, optionally, the third is the
	   *   index of the sorting order from the `column.sorting` initialisation array.
	   */ /**
	      * Set the ordering for the table.
	      *
	      * @param {integer} order Column index to sort upon.
	      * @param {string} direction Direction of the sort to be applied (`asc` or `desc`)
	      * @returns {DataTables.Api} this
	      */ /**
	         * Set the ordering for the table.
	         *
	         * @param {array} order 1D array of sorting information to be applied.
	         * @param {array} [...] Optional additional sorting conditions
	         * @returns {DataTables.Api} this
	         */ /**
	            * Set the ordering for the table.
	            *
	            * @param {array} order 2D array of sorting information to be applied.
	            * @returns {DataTables.Api} this
	            */
			_api_register('order()', function (order, dir) {
				var ctx = this.context;
	
				if (order === undefined) {
					// get
					return ctx.length !== 0 ? ctx[0].aaSorting : undefined;
				}
	
				// set
				if (typeof order === 'number') {
					// Simple column / direction passed in
					order = [[order, dir]];
				} else if (!$.isArray(order[0])) {
					// Arguments passed in (list of 1D arrays)
					order = Array.prototype.slice.call(arguments);
				}
				// otherwise a 2D array was passed in
	
				return this.iterator('table', function (settings) {
					settings.aaSorting = order.slice();
				});
			});
	
			/**
	   * Attach a sort listener to an element for a given column
	   *
	   * @param {node|jQuery|string} node Identifier for the element(s) to attach the
	   *   listener to. This can take the form of a single DOM node, a jQuery
	   *   collection of nodes or a jQuery selector which will identify the node(s).
	   * @param {integer} column the column that a click on this node will sort on
	   * @param {function} [callback] callback function when sort is run
	   * @returns {DataTables.Api} this
	   */
			_api_register('order.listener()', function (node, column, callback) {
				return this.iterator('table', function (settings) {
					_fnSortAttachListener(settings, node, column, callback);
				});
			});
	
			// Order by the selected column(s)
			_api_register(['columns().order()', 'column().order()'], function (dir) {
				var that = this;
	
				return this.iterator('table', function (settings, i) {
					var sort = [];
	
					$.each(that[i], function (j, col) {
						sort.push([col, dir]);
					});
	
					settings.aaSorting = sort;
				});
			});
	
			_api_register('search()', function (input, regex, smart, caseInsen) {
				var ctx = this.context;
	
				if (input === undefined) {
					// get
					return ctx.length !== 0 ? ctx[0].oPreviousSearch.sSearch : undefined;
				}
	
				// set
				return this.iterator('table', function (settings) {
					if (!settings.oFeatures.bFilter) {
						return;
					}
	
					_fnFilterComplete(settings, $.extend({}, settings.oPreviousSearch, {
						"sSearch": input + "",
						"bRegex": regex === null ? false : regex,
						"bSmart": smart === null ? true : smart,
						"bCaseInsensitive": caseInsen === null ? true : caseInsen
					}), 1);
				});
			});
	
			_api_registerPlural('columns().search()', 'column().search()', function (input, regex, smart, caseInsen) {
				return this.iterator('column', function (settings, column) {
					var preSearch = settings.aoPreSearchCols;
	
					if (input === undefined) {
						// get
						return preSearch[column].sSearch;
					}
	
					// set
					if (!settings.oFeatures.bFilter) {
						return;
					}
	
					$.extend(preSearch[column], {
						"sSearch": input + "",
						"bRegex": regex === null ? false : regex,
						"bSmart": smart === null ? true : smart,
						"bCaseInsensitive": caseInsen === null ? true : caseInsen
					});
	
					_fnFilterComplete(settings, settings.oPreviousSearch, 1);
				});
			});
	
			/*
	   * State API methods
	   */
	
			_api_register('state()', function () {
				return this.context.length ? this.context[0].oSavedState : null;
			});
	
			_api_register('state.clear()', function () {
				return this.iterator('table', function (settings) {
					// Save an empty object
					settings.fnStateSaveCallback.call(settings.oInstance, settings, {});
				});
			});
	
			_api_register('state.loaded()', function () {
				return this.context.length ? this.context[0].oLoadedState : null;
			});
	
			_api_register('state.save()', function () {
				return this.iterator('table', function (settings) {
					_fnSaveState(settings);
				});
			});
	
			/**
	   * Provide a common method for plug-ins to check the version of DataTables being
	   * used, in order to ensure compatibility.
	   *
	   *  @param {string} version Version string to check for, in the format "X.Y.Z".
	   *    Note that the formats "X" and "X.Y" are also acceptable.
	   *  @returns {boolean} true if this version of DataTables is greater or equal to
	   *    the required version, or false if this version of DataTales is not
	   *    suitable
	   *  @static
	   *  @dtopt API-Static
	   *
	   *  @example
	   *    alert( $.fn.dataTable.versionCheck( '1.9.0' ) );
	   */
			_DataTable.versionCheck = _DataTable.fnVersionCheck = function (version) {
				var aThis = _DataTable.version.split('.');
				var aThat = version.split('.');
				var iThis, iThat;
	
				for (var i = 0, iLen = aThat.length; i < iLen; i++) {
					iThis = parseInt(aThis[i], 10) || 0;
					iThat = parseInt(aThat[i], 10) || 0;
	
					// Parts are the same, keep comparing
					if (iThis === iThat) {
						continue;
					}
	
					// Parts are different, return immediately
					return iThis > iThat;
				}
	
				return true;
			};
	
			/**
	   * Check if a `<table>` node is a DataTable table already or not.
	   *
	   *  @param {node|jquery|string} table Table node, jQuery object or jQuery
	   *      selector for the table to test. Note that if more than more than one
	   *      table is passed on, only the first will be checked
	   *  @returns {boolean} true the table given is a DataTable, or false otherwise
	   *  @static
	   *  @dtopt API-Static
	   *
	   *  @example
	   *    if ( ! $.fn.DataTable.isDataTable( '#example' ) ) {
	   *      $('#example').dataTable();
	   *    }
	   */
			_DataTable.isDataTable = _DataTable.fnIsDataTable = function (table) {
				var t = $(table).get(0);
				var is = false;
	
				$.each(_DataTable.settings, function (i, o) {
					if (o.nTable === t || o.nScrollHead === t || o.nScrollFoot === t) {
						is = true;
					}
				});
	
				return is;
			};
	
			/**
	   * Get all DataTable tables that have been initialised - optionally you can
	   * select to get only currently visible tables.
	   *
	   *  @param {boolean} [visible=false] Flag to indicate if you want all (default)
	   *    or visible tables only.
	   *  @returns {array} Array of `table` nodes (not DataTable instances) which are
	   *    DataTables
	   *  @static
	   *  @dtopt API-Static
	   *
	   *  @example
	   *    $.each( $.fn.dataTable.tables(true), function () {
	   *      $(table).DataTable().columns.adjust();
	   *    } );
	   */
			_DataTable.tables = _DataTable.fnTables = function (visible) {
				return $.map(_DataTable.settings, function (o) {
					if (!visible || visible && $(o.nTable).is(':visible')) {
						return o.nTable;
					}
				});
			};
	
			/**
	   * DataTables utility methods
	   * 
	   * This namespace provides helper methods that DataTables uses internally to
	   * create a DataTable, but which are not exclusively used only for DataTables.
	   * These methods can be used by extension authors to save the duplication of
	   * code.
	   *
	   *  @namespace
	   */
			_DataTable.util = {
				/**
	    * Throttle the calls to a function. Arguments and context are maintained
	    * for the throttled function.
	    *
	    * @param {function} fn Function to be called
	    * @param {integer} freq Call frequency in mS
	    * @return {function} Wrapped function
	    */
				throttle: _fnThrottle,
	
				/**
	    * Escape a string such that it can be used in a regular expression
	    *
	    *  @param {string} sVal string to escape
	    *  @returns {string} escaped string
	    */
				escapeRegex: _fnEscapeRegex
			};
	
			/**
	   * Convert from camel case parameters to Hungarian notation. This is made public
	   * for the extensions to provide the same ability as DataTables core to accept
	   * either the 1.9 style Hungarian notation, or the 1.10+ style camelCase
	   * parameters.
	   *
	   *  @param {object} src The model object which holds all parameters that can be
	   *    mapped.
	   *  @param {object} user The object to convert from camel case to Hungarian.
	   *  @param {boolean} force When set to `true`, properties which already have a
	   *    Hungarian value in the `user` object will be overwritten. Otherwise they
	   *    won't be.
	   */
			_DataTable.camelToHungarian = _fnCamelToHungarian;
	
			/**
	   *
	   */
			_api_register('$()', function (selector, opts) {
				var rows = this.rows(opts).nodes(),
				    // Get all rows
				jqRows = $(rows);
	
				return $([].concat(jqRows.filter(selector).toArray(), jqRows.find(selector).toArray()));
			});
	
			// jQuery functions to operate on the tables
			$.each(['on', 'one', 'off'], function (i, key) {
				_api_register(key + '()', function () /* event, handler */{
					var args = Array.prototype.slice.call(arguments);
	
					// Add the `dt` namespace automatically if it isn't already present
					if (!args[0].match(/\.dt\b/)) {
						args[0] += '.dt';
					}
	
					var inst = $(this.tables().nodes());
					inst[key].apply(inst, args);
					return this;
				});
			});
	
			_api_register('clear()', function () {
				return this.iterator('table', function (settings) {
					_fnClearTable(settings);
				});
			});
	
			_api_register('settings()', function () {
				return new _Api2(this.context, this.context);
			});
	
			_api_register('data()', function () {
				return this.iterator('table', function (settings) {
					return _pluck(settings.aoData, '_aData');
				}).flatten();
			});
	
			_api_register('destroy()', function (remove) {
				remove = remove || false;
	
				return this.iterator('table', function (settings) {
					var orig = settings.nTableWrapper.parentNode;
					var classes = settings.oClasses;
					var table = settings.nTable;
					var tbody = settings.nTBody;
					var thead = settings.nTHead;
					var tfoot = settings.nTFoot;
					var jqTable = $(table);
					var jqTbody = $(tbody);
					var jqWrapper = $(settings.nTableWrapper);
					var rows = $.map(settings.aoData, function (r) {
						return r.nTr;
					});
					var i, ien;
	
					// Flag to note that the table is currently being destroyed - no action
					// should be taken
					settings.bDestroying = true;
	
					// Fire off the destroy callbacks for plug-ins etc
					_fnCallbackFire(settings, "aoDestroyCallback", "destroy", [settings]);
	
					// If not being removed from the document, make all columns visible
					if (!remove) {
						new _Api2(settings).columns().visible(true);
					}
	
					// Blitz all `DT` namespaced events (these are internal events, the
					// lowercase, `dt` events are user subscribed and they are responsible
					// for removing them
					jqWrapper.unbind('.DT').find(':not(tbody *)').unbind('.DT');
					$(window).unbind('.DT-' + settings.sInstance);
	
					// When scrolling we had to break the table up - restore it
					if (table != thead.parentNode) {
						jqTable.children('thead').detach();
						jqTable.append(thead);
					}
	
					if (tfoot && table != tfoot.parentNode) {
						jqTable.children('tfoot').detach();
						jqTable.append(tfoot);
					}
	
					// Remove the DataTables generated nodes, events and classes
					jqTable.detach();
					jqWrapper.detach();
	
					settings.aaSorting = [];
					settings.aaSortingFixed = [];
					_fnSortingClasses(settings);
	
					$(rows).removeClass(settings.asStripeClasses.join(' '));
	
					$('th, td', thead).removeClass(classes.sSortable + ' ' + classes.sSortableAsc + ' ' + classes.sSortableDesc + ' ' + classes.sSortableNone);
	
					if (settings.bJUI) {
						$('th span.' + classes.sSortIcon + ', td span.' + classes.sSortIcon, thead).detach();
						$('th, td', thead).each(function () {
							var wrapper = $('div.' + classes.sSortJUIWrapper, this);
							$(this).append(wrapper.contents());
							wrapper.detach();
						});
					}
	
					if (!remove && orig) {
						// insertBefore acts like appendChild if !arg[1]
						orig.insertBefore(table, settings.nTableReinsertBefore);
					}
	
					// Add the TR elements back into the table in their original order
					jqTbody.children().detach();
					jqTbody.append(rows);
	
					// Restore the width of the original table - was read from the style property,
					// so we can restore directly to that
					jqTable.css('width', settings.sDestroyWidth).removeClass(classes.sTable);
	
					// If the were originally stripe classes - then we add them back here.
					// Note this is not fool proof (for example if not all rows had stripe
					// classes - but it's a good effort without getting carried away
					ien = settings.asDestroyStripes.length;
	
					if (ien) {
						jqTbody.children().each(function (i) {
							$(this).addClass(settings.asDestroyStripes[i % ien]);
						});
					}
	
					/* Remove the settings object from the settings array */
					var idx = $.inArray(settings, _DataTable.settings);
					if (idx !== -1) {
						_DataTable.settings.splice(idx, 1);
					}
				});
			});
	
			/**
	   * Version string for plug-ins to check compatibility. Allowed format is
	   * `a.b.c-d` where: a:int, b:int, c:int, d:string(dev|beta|alpha). `d` is used
	   * only for non-release builds. See http://semver.org/ for more information.
	   *  @member
	   *  @type string
	   *  @default Version number
	   */
			_DataTable.version = "1.10.4";
	
			/**
	   * Private data store, containing all of the settings objects that are
	   * created for the tables on a given page.
	   *
	   * Note that the `DataTable.settings` object is aliased to
	   * `jQuery.fn.dataTableExt` through which it may be accessed and
	   * manipulated, or `jQuery.fn.dataTable.settings`.
	   *  @member
	   *  @type array
	   *  @default []
	   *  @private
	   */
			_DataTable.settings = [];
	
			/**
	   * Object models container, for the various models that DataTables has
	   * available to it. These models define the objects that are used to hold
	   * the active state and configuration of the table.
	   *  @namespace
	   */
			_DataTable.models = {};
	
			/**
	   * Template object for the way in which DataTables holds information about
	   * search information for the global filter and individual column filters.
	   *  @namespace
	   */
			_DataTable.models.oSearch = {
				/**
	    * Flag to indicate if the filtering should be case insensitive or not
	    *  @type boolean
	    *  @default true
	    */
				"bCaseInsensitive": true,
	
				/**
	    * Applied search term
	    *  @type string
	    *  @default <i>Empty string</i>
	    */
				"sSearch": "",
	
				/**
	    * Flag to indicate if the search term should be interpreted as a
	    * regular expression (true) or not (false) and therefore and special
	    * regex characters escaped.
	    *  @type boolean
	    *  @default false
	    */
				"bRegex": false,
	
				/**
	    * Flag to indicate if DataTables is to use its smart filtering or not.
	    *  @type boolean
	    *  @default true
	    */
				"bSmart": true
			};
	
			/**
	   * Template object for the way in which DataTables holds information about
	   * each individual row. This is the object format used for the settings
	   * aoData array.
	   *  @namespace
	   */
			_DataTable.models.oRow = {
				/**
	    * TR element for the row
	    *  @type node
	    *  @default null
	    */
				"nTr": null,
	
				/**
	    * Array of TD elements for each row. This is null until the row has been
	    * created.
	    *  @type array nodes
	    *  @default []
	    */
				"anCells": null,
	
				/**
	    * Data object from the original data source for the row. This is either
	    * an array if using the traditional form of DataTables, or an object if
	    * using mData options. The exact type will depend on the passed in
	    * data from the data source, or will be an array if using DOM a data
	    * source.
	    *  @type array|object
	    *  @default []
	    */
				"_aData": [],
	
				/**
	    * Sorting data cache - this array is ostensibly the same length as the
	    * number of columns (although each index is generated only as it is
	    * needed), and holds the data that is used for sorting each column in the
	    * row. We do this cache generation at the start of the sort in order that
	    * the formatting of the sort data need be done only once for each cell
	    * per sort. This array should not be read from or written to by anything
	    * other than the master sorting methods.
	    *  @type array
	    *  @default null
	    *  @private
	    */
				"_aSortData": null,
	
				/**
	    * Per cell filtering data cache. As per the sort data cache, used to
	    * increase the performance of the filtering in DataTables
	    *  @type array
	    *  @default null
	    *  @private
	    */
				"_aFilterData": null,
	
				/**
	    * Filtering data cache. This is the same as the cell filtering cache, but
	    * in this case a string rather than an array. This is easily computed with
	    * a join on `_aFilterData`, but is provided as a cache so the join isn't
	    * needed on every search (memory traded for performance)
	    *  @type array
	    *  @default null
	    *  @private
	    */
				"_sFilterRow": null,
	
				/**
	    * Cache of the class name that DataTables has applied to the row, so we
	    * can quickly look at this variable rather than needing to do a DOM check
	    * on className for the nTr property.
	    *  @type string
	    *  @default <i>Empty string</i>
	    *  @private
	    */
				"_sRowStripe": "",
	
				/**
	    * Denote if the original data source was from the DOM, or the data source
	    * object. This is used for invalidating data, so DataTables can
	    * automatically read data from the original source, unless uninstructed
	    * otherwise.
	    *  @type string
	    *  @default null
	    *  @private
	    */
				"src": null
			};
	
			/**
	   * Template object for the column information object in DataTables. This object
	   * is held in the settings aoColumns array and contains all the information that
	   * DataTables needs about each individual column.
	   *
	   * Note that this object is related to {@link DataTable.defaults.column}
	   * but this one is the internal data store for DataTables's cache of columns.
	   * It should NOT be manipulated outside of DataTables. Any configuration should
	   * be done through the initialisation options.
	   *  @namespace
	   */
			_DataTable.models.oColumn = {
				/**
	    * Column index. This could be worked out on-the-fly with $.inArray, but it
	    * is faster to just hold it as a variable
	    *  @type integer
	    *  @default null
	    */
				"idx": null,
	
				/**
	    * A list of the columns that sorting should occur on when this column
	    * is sorted. That this property is an array allows multi-column sorting
	    * to be defined for a column (for example first name / last name columns
	    * would benefit from this). The values are integers pointing to the
	    * columns to be sorted on (typically it will be a single integer pointing
	    * at itself, but that doesn't need to be the case).
	    *  @type array
	    */
				"aDataSort": null,
	
				/**
	    * Define the sorting directions that are applied to the column, in sequence
	    * as the column is repeatedly sorted upon - i.e. the first value is used
	    * as the sorting direction when the column if first sorted (clicked on).
	    * Sort it again (click again) and it will move on to the next index.
	    * Repeat until loop.
	    *  @type array
	    */
				"asSorting": null,
	
				/**
	    * Flag to indicate if the column is searchable, and thus should be included
	    * in the filtering or not.
	    *  @type boolean
	    */
				"bSearchable": null,
	
				/**
	    * Flag to indicate if the column is sortable or not.
	    *  @type boolean
	    */
				"bSortable": null,
	
				/**
	    * Flag to indicate if the column is currently visible in the table or not
	    *  @type boolean
	    */
				"bVisible": null,
	
				/**
	    * Store for manual type assignment using the `column.type` option. This
	    * is held in store so we can manipulate the column's `sType` property.
	    *  @type string
	    *  @default null
	    *  @private
	    */
				"_sManualType": null,
	
				/**
	    * Flag to indicate if HTML5 data attributes should be used as the data
	    * source for filtering or sorting. True is either are.
	    *  @type boolean
	    *  @default false
	    *  @private
	    */
				"_bAttrSrc": false,
	
				/**
	    * Developer definable function that is called whenever a cell is created (Ajax source,
	    * etc) or processed for input (DOM source). This can be used as a compliment to mRender
	    * allowing you to modify the DOM element (add background colour for example) when the
	    * element is available.
	    *  @type function
	    *  @param {element} nTd The TD node that has been created
	    *  @param {*} sData The Data for the cell
	    *  @param {array|object} oData The data for the whole row
	    *  @param {int} iRow The row index for the aoData data store
	    *  @default null
	    */
				"fnCreatedCell": null,
	
				/**
	    * Function to get data from a cell in a column. You should <b>never</b>
	    * access data directly through _aData internally in DataTables - always use
	    * the method attached to this property. It allows mData to function as
	    * required. This function is automatically assigned by the column
	    * initialisation method
	    *  @type function
	    *  @param {array|object} oData The data array/object for the array
	    *    (i.e. aoData[]._aData)
	    *  @param {string} sSpecific The specific data type you want to get -
	    *    'display', 'type' 'filter' 'sort'
	    *  @returns {*} The data for the cell from the given row's data
	    *  @default null
	    */
				"fnGetData": null,
	
				/**
	    * Function to set data for a cell in the column. You should <b>never</b>
	    * set the data directly to _aData internally in DataTables - always use
	    * this method. It allows mData to function as required. This function
	    * is automatically assigned by the column initialisation method
	    *  @type function
	    *  @param {array|object} oData The data array/object for the array
	    *    (i.e. aoData[]._aData)
	    *  @param {*} sValue Value to set
	    *  @default null
	    */
				"fnSetData": null,
	
				/**
	    * Property to read the value for the cells in the column from the data
	    * source array / object. If null, then the default content is used, if a
	    * function is given then the return from the function is used.
	    *  @type function|int|string|null
	    *  @default null
	    */
				"mData": null,
	
				/**
	    * Partner property to mData which is used (only when defined) to get
	    * the data - i.e. it is basically the same as mData, but without the
	    * 'set' option, and also the data fed to it is the result from mData.
	    * This is the rendering method to match the data method of mData.
	    *  @type function|int|string|null
	    *  @default null
	    */
				"mRender": null,
	
				/**
	    * Unique header TH/TD element for this column - this is what the sorting
	    * listener is attached to (if sorting is enabled.)
	    *  @type node
	    *  @default null
	    */
				"nTh": null,
	
				/**
	    * Unique footer TH/TD element for this column (if there is one). Not used
	    * in DataTables as such, but can be used for plug-ins to reference the
	    * footer for each column.
	    *  @type node
	    *  @default null
	    */
				"nTf": null,
	
				/**
	    * The class to apply to all TD elements in the table's TBODY for the column
	    *  @type string
	    *  @default null
	    */
				"sClass": null,
	
				/**
	    * When DataTables calculates the column widths to assign to each column,
	    * it finds the longest string in each column and then constructs a
	    * temporary table and reads the widths from that. The problem with this
	    * is that "mmm" is much wider then "iiii", but the latter is a longer
	    * string - thus the calculation can go wrong (doing it properly and putting
	    * it into an DOM object and measuring that is horribly(!) slow). Thus as
	    * a "work around" we provide this option. It will append its value to the
	    * text that is found to be the longest string for the column - i.e. padding.
	    *  @type string
	    */
				"sContentPadding": null,
	
				/**
	    * Allows a default value to be given for a column's data, and will be used
	    * whenever a null data source is encountered (this can be because mData
	    * is set to null, or because the data source itself is null).
	    *  @type string
	    *  @default null
	    */
				"sDefaultContent": null,
	
				/**
	    * Name for the column, allowing reference to the column by name as well as
	    * by index (needs a lookup to work by name).
	    *  @type string
	    */
				"sName": null,
	
				/**
	    * Custom sorting data type - defines which of the available plug-ins in
	    * afnSortData the custom sorting will use - if any is defined.
	    *  @type string
	    *  @default std
	    */
				"sSortDataType": 'std',
	
				/**
	    * Class to be applied to the header element when sorting on this column
	    *  @type string
	    *  @default null
	    */
				"sSortingClass": null,
	
				/**
	    * Class to be applied to the header element when sorting on this column -
	    * when jQuery UI theming is used.
	    *  @type string
	    *  @default null
	    */
				"sSortingClassJUI": null,
	
				/**
	    * Title of the column - what is seen in the TH element (nTh).
	    *  @type string
	    */
				"sTitle": null,
	
				/**
	    * Column sorting and filtering type
	    *  @type string
	    *  @default null
	    */
				"sType": null,
	
				/**
	    * Width of the column
	    *  @type string
	    *  @default null
	    */
				"sWidth": null,
	
				/**
	    * Width of the column when it was first "encountered"
	    *  @type string
	    *  @default null
	    */
				"sWidthOrig": null
			};
	
			/*
	   * Developer note: The properties of the object below are given in Hungarian
	   * notation, that was used as the interface for DataTables prior to v1.10, however
	   * from v1.10 onwards the primary interface is camel case. In order to avoid
	   * breaking backwards compatibility utterly with this change, the Hungarian
	   * version is still, internally the primary interface, but is is not documented
	   * - hence the @name tags in each doc comment. This allows a Javascript function
	   * to create a map from Hungarian notation to camel case (going the other direction
	   * would require each property to be listed, which would at around 3K to the size
	   * of DataTables, while this method is about a 0.5K hit.
	   *
	   * Ultimately this does pave the way for Hungarian notation to be dropped
	   * completely, but that is a massive amount of work and will break current
	   * installs (therefore is on-hold until v2).
	   */
	
			/**
	   * Initialisation options that can be given to DataTables at initialisation
	   * time.
	   *  @namespace
	   */
			_DataTable.defaults = {
				/**
	    * An array of data to use for the table, passed in at initialisation which
	    * will be used in preference to any data which is already in the DOM. This is
	    * particularly useful for constructing tables purely in Javascript, for
	    * example with a custom Ajax call.
	    *  @type array
	    *  @default null
	    *
	    *  @dtopt Option
	    *  @name DataTable.defaults.data
	    *
	    *  @example
	    *    // Using a 2D array data source
	    *    $(document).ready( function () {
	    *      $('#example').dataTable( {
	    *        "data": [
	    *          ['Trident', 'Internet Explorer 4.0', 'Win 95+', 4, 'X'],
	    *          ['Trident', 'Internet Explorer 5.0', 'Win 95+', 5, 'C'],
	    *        ],
	    *        "columns": [
	    *          { "title": "Engine" },
	    *          { "title": "Browser" },
	    *          { "title": "Platform" },
	    *          { "title": "Version" },
	    *          { "title": "Grade" }
	    *        ]
	    *      } );
	    *    } );
	    *
	    *  @example
	    *    // Using an array of objects as a data source (`data`)
	    *    $(document).ready( function () {
	    *      $('#example').dataTable( {
	    *        "data": [
	    *          {
	    *            "engine":   "Trident",
	    *            "browser":  "Internet Explorer 4.0",
	    *            "platform": "Win 95+",
	    *            "version":  4,
	    *            "grade":    "X"
	    *          },
	    *          {
	    *            "engine":   "Trident",
	    *            "browser":  "Internet Explorer 5.0",
	    *            "platform": "Win 95+",
	    *            "version":  5,
	    *            "grade":    "C"
	    *          }
	    *        ],
	    *        "columns": [
	    *          { "title": "Engine",   "data": "engine" },
	    *          { "title": "Browser",  "data": "browser" },
	    *          { "title": "Platform", "data": "platform" },
	    *          { "title": "Version",  "data": "version" },
	    *          { "title": "Grade",    "data": "grade" }
	    *        ]
	    *      } );
	    *    } );
	    */
				"aaData": null,
	
				/**
	    * If ordering is enabled, then DataTables will perform a first pass sort on
	    * initialisation. You can define which column(s) the sort is performed
	    * upon, and the sorting direction, with this variable. The `sorting` array
	    * should contain an array for each column to be sorted initially containing
	    * the column's index and a direction string ('asc' or 'desc').
	    *  @type array
	    *  @default [[0,'asc']]
	    *
	    *  @dtopt Option
	    *  @name DataTable.defaults.order
	    *
	    *  @example
	    *    // Sort by 3rd column first, and then 4th column
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "order": [[2,'asc'], [3,'desc']]
	    *      } );
	    *    } );
	    *
	    *    // No initial sorting
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "order": []
	    *      } );
	    *    } );
	    */
				"aaSorting": [[0, 'asc']],
	
				/**
	    * This parameter is basically identical to the `sorting` parameter, but
	    * cannot be overridden by user interaction with the table. What this means
	    * is that you could have a column (visible or hidden) which the sorting
	    * will always be forced on first - any sorting after that (from the user)
	    * will then be performed as required. This can be useful for grouping rows
	    * together.
	    *  @type array
	    *  @default null
	    *
	    *  @dtopt Option
	    *  @name DataTable.defaults.orderFixed
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "orderFixed": [[0,'asc']]
	    *      } );
	    *    } )
	    */
				"aaSortingFixed": [],
	
				/**
	    * DataTables can be instructed to load data to display in the table from a
	    * Ajax source. This option defines how that Ajax call is made and where to.
	    *
	    * The `ajax` property has three different modes of operation, depending on
	    * how it is defined. These are:
	    *
	    * * `string` - Set the URL from where the data should be loaded from.
	    * * `object` - Define properties for `jQuery.ajax`.
	    * * `function` - Custom data get function
	    *
	    * `string`
	    * --------
	    *
	    * As a string, the `ajax` property simply defines the URL from which
	    * DataTables will load data.
	    *
	    * `object`
	    * --------
	    *
	    * As an object, the parameters in the object are passed to
	    * [jQuery.ajax](http://api.jquery.com/jQuery.ajax/) allowing fine control
	    * of the Ajax request. DataTables has a number of default parameters which
	    * you can override using this option. Please refer to the jQuery
	    * documentation for a full description of the options available, although
	    * the following parameters provide additional options in DataTables or
	    * require special consideration:
	    *
	    * * `data` - As with jQuery, `data` can be provided as an object, but it
	    *   can also be used as a function to manipulate the data DataTables sends
	    *   to the server. The function takes a single parameter, an object of
	    *   parameters with the values that DataTables has readied for sending. An
	    *   object may be returned which will be merged into the DataTables
	    *   defaults, or you can add the items to the object that was passed in and
	    *   not return anything from the function. This supersedes `fnServerParams`
	    *   from DataTables 1.9-.
	    *
	    * * `dataSrc` - By default DataTables will look for the property `data` (or
	    *   `aaData` for compatibility with DataTables 1.9-) when obtaining data
	    *   from an Ajax source or for server-side processing - this parameter
	    *   allows that property to be changed. You can use Javascript dotted
	    *   object notation to get a data source for multiple levels of nesting, or
	    *   it my be used as a function. As a function it takes a single parameter,
	    *   the JSON returned from the server, which can be manipulated as
	    *   required, with the returned value being that used by DataTables as the
	    *   data source for the table. This supersedes `sAjaxDataProp` from
	    *   DataTables 1.9-.
	    *
	    * * `success` - Should not be overridden it is used internally in
	    *   DataTables. To manipulate / transform the data returned by the server
	    *   use `ajax.dataSrc`, or use `ajax` as a function (see below).
	    *
	    * `function`
	    * ----------
	    *
	    * As a function, making the Ajax call is left up to yourself allowing
	    * complete control of the Ajax request. Indeed, if desired, a method other
	    * than Ajax could be used to obtain the required data, such as Web storage
	    * or an AIR database.
	    *
	    * The function is given four parameters and no return is required. The
	    * parameters are:
	    *
	    * 1. _object_ - Data to send to the server
	    * 2. _function_ - Callback function that must be executed when the required
	    *    data has been obtained. That data should be passed into the callback
	    *    as the only parameter
	    * 3. _object_ - DataTables settings object for the table
	    *
	    * Note that this supersedes `fnServerData` from DataTables 1.9-.
	    *
	    *  @type string|object|function
	    *  @default null
	    *
	    *  @dtopt Option
	    *  @name DataTable.defaults.ajax
	    *  @since 1.10.0
	    *
	    * @example
	    *   // Get JSON data from a file via Ajax.
	    *   // Note DataTables expects data in the form `{ data: [ ...data... ] }` by default).
	    *   $('#example').dataTable( {
	    *     "ajax": "data.json"
	    *   } );
	    *
	    * @example
	    *   // Get JSON data from a file via Ajax, using `dataSrc` to change
	    *   // `data` to `tableData` (i.e. `{ tableData: [ ...data... ] }`)
	    *   $('#example').dataTable( {
	    *     "ajax": {
	    *       "url": "data.json",
	    *       "dataSrc": "tableData"
	    *     }
	    *   } );
	    *
	    * @example
	    *   // Get JSON data from a file via Ajax, using `dataSrc` to read data
	    *   // from a plain array rather than an array in an object
	    *   $('#example').dataTable( {
	    *     "ajax": {
	    *       "url": "data.json",
	    *       "dataSrc": ""
	    *     }
	    *   } );
	    *
	    * @example
	    *   // Manipulate the data returned from the server - add a link to data
	    *   // (note this can, should, be done using `render` for the column - this
	    *   // is just a simple example of how the data can be manipulated).
	    *   $('#example').dataTable( {
	    *     "ajax": {
	    *       "url": "data.json",
	    *       "dataSrc": function ( json ) {
	    *         for ( var i=0, ien=json.length ; i<ien ; i++ ) {
	    *           json[i][0] = '<a href="/message/'+json[i][0]+'>View message</a>';
	    *         }
	    *         return json;
	    *       }
	    *     }
	    *   } );
	    *
	    * @example
	    *   // Add data to the request
	    *   $('#example').dataTable( {
	    *     "ajax": {
	    *       "url": "data.json",
	    *       "data": function ( d ) {
	    *         return {
	    *           "extra_search": $('#extra').val()
	    *         };
	    *       }
	    *     }
	    *   } );
	    *
	    * @example
	    *   // Send request as POST
	    *   $('#example').dataTable( {
	    *     "ajax": {
	    *       "url": "data.json",
	    *       "type": "POST"
	    *     }
	    *   } );
	    *
	    * @example
	    *   // Get the data from localStorage (could interface with a form for
	    *   // adding, editing and removing rows).
	    *   $('#example').dataTable( {
	    *     "ajax": function (data, callback, settings) {
	    *       callback(
	    *         JSON.parse( localStorage.getItem('dataTablesData') )
	    *       );
	    *     }
	    *   } );
	    */
				"ajax": null,
	
				/**
	    * This parameter allows you to readily specify the entries in the length drop
	    * down menu that DataTables shows when pagination is enabled. It can be
	    * either a 1D array of options which will be used for both the displayed
	    * option and the value, or a 2D array which will use the array in the first
	    * position as the value, and the array in the second position as the
	    * displayed options (useful for language strings such as 'All').
	    *
	    * Note that the `pageLength` property will be automatically set to the
	    * first value given in this array, unless `pageLength` is also provided.
	    *  @type array
	    *  @default [ 10, 25, 50, 100 ]
	    *
	    *  @dtopt Option
	    *  @name DataTable.defaults.lengthMenu
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]]
	    *      } );
	    *    } );
	    */
				"aLengthMenu": [10, 25, 50, 100],
	
				/**
	    * The `columns` option in the initialisation parameter allows you to define
	    * details about the way individual columns behave. For a full list of
	    * column options that can be set, please see
	    * {@link DataTable.defaults.column}. Note that if you use `columns` to
	    * define your columns, you must have an entry in the array for every single
	    * column that you have in your table (these can be null if you don't which
	    * to specify any options).
	    *  @member
	    *
	    *  @name DataTable.defaults.column
	    */
				"aoColumns": null,
	
				/**
	    * Very similar to `columns`, `columnDefs` allows you to target a specific
	    * column, multiple columns, or all columns, using the `targets` property of
	    * each object in the array. This allows great flexibility when creating
	    * tables, as the `columnDefs` arrays can be of any length, targeting the
	    * columns you specifically want. `columnDefs` may use any of the column
	    * options available: {@link DataTable.defaults.column}, but it _must_
	    * have `targets` defined in each object in the array. Values in the `targets`
	    * array may be:
	    *   <ul>
	    *     <li>a string - class name will be matched on the TH for the column</li>
	    *     <li>0 or a positive integer - column index counting from the left</li>
	    *     <li>a negative integer - column index counting from the right</li>
	    *     <li>the string "_all" - all columns (i.e. assign a default)</li>
	    *   </ul>
	    *  @member
	    *
	    *  @name DataTable.defaults.columnDefs
	    */
				"aoColumnDefs": null,
	
				/**
	    * Basically the same as `search`, this parameter defines the individual column
	    * filtering state at initialisation time. The array must be of the same size
	    * as the number of columns, and each element be an object with the parameters
	    * `search` and `escapeRegex` (the latter is optional). 'null' is also
	    * accepted and the default will be used.
	    *  @type array
	    *  @default []
	    *
	    *  @dtopt Option
	    *  @name DataTable.defaults.searchCols
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "searchCols": [
	    *          null,
	    *          { "search": "My filter" },
	    *          null,
	    *          { "search": "^[0-9]", "escapeRegex": false }
	    *        ]
	    *      } );
	    *    } )
	    */
				"aoSearchCols": [],
	
				/**
	    * An array of CSS classes that should be applied to displayed rows. This
	    * array may be of any length, and DataTables will apply each class
	    * sequentially, looping when required.
	    *  @type array
	    *  @default null <i>Will take the values determined by the `oClasses.stripe*`
	    *    options</i>
	    *
	    *  @dtopt Option
	    *  @name DataTable.defaults.stripeClasses
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "stripeClasses": [ 'strip1', 'strip2', 'strip3' ]
	    *      } );
	    *    } )
	    */
				"asStripeClasses": null,
	
				/**
	    * Enable or disable automatic column width calculation. This can be disabled
	    * as an optimisation (it takes some time to calculate the widths) if the
	    * tables widths are passed in using `columns`.
	    *  @type boolean
	    *  @default true
	    *
	    *  @dtopt Features
	    *  @name DataTable.defaults.autoWidth
	    *
	    *  @example
	    *    $(document).ready( function () {
	    *      $('#example').dataTable( {
	    *        "autoWidth": false
	    *      } );
	    *    } );
	    */
				"bAutoWidth": true,
	
				/**
	    * Deferred rendering can provide DataTables with a huge speed boost when you
	    * are using an Ajax or JS data source for the table. This option, when set to
	    * true, will cause DataTables to defer the creation of the table elements for
	    * each row until they are needed for a draw - saving a significant amount of
	    * time.
	    *  @type boolean
	    *  @default false
	    *
	    *  @dtopt Features
	    *  @name DataTable.defaults.deferRender
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "ajax": "sources/arrays.txt",
	    *        "deferRender": true
	    *      } );
	    *    } );
	    */
				"bDeferRender": false,
	
				/**
	    * Replace a DataTable which matches the given selector and replace it with
	    * one which has the properties of the new initialisation object passed. If no
	    * table matches the selector, then the new DataTable will be constructed as
	    * per normal.
	    *  @type boolean
	    *  @default false
	    *
	    *  @dtopt Options
	    *  @name DataTable.defaults.destroy
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "srollY": "200px",
	    *        "paginate": false
	    *      } );
	    *
	    *      // Some time later....
	    *      $('#example').dataTable( {
	    *        "filter": false,
	    *        "destroy": true
	    *      } );
	    *    } );
	    */
				"bDestroy": false,
	
				/**
	    * Enable or disable filtering of data. Filtering in DataTables is "smart" in
	    * that it allows the end user to input multiple words (space separated) and
	    * will match a row containing those words, even if not in the order that was
	    * specified (this allow matching across multiple columns). Note that if you
	    * wish to use filtering in DataTables this must remain 'true' - to remove the
	    * default filtering input box and retain filtering abilities, please use
	    * {@link DataTable.defaults.dom}.
	    *  @type boolean
	    *  @default true
	    *
	    *  @dtopt Features
	    *  @name DataTable.defaults.searching
	    *
	    *  @example
	    *    $(document).ready( function () {
	    *      $('#example').dataTable( {
	    *        "searching": false
	    *      } );
	    *    } );
	    */
				"bFilter": true,
	
				/**
	    * Enable or disable the table information display. This shows information
	    * about the data that is currently visible on the page, including information
	    * about filtered data if that action is being performed.
	    *  @type boolean
	    *  @default true
	    *
	    *  @dtopt Features
	    *  @name DataTable.defaults.info
	    *
	    *  @example
	    *    $(document).ready( function () {
	    *      $('#example').dataTable( {
	    *        "info": false
	    *      } );
	    *    } );
	    */
				"bInfo": true,
	
				/**
	    * Enable jQuery UI ThemeRoller support (required as ThemeRoller requires some
	    * slightly different and additional mark-up from what DataTables has
	    * traditionally used).
	    *  @type boolean
	    *  @default false
	    *
	    *  @dtopt Features
	    *  @name DataTable.defaults.jQueryUI
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "jQueryUI": true
	    *      } );
	    *    } );
	    */
				"bJQueryUI": false,
	
				/**
	    * Allows the end user to select the size of a formatted page from a select
	    * menu (sizes are 10, 25, 50 and 100). Requires pagination (`paginate`).
	    *  @type boolean
	    *  @default true
	    *
	    *  @dtopt Features
	    *  @name DataTable.defaults.lengthChange
	    *
	    *  @example
	    *    $(document).ready( function () {
	    *      $('#example').dataTable( {
	    *        "lengthChange": false
	    *      } );
	    *    } );
	    */
				"bLengthChange": true,
	
				/**
	    * Enable or disable pagination.
	    *  @type boolean
	    *  @default true
	    *
	    *  @dtopt Features
	    *  @name DataTable.defaults.paging
	    *
	    *  @example
	    *    $(document).ready( function () {
	    *      $('#example').dataTable( {
	    *        "paging": false
	    *      } );
	    *    } );
	    */
				"bPaginate": true,
	
				/**
	    * Enable or disable the display of a 'processing' indicator when the table is
	    * being processed (e.g. a sort). This is particularly useful for tables with
	    * large amounts of data where it can take a noticeable amount of time to sort
	    * the entries.
	    *  @type boolean
	    *  @default false
	    *
	    *  @dtopt Features
	    *  @name DataTable.defaults.processing
	    *
	    *  @example
	    *    $(document).ready( function () {
	    *      $('#example').dataTable( {
	    *        "processing": true
	    *      } );
	    *    } );
	    */
				"bProcessing": false,
	
				/**
	    * Retrieve the DataTables object for the given selector. Note that if the
	    * table has already been initialised, this parameter will cause DataTables
	    * to simply return the object that has already been set up - it will not take
	    * account of any changes you might have made to the initialisation object
	    * passed to DataTables (setting this parameter to true is an acknowledgement
	    * that you understand this). `destroy` can be used to reinitialise a table if
	    * you need.
	    *  @type boolean
	    *  @default false
	    *
	    *  @dtopt Options
	    *  @name DataTable.defaults.retrieve
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      initTable();
	    *      tableActions();
	    *    } );
	    *
	    *    function initTable ()
	    *    {
	    *      return $('#example').dataTable( {
	    *        "scrollY": "200px",
	    *        "paginate": false,
	    *        "retrieve": true
	    *      } );
	    *    }
	    *
	    *    function tableActions ()
	    *    {
	    *      var table = initTable();
	    *      // perform API operations with oTable
	    *    }
	    */
				"bRetrieve": false,
	
				/**
	    * When vertical (y) scrolling is enabled, DataTables will force the height of
	    * the table's viewport to the given height at all times (useful for layout).
	    * However, this can look odd when filtering data down to a small data set,
	    * and the footer is left "floating" further down. This parameter (when
	    * enabled) will cause DataTables to collapse the table's viewport down when
	    * the result set will fit within the given Y height.
	    *  @type boolean
	    *  @default false
	    *
	    *  @dtopt Options
	    *  @name DataTable.defaults.scrollCollapse
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "scrollY": "200",
	    *        "scrollCollapse": true
	    *      } );
	    *    } );
	    */
				"bScrollCollapse": false,
	
				/**
	    * Configure DataTables to use server-side processing. Note that the
	    * `ajax` parameter must also be given in order to give DataTables a
	    * source to obtain the required data for each draw.
	    *  @type boolean
	    *  @default false
	    *
	    *  @dtopt Features
	    *  @dtopt Server-side
	    *  @name DataTable.defaults.serverSide
	    *
	    *  @example
	    *    $(document).ready( function () {
	    *      $('#example').dataTable( {
	    *        "serverSide": true,
	    *        "ajax": "xhr.php"
	    *      } );
	    *    } );
	    */
				"bServerSide": false,
	
				/**
	    * Enable or disable sorting of columns. Sorting of individual columns can be
	    * disabled by the `sortable` option for each column.
	    *  @type boolean
	    *  @default true
	    *
	    *  @dtopt Features
	    *  @name DataTable.defaults.ordering
	    *
	    *  @example
	    *    $(document).ready( function () {
	    *      $('#example').dataTable( {
	    *        "ordering": false
	    *      } );
	    *    } );
	    */
				"bSort": true,
	
				/**
	    * Enable or display DataTables' ability to sort multiple columns at the
	    * same time (activated by shift-click by the user).
	    *  @type boolean
	    *  @default true
	    *
	    *  @dtopt Options
	    *  @name DataTable.defaults.orderMulti
	    *
	    *  @example
	    *    // Disable multiple column sorting ability
	    *    $(document).ready( function () {
	    *      $('#example').dataTable( {
	    *        "orderMulti": false
	    *      } );
	    *    } );
	    */
				"bSortMulti": true,
	
				/**
	    * Allows control over whether DataTables should use the top (true) unique
	    * cell that is found for a single column, or the bottom (false - default).
	    * This is useful when using complex headers.
	    *  @type boolean
	    *  @default false
	    *
	    *  @dtopt Options
	    *  @name DataTable.defaults.orderCellsTop
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "orderCellsTop": true
	    *      } );
	    *    } );
	    */
				"bSortCellsTop": false,
	
				/**
	    * Enable or disable the addition of the classes `sorting\_1`, `sorting\_2` and
	    * `sorting\_3` to the columns which are currently being sorted on. This is
	    * presented as a feature switch as it can increase processing time (while
	    * classes are removed and added) so for large data sets you might want to
	    * turn this off.
	    *  @type boolean
	    *  @default true
	    *
	    *  @dtopt Features
	    *  @name DataTable.defaults.orderClasses
	    *
	    *  @example
	    *    $(document).ready( function () {
	    *      $('#example').dataTable( {
	    *        "orderClasses": false
	    *      } );
	    *    } );
	    */
				"bSortClasses": true,
	
				/**
	    * Enable or disable state saving. When enabled HTML5 `localStorage` will be
	    * used to save table display information such as pagination information,
	    * display length, filtering and sorting. As such when the end user reloads
	    * the page the display display will match what thy had previously set up.
	    *
	    * Due to the use of `localStorage` the default state saving is not supported
	    * in IE6 or 7. If state saving is required in those browsers, use
	    * `stateSaveCallback` to provide a storage solution such as cookies.
	    *  @type boolean
	    *  @default false
	    *
	    *  @dtopt Features
	    *  @name DataTable.defaults.stateSave
	    *
	    *  @example
	    *    $(document).ready( function () {
	    *      $('#example').dataTable( {
	    *        "stateSave": true
	    *      } );
	    *    } );
	    */
				"bStateSave": false,
	
				/**
	    * This function is called when a TR element is created (and all TD child
	    * elements have been inserted), or registered if using a DOM source, allowing
	    * manipulation of the TR element (adding classes etc).
	    *  @type function
	    *  @param {node} row "TR" element for the current row
	    *  @param {array} data Raw data array for this row
	    *  @param {int} dataIndex The index of this row in the internal aoData array
	    *
	    *  @dtopt Callbacks
	    *  @name DataTable.defaults.createdRow
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "createdRow": function( row, data, dataIndex ) {
	    *          // Bold the grade for all 'A' grade browsers
	    *          if ( data[4] == "A" )
	    *          {
	    *            $('td:eq(4)', row).html( '<b>A</b>' );
	    *          }
	    *        }
	    *      } );
	    *    } );
	    */
				"fnCreatedRow": null,
	
				/**
	    * This function is called on every 'draw' event, and allows you to
	    * dynamically modify any aspect you want about the created DOM.
	    *  @type function
	    *  @param {object} settings DataTables settings object
	    *
	    *  @dtopt Callbacks
	    *  @name DataTable.defaults.drawCallback
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "drawCallback": function( settings ) {
	    *          alert( 'DataTables has redrawn the table' );
	    *        }
	    *      } );
	    *    } );
	    */
				"fnDrawCallback": null,
	
				/**
	    * Identical to fnHeaderCallback() but for the table footer this function
	    * allows you to modify the table footer on every 'draw' event.
	    *  @type function
	    *  @param {node} foot "TR" element for the footer
	    *  @param {array} data Full table data (as derived from the original HTML)
	    *  @param {int} start Index for the current display starting point in the
	    *    display array
	    *  @param {int} end Index for the current display ending point in the
	    *    display array
	    *  @param {array int} display Index array to translate the visual position
	    *    to the full data array
	    *
	    *  @dtopt Callbacks
	    *  @name DataTable.defaults.footerCallback
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "footerCallback": function( tfoot, data, start, end, display ) {
	    *          tfoot.getElementsByTagName('th')[0].innerHTML = "Starting index is "+start;
	    *        }
	    *      } );
	    *    } )
	    */
				"fnFooterCallback": null,
	
				/**
	    * When rendering large numbers in the information element for the table
	    * (i.e. "Showing 1 to 10 of 57 entries") DataTables will render large numbers
	    * to have a comma separator for the 'thousands' units (e.g. 1 million is
	    * rendered as "1,000,000") to help readability for the end user. This
	    * function will override the default method DataTables uses.
	    *  @type function
	    *  @member
	    *  @param {int} toFormat number to be formatted
	    *  @returns {string} formatted string for DataTables to show the number
	    *
	    *  @dtopt Callbacks
	    *  @name DataTable.defaults.formatNumber
	    *
	    *  @example
	    *    // Format a number using a single quote for the separator (note that
	    *    // this can also be done with the language.thousands option)
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "formatNumber": function ( toFormat ) {
	    *          return toFormat.toString().replace(
	    *            /\B(?=(\d{3})+(?!\d))/g, "'"
	    *          );
	    *        };
	    *      } );
	    *    } );
	    */
				"fnFormatNumber": function fnFormatNumber(toFormat) {
					return toFormat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, this.oLanguage.sThousands);
				},
	
				/**
	    * This function is called on every 'draw' event, and allows you to
	    * dynamically modify the header row. This can be used to calculate and
	    * display useful information about the table.
	    *  @type function
	    *  @param {node} head "TR" element for the header
	    *  @param {array} data Full table data (as derived from the original HTML)
	    *  @param {int} start Index for the current display starting point in the
	    *    display array
	    *  @param {int} end Index for the current display ending point in the
	    *    display array
	    *  @param {array int} display Index array to translate the visual position
	    *    to the full data array
	    *
	    *  @dtopt Callbacks
	    *  @name DataTable.defaults.headerCallback
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "fheaderCallback": function( head, data, start, end, display ) {
	    *          head.getElementsByTagName('th')[0].innerHTML = "Displaying "+(end-start)+" records";
	    *        }
	    *      } );
	    *    } )
	    */
				"fnHeaderCallback": null,
	
				/**
	    * The information element can be used to convey information about the current
	    * state of the table. Although the internationalisation options presented by
	    * DataTables are quite capable of dealing with most customisations, there may
	    * be times where you wish to customise the string further. This callback
	    * allows you to do exactly that.
	    *  @type function
	    *  @param {object} oSettings DataTables settings object
	    *  @param {int} start Starting position in data for the draw
	    *  @param {int} end End position in data for the draw
	    *  @param {int} max Total number of rows in the table (regardless of
	    *    filtering)
	    *  @param {int} total Total number of rows in the data set, after filtering
	    *  @param {string} pre The string that DataTables has formatted using it's
	    *    own rules
	    *  @returns {string} The string to be displayed in the information element.
	    *
	    *  @dtopt Callbacks
	    *  @name DataTable.defaults.infoCallback
	    *
	    *  @example
	    *    $('#example').dataTable( {
	    *      "infoCallback": function( settings, start, end, max, total, pre ) {
	    *        return start +" to "+ end;
	    *      }
	    *    } );
	    */
				"fnInfoCallback": null,
	
				/**
	    * Called when the table has been initialised. Normally DataTables will
	    * initialise sequentially and there will be no need for this function,
	    * however, this does not hold true when using external language information
	    * since that is obtained using an async XHR call.
	    *  @type function
	    *  @param {object} settings DataTables settings object
	    *  @param {object} json The JSON object request from the server - only
	    *    present if client-side Ajax sourced data is used
	    *
	    *  @dtopt Callbacks
	    *  @name DataTable.defaults.initComplete
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "initComplete": function(settings, json) {
	    *          alert( 'DataTables has finished its initialisation.' );
	    *        }
	    *      } );
	    *    } )
	    */
				"fnInitComplete": null,
	
				/**
	    * Called at the very start of each table draw and can be used to cancel the
	    * draw by returning false, any other return (including undefined) results in
	    * the full draw occurring).
	    *  @type function
	    *  @param {object} settings DataTables settings object
	    *  @returns {boolean} False will cancel the draw, anything else (including no
	    *    return) will allow it to complete.
	    *
	    *  @dtopt Callbacks
	    *  @name DataTable.defaults.preDrawCallback
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "preDrawCallback": function( settings ) {
	    *          if ( $('#test').val() == 1 ) {
	    *            return false;
	    *          }
	    *        }
	    *      } );
	    *    } );
	    */
				"fnPreDrawCallback": null,
	
				/**
	    * This function allows you to 'post process' each row after it have been
	    * generated for each table draw, but before it is rendered on screen. This
	    * function might be used for setting the row class name etc.
	    *  @type function
	    *  @param {node} row "TR" element for the current row
	    *  @param {array} data Raw data array for this row
	    *  @param {int} displayIndex The display index for the current table draw
	    *  @param {int} displayIndexFull The index of the data in the full list of
	    *    rows (after filtering)
	    *
	    *  @dtopt Callbacks
	    *  @name DataTable.defaults.rowCallback
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "rowCallback": function( row, data, displayIndex, displayIndexFull ) {
	    *          // Bold the grade for all 'A' grade browsers
	    *          if ( data[4] == "A" ) {
	    *            $('td:eq(4)', row).html( '<b>A</b>' );
	    *          }
	    *        }
	    *      } );
	    *    } );
	    */
				"fnRowCallback": null,
	
				/**
	    * __Deprecated__ The functionality provided by this parameter has now been
	    * superseded by that provided through `ajax`, which should be used instead.
	    *
	    * This parameter allows you to override the default function which obtains
	    * the data from the server so something more suitable for your application.
	    * For example you could use POST data, or pull information from a Gears or
	    * AIR database.
	    *  @type function
	    *  @member
	    *  @param {string} source HTTP source to obtain the data from (`ajax`)
	    *  @param {array} data A key/value pair object containing the data to send
	    *    to the server
	    *  @param {function} callback to be called on completion of the data get
	    *    process that will draw the data on the page.
	    *  @param {object} settings DataTables settings object
	    *
	    *  @dtopt Callbacks
	    *  @dtopt Server-side
	    *  @name DataTable.defaults.serverData
	    *
	    *  @deprecated 1.10. Please use `ajax` for this functionality now.
	    */
				"fnServerData": null,
	
				/**
	    * __Deprecated__ The functionality provided by this parameter has now been
	    * superseded by that provided through `ajax`, which should be used instead.
	    *
	    *  It is often useful to send extra data to the server when making an Ajax
	    * request - for example custom filtering information, and this callback
	    * function makes it trivial to send extra information to the server. The
	    * passed in parameter is the data set that has been constructed by
	    * DataTables, and you can add to this or modify it as you require.
	    *  @type function
	    *  @param {array} data Data array (array of objects which are name/value
	    *    pairs) that has been constructed by DataTables and will be sent to the
	    *    server. In the case of Ajax sourced data with server-side processing
	    *    this will be an empty array, for server-side processing there will be a
	    *    significant number of parameters!
	    *  @returns {undefined} Ensure that you modify the data array passed in,
	    *    as this is passed by reference.
	    *
	    *  @dtopt Callbacks
	    *  @dtopt Server-side
	    *  @name DataTable.defaults.serverParams
	    *
	    *  @deprecated 1.10. Please use `ajax` for this functionality now.
	    */
				"fnServerParams": null,
	
				/**
	    * Load the table state. With this function you can define from where, and how, the
	    * state of a table is loaded. By default DataTables will load from `localStorage`
	    * but you might wish to use a server-side database or cookies.
	    *  @type function
	    *  @member
	    *  @param {object} settings DataTables settings object
	    *  @return {object} The DataTables state object to be loaded
	    *
	    *  @dtopt Callbacks
	    *  @name DataTable.defaults.stateLoadCallback
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "stateSave": true,
	    *        "stateLoadCallback": function (settings) {
	    *          var o;
	    *
	    *          // Send an Ajax request to the server to get the data. Note that
	    *          // this is a synchronous request.
	    *          $.ajax( {
	    *            "url": "/state_load",
	    *            "async": false,
	    *            "dataType": "json",
	    *            "success": function (json) {
	    *              o = json;
	    *            }
	    *          } );
	    *
	    *          return o;
	    *        }
	    *      } );
	    *    } );
	    */
				"fnStateLoadCallback": function fnStateLoadCallback(settings) {
					try {
						return JSON.parse((settings.iStateDuration === -1 ? sessionStorage : localStorage).getItem('DataTables_' + settings.sInstance + '_' + location.pathname));
					} catch (e) {}
				},
	
				/**
	    * Callback which allows modification of the saved state prior to loading that state.
	    * This callback is called when the table is loading state from the stored data, but
	    * prior to the settings object being modified by the saved state. Note that for
	    * plug-in authors, you should use the `stateLoadParams` event to load parameters for
	    * a plug-in.
	    *  @type function
	    *  @param {object} settings DataTables settings object
	    *  @param {object} data The state object that is to be loaded
	    *
	    *  @dtopt Callbacks
	    *  @name DataTable.defaults.stateLoadParams
	    *
	    *  @example
	    *    // Remove a saved filter, so filtering is never loaded
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "stateSave": true,
	    *        "stateLoadParams": function (settings, data) {
	    *          data.oSearch.sSearch = "";
	    *        }
	    *      } );
	    *    } );
	    *
	    *  @example
	    *    // Disallow state loading by returning false
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "stateSave": true,
	    *        "stateLoadParams": function (settings, data) {
	    *          return false;
	    *        }
	    *      } );
	    *    } );
	    */
				"fnStateLoadParams": null,
	
				/**
	    * Callback that is called when the state has been loaded from the state saving method
	    * and the DataTables settings object has been modified as a result of the loaded state.
	    *  @type function
	    *  @param {object} settings DataTables settings object
	    *  @param {object} data The state object that was loaded
	    *
	    *  @dtopt Callbacks
	    *  @name DataTable.defaults.stateLoaded
	    *
	    *  @example
	    *    // Show an alert with the filtering value that was saved
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "stateSave": true,
	    *        "stateLoaded": function (settings, data) {
	    *          alert( 'Saved filter was: '+data.oSearch.sSearch );
	    *        }
	    *      } );
	    *    } );
	    */
				"fnStateLoaded": null,
	
				/**
	    * Save the table state. This function allows you to define where and how the state
	    * information for the table is stored By default DataTables will use `localStorage`
	    * but you might wish to use a server-side database or cookies.
	    *  @type function
	    *  @member
	    *  @param {object} settings DataTables settings object
	    *  @param {object} data The state object to be saved
	    *
	    *  @dtopt Callbacks
	    *  @name DataTable.defaults.stateSaveCallback
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "stateSave": true,
	    *        "stateSaveCallback": function (settings, data) {
	    *          // Send an Ajax request to the server with the state object
	    *          $.ajax( {
	    *            "url": "/state_save",
	    *            "data": data,
	    *            "dataType": "json",
	    *            "method": "POST"
	    *            "success": function () {}
	    *          } );
	    *        }
	    *      } );
	    *    } );
	    */
				"fnStateSaveCallback": function fnStateSaveCallback(settings, data) {
					try {
						(settings.iStateDuration === -1 ? sessionStorage : localStorage).setItem('DataTables_' + settings.sInstance + '_' + location.pathname, JSON.stringify(data));
					} catch (e) {}
				},
	
				/**
	    * Callback which allows modification of the state to be saved. Called when the table
	    * has changed state a new state save is required. This method allows modification of
	    * the state saving object prior to actually doing the save, including addition or
	    * other state properties or modification. Note that for plug-in authors, you should
	    * use the `stateSaveParams` event to save parameters for a plug-in.
	    *  @type function
	    *  @param {object} settings DataTables settings object
	    *  @param {object} data The state object to be saved
	    *
	    *  @dtopt Callbacks
	    *  @name DataTable.defaults.stateSaveParams
	    *
	    *  @example
	    *    // Remove a saved filter, so filtering is never saved
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "stateSave": true,
	    *        "stateSaveParams": function (settings, data) {
	    *          data.oSearch.sSearch = "";
	    *        }
	    *      } );
	    *    } );
	    */
				"fnStateSaveParams": null,
	
				/**
	    * Duration for which the saved state information is considered valid. After this period
	    * has elapsed the state will be returned to the default.
	    * Value is given in seconds.
	    *  @type int
	    *  @default 7200 <i>(2 hours)</i>
	    *
	    *  @dtopt Options
	    *  @name DataTable.defaults.stateDuration
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "stateDuration": 60*60*24; // 1 day
	    *      } );
	    *    } )
	    */
				"iStateDuration": 7200,
	
				/**
	    * When enabled DataTables will not make a request to the server for the first
	    * page draw - rather it will use the data already on the page (no sorting etc
	    * will be applied to it), thus saving on an XHR at load time. `deferLoading`
	    * is used to indicate that deferred loading is required, but it is also used
	    * to tell DataTables how many records there are in the full table (allowing
	    * the information element and pagination to be displayed correctly). In the case
	    * where a filtering is applied to the table on initial load, this can be
	    * indicated by giving the parameter as an array, where the first element is
	    * the number of records available after filtering and the second element is the
	    * number of records without filtering (allowing the table information element
	    * to be shown correctly).
	    *  @type int | array
	    *  @default null
	    *
	    *  @dtopt Options
	    *  @name DataTable.defaults.deferLoading
	    *
	    *  @example
	    *    // 57 records available in the table, no filtering applied
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "serverSide": true,
	    *        "ajax": "scripts/server_processing.php",
	    *        "deferLoading": 57
	    *      } );
	    *    } );
	    *
	    *  @example
	    *    // 57 records after filtering, 100 without filtering (an initial filter applied)
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "serverSide": true,
	    *        "ajax": "scripts/server_processing.php",
	    *        "deferLoading": [ 57, 100 ],
	    *        "search": {
	    *          "search": "my_filter"
	    *        }
	    *      } );
	    *    } );
	    */
				"iDeferLoading": null,
	
				/**
	    * Number of rows to display on a single page when using pagination. If
	    * feature enabled (`lengthChange`) then the end user will be able to override
	    * this to a custom setting using a pop-up menu.
	    *  @type int
	    *  @default 10
	    *
	    *  @dtopt Options
	    *  @name DataTable.defaults.pageLength
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "pageLength": 50
	    *      } );
	    *    } )
	    */
				"iDisplayLength": 10,
	
				/**
	    * Define the starting point for data display when using DataTables with
	    * pagination. Note that this parameter is the number of records, rather than
	    * the page number, so if you have 10 records per page and want to start on
	    * the third page, it should be "20".
	    *  @type int
	    *  @default 0
	    *
	    *  @dtopt Options
	    *  @name DataTable.defaults.displayStart
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "displayStart": 20
	    *      } );
	    *    } )
	    */
				"iDisplayStart": 0,
	
				/**
	    * By default DataTables allows keyboard navigation of the table (sorting, paging,
	    * and filtering) by adding a `tabindex` attribute to the required elements. This
	    * allows you to tab through the controls and press the enter key to activate them.
	    * The tabindex is default 0, meaning that the tab follows the flow of the document.
	    * You can overrule this using this parameter if you wish. Use a value of -1 to
	    * disable built-in keyboard navigation.
	    *  @type int
	    *  @default 0
	    *
	    *  @dtopt Options
	    *  @name DataTable.defaults.tabIndex
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "tabIndex": 1
	    *      } );
	    *    } );
	    */
				"iTabIndex": 0,
	
				/**
	    * Classes that DataTables assigns to the various components and features
	    * that it adds to the HTML table. This allows classes to be configured
	    * during initialisation in addition to through the static
	    * {@link DataTable.ext.oStdClasses} object).
	    *  @namespace
	    *  @name DataTable.defaults.classes
	    */
				"oClasses": {},
	
				/**
	    * All strings that DataTables uses in the user interface that it creates
	    * are defined in this object, allowing you to modified them individually or
	    * completely replace them all as required.
	    *  @namespace
	    *  @name DataTable.defaults.language
	    */
				"oLanguage": {
					/**
	     * Strings that are used for WAI-ARIA labels and controls only (these are not
	     * actually visible on the page, but will be read by screenreaders, and thus
	     * must be internationalised as well).
	     *  @namespace
	     *  @name DataTable.defaults.language.aria
	     */
					"oAria": {
						/**
	      * ARIA label that is added to the table headers when the column may be
	      * sorted ascending by activing the column (click or return when focused).
	      * Note that the column header is prefixed to this string.
	      *  @type string
	      *  @default : activate to sort column ascending
	      *
	      *  @dtopt Language
	      *  @name DataTable.defaults.language.aria.sortAscending
	      *
	      *  @example
	      *    $(document).ready( function() {
	      *      $('#example').dataTable( {
	      *        "language": {
	      *          "aria": {
	      *            "sortAscending": " - click/return to sort ascending"
	      *          }
	      *        }
	      *      } );
	      *    } );
	      */
						"sSortAscending": ": activate to sort column ascending",
	
						/**
	      * ARIA label that is added to the table headers when the column may be
	      * sorted descending by activing the column (click or return when focused).
	      * Note that the column header is prefixed to this string.
	      *  @type string
	      *  @default : activate to sort column ascending
	      *
	      *  @dtopt Language
	      *  @name DataTable.defaults.language.aria.sortDescending
	      *
	      *  @example
	      *    $(document).ready( function() {
	      *      $('#example').dataTable( {
	      *        "language": {
	      *          "aria": {
	      *            "sortDescending": " - click/return to sort descending"
	      *          }
	      *        }
	      *      } );
	      *    } );
	      */
						"sSortDescending": ": activate to sort column descending"
					},
	
					/**
	     * Pagination string used by DataTables for the built-in pagination
	     * control types.
	     *  @namespace
	     *  @name DataTable.defaults.language.paginate
	     */
					"oPaginate": {
						/**
	      * Text to use when using the 'full_numbers' type of pagination for the
	      * button to take the user to the first page.
	      *  @type string
	      *  @default First
	      *
	      *  @dtopt Language
	      *  @name DataTable.defaults.language.paginate.first
	      *
	      *  @example
	      *    $(document).ready( function() {
	      *      $('#example').dataTable( {
	      *        "language": {
	      *          "paginate": {
	      *            "first": "First page"
	      *          }
	      *        }
	      *      } );
	      *    } );
	      */
						"sFirst": "First",
	
						/**
	      * Text to use when using the 'full_numbers' type of pagination for the
	      * button to take the user to the last page.
	      *  @type string
	      *  @default Last
	      *
	      *  @dtopt Language
	      *  @name DataTable.defaults.language.paginate.last
	      *
	      *  @example
	      *    $(document).ready( function() {
	      *      $('#example').dataTable( {
	      *        "language": {
	      *          "paginate": {
	      *            "last": "Last page"
	      *          }
	      *        }
	      *      } );
	      *    } );
	      */
						"sLast": "Last",
	
						/**
	      * Text to use for the 'next' pagination button (to take the user to the
	      * next page).
	      *  @type string
	      *  @default Next
	      *
	      *  @dtopt Language
	      *  @name DataTable.defaults.language.paginate.next
	      *
	      *  @example
	      *    $(document).ready( function() {
	      *      $('#example').dataTable( {
	      *        "language": {
	      *          "paginate": {
	      *            "next": "Next page"
	      *          }
	      *        }
	      *      } );
	      *    } );
	      */
						"sNext": "Next",
	
						/**
	      * Text to use for the 'previous' pagination button (to take the user to
	      * the previous page).
	      *  @type string
	      *  @default Previous
	      *
	      *  @dtopt Language
	      *  @name DataTable.defaults.language.paginate.previous
	      *
	      *  @example
	      *    $(document).ready( function() {
	      *      $('#example').dataTable( {
	      *        "language": {
	      *          "paginate": {
	      *            "previous": "Previous page"
	      *          }
	      *        }
	      *      } );
	      *    } );
	      */
						"sPrevious": "Previous"
					},
	
					/**
	     * This string is shown in preference to `zeroRecords` when the table is
	     * empty of data (regardless of filtering). Note that this is an optional
	     * parameter - if it is not given, the value of `zeroRecords` will be used
	     * instead (either the default or given value).
	     *  @type string
	     *  @default No data available in table
	     *
	     *  @dtopt Language
	     *  @name DataTable.defaults.language.emptyTable
	     *
	     *  @example
	     *    $(document).ready( function() {
	     *      $('#example').dataTable( {
	     *        "language": {
	     *          "emptyTable": "No data available in table"
	     *        }
	     *      } );
	     *    } );
	     */
					"sEmptyTable": "No data available in table",
	
					/**
	     * This string gives information to the end user about the information
	     * that is current on display on the page. The following tokens can be
	     * used in the string and will be dynamically replaced as the table
	     * display updates. This tokens can be placed anywhere in the string, or
	     * removed as needed by the language requires:
	     *
	     * * `\_START\_` - Display index of the first record on the current page
	     * * `\_END\_` - Display index of the last record on the current page
	     * * `\_TOTAL\_` - Number of records in the table after filtering
	     * * `\_MAX\_` - Number of records in the table without filtering
	     * * `\_PAGE\_` - Current page number
	     * * `\_PAGES\_` - Total number of pages of data in the table
	     *
	     *  @type string
	     *  @default Showing _START_ to _END_ of _TOTAL_ entries
	     *
	     *  @dtopt Language
	     *  @name DataTable.defaults.language.info
	     *
	     *  @example
	     *    $(document).ready( function() {
	     *      $('#example').dataTable( {
	     *        "language": {
	     *          "info": "Showing page _PAGE_ of _PAGES_"
	     *        }
	     *      } );
	     *    } );
	     */
					"sInfo": "Showing _START_ to _END_ of _TOTAL_ entries",
	
					/**
	     * Display information string for when the table is empty. Typically the
	     * format of this string should match `info`.
	     *  @type string
	     *  @default Showing 0 to 0 of 0 entries
	     *
	     *  @dtopt Language
	     *  @name DataTable.defaults.language.infoEmpty
	     *
	     *  @example
	     *    $(document).ready( function() {
	     *      $('#example').dataTable( {
	     *        "language": {
	     *          "infoEmpty": "No entries to show"
	     *        }
	     *      } );
	     *    } );
	     */
					"sInfoEmpty": "Showing 0 to 0 of 0 entries",
	
					/**
	     * When a user filters the information in a table, this string is appended
	     * to the information (`info`) to give an idea of how strong the filtering
	     * is. The variable _MAX_ is dynamically updated.
	     *  @type string
	     *  @default (filtered from _MAX_ total entries)
	     *
	     *  @dtopt Language
	     *  @name DataTable.defaults.language.infoFiltered
	     *
	     *  @example
	     *    $(document).ready( function() {
	     *      $('#example').dataTable( {
	     *        "language": {
	     *          "infoFiltered": " - filtering from _MAX_ records"
	     *        }
	     *      } );
	     *    } );
	     */
					"sInfoFiltered": "(filtered from _MAX_ total entries)",
	
					/**
	     * If can be useful to append extra information to the info string at times,
	     * and this variable does exactly that. This information will be appended to
	     * the `info` (`infoEmpty` and `infoFiltered` in whatever combination they are
	     * being used) at all times.
	     *  @type string
	     *  @default <i>Empty string</i>
	     *
	     *  @dtopt Language
	     *  @name DataTable.defaults.language.infoPostFix
	     *
	     *  @example
	     *    $(document).ready( function() {
	     *      $('#example').dataTable( {
	     *        "language": {
	     *          "infoPostFix": "All records shown are derived from real information."
	     *        }
	     *      } );
	     *    } );
	     */
					"sInfoPostFix": "",
	
					/**
	     * This decimal place operator is a little different from the other
	     * language options since DataTables doesn't output floating point
	     * numbers, so it won't ever use this for display of a number. Rather,
	     * what this parameter does is modify the sort methods of the table so
	     * that numbers which are in a format which has a character other than
	     * a period (`.`) as a decimal place will be sorted numerically.
	     *
	     * Note that numbers with different decimal places cannot be shown in
	     * the same table and still be sortable, the table must be consistent.
	     * However, multiple different tables on the page can use different
	     * decimal place characters.
	     *  @type string
	     *  @default 
	     *
	     *  @dtopt Language
	     *  @name DataTable.defaults.language.decimal
	     *
	     *  @example
	     *    $(document).ready( function() {
	     *      $('#example').dataTable( {
	     *        "language": {
	     *          "decimal": ","
	     *          "thousands": "."
	     *        }
	     *      } );
	     *    } );
	     */
					"sDecimal": "",
	
					/**
	     * DataTables has a build in number formatter (`formatNumber`) which is
	     * used to format large numbers that are used in the table information.
	     * By default a comma is used, but this can be trivially changed to any
	     * character you wish with this parameter.
	     *  @type string
	     *  @default ,
	     *
	     *  @dtopt Language
	     *  @name DataTable.defaults.language.thousands
	     *
	     *  @example
	     *    $(document).ready( function() {
	     *      $('#example').dataTable( {
	     *        "language": {
	     *          "thousands": "'"
	     *        }
	     *      } );
	     *    } );
	     */
					"sThousands": ",",
	
					/**
	     * Detail the action that will be taken when the drop down menu for the
	     * pagination length option is changed. The '_MENU_' variable is replaced
	     * with a default select list of 10, 25, 50 and 100, and can be replaced
	     * with a custom select box if required.
	     *  @type string
	     *  @default Show _MENU_ entries
	     *
	     *  @dtopt Language
	     *  @name DataTable.defaults.language.lengthMenu
	     *
	     *  @example
	     *    // Language change only
	     *    $(document).ready( function() {
	     *      $('#example').dataTable( {
	     *        "language": {
	     *          "lengthMenu": "Display _MENU_ records"
	     *        }
	     *      } );
	     *    } );
	     *
	     *  @example
	     *    // Language and options change
	     *    $(document).ready( function() {
	     *      $('#example').dataTable( {
	     *        "language": {
	     *          "lengthMenu": 'Display <select>'+
	     *            '<option value="10">10</option>'+
	     *            '<option value="20">20</option>'+
	     *            '<option value="30">30</option>'+
	     *            '<option value="40">40</option>'+
	     *            '<option value="50">50</option>'+
	     *            '<option value="-1">All</option>'+
	     *            '</select> records'
	     *        }
	     *      } );
	     *    } );
	     */
					"sLengthMenu": "Show _MENU_ entries",
	
					/**
	     * When using Ajax sourced data and during the first draw when DataTables is
	     * gathering the data, this message is shown in an empty row in the table to
	     * indicate to the end user the the data is being loaded. Note that this
	     * parameter is not used when loading data by server-side processing, just
	     * Ajax sourced data with client-side processing.
	     *  @type string
	     *  @default Loading...
	     *
	     *  @dtopt Language
	     *  @name DataTable.defaults.language.loadingRecords
	     *
	     *  @example
	     *    $(document).ready( function() {
	     *      $('#example').dataTable( {
	     *        "language": {
	     *          "loadingRecords": "Please wait - loading..."
	     *        }
	     *      } );
	     *    } );
	     */
					"sLoadingRecords": "Loading...",
	
					/**
	     * Text which is displayed when the table is processing a user action
	     * (usually a sort command or similar).
	     *  @type string
	     *  @default Processing...
	     *
	     *  @dtopt Language
	     *  @name DataTable.defaults.language.processing
	     *
	     *  @example
	     *    $(document).ready( function() {
	     *      $('#example').dataTable( {
	     *        "language": {
	     *          "processing": "DataTables is currently busy"
	     *        }
	     *      } );
	     *    } );
	     */
					"sProcessing": "Processing...",
	
					/**
	     * Details the actions that will be taken when the user types into the
	     * filtering input text box. The variable "_INPUT_", if used in the string,
	     * is replaced with the HTML text box for the filtering input allowing
	     * control over where it appears in the string. If "_INPUT_" is not given
	     * then the input box is appended to the string automatically.
	     *  @type string
	     *  @default Search:
	     *
	     *  @dtopt Language
	     *  @name DataTable.defaults.language.search
	     *
	     *  @example
	     *    // Input text box will be appended at the end automatically
	     *    $(document).ready( function() {
	     *      $('#example').dataTable( {
	     *        "language": {
	     *          "search": "Filter records:"
	     *        }
	     *      } );
	     *    } );
	     *
	     *  @example
	     *    // Specify where the filter should appear
	     *    $(document).ready( function() {
	     *      $('#example').dataTable( {
	     *        "language": {
	     *          "search": "Apply filter _INPUT_ to table"
	     *        }
	     *      } );
	     *    } );
	     */
					"sSearch": "Search:",
	
					/**
	     * Assign a `placeholder` attribute to the search `input` element
	     *  @type string
	     *  @default 
	     *
	     *  @dtopt Language
	     *  @name DataTable.defaults.language.searchPlaceholder
	     */
					"sSearchPlaceholder": "",
	
					/**
	     * All of the language information can be stored in a file on the
	     * server-side, which DataTables will look up if this parameter is passed.
	     * It must store the URL of the language file, which is in a JSON format,
	     * and the object has the same properties as the oLanguage object in the
	     * initialiser object (i.e. the above parameters). Please refer to one of
	     * the example language files to see how this works in action.
	     *  @type string
	     *  @default <i>Empty string - i.e. disabled</i>
	     *
	     *  @dtopt Language
	     *  @name DataTable.defaults.language.url
	     *
	     *  @example
	     *    $(document).ready( function() {
	     *      $('#example').dataTable( {
	     *        "language": {
	     *          "url": "http://www.sprymedia.co.uk/dataTables/lang.txt"
	     *        }
	     *      } );
	     *    } );
	     */
					"sUrl": "",
	
					/**
	     * Text shown inside the table records when the is no information to be
	     * displayed after filtering. `emptyTable` is shown when there is simply no
	     * information in the table at all (regardless of filtering).
	     *  @type string
	     *  @default No matching records found
	     *
	     *  @dtopt Language
	     *  @name DataTable.defaults.language.zeroRecords
	     *
	     *  @example
	     *    $(document).ready( function() {
	     *      $('#example').dataTable( {
	     *        "language": {
	     *          "zeroRecords": "No records to display"
	     *        }
	     *      } );
	     *    } );
	     */
					"sZeroRecords": "No matching records found"
				},
	
				/**
	    * This parameter allows you to have define the global filtering state at
	    * initialisation time. As an object the `search` parameter must be
	    * defined, but all other parameters are optional. When `regex` is true,
	    * the search string will be treated as a regular expression, when false
	    * (default) it will be treated as a straight string. When `smart`
	    * DataTables will use it's smart filtering methods (to word match at
	    * any point in the data), when false this will not be done.
	    *  @namespace
	    *  @extends DataTable.models.oSearch
	    *
	    *  @dtopt Options
	    *  @name DataTable.defaults.search
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "search": {"search": "Initial search"}
	    *      } );
	    *    } )
	    */
				"oSearch": $.extend({}, _DataTable.models.oSearch),
	
				/**
	    * __Deprecated__ The functionality provided by this parameter has now been
	    * superseded by that provided through `ajax`, which should be used instead.
	    *
	    * By default DataTables will look for the property `data` (or `aaData` for
	    * compatibility with DataTables 1.9-) when obtaining data from an Ajax
	    * source or for server-side processing - this parameter allows that
	    * property to be changed. You can use Javascript dotted object notation to
	    * get a data source for multiple levels of nesting.
	    *  @type string
	    *  @default data
	    *
	    *  @dtopt Options
	    *  @dtopt Server-side
	    *  @name DataTable.defaults.ajaxDataProp
	    *
	    *  @deprecated 1.10. Please use `ajax` for this functionality now.
	    */
				"sAjaxDataProp": "data",
	
				/**
	    * __Deprecated__ The functionality provided by this parameter has now been
	    * superseded by that provided through `ajax`, which should be used instead.
	    *
	    * You can instruct DataTables to load data from an external
	    * source using this parameter (use aData if you want to pass data in you
	    * already have). Simply provide a url a JSON object can be obtained from.
	    *  @type string
	    *  @default null
	    *
	    *  @dtopt Options
	    *  @dtopt Server-side
	    *  @name DataTable.defaults.ajaxSource
	    *
	    *  @deprecated 1.10. Please use `ajax` for this functionality now.
	    */
				"sAjaxSource": null,
	
				/**
	    * This initialisation variable allows you to specify exactly where in the
	    * DOM you want DataTables to inject the various controls it adds to the page
	    * (for example you might want the pagination controls at the top of the
	    * table). DIV elements (with or without a custom class) can also be added to
	    * aid styling. The follow syntax is used:
	    *   <ul>
	    *     <li>The following options are allowed:
	    *       <ul>
	    *         <li>'l' - Length changing</li>
	    *         <li>'f' - Filtering input</li>
	    *         <li>'t' - The table!</li>
	    *         <li>'i' - Information</li>
	    *         <li>'p' - Pagination</li>
	    *         <li>'r' - pRocessing</li>
	    *       </ul>
	    *     </li>
	    *     <li>The following constants are allowed:
	    *       <ul>
	    *         <li>'H' - jQueryUI theme "header" classes ('fg-toolbar ui-widget-header ui-corner-tl ui-corner-tr ui-helper-clearfix')</li>
	    *         <li>'F' - jQueryUI theme "footer" classes ('fg-toolbar ui-widget-header ui-corner-bl ui-corner-br ui-helper-clearfix')</li>
	    *       </ul>
	    *     </li>
	    *     <li>The following syntax is expected:
	    *       <ul>
	    *         <li>'&lt;' and '&gt;' - div elements</li>
	    *         <li>'&lt;"class" and '&gt;' - div with a class</li>
	    *         <li>'&lt;"#id" and '&gt;' - div with an ID</li>
	    *       </ul>
	    *     </li>
	    *     <li>Examples:
	    *       <ul>
	    *         <li>'&lt;"wrapper"flipt&gt;'</li>
	    *         <li>'&lt;lf&lt;t&gt;ip&gt;'</li>
	    *       </ul>
	    *     </li>
	    *   </ul>
	    *  @type string
	    *  @default lfrtip <i>(when `jQueryUI` is false)</i> <b>or</b>
	    *    <"H"lfr>t<"F"ip> <i>(when `jQueryUI` is true)</i>
	    *
	    *  @dtopt Options
	    *  @name DataTable.defaults.dom
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "dom": '&lt;"top"i&gt;rt&lt;"bottom"flp&gt;&lt;"clear"&gt;'
	    *      } );
	    *    } );
	    */
				"sDom": "lfrtip",
	
				/**
	    * Search delay option. This will throttle full table searches that use the
	    * DataTables provided search input element (it does not effect calls to
	    * `dt-api search()`, providing a delay before the search is made.
	    *  @type integer
	    *  @default 0
	    *
	    *  @dtopt Options
	    *  @name DataTable.defaults.searchDelay
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "searchDelay": 200
	    *      } );
	    *    } )
	    */
				"searchDelay": null,
	
				/**
	    * DataTables features four different built-in options for the buttons to
	    * display for pagination control:
	    *
	    * * `simple` - 'Previous' and 'Next' buttons only
	    * * 'simple_numbers` - 'Previous' and 'Next' buttons, plus page numbers
	    * * `full` - 'First', 'Previous', 'Next' and 'Last' buttons
	    * * `full_numbers` - 'First', 'Previous', 'Next' and 'Last' buttons, plus
	    *   page numbers
	    *  
	    * Further methods can be added using {@link DataTable.ext.oPagination}.
	    *  @type string
	    *  @default simple_numbers
	    *
	    *  @dtopt Options
	    *  @name DataTable.defaults.pagingType
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "pagingType": "full_numbers"
	    *      } );
	    *    } )
	    */
				"sPaginationType": "simple_numbers",
	
				/**
	    * Enable horizontal scrolling. When a table is too wide to fit into a
	    * certain layout, or you have a large number of columns in the table, you
	    * can enable x-scrolling to show the table in a viewport, which can be
	    * scrolled. This property can be `true` which will allow the table to
	    * scroll horizontally when needed, or any CSS unit, or a number (in which
	    * case it will be treated as a pixel measurement). Setting as simply `true`
	    * is recommended.
	    *  @type boolean|string
	    *  @default <i>blank string - i.e. disabled</i>
	    *
	    *  @dtopt Features
	    *  @name DataTable.defaults.scrollX
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "scrollX": true,
	    *        "scrollCollapse": true
	    *      } );
	    *    } );
	    */
				"sScrollX": "",
	
				/**
	    * This property can be used to force a DataTable to use more width than it
	    * might otherwise do when x-scrolling is enabled. For example if you have a
	    * table which requires to be well spaced, this parameter is useful for
	    * "over-sizing" the table, and thus forcing scrolling. This property can by
	    * any CSS unit, or a number (in which case it will be treated as a pixel
	    * measurement).
	    *  @type string
	    *  @default <i>blank string - i.e. disabled</i>
	    *
	    *  @dtopt Options
	    *  @name DataTable.defaults.scrollXInner
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "scrollX": "100%",
	    *        "scrollXInner": "110%"
	    *      } );
	    *    } );
	    */
				"sScrollXInner": "",
	
				/**
	    * Enable vertical scrolling. Vertical scrolling will constrain the DataTable
	    * to the given height, and enable scrolling for any data which overflows the
	    * current viewport. This can be used as an alternative to paging to display
	    * a lot of data in a small area (although paging and scrolling can both be
	    * enabled at the same time). This property can be any CSS unit, or a number
	    * (in which case it will be treated as a pixel measurement).
	    *  @type string
	    *  @default <i>blank string - i.e. disabled</i>
	    *
	    *  @dtopt Features
	    *  @name DataTable.defaults.scrollY
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "scrollY": "200px",
	    *        "paginate": false
	    *      } );
	    *    } );
	    */
				"sScrollY": "",
	
				/**
	    * __Deprecated__ The functionality provided by this parameter has now been
	    * superseded by that provided through `ajax`, which should be used instead.
	    *
	    * Set the HTTP method that is used to make the Ajax call for server-side
	    * processing or Ajax sourced data.
	    *  @type string
	    *  @default GET
	    *
	    *  @dtopt Options
	    *  @dtopt Server-side
	    *  @name DataTable.defaults.serverMethod
	    *
	    *  @deprecated 1.10. Please use `ajax` for this functionality now.
	    */
				"sServerMethod": "GET",
	
				/**
	    * DataTables makes use of renderers when displaying HTML elements for
	    * a table. These renderers can be added or modified by plug-ins to
	    * generate suitable mark-up for a site. For example the Bootstrap
	    * integration plug-in for DataTables uses a paging button renderer to
	    * display pagination buttons in the mark-up required by Bootstrap.
	    *
	    * For further information about the renderers available see
	    * DataTable.ext.renderer
	    *  @type string|object
	    *  @default null
	    *
	    *  @name DataTable.defaults.renderer
	    *
	    */
				"renderer": null
			};
	
			_fnHungarianMap(_DataTable.defaults);
	
			/*
	   * Developer note - See note in model.defaults.js about the use of Hungarian
	   * notation and camel case.
	   */
	
			/**
	   * Column options that can be given to DataTables at initialisation time.
	   *  @namespace
	   */
			_DataTable.defaults.column = {
				/**
	    * Define which column(s) an order will occur on for this column. This
	    * allows a column's ordering to take multiple columns into account when
	    * doing a sort or use the data from a different column. For example first
	    * name / last name columns make sense to do a multi-column sort over the
	    * two columns.
	    *  @type array|int
	    *  @default null <i>Takes the value of the column index automatically</i>
	    *
	    *  @name DataTable.defaults.column.orderData
	    *  @dtopt Columns
	    *
	    *  @example
	    *    // Using `columnDefs`
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columnDefs": [
	    *          { "orderData": [ 0, 1 ], "targets": [ 0 ] },
	    *          { "orderData": [ 1, 0 ], "targets": [ 1 ] },
	    *          { "orderData": 2, "targets": [ 2 ] }
	    *        ]
	    *      } );
	    *    } );
	    *
	    *  @example
	    *    // Using `columns`
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columns": [
	    *          { "orderData": [ 0, 1 ] },
	    *          { "orderData": [ 1, 0 ] },
	    *          { "orderData": 2 },
	    *          null,
	    *          null
	    *        ]
	    *      } );
	    *    } );
	    */
				"aDataSort": null,
				"iDataSort": -1,
	
				/**
	    * You can control the default ordering direction, and even alter the
	    * behaviour of the sort handler (i.e. only allow ascending ordering etc)
	    * using this parameter.
	    *  @type array
	    *  @default [ 'asc', 'desc' ]
	    *
	    *  @name DataTable.defaults.column.orderSequence
	    *  @dtopt Columns
	    *
	    *  @example
	    *    // Using `columnDefs`
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columnDefs": [
	    *          { "orderSequence": [ "asc" ], "targets": [ 1 ] },
	    *          { "orderSequence": [ "desc", "asc", "asc" ], "targets": [ 2 ] },
	    *          { "orderSequence": [ "desc" ], "targets": [ 3 ] }
	    *        ]
	    *      } );
	    *    } );
	    *
	    *  @example
	    *    // Using `columns`
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columns": [
	    *          null,
	    *          { "orderSequence": [ "asc" ] },
	    *          { "orderSequence": [ "desc", "asc", "asc" ] },
	    *          { "orderSequence": [ "desc" ] },
	    *          null
	    *        ]
	    *      } );
	    *    } );
	    */
				"asSorting": ['asc', 'desc'],
	
				/**
	    * Enable or disable filtering on the data in this column.
	    *  @type boolean
	    *  @default true
	    *
	    *  @name DataTable.defaults.column.searchable
	    *  @dtopt Columns
	    *
	    *  @example
	    *    // Using `columnDefs`
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columnDefs": [
	    *          { "searchable": false, "targets": [ 0 ] }
	    *        ] } );
	    *    } );
	    *
	    *  @example
	    *    // Using `columns`
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columns": [
	    *          { "searchable": false },
	    *          null,
	    *          null,
	    *          null,
	    *          null
	    *        ] } );
	    *    } );
	    */
				"bSearchable": true,
	
				/**
	    * Enable or disable ordering on this column.
	    *  @type boolean
	    *  @default true
	    *
	    *  @name DataTable.defaults.column.orderable
	    *  @dtopt Columns
	    *
	    *  @example
	    *    // Using `columnDefs`
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columnDefs": [
	    *          { "orderable": false, "targets": [ 0 ] }
	    *        ] } );
	    *    } );
	    *
	    *  @example
	    *    // Using `columns`
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columns": [
	    *          { "orderable": false },
	    *          null,
	    *          null,
	    *          null,
	    *          null
	    *        ] } );
	    *    } );
	    */
				"bSortable": true,
	
				/**
	    * Enable or disable the display of this column.
	    *  @type boolean
	    *  @default true
	    *
	    *  @name DataTable.defaults.column.visible
	    *  @dtopt Columns
	    *
	    *  @example
	    *    // Using `columnDefs`
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columnDefs": [
	    *          { "visible": false, "targets": [ 0 ] }
	    *        ] } );
	    *    } );
	    *
	    *  @example
	    *    // Using `columns`
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columns": [
	    *          { "visible": false },
	    *          null,
	    *          null,
	    *          null,
	    *          null
	    *        ] } );
	    *    } );
	    */
				"bVisible": true,
	
				/**
	    * Developer definable function that is called whenever a cell is created (Ajax source,
	    * etc) or processed for input (DOM source). This can be used as a compliment to mRender
	    * allowing you to modify the DOM element (add background colour for example) when the
	    * element is available.
	    *  @type function
	    *  @param {element} td The TD node that has been created
	    *  @param {*} cellData The Data for the cell
	    *  @param {array|object} rowData The data for the whole row
	    *  @param {int} row The row index for the aoData data store
	    *  @param {int} col The column index for aoColumns
	    *
	    *  @name DataTable.defaults.column.createdCell
	    *  @dtopt Columns
	    *
	    *  @example
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columnDefs": [ {
	    *          "targets": [3],
	    *          "createdCell": function (td, cellData, rowData, row, col) {
	    *            if ( cellData == "1.7" ) {
	    *              $(td).css('color', 'blue')
	    *            }
	    *          }
	    *        } ]
	    *      });
	    *    } );
	    */
				"fnCreatedCell": null,
	
				/**
	    * This parameter has been replaced by `data` in DataTables to ensure naming
	    * consistency. `dataProp` can still be used, as there is backwards
	    * compatibility in DataTables for this option, but it is strongly
	    * recommended that you use `data` in preference to `dataProp`.
	    *  @name DataTable.defaults.column.dataProp
	    */
	
				/**
	    * This property can be used to read data from any data source property,
	    * including deeply nested objects / properties. `data` can be given in a
	    * number of different ways which effect its behaviour:
	    *
	    * * `integer` - treated as an array index for the data source. This is the
	    *   default that DataTables uses (incrementally increased for each column).
	    * * `string` - read an object property from the data source. There are
	    *   three 'special' options that can be used in the string to alter how
	    *   DataTables reads the data from the source object:
	    *    * `.` - Dotted Javascript notation. Just as you use a `.` in
	    *      Javascript to read from nested objects, so to can the options
	    *      specified in `data`. For example: `browser.version` or
	    *      `browser.name`. If your object parameter name contains a period, use
	    *      `\\` to escape it - i.e. `first\\.name`.
	    *    * `[]` - Array notation. DataTables can automatically combine data
	    *      from and array source, joining the data with the characters provided
	    *      between the two brackets. For example: `name[, ]` would provide a
	    *      comma-space separated list from the source array. If no characters
	    *      are provided between the brackets, the original array source is
	    *      returned.
	    *    * `()` - Function notation. Adding `()` to the end of a parameter will
	    *      execute a function of the name given. For example: `browser()` for a
	    *      simple function on the data source, `browser.version()` for a
	    *      function in a nested property or even `browser().version` to get an
	    *      object property if the function called returns an object. Note that
	    *      function notation is recommended for use in `render` rather than
	    *      `data` as it is much simpler to use as a renderer.
	    * * `null` - use the original data source for the row rather than plucking
	    *   data directly from it. This action has effects on two other
	    *   initialisation options:
	    *    * `defaultContent` - When null is given as the `data` option and
	    *      `defaultContent` is specified for the column, the value defined by
	    *      `defaultContent` will be used for the cell.
	    *    * `render` - When null is used for the `data` option and the `render`
	    *      option is specified for the column, the whole data source for the
	    *      row is used for the renderer.
	    * * `function` - the function given will be executed whenever DataTables
	    *   needs to set or get the data for a cell in the column. The function
	    *   takes three parameters:
	    *    * Parameters:
	    *      * `{array|object}` The data source for the row
	    *      * `{string}` The type call data requested - this will be 'set' when
	    *        setting data or 'filter', 'display', 'type', 'sort' or undefined
	    *        when gathering data. Note that when `undefined` is given for the
	    *        type DataTables expects to get the raw data for the object back<
	    *      * `{*}` Data to set when the second parameter is 'set'.
	    *    * Return:
	    *      * The return value from the function is not required when 'set' is
	    *        the type of call, but otherwise the return is what will be used
	    *        for the data requested.
	    *
	    * Note that `data` is a getter and setter option. If you just require
	    * formatting of data for output, you will likely want to use `render` which
	    * is simply a getter and thus simpler to use.
	    *
	    * Note that prior to DataTables 1.9.2 `data` was called `mDataProp`. The
	    * name change reflects the flexibility of this property and is consistent
	    * with the naming of mRender. If 'mDataProp' is given, then it will still
	    * be used by DataTables, as it automatically maps the old name to the new
	    * if required.
	    *
	    *  @type string|int|function|null
	    *  @default null <i>Use automatically calculated column index</i>
	    *
	    *  @name DataTable.defaults.column.data
	    *  @dtopt Columns
	    *
	    *  @example
	    *    // Read table data from objects
	    *    // JSON structure for each row:
	    *    //   {
	    *    //      "engine": {value},
	    *    //      "browser": {value},
	    *    //      "platform": {value},
	    *    //      "version": {value},
	    *    //      "grade": {value}
	    *    //   }
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "ajaxSource": "sources/objects.txt",
	    *        "columns": [
	    *          { "data": "engine" },
	    *          { "data": "browser" },
	    *          { "data": "platform" },
	    *          { "data": "version" },
	    *          { "data": "grade" }
	    *        ]
	    *      } );
	    *    } );
	    *
	    *  @example
	    *    // Read information from deeply nested objects
	    *    // JSON structure for each row:
	    *    //   {
	    *    //      "engine": {value},
	    *    //      "browser": {value},
	    *    //      "platform": {
	    *    //         "inner": {value}
	    *    //      },
	    *    //      "details": [
	    *    //         {value}, {value}
	    *    //      ]
	    *    //   }
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "ajaxSource": "sources/deep.txt",
	    *        "columns": [
	    *          { "data": "engine" },
	    *          { "data": "browser" },
	    *          { "data": "platform.inner" },
	    *          { "data": "platform.details.0" },
	    *          { "data": "platform.details.1" }
	    *        ]
	    *      } );
	    *    } );
	    *
	    *  @example
	    *    // Using `data` as a function to provide different information for
	    *    // sorting, filtering and display. In this case, currency (price)
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columnDefs": [ {
	    *          "targets": [ 0 ],
	    *          "data": function ( source, type, val ) {
	    *            if (type === 'set') {
	    *              source.price = val;
	    *              // Store the computed dislay and filter values for efficiency
	    *              source.price_display = val=="" ? "" : "$"+numberFormat(val);
	    *              source.price_filter  = val=="" ? "" : "$"+numberFormat(val)+" "+val;
	    *              return;
	    *            }
	    *            else if (type === 'display') {
	    *              return source.price_display;
	    *            }
	    *            else if (type === 'filter') {
	    *              return source.price_filter;
	    *            }
	    *            // 'sort', 'type' and undefined all just use the integer
	    *            return source.price;
	    *          }
	    *        } ]
	    *      } );
	    *    } );
	    *
	    *  @example
	    *    // Using default content
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columnDefs": [ {
	    *          "targets": [ 0 ],
	    *          "data": null,
	    *          "defaultContent": "Click to edit"
	    *        } ]
	    *      } );
	    *    } );
	    *
	    *  @example
	    *    // Using array notation - outputting a list from an array
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columnDefs": [ {
	    *          "targets": [ 0 ],
	    *          "data": "name[, ]"
	    *        } ]
	    *      } );
	    *    } );
	    *
	    */
				"mData": null,
	
				/**
	    * This property is the rendering partner to `data` and it is suggested that
	    * when you want to manipulate data for display (including filtering,
	    * sorting etc) without altering the underlying data for the table, use this
	    * property. `render` can be considered to be the the read only companion to
	    * `data` which is read / write (then as such more complex). Like `data`
	    * this option can be given in a number of different ways to effect its
	    * behaviour:
	    *
	    * * `integer` - treated as an array index for the data source. This is the
	    *   default that DataTables uses (incrementally increased for each column).
	    * * `string` - read an object property from the data source. There are
	    *   three 'special' options that can be used in the string to alter how
	    *   DataTables reads the data from the source object:
	    *    * `.` - Dotted Javascript notation. Just as you use a `.` in
	    *      Javascript to read from nested objects, so to can the options
	    *      specified in `data`. For example: `browser.version` or
	    *      `browser.name`. If your object parameter name contains a period, use
	    *      `\\` to escape it - i.e. `first\\.name`.
	    *    * `[]` - Array notation. DataTables can automatically combine data
	    *      from and array source, joining the data with the characters provided
	    *      between the two brackets. For example: `name[, ]` would provide a
	    *      comma-space separated list from the source array. If no characters
	    *      are provided between the brackets, the original array source is
	    *      returned.
	    *    * `()` - Function notation. Adding `()` to the end of a parameter will
	    *      execute a function of the name given. For example: `browser()` for a
	    *      simple function on the data source, `browser.version()` for a
	    *      function in a nested property or even `browser().version` to get an
	    *      object property if the function called returns an object.
	    * * `object` - use different data for the different data types requested by
	    *   DataTables ('filter', 'display', 'type' or 'sort'). The property names
	    *   of the object is the data type the property refers to and the value can
	    *   defined using an integer, string or function using the same rules as
	    *   `render` normally does. Note that an `_` option _must_ be specified.
	    *   This is the default value to use if you haven't specified a value for
	    *   the data type requested by DataTables.
	    * * `function` - the function given will be executed whenever DataTables
	    *   needs to set or get the data for a cell in the column. The function
	    *   takes three parameters:
	    *    * Parameters:
	    *      * {array|object} The data source for the row (based on `data`)
	    *      * {string} The type call data requested - this will be 'filter',
	    *        'display', 'type' or 'sort'.
	    *      * {array|object} The full data source for the row (not based on
	    *        `data`)
	    *    * Return:
	    *      * The return value from the function is what will be used for the
	    *        data requested.
	    *
	    *  @type string|int|function|object|null
	    *  @default null Use the data source value.
	    *
	    *  @name DataTable.defaults.column.render
	    *  @dtopt Columns
	    *
	    *  @example
	    *    // Create a comma separated list from an array of objects
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "ajaxSource": "sources/deep.txt",
	    *        "columns": [
	    *          { "data": "engine" },
	    *          { "data": "browser" },
	    *          {
	    *            "data": "platform",
	    *            "render": "[, ].name"
	    *          }
	    *        ]
	    *      } );
	    *    } );
	    *
	    *  @example
	    *    // Execute a function to obtain data
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columnDefs": [ {
	    *          "targets": [ 0 ],
	    *          "data": null, // Use the full data source object for the renderer's source
	    *          "render": "browserName()"
	    *        } ]
	    *      } );
	    *    } );
	    *
	    *  @example
	    *    // As an object, extracting different data for the different types
	    *    // This would be used with a data source such as:
	    *    //   { "phone": 5552368, "phone_filter": "5552368 555-2368", "phone_display": "555-2368" }
	    *    // Here the `phone` integer is used for sorting and type detection, while `phone_filter`
	    *    // (which has both forms) is used for filtering for if a user inputs either format, while
	    *    // the formatted phone number is the one that is shown in the table.
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columnDefs": [ {
	    *          "targets": [ 0 ],
	    *          "data": null, // Use the full data source object for the renderer's source
	    *          "render": {
	    *            "_": "phone",
	    *            "filter": "phone_filter",
	    *            "display": "phone_display"
	    *          }
	    *        } ]
	    *      } );
	    *    } );
	    *
	    *  @example
	    *    // Use as a function to create a link from the data source
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columnDefs": [ {
	    *          "targets": [ 0 ],
	    *          "data": "download_link",
	    *          "render": function ( data, type, full ) {
	    *            return '<a href="'+data+'">Download</a>';
	    *          }
	    *        } ]
	    *      } );
	    *    } );
	    */
				"mRender": null,
	
				/**
	    * Change the cell type created for the column - either TD cells or TH cells. This
	    * can be useful as TH cells have semantic meaning in the table body, allowing them
	    * to act as a header for a row (you may wish to add scope='row' to the TH elements).
	    *  @type string
	    *  @default td
	    *
	    *  @name DataTable.defaults.column.cellType
	    *  @dtopt Columns
	    *
	    *  @example
	    *    // Make the first column use TH cells
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columnDefs": [ {
	    *          "targets": [ 0 ],
	    *          "cellType": "th"
	    *        } ]
	    *      } );
	    *    } );
	    */
				"sCellType": "td",
	
				/**
	    * Class to give to each cell in this column.
	    *  @type string
	    *  @default <i>Empty string</i>
	    *
	    *  @name DataTable.defaults.column.class
	    *  @dtopt Columns
	    *
	    *  @example
	    *    // Using `columnDefs`
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columnDefs": [
	    *          { "class": "my_class", "targets": [ 0 ] }
	    *        ]
	    *      } );
	    *    } );
	    *
	    *  @example
	    *    // Using `columns`
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columns": [
	    *          { "class": "my_class" },
	    *          null,
	    *          null,
	    *          null,
	    *          null
	    *        ]
	    *      } );
	    *    } );
	    */
				"sClass": "",
	
				/**
	    * When DataTables calculates the column widths to assign to each column,
	    * it finds the longest string in each column and then constructs a
	    * temporary table and reads the widths from that. The problem with this
	    * is that "mmm" is much wider then "iiii", but the latter is a longer
	    * string - thus the calculation can go wrong (doing it properly and putting
	    * it into an DOM object and measuring that is horribly(!) slow). Thus as
	    * a "work around" we provide this option. It will append its value to the
	    * text that is found to be the longest string for the column - i.e. padding.
	    * Generally you shouldn't need this!
	    *  @type string
	    *  @default <i>Empty string<i>
	    *
	    *  @name DataTable.defaults.column.contentPadding
	    *  @dtopt Columns
	    *
	    *  @example
	    *    // Using `columns`
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columns": [
	    *          null,
	    *          null,
	    *          null,
	    *          {
	    *            "contentPadding": "mmm"
	    *          }
	    *        ]
	    *      } );
	    *    } );
	    */
				"sContentPadding": "",
	
				/**
	    * Allows a default value to be given for a column's data, and will be used
	    * whenever a null data source is encountered (this can be because `data`
	    * is set to null, or because the data source itself is null).
	    *  @type string
	    *  @default null
	    *
	    *  @name DataTable.defaults.column.defaultContent
	    *  @dtopt Columns
	    *
	    *  @example
	    *    // Using `columnDefs`
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columnDefs": [
	    *          {
	    *            "data": null,
	    *            "defaultContent": "Edit",
	    *            "targets": [ -1 ]
	    *          }
	    *        ]
	    *      } );
	    *    } );
	    *
	    *  @example
	    *    // Using `columns`
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columns": [
	    *          null,
	    *          null,
	    *          null,
	    *          {
	    *            "data": null,
	    *            "defaultContent": "Edit"
	    *          }
	    *        ]
	    *      } );
	    *    } );
	    */
				"sDefaultContent": null,
	
				/**
	    * This parameter is only used in DataTables' server-side processing. It can
	    * be exceptionally useful to know what columns are being displayed on the
	    * client side, and to map these to database fields. When defined, the names
	    * also allow DataTables to reorder information from the server if it comes
	    * back in an unexpected order (i.e. if you switch your columns around on the
	    * client-side, your server-side code does not also need updating).
	    *  @type string
	    *  @default <i>Empty string</i>
	    *
	    *  @name DataTable.defaults.column.name
	    *  @dtopt Columns
	    *
	    *  @example
	    *    // Using `columnDefs`
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columnDefs": [
	    *          { "name": "engine", "targets": [ 0 ] },
	    *          { "name": "browser", "targets": [ 1 ] },
	    *          { "name": "platform", "targets": [ 2 ] },
	    *          { "name": "version", "targets": [ 3 ] },
	    *          { "name": "grade", "targets": [ 4 ] }
	    *        ]
	    *      } );
	    *    } );
	    *
	    *  @example
	    *    // Using `columns`
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columns": [
	    *          { "name": "engine" },
	    *          { "name": "browser" },
	    *          { "name": "platform" },
	    *          { "name": "version" },
	    *          { "name": "grade" }
	    *        ]
	    *      } );
	    *    } );
	    */
				"sName": "",
	
				/**
	    * Defines a data source type for the ordering which can be used to read
	    * real-time information from the table (updating the internally cached
	    * version) prior to ordering. This allows ordering to occur on user
	    * editable elements such as form inputs.
	    *  @type string
	    *  @default std
	    *
	    *  @name DataTable.defaults.column.orderDataType
	    *  @dtopt Columns
	    *
	    *  @example
	    *    // Using `columnDefs`
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columnDefs": [
	    *          { "orderDataType": "dom-text", "targets": [ 2, 3 ] },
	    *          { "type": "numeric", "targets": [ 3 ] },
	    *          { "orderDataType": "dom-select", "targets": [ 4 ] },
	    *          { "orderDataType": "dom-checkbox", "targets": [ 5 ] }
	    *        ]
	    *      } );
	    *    } );
	    *
	    *  @example
	    *    // Using `columns`
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columns": [
	    *          null,
	    *          null,
	    *          { "orderDataType": "dom-text" },
	    *          { "orderDataType": "dom-text", "type": "numeric" },
	    *          { "orderDataType": "dom-select" },
	    *          { "orderDataType": "dom-checkbox" }
	    *        ]
	    *      } );
	    *    } );
	    */
				"sSortDataType": "std",
	
				/**
	    * The title of this column.
	    *  @type string
	    *  @default null <i>Derived from the 'TH' value for this column in the
	    *    original HTML table.</i>
	    *
	    *  @name DataTable.defaults.column.title
	    *  @dtopt Columns
	    *
	    *  @example
	    *    // Using `columnDefs`
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columnDefs": [
	    *          { "title": "My column title", "targets": [ 0 ] }
	    *        ]
	    *      } );
	    *    } );
	    *
	    *  @example
	    *    // Using `columns`
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columns": [
	    *          { "title": "My column title" },
	    *          null,
	    *          null,
	    *          null,
	    *          null
	    *        ]
	    *      } );
	    *    } );
	    */
				"sTitle": null,
	
				/**
	    * The type allows you to specify how the data for this column will be
	    * ordered. Four types (string, numeric, date and html (which will strip
	    * HTML tags before ordering)) are currently available. Note that only date
	    * formats understood by Javascript's Date() object will be accepted as type
	    * date. For example: "Mar 26, 2008 5:03 PM". May take the values: 'string',
	    * 'numeric', 'date' or 'html' (by default). Further types can be adding
	    * through plug-ins.
	    *  @type string
	    *  @default null <i>Auto-detected from raw data</i>
	    *
	    *  @name DataTable.defaults.column.type
	    *  @dtopt Columns
	    *
	    *  @example
	    *    // Using `columnDefs`
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columnDefs": [
	    *          { "type": "html", "targets": [ 0 ] }
	    *        ]
	    *      } );
	    *    } );
	    *
	    *  @example
	    *    // Using `columns`
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columns": [
	    *          { "type": "html" },
	    *          null,
	    *          null,
	    *          null,
	    *          null
	    *        ]
	    *      } );
	    *    } );
	    */
				"sType": null,
	
				/**
	    * Defining the width of the column, this parameter may take any CSS value
	    * (3em, 20px etc). DataTables applies 'smart' widths to columns which have not
	    * been given a specific width through this interface ensuring that the table
	    * remains readable.
	    *  @type string
	    *  @default null <i>Automatic</i>
	    *
	    *  @name DataTable.defaults.column.width
	    *  @dtopt Columns
	    *
	    *  @example
	    *    // Using `columnDefs`
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columnDefs": [
	    *          { "width": "20%", "targets": [ 0 ] }
	    *        ]
	    *      } );
	    *    } );
	    *
	    *  @example
	    *    // Using `columns`
	    *    $(document).ready( function() {
	    *      $('#example').dataTable( {
	    *        "columns": [
	    *          { "width": "20%" },
	    *          null,
	    *          null,
	    *          null,
	    *          null
	    *        ]
	    *      } );
	    *    } );
	    */
				"sWidth": null
			};
	
			_fnHungarianMap(_DataTable.defaults.column);
	
			/**
	   * DataTables settings object - this holds all the information needed for a
	   * given table, including configuration, data and current application of the
	   * table options. DataTables does not have a single instance for each DataTable
	   * with the settings attached to that instance, but rather instances of the
	   * DataTable "class" are created on-the-fly as needed (typically by a
	   * $().dataTable() call) and the settings object is then applied to that
	   * instance.
	   *
	   * Note that this object is related to {@link DataTable.defaults} but this
	   * one is the internal data store for DataTables's cache of columns. It should
	   * NOT be manipulated outside of DataTables. Any configuration should be done
	   * through the initialisation options.
	   *  @namespace
	   *  @todo Really should attach the settings object to individual instances so we
	   *    don't need to create new instances on each $().dataTable() call (if the
	   *    table already exists). It would also save passing oSettings around and
	   *    into every single function. However, this is a very significant
	   *    architecture change for DataTables and will almost certainly break
	   *    backwards compatibility with older installations. This is something that
	   *    will be done in 2.0.
	   */
			_DataTable.models.oSettings = {
				/**
	    * Primary features of DataTables and their enablement state.
	    *  @namespace
	    */
				"oFeatures": {
	
					/**
	     * Flag to say if DataTables should automatically try to calculate the
	     * optimum table and columns widths (true) or not (false).
	     * Note that this parameter will be set by the initialisation routine. To
	     * set a default use {@link DataTable.defaults}.
	     *  @type boolean
	     */
					"bAutoWidth": null,
	
					/**
	     * Delay the creation of TR and TD elements until they are actually
	     * needed by a driven page draw. This can give a significant speed
	     * increase for Ajax source and Javascript source data, but makes no
	     * difference at all fro DOM and server-side processing tables.
	     * Note that this parameter will be set by the initialisation routine. To
	     * set a default use {@link DataTable.defaults}.
	     *  @type boolean
	     */
					"bDeferRender": null,
	
					/**
	     * Enable filtering on the table or not. Note that if this is disabled
	     * then there is no filtering at all on the table, including fnFilter.
	     * To just remove the filtering input use sDom and remove the 'f' option.
	     * Note that this parameter will be set by the initialisation routine. To
	     * set a default use {@link DataTable.defaults}.
	     *  @type boolean
	     */
					"bFilter": null,
	
					/**
	     * Table information element (the 'Showing x of y records' div) enable
	     * flag.
	     * Note that this parameter will be set by the initialisation routine. To
	     * set a default use {@link DataTable.defaults}.
	     *  @type boolean
	     */
					"bInfo": null,
	
					/**
	     * Present a user control allowing the end user to change the page size
	     * when pagination is enabled.
	     * Note that this parameter will be set by the initialisation routine. To
	     * set a default use {@link DataTable.defaults}.
	     *  @type boolean
	     */
					"bLengthChange": null,
	
					/**
	     * Pagination enabled or not. Note that if this is disabled then length
	     * changing must also be disabled.
	     * Note that this parameter will be set by the initialisation routine. To
	     * set a default use {@link DataTable.defaults}.
	     *  @type boolean
	     */
					"bPaginate": null,
	
					/**
	     * Processing indicator enable flag whenever DataTables is enacting a
	     * user request - typically an Ajax request for server-side processing.
	     * Note that this parameter will be set by the initialisation routine. To
	     * set a default use {@link DataTable.defaults}.
	     *  @type boolean
	     */
					"bProcessing": null,
	
					/**
	     * Server-side processing enabled flag - when enabled DataTables will
	     * get all data from the server for every draw - there is no filtering,
	     * sorting or paging done on the client-side.
	     * Note that this parameter will be set by the initialisation routine. To
	     * set a default use {@link DataTable.defaults}.
	     *  @type boolean
	     */
					"bServerSide": null,
	
					/**
	     * Sorting enablement flag.
	     * Note that this parameter will be set by the initialisation routine. To
	     * set a default use {@link DataTable.defaults}.
	     *  @type boolean
	     */
					"bSort": null,
	
					/**
	     * Multi-column sorting
	     * Note that this parameter will be set by the initialisation routine. To
	     * set a default use {@link DataTable.defaults}.
	     *  @type boolean
	     */
					"bSortMulti": null,
	
					/**
	     * Apply a class to the columns which are being sorted to provide a
	     * visual highlight or not. This can slow things down when enabled since
	     * there is a lot of DOM interaction.
	     * Note that this parameter will be set by the initialisation routine. To
	     * set a default use {@link DataTable.defaults}.
	     *  @type boolean
	     */
					"bSortClasses": null,
	
					/**
	     * State saving enablement flag.
	     * Note that this parameter will be set by the initialisation routine. To
	     * set a default use {@link DataTable.defaults}.
	     *  @type boolean
	     */
					"bStateSave": null
				},
	
				/**
	    * Scrolling settings for a table.
	    *  @namespace
	    */
				"oScroll": {
					/**
	     * When the table is shorter in height than sScrollY, collapse the
	     * table container down to the height of the table (when true).
	     * Note that this parameter will be set by the initialisation routine. To
	     * set a default use {@link DataTable.defaults}.
	     *  @type boolean
	     */
					"bCollapse": null,
	
					/**
	     * Width of the scrollbar for the web-browser's platform. Calculated
	     * during table initialisation.
	     *  @type int
	     *  @default 0
	     */
					"iBarWidth": 0,
	
					/**
	     * Viewport width for horizontal scrolling. Horizontal scrolling is
	     * disabled if an empty string.
	     * Note that this parameter will be set by the initialisation routine. To
	     * set a default use {@link DataTable.defaults}.
	     *  @type string
	     */
					"sX": null,
	
					/**
	     * Width to expand the table to when using x-scrolling. Typically you
	     * should not need to use this.
	     * Note that this parameter will be set by the initialisation routine. To
	     * set a default use {@link DataTable.defaults}.
	     *  @type string
	     *  @deprecated
	     */
					"sXInner": null,
	
					/**
	     * Viewport height for vertical scrolling. Vertical scrolling is disabled
	     * if an empty string.
	     * Note that this parameter will be set by the initialisation routine. To
	     * set a default use {@link DataTable.defaults}.
	     *  @type string
	     */
					"sY": null
				},
	
				/**
	    * Language information for the table.
	    *  @namespace
	    *  @extends DataTable.defaults.oLanguage
	    */
				"oLanguage": {
					/**
	     * Information callback function. See
	     * {@link DataTable.defaults.fnInfoCallback}
	     *  @type function
	     *  @default null
	     */
					"fnInfoCallback": null
				},
	
				/**
	    * Browser support parameters
	    *  @namespace
	    */
				"oBrowser": {
					/**
	     * Indicate if the browser incorrectly calculates width:100% inside a
	     * scrolling element (IE6/7)
	     *  @type boolean
	     *  @default false
	     */
					"bScrollOversize": false,
	
					/**
	     * Determine if the vertical scrollbar is on the right or left of the
	     * scrolling container - needed for rtl language layout, although not
	     * all browsers move the scrollbar (Safari).
	     *  @type boolean
	     *  @default false
	     */
					"bScrollbarLeft": false
				},
	
				"ajax": null,
	
				/**
	    * Array referencing the nodes which are used for the features. The
	    * parameters of this object match what is allowed by sDom - i.e.
	    *   <ul>
	    *     <li>'l' - Length changing</li>
	    *     <li>'f' - Filtering input</li>
	    *     <li>'t' - The table!</li>
	    *     <li>'i' - Information</li>
	    *     <li>'p' - Pagination</li>
	    *     <li>'r' - pRocessing</li>
	    *   </ul>
	    *  @type array
	    *  @default []
	    */
				"aanFeatures": [],
	
				/**
	    * Store data information - see {@link DataTable.models.oRow} for detailed
	    * information.
	    *  @type array
	    *  @default []
	    */
				"aoData": [],
	
				/**
	    * Array of indexes which are in the current display (after filtering etc)
	    *  @type array
	    *  @default []
	    */
				"aiDisplay": [],
	
				/**
	    * Array of indexes for display - no filtering
	    *  @type array
	    *  @default []
	    */
				"aiDisplayMaster": [],
	
				/**
	    * Store information about each column that is in use
	    *  @type array
	    *  @default []
	    */
				"aoColumns": [],
	
				/**
	    * Store information about the table's header
	    *  @type array
	    *  @default []
	    */
				"aoHeader": [],
	
				/**
	    * Store information about the table's footer
	    *  @type array
	    *  @default []
	    */
				"aoFooter": [],
	
				/**
	    * Store the applied global search information in case we want to force a
	    * research or compare the old search to a new one.
	    * Note that this parameter will be set by the initialisation routine. To
	    * set a default use {@link DataTable.defaults}.
	    *  @namespace
	    *  @extends DataTable.models.oSearch
	    */
				"oPreviousSearch": {},
	
				/**
	    * Store the applied search for each column - see
	    * {@link DataTable.models.oSearch} for the format that is used for the
	    * filtering information for each column.
	    *  @type array
	    *  @default []
	    */
				"aoPreSearchCols": [],
	
				/**
	    * Sorting that is applied to the table. Note that the inner arrays are
	    * used in the following manner:
	    * <ul>
	    *   <li>Index 0 - column number</li>
	    *   <li>Index 1 - current sorting direction</li>
	    * </ul>
	    * Note that this parameter will be set by the initialisation routine. To
	    * set a default use {@link DataTable.defaults}.
	    *  @type array
	    *  @todo These inner arrays should really be objects
	    */
				"aaSorting": null,
	
				/**
	    * Sorting that is always applied to the table (i.e. prefixed in front of
	    * aaSorting).
	    * Note that this parameter will be set by the initialisation routine. To
	    * set a default use {@link DataTable.defaults}.
	    *  @type array
	    *  @default []
	    */
				"aaSortingFixed": [],
	
				/**
	    * Classes to use for the striping of a table.
	    * Note that this parameter will be set by the initialisation routine. To
	    * set a default use {@link DataTable.defaults}.
	    *  @type array
	    *  @default []
	    */
				"asStripeClasses": null,
	
				/**
	    * If restoring a table - we should restore its striping classes as well
	    *  @type array
	    *  @default []
	    */
				"asDestroyStripes": [],
	
				/**
	    * If restoring a table - we should restore its width
	    *  @type int
	    *  @default 0
	    */
				"sDestroyWidth": 0,
	
				/**
	    * Callback functions array for every time a row is inserted (i.e. on a draw).
	    *  @type array
	    *  @default []
	    */
				"aoRowCallback": [],
	
				/**
	    * Callback functions for the header on each draw.
	    *  @type array
	    *  @default []
	    */
				"aoHeaderCallback": [],
	
				/**
	    * Callback function for the footer on each draw.
	    *  @type array
	    *  @default []
	    */
				"aoFooterCallback": [],
	
				/**
	    * Array of callback functions for draw callback functions
	    *  @type array
	    *  @default []
	    */
				"aoDrawCallback": [],
	
				/**
	    * Array of callback functions for row created function
	    *  @type array
	    *  @default []
	    */
				"aoRowCreatedCallback": [],
	
				/**
	    * Callback functions for just before the table is redrawn. A return of
	    * false will be used to cancel the draw.
	    *  @type array
	    *  @default []
	    */
				"aoPreDrawCallback": [],
	
				/**
	    * Callback functions for when the table has been initialised.
	    *  @type array
	    *  @default []
	    */
				"aoInitComplete": [],
	
				/**
	    * Callbacks for modifying the settings to be stored for state saving, prior to
	    * saving state.
	    *  @type array
	    *  @default []
	    */
				"aoStateSaveParams": [],
	
				/**
	    * Callbacks for modifying the settings that have been stored for state saving
	    * prior to using the stored values to restore the state.
	    *  @type array
	    *  @default []
	    */
				"aoStateLoadParams": [],
	
				/**
	    * Callbacks for operating on the settings object once the saved state has been
	    * loaded
	    *  @type array
	    *  @default []
	    */
				"aoStateLoaded": [],
	
				/**
	    * Cache the table ID for quick access
	    *  @type string
	    *  @default <i>Empty string</i>
	    */
				"sTableId": "",
	
				/**
	    * The TABLE node for the main table
	    *  @type node
	    *  @default null
	    */
				"nTable": null,
	
				/**
	    * Permanent ref to the thead element
	    *  @type node
	    *  @default null
	    */
				"nTHead": null,
	
				/**
	    * Permanent ref to the tfoot element - if it exists
	    *  @type node
	    *  @default null
	    */
				"nTFoot": null,
	
				/**
	    * Permanent ref to the tbody element
	    *  @type node
	    *  @default null
	    */
				"nTBody": null,
	
				/**
	    * Cache the wrapper node (contains all DataTables controlled elements)
	    *  @type node
	    *  @default null
	    */
				"nTableWrapper": null,
	
				/**
	    * Indicate if when using server-side processing the loading of data
	    * should be deferred until the second draw.
	    * Note that this parameter will be set by the initialisation routine. To
	    * set a default use {@link DataTable.defaults}.
	    *  @type boolean
	    *  @default false
	    */
				"bDeferLoading": false,
	
				/**
	    * Indicate if all required information has been read in
	    *  @type boolean
	    *  @default false
	    */
				"bInitialised": false,
	
				/**
	    * Information about open rows. Each object in the array has the parameters
	    * 'nTr' and 'nParent'
	    *  @type array
	    *  @default []
	    */
				"aoOpenRows": [],
	
				/**
	    * Dictate the positioning of DataTables' control elements - see
	    * {@link DataTable.model.oInit.sDom}.
	    * Note that this parameter will be set by the initialisation routine. To
	    * set a default use {@link DataTable.defaults}.
	    *  @type string
	    *  @default null
	    */
				"sDom": null,
	
				/**
	    * Search delay (in mS)
	    *  @type integer
	    *  @default null
	    */
				"searchDelay": null,
	
				/**
	    * Which type of pagination should be used.
	    * Note that this parameter will be set by the initialisation routine. To
	    * set a default use {@link DataTable.defaults}.
	    *  @type string
	    *  @default two_button
	    */
				"sPaginationType": "two_button",
	
				/**
	    * The state duration (for `stateSave`) in seconds.
	    * Note that this parameter will be set by the initialisation routine. To
	    * set a default use {@link DataTable.defaults}.
	    *  @type int
	    *  @default 0
	    */
				"iStateDuration": 0,
	
				/**
	    * Array of callback functions for state saving. Each array element is an
	    * object with the following parameters:
	    *   <ul>
	    *     <li>function:fn - function to call. Takes two parameters, oSettings
	    *       and the JSON string to save that has been thus far created. Returns
	    *       a JSON string to be inserted into a json object
	    *       (i.e. '"param": [ 0, 1, 2]')</li>
	    *     <li>string:sName - name of callback</li>
	    *   </ul>
	    *  @type array
	    *  @default []
	    */
				"aoStateSave": [],
	
				/**
	    * Array of callback functions for state loading. Each array element is an
	    * object with the following parameters:
	    *   <ul>
	    *     <li>function:fn - function to call. Takes two parameters, oSettings
	    *       and the object stored. May return false to cancel state loading</li>
	    *     <li>string:sName - name of callback</li>
	    *   </ul>
	    *  @type array
	    *  @default []
	    */
				"aoStateLoad": [],
	
				/**
	    * State that was saved. Useful for back reference
	    *  @type object
	    *  @default null
	    */
				"oSavedState": null,
	
				/**
	    * State that was loaded. Useful for back reference
	    *  @type object
	    *  @default null
	    */
				"oLoadedState": null,
	
				/**
	    * Source url for AJAX data for the table.
	    * Note that this parameter will be set by the initialisation routine. To
	    * set a default use {@link DataTable.defaults}.
	    *  @type string
	    *  @default null
	    */
				"sAjaxSource": null,
	
				/**
	    * Property from a given object from which to read the table data from. This
	    * can be an empty string (when not server-side processing), in which case
	    * it is  assumed an an array is given directly.
	    * Note that this parameter will be set by the initialisation routine. To
	    * set a default use {@link DataTable.defaults}.
	    *  @type string
	    */
				"sAjaxDataProp": null,
	
				/**
	    * Note if draw should be blocked while getting data
	    *  @type boolean
	    *  @default true
	    */
				"bAjaxDataGet": true,
	
				/**
	    * The last jQuery XHR object that was used for server-side data gathering.
	    * This can be used for working with the XHR information in one of the
	    * callbacks
	    *  @type object
	    *  @default null
	    */
				"jqXHR": null,
	
				/**
	    * JSON returned from the server in the last Ajax request
	    *  @type object
	    *  @default undefined
	    */
				"json": undefined,
	
				/**
	    * Data submitted as part of the last Ajax request
	    *  @type object
	    *  @default undefined
	    */
				"oAjaxData": undefined,
	
				/**
	    * Function to get the server-side data.
	    * Note that this parameter will be set by the initialisation routine. To
	    * set a default use {@link DataTable.defaults}.
	    *  @type function
	    */
				"fnServerData": null,
	
				/**
	    * Functions which are called prior to sending an Ajax request so extra
	    * parameters can easily be sent to the server
	    *  @type array
	    *  @default []
	    */
				"aoServerParams": [],
	
				/**
	    * Send the XHR HTTP method - GET or POST (could be PUT or DELETE if
	    * required).
	    * Note that this parameter will be set by the initialisation routine. To
	    * set a default use {@link DataTable.defaults}.
	    *  @type string
	    */
				"sServerMethod": null,
	
				/**
	    * Format numbers for display.
	    * Note that this parameter will be set by the initialisation routine. To
	    * set a default use {@link DataTable.defaults}.
	    *  @type function
	    */
				"fnFormatNumber": null,
	
				/**
	    * List of options that can be used for the user selectable length menu.
	    * Note that this parameter will be set by the initialisation routine. To
	    * set a default use {@link DataTable.defaults}.
	    *  @type array
	    *  @default []
	    */
				"aLengthMenu": null,
	
				/**
	    * Counter for the draws that the table does. Also used as a tracker for
	    * server-side processing
	    *  @type int
	    *  @default 0
	    */
				"iDraw": 0,
	
				/**
	    * Indicate if a redraw is being done - useful for Ajax
	    *  @type boolean
	    *  @default false
	    */
				"bDrawing": false,
	
				/**
	    * Draw index (iDraw) of the last error when parsing the returned data
	    *  @type int
	    *  @default -1
	    */
				"iDrawError": -1,
	
				/**
	    * Paging display length
	    *  @type int
	    *  @default 10
	    */
				"_iDisplayLength": 10,
	
				/**
	    * Paging start point - aiDisplay index
	    *  @type int
	    *  @default 0
	    */
				"_iDisplayStart": 0,
	
				/**
	    * Server-side processing - number of records in the result set
	    * (i.e. before filtering), Use fnRecordsTotal rather than
	    * this property to get the value of the number of records, regardless of
	    * the server-side processing setting.
	    *  @type int
	    *  @default 0
	    *  @private
	    */
				"_iRecordsTotal": 0,
	
				/**
	    * Server-side processing - number of records in the current display set
	    * (i.e. after filtering). Use fnRecordsDisplay rather than
	    * this property to get the value of the number of records, regardless of
	    * the server-side processing setting.
	    *  @type boolean
	    *  @default 0
	    *  @private
	    */
				"_iRecordsDisplay": 0,
	
				/**
	    * Flag to indicate if jQuery UI marking and classes should be used.
	    * Note that this parameter will be set by the initialisation routine. To
	    * set a default use {@link DataTable.defaults}.
	    *  @type boolean
	    */
				"bJUI": null,
	
				/**
	    * The classes to use for the table
	    *  @type object
	    *  @default {}
	    */
				"oClasses": {},
	
				/**
	    * Flag attached to the settings object so you can check in the draw
	    * callback if filtering has been done in the draw. Deprecated in favour of
	    * events.
	    *  @type boolean
	    *  @default false
	    *  @deprecated
	    */
				"bFiltered": false,
	
				/**
	    * Flag attached to the settings object so you can check in the draw
	    * callback if sorting has been done in the draw. Deprecated in favour of
	    * events.
	    *  @type boolean
	    *  @default false
	    *  @deprecated
	    */
				"bSorted": false,
	
				/**
	    * Indicate that if multiple rows are in the header and there is more than
	    * one unique cell per column, if the top one (true) or bottom one (false)
	    * should be used for sorting / title by DataTables.
	    * Note that this parameter will be set by the initialisation routine. To
	    * set a default use {@link DataTable.defaults}.
	    *  @type boolean
	    */
				"bSortCellsTop": null,
	
				/**
	    * Initialisation object that is used for the table
	    *  @type object
	    *  @default null
	    */
				"oInit": null,
	
				/**
	    * Destroy callback functions - for plug-ins to attach themselves to the
	    * destroy so they can clean up markup and events.
	    *  @type array
	    *  @default []
	    */
				"aoDestroyCallback": [],
	
				/**
	    * Get the number of records in the current record set, before filtering
	    *  @type function
	    */
				"fnRecordsTotal": function fnRecordsTotal() {
					return _fnDataSource(this) == 'ssp' ? this._iRecordsTotal * 1 : this.aiDisplayMaster.length;
				},
	
				/**
	    * Get the number of records in the current record set, after filtering
	    *  @type function
	    */
				"fnRecordsDisplay": function fnRecordsDisplay() {
					return _fnDataSource(this) == 'ssp' ? this._iRecordsDisplay * 1 : this.aiDisplay.length;
				},
	
				/**
	    * Get the display end point - aiDisplay index
	    *  @type function
	    */
				"fnDisplayEnd": function fnDisplayEnd() {
					var len = this._iDisplayLength,
					    start = this._iDisplayStart,
					    calc = start + len,
					    records = this.aiDisplay.length,
					    features = this.oFeatures,
					    paginate = features.bPaginate;
	
					if (features.bServerSide) {
						return paginate === false || len === -1 ? start + records : Math.min(start + len, this._iRecordsDisplay);
					} else {
						return !paginate || calc > records || len === -1 ? records : calc;
					}
				},
	
				/**
	    * The DataTables object for this table
	    *  @type object
	    *  @default null
	    */
				"oInstance": null,
	
				/**
	    * Unique identifier for each instance of the DataTables object. If there
	    * is an ID on the table node, then it takes that value, otherwise an
	    * incrementing internal counter is used.
	    *  @type string
	    *  @default null
	    */
				"sInstance": null,
	
				/**
	    * tabindex attribute value that is added to DataTables control elements, allowing
	    * keyboard navigation of the table and its controls.
	    */
				"iTabIndex": 0,
	
				/**
	    * DIV container for the footer scrolling table if scrolling
	    */
				"nScrollHead": null,
	
				/**
	    * DIV container for the footer scrolling table if scrolling
	    */
				"nScrollFoot": null,
	
				/**
	    * Last applied sort
	    *  @type array
	    *  @default []
	    */
				"aLastSort": [],
	
				/**
	    * Stored plug-in instances
	    *  @type object
	    *  @default {}
	    */
				"oPlugins": {}
			};
	
			/**
	   * Extension object for DataTables that is used to provide all extension
	   * options.
	   *
	   * Note that the `DataTable.ext` object is available through
	   * `jQuery.fn.dataTable.ext` where it may be accessed and manipulated. It is
	   * also aliased to `jQuery.fn.dataTableExt` for historic reasons.
	   *  @namespace
	   *  @extends DataTable.models.ext
	   */
	
			/**
	   * DataTables extensions
	   * 
	   * This namespace acts as a collection area for plug-ins that can be used to
	   * extend DataTables capabilities. Indeed many of the build in methods
	   * use this method to provide their own capabilities (sorting methods for
	   * example).
	   *
	   * Note that this namespace is aliased to `jQuery.fn.dataTableExt` for legacy
	   * reasons
	   *
	   *  @namespace
	   */
			_DataTable.ext = _ext = {
				/**
	    * Element class names
	    *
	    *  @type object
	    *  @default {}
	    */
				classes: {},
	
				/**
	    * Error reporting.
	    * 
	    * How should DataTables report an error. Can take the value 'alert' or
	    * 'throw'
	    *
	    *  @type string
	    *  @default alert
	    */
				errMode: "alert",
	
				/**
	    * Feature plug-ins.
	    * 
	    * This is an array of objects which describe the feature plug-ins that are
	    * available to DataTables. These feature plug-ins are then available for
	    * use through the `dom` initialisation option.
	    * 
	    * Each feature plug-in is described by an object which must have the
	    * following properties:
	    * 
	    * * `fnInit` - function that is used to initialise the plug-in,
	    * * `cFeature` - a character so the feature can be enabled by the `dom`
	    *   instillation option. This is case sensitive.
	    *
	    * The `fnInit` function has the following input parameters:
	    *
	    * 1. `{object}` DataTables settings object: see
	    *    {@link DataTable.models.oSettings}
	    *
	    * And the following return is expected:
	    * 
	    * * {node|null} The element which contains your feature. Note that the
	    *   return may also be void if your plug-in does not require to inject any
	    *   DOM elements into DataTables control (`dom`) - for example this might
	    *   be useful when developing a plug-in which allows table control via
	    *   keyboard entry
	    *
	    *  @type array
	    *
	    *  @example
	    *    $.fn.dataTable.ext.features.push( {
	    *      "fnInit": function( oSettings ) {
	    *        return new TableTools( { "oDTSettings": oSettings } );
	    *      },
	    *      "cFeature": "T"
	    *    } );
	    */
				feature: [],
	
				/**
	    * Row searching.
	    * 
	    * This method of searching is complimentary to the default type based
	    * searching, and a lot more comprehensive as it allows you complete control
	    * over the searching logic. Each element in this array is a function
	    * (parameters described below) that is called for every row in the table,
	    * and your logic decides if it should be included in the searching data set
	    * or not.
	    *
	    * Searching functions have the following input parameters:
	    *
	    * 1. `{object}` DataTables settings object: see
	    *    {@link DataTable.models.oSettings}
	    * 2. `{array|object}` Data for the row to be processed (same as the
	    *    original format that was passed in as the data source, or an array
	    *    from a DOM data source
	    * 3. `{int}` Row index ({@link DataTable.models.oSettings.aoData}), which
	    *    can be useful to retrieve the `TR` element if you need DOM interaction.
	    *
	    * And the following return is expected:
	    *
	    * * {boolean} Include the row in the searched result set (true) or not
	    *   (false)
	    *
	    * Note that as with the main search ability in DataTables, technically this
	    * is "filtering", since it is subtractive. However, for consistency in
	    * naming we call it searching here.
	    *
	    *  @type array
	    *  @default []
	    *
	    *  @example
	    *    // The following example shows custom search being applied to the
	    *    // fourth column (i.e. the data[3] index) based on two input values
	    *    // from the end-user, matching the data in a certain range.
	    *    $.fn.dataTable.ext.search.push(
	    *      function( settings, data, dataIndex ) {
	    *        var min = document.getElementById('min').value * 1;
	    *        var max = document.getElementById('max').value * 1;
	    *        var version = data[3] == "-" ? 0 : data[3]*1;
	    *
	    *        if ( min == "" && max == "" ) {
	    *          return true;
	    *        }
	    *        else if ( min == "" && version < max ) {
	    *          return true;
	    *        }
	    *        else if ( min < version && "" == max ) {
	    *          return true;
	    *        }
	    *        else if ( min < version && version < max ) {
	    *          return true;
	    *        }
	    *        return false;
	    *      }
	    *    );
	    */
				search: [],
	
				/**
	    * Internal functions, exposed for used in plug-ins.
	    * 
	    * Please note that you should not need to use the internal methods for
	    * anything other than a plug-in (and even then, try to avoid if possible).
	    * The internal function may change between releases.
	    *
	    *  @type object
	    *  @default {}
	    */
				internal: {},
	
				/**
	    * Legacy configuration options. Enable and disable legacy options that
	    * are available in DataTables.
	    *
	    *  @type object
	    */
				legacy: {
					/**
	     * Enable / disable DataTables 1.9 compatible server-side processing
	     * requests
	     *
	     *  @type boolean
	     *  @default null
	     */
					ajax: null
				},
	
				/**
	    * Pagination plug-in methods.
	    * 
	    * Each entry in this object is a function and defines which buttons should
	    * be shown by the pagination rendering method that is used for the table:
	    * {@link DataTable.ext.renderer.pageButton}. The renderer addresses how the
	    * buttons are displayed in the document, while the functions here tell it
	    * what buttons to display. This is done by returning an array of button
	    * descriptions (what each button will do).
	    *
	    * Pagination types (the four built in options and any additional plug-in
	    * options defined here) can be used through the `paginationType`
	    * initialisation parameter.
	    *
	    * The functions defined take two parameters:
	    *
	    * 1. `{int} page` The current page index
	    * 2. `{int} pages` The number of pages in the table
	    *
	    * Each function is expected to return an array where each element of the
	    * array can be one of:
	    *
	    * * `first` - Jump to first page when activated
	    * * `last` - Jump to last page when activated
	    * * `previous` - Show previous page when activated
	    * * `next` - Show next page when activated
	    * * `{int}` - Show page of the index given
	    * * `{array}` - A nested array containing the above elements to add a
	    *   containing 'DIV' element (might be useful for styling).
	    *
	    * Note that DataTables v1.9- used this object slightly differently whereby
	    * an object with two functions would be defined for each plug-in. That
	    * ability is still supported by DataTables 1.10+ to provide backwards
	    * compatibility, but this option of use is now decremented and no longer
	    * documented in DataTables 1.10+.
	    *
	    *  @type object
	    *  @default {}
	    *
	    *  @example
	    *    // Show previous, next and current page buttons only
	    *    $.fn.dataTableExt.oPagination.current = function ( page, pages ) {
	    *      return [ 'previous', page, 'next' ];
	    *    };
	    */
				pager: {},
	
				renderer: {
					pageButton: {},
					header: {}
				},
	
				/**
	    * Ordering plug-ins - custom data source
	    * 
	    * The extension options for ordering of data available here is complimentary
	    * to the default type based ordering that DataTables typically uses. It
	    * allows much greater control over the the data that is being used to
	    * order a column, but is necessarily therefore more complex.
	    * 
	    * This type of ordering is useful if you want to do ordering based on data
	    * live from the DOM (for example the contents of an 'input' element) rather
	    * than just the static string that DataTables knows of.
	    * 
	    * The way these plug-ins work is that you create an array of the values you
	    * wish to be ordering for the column in question and then return that
	    * array. The data in the array much be in the index order of the rows in
	    * the table (not the currently ordering order!). Which order data gathering
	    * function is run here depends on the `dt-init columns.orderDataType`
	    * parameter that is used for the column (if any).
	    *
	    * The functions defined take two parameters:
	    *
	    * 1. `{object}` DataTables settings object: see
	    *    {@link DataTable.models.oSettings}
	    * 2. `{int}` Target column index
	    *
	    * Each function is expected to return an array:
	    *
	    * * `{array}` Data for the column to be ordering upon
	    *
	    *  @type array
	    *
	    *  @example
	    *    // Ordering using `input` node values
	    *    $.fn.dataTable.ext.order['dom-text'] = function  ( settings, col )
	    *    {
	    *      return this.api().column( col, {order:'index'} ).nodes().map( function ( td, i ) {
	    *        return $('input', td).val();
	    *      } );
	    *    }
	    */
				order: {},
	
				/**
	    * Type based plug-ins.
	    *
	    * Each column in DataTables has a type assigned to it, either by automatic
	    * detection or by direct assignment using the `type` option for the column.
	    * The type of a column will effect how it is ordering and search (plug-ins
	    * can also make use of the column type if required).
	    *
	    * @namespace
	    */
				type: {
					/**
	     * Type detection functions.
	     *
	     * The functions defined in this object are used to automatically detect
	     * a column's type, making initialisation of DataTables super easy, even
	     * when complex data is in the table.
	     *
	     * The functions defined take two parameters:
	     *
	        *  1. `{*}` Data from the column cell to be analysed
	        *  2. `{settings}` DataTables settings object. This can be used to
	        *     perform context specific type detection - for example detection
	        *     based on language settings such as using a comma for a decimal
	        *     place. Generally speaking the options from the settings will not
	        *     be required
	     *
	     * Each function is expected to return:
	     *
	     * * `{string|null}` Data type detected, or null if unknown (and thus
	     *   pass it on to the other type detection functions.
	     *
	     *  @type array
	     *
	     *  @example
	     *    // Currency type detection plug-in:
	     *    $.fn.dataTable.ext.type.detect.push(
	     *      function ( data, settings ) {
	     *        // Check the numeric part
	     *        if ( ! $.isNumeric( data.substring(1) ) ) {
	     *          return null;
	     *        }
	     *
	     *        // Check prefixed by currency
	     *        if ( data.charAt(0) == '$' || data.charAt(0) == '&pound;' ) {
	     *          return 'currency';
	     *        }
	     *        return null;
	     *      }
	     *    );
	     */
					detect: [],
	
					/**
	     * Type based search formatting.
	     *
	     * The type based searching functions can be used to pre-format the
	     * data to be search on. For example, it can be used to strip HTML
	     * tags or to de-format telephone numbers for numeric only searching.
	     *
	     * Note that is a search is not defined for a column of a given type,
	     * no search formatting will be performed.
	     * 
	     * Pre-processing of searching data plug-ins - When you assign the sType
	     * for a column (or have it automatically detected for you by DataTables
	     * or a type detection plug-in), you will typically be using this for
	     * custom sorting, but it can also be used to provide custom searching
	     * by allowing you to pre-processing the data and returning the data in
	     * the format that should be searched upon. This is done by adding
	     * functions this object with a parameter name which matches the sType
	     * for that target column. This is the corollary of <i>afnSortData</i>
	     * for searching data.
	     *
	     * The functions defined take a single parameter:
	     *
	        *  1. `{*}` Data from the column cell to be prepared for searching
	     *
	     * Each function is expected to return:
	     *
	     * * `{string|null}` Formatted string that will be used for the searching.
	     *
	     *  @type object
	     *  @default {}
	     *
	     *  @example
	     *    $.fn.dataTable.ext.type.search['title-numeric'] = function ( d ) {
	     *      return d.replace(/\n/g," ").replace( /<.*?>/g, "" );
	     *    }
	     */
					search: {},
	
					/**
	     * Type based ordering.
	     *
	     * The column type tells DataTables what ordering to apply to the table
	     * when a column is sorted upon. The order for each type that is defined,
	     * is defined by the functions available in this object.
	     *
	     * Each ordering option can be described by three properties added to
	     * this object:
	     *
	     * * `{type}-pre` - Pre-formatting function
	     * * `{type}-asc` - Ascending order function
	     * * `{type}-desc` - Descending order function
	     *
	     * All three can be used together, only `{type}-pre` or only
	     * `{type}-asc` and `{type}-desc` together. It is generally recommended
	     * that only `{type}-pre` is used, as this provides the optimal
	     * implementation in terms of speed, although the others are provided
	     * for compatibility with existing Javascript sort functions.
	     *
	     * `{type}-pre`: Functions defined take a single parameter:
	     *
	        *  1. `{*}` Data from the column cell to be prepared for ordering
	     *
	     * And return:
	     *
	     * * `{*}` Data to be sorted upon
	     *
	     * `{type}-asc` and `{type}-desc`: Functions are typical Javascript sort
	     * functions, taking two parameters:
	     *
	        *  1. `{*}` Data to compare to the second parameter
	        *  2. `{*}` Data to compare to the first parameter
	     *
	     * And returning:
	     *
	     * * `{*}` Ordering match: <0 if first parameter should be sorted lower
	     *   than the second parameter, ===0 if the two parameters are equal and
	     *   >0 if the first parameter should be sorted height than the second
	     *   parameter.
	     * 
	     *  @type object
	     *  @default {}
	     *
	     *  @example
	     *    // Numeric ordering of formatted numbers with a pre-formatter
	     *    $.extend( $.fn.dataTable.ext.type.order, {
	     *      "string-pre": function(x) {
	     *        a = (a === "-" || a === "") ? 0 : a.replace( /[^\d\-\.]/g, "" );
	     *        return parseFloat( a );
	     *      }
	     *    } );
	     *
	     *  @example
	     *    // Case-sensitive string ordering, with no pre-formatting method
	     *    $.extend( $.fn.dataTable.ext.order, {
	     *      "string-case-asc": function(x,y) {
	     *        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
	     *      },
	     *      "string-case-desc": function(x,y) {
	     *        return ((x < y) ? 1 : ((x > y) ? -1 : 0));
	     *      }
	     *    } );
	     */
					order: {}
				},
	
				/**
	    * Unique DataTables instance counter
	    *
	    * @type int
	    * @private
	    */
				_unique: 0,
	
				//
				// Depreciated
				// The following properties are retained for backwards compatiblity only.
				// The should not be used in new projects and will be removed in a future
				// version
				//
	
				/**
	    * Version check function.
	    *  @type function
	    *  @depreciated Since 1.10
	    */
				fnVersionCheck: _DataTable.fnVersionCheck,
	
				/**
	    * Index for what 'this' index API functions should use
	    *  @type int
	    *  @deprecated Since v1.10
	    */
				iApiIndex: 0,
	
				/**
	    * jQuery UI class container
	    *  @type object
	    *  @deprecated Since v1.10
	    */
				oJUIClasses: {},
	
				/**
	    * Software version
	    *  @type string
	    *  @deprecated Since v1.10
	    */
				sVersion: _DataTable.version
			};
	
			//
			// Backwards compatibility. Alias to pre 1.10 Hungarian notation counter parts
			//
			$.extend(_ext, {
				afnFiltering: _ext.search,
				aTypes: _ext.type.detect,
				ofnSearch: _ext.type.search,
				oSort: _ext.type.order,
				afnSortData: _ext.order,
				aoFeatures: _ext.feature,
				oApi: _ext.internal,
				oStdClasses: _ext.classes,
				oPagination: _ext.pager
			});
	
			$.extend(_DataTable.ext.classes, {
				"sTable": "dataTable",
				"sNoFooter": "no-footer",
	
				/* Paging buttons */
				"sPageButton": "paginate_button",
				"sPageButtonActive": "current",
				"sPageButtonDisabled": "disabled",
	
				/* Striping classes */
				"sStripeOdd": "odd",
				"sStripeEven": "even",
	
				/* Empty row */
				"sRowEmpty": "dataTables_empty",
	
				/* Features */
				"sWrapper": "dataTables_wrapper",
				"sFilter": "dataTables_filter",
				"sInfo": "dataTables_info",
				"sPaging": "dataTables_paginate paging_", /* Note that the type is postfixed */
				"sLength": "dataTables_length",
				"sProcessing": "dataTables_processing",
	
				/* Sorting */
				"sSortAsc": "sorting_asc",
				"sSortDesc": "sorting_desc",
				"sSortable": "sorting", /* Sortable in both directions */
				"sSortableAsc": "sorting_asc_disabled",
				"sSortableDesc": "sorting_desc_disabled",
				"sSortableNone": "sorting_disabled",
				"sSortColumn": "sorting_", /* Note that an int is postfixed for the sorting order */
	
				/* Filtering */
				"sFilterInput": "",
	
				/* Page length */
				"sLengthSelect": "",
	
				/* Scrolling */
				"sScrollWrapper": "dataTables_scroll",
				"sScrollHead": "dataTables_scrollHead",
				"sScrollHeadInner": "dataTables_scrollHeadInner",
				"sScrollBody": "dataTables_scrollBody",
				"sScrollFoot": "dataTables_scrollFoot",
				"sScrollFootInner": "dataTables_scrollFootInner",
	
				/* Misc */
				"sHeaderTH": "",
				"sFooterTH": "",
	
				// Deprecated
				"sSortJUIAsc": "",
				"sSortJUIDesc": "",
				"sSortJUI": "",
				"sSortJUIAscAllowed": "",
				"sSortJUIDescAllowed": "",
				"sSortJUIWrapper": "",
				"sSortIcon": "",
				"sJUIHeader": "",
				"sJUIFooter": ""
			});
	
			(function () {
	
				// Reused strings for better compression. Closure compiler appears to have a
				// weird edge case where it is trying to expand strings rather than use the
				// variable version. This results in about 200 bytes being added, for very
				// little preference benefit since it this run on script load only.
				var _empty = '';
				_empty = '';
	
				var _stateDefault = _empty + 'ui-state-default';
				var _sortIcon = _empty + 'css_right ui-icon ui-icon-';
				var _headerFooter = _empty + 'fg-toolbar ui-toolbar ui-widget-header ui-helper-clearfix';
	
				$.extend(_DataTable.ext.oJUIClasses, _DataTable.ext.classes, {
					/* Full numbers paging buttons */
					"sPageButton": "fg-button ui-button " + _stateDefault,
					"sPageButtonActive": "ui-state-disabled",
					"sPageButtonDisabled": "ui-state-disabled",
	
					/* Features */
					"sPaging": "dataTables_paginate fg-buttonset ui-buttonset fg-buttonset-multi " + "ui-buttonset-multi paging_", /* Note that the type is postfixed */
	
					/* Sorting */
					"sSortAsc": _stateDefault + " sorting_asc",
					"sSortDesc": _stateDefault + " sorting_desc",
					"sSortable": _stateDefault + " sorting",
					"sSortableAsc": _stateDefault + " sorting_asc_disabled",
					"sSortableDesc": _stateDefault + " sorting_desc_disabled",
					"sSortableNone": _stateDefault + " sorting_disabled",
					"sSortJUIAsc": _sortIcon + "triangle-1-n",
					"sSortJUIDesc": _sortIcon + "triangle-1-s",
					"sSortJUI": _sortIcon + "carat-2-n-s",
					"sSortJUIAscAllowed": _sortIcon + "carat-1-n",
					"sSortJUIDescAllowed": _sortIcon + "carat-1-s",
					"sSortJUIWrapper": "DataTables_sort_wrapper",
					"sSortIcon": "DataTables_sort_icon",
	
					/* Scrolling */
					"sScrollHead": "dataTables_scrollHead " + _stateDefault,
					"sScrollFoot": "dataTables_scrollFoot " + _stateDefault,
	
					/* Misc */
					"sHeaderTH": _stateDefault,
					"sFooterTH": _stateDefault,
					"sJUIHeader": _headerFooter + " ui-corner-tl ui-corner-tr",
					"sJUIFooter": _headerFooter + " ui-corner-bl ui-corner-br"
				});
			})();
	
			var extPagination = _DataTable.ext.pager;
	
			function _numbers(page, pages) {
				var numbers = [],
				    buttons = extPagination.numbers_length,
				    half = Math.floor(buttons / 2),
				    i = 1;
	
				if (pages <= buttons) {
					numbers = _range(0, pages);
				} else if (page <= half) {
					numbers = _range(0, buttons - 2);
					numbers.push('ellipsis');
					numbers.push(pages - 1);
				} else if (page >= pages - 1 - half) {
					numbers = _range(pages - (buttons - 2), pages);
					numbers.splice(0, 0, 'ellipsis'); // no unshift in ie6
					numbers.splice(0, 0, 0);
				} else {
					numbers = _range(page - 1, page + 2);
					numbers.push('ellipsis');
					numbers.push(pages - 1);
					numbers.splice(0, 0, 'ellipsis');
					numbers.splice(0, 0, 0);
				}
	
				numbers.DT_el = 'span';
				return numbers;
			}
	
			$.extend(extPagination, {
				simple: function simple(page, pages) {
					return ['previous', 'next'];
				},
	
				full: function full(page, pages) {
					return ['first', 'previous', 'next', 'last'];
				},
	
				simple_numbers: function simple_numbers(page, pages) {
					return ['previous', _numbers(page, pages), 'next'];
				},
	
				full_numbers: function full_numbers(page, pages) {
					return ['first', 'previous', _numbers(page, pages), 'next', 'last'];
				},
	
				// For testing and plug-ins to use
				_numbers: _numbers,
				numbers_length: 7
			});
	
			$.extend(true, _DataTable.ext.renderer, {
				pageButton: {
					_: function _(settings, host, idx, buttons, page, pages) {
						var classes = settings.oClasses;
						var lang = settings.oLanguage.oPaginate;
						var btnDisplay,
						    btnClass,
						    counter = 0;
	
						var attach = function attach(container, buttons) {
							var i, ien, node, button;
							var clickHandler = function clickHandler(e) {
								_fnPageChange(settings, e.data.action, true);
							};
	
							for (i = 0, ien = buttons.length; i < ien; i++) {
								button = buttons[i];
	
								if ($.isArray(button)) {
									var inner = $('<' + (button.DT_el || 'div') + '/>').appendTo(container);
									attach(inner, button);
								} else {
									btnDisplay = '';
									btnClass = '';
	
									switch (button) {
										case 'ellipsis':
											container.append('<span>&hellip;</span>');
											break;
	
										case 'first':
											btnDisplay = lang.sFirst;
											btnClass = button + (page > 0 ? '' : ' ' + classes.sPageButtonDisabled);
											break;
	
										case 'previous':
											btnDisplay = lang.sPrevious;
											btnClass = button + (page > 0 ? '' : ' ' + classes.sPageButtonDisabled);
											break;
	
										case 'next':
											btnDisplay = lang.sNext;
											btnClass = button + (page < pages - 1 ? '' : ' ' + classes.sPageButtonDisabled);
											break;
	
										case 'last':
											btnDisplay = lang.sLast;
											btnClass = button + (page < pages - 1 ? '' : ' ' + classes.sPageButtonDisabled);
											break;
	
										default:
											btnDisplay = button + 1;
											btnClass = page === button ? classes.sPageButtonActive : '';
											break;
									}
	
									if (btnDisplay) {
										node = $('<a>', {
											'class': classes.sPageButton + ' ' + btnClass,
											'aria-controls': settings.sTableId,
											'data-dt-idx': counter,
											'tabindex': settings.iTabIndex,
											'id': idx === 0 && typeof button === 'string' ? settings.sTableId + '_' + button : null
										}).html(btnDisplay).appendTo(container);
	
										_fnBindAction(node, { action: button }, clickHandler);
	
										counter++;
									}
								}
							}
						};
	
						// IE9 throws an 'unknown error' if document.activeElement is used
						// inside an iframe or frame. Try / catch the error. Not good for
						// accessibility, but neither are frames.
						try {
							// Because this approach is destroying and recreating the paging
							// elements, focus is lost on the select button which is bad for
							// accessibility. So we want to restore focus once the draw has
							// completed
							var activeEl = $(document.activeElement).data('dt-idx');
	
							attach($(host).empty(), buttons);
	
							if (activeEl !== null) {
								$(host).find('[data-dt-idx=' + activeEl + ']').focus();
							}
						} catch (e) {}
					}
				}
			});
	
			// Built in type detection. See model.ext.aTypes for information about
			// what is required from this methods.
			$.extend(_DataTable.ext.type.detect, [
			// Plain numbers - first since V8 detects some plain numbers as dates
			// e.g. Date.parse('55') (but not all, e.g. Date.parse('22')...).
			function (d, settings) {
				var decimal = settings.oLanguage.sDecimal;
				return _isNumber(d, decimal) ? 'num' + decimal : null;
			},
	
			// Dates (only those recognised by the browser's Date.parse)
			function (d, settings) {
				// V8 will remove any unknown characters at the start and end of the
				// expression, leading to false matches such as `$245.12` or `10%` being
				// a valid date. See forum thread 18941 for detail.
				if (d && !(d instanceof Date) && (!_re_date_start.test(d) || !_re_date_end.test(d))) {
					return null;
				}
				var parsed = Date.parse(d);
				return parsed !== null && !isNaN(parsed) || _empty(d) ? 'date' : null;
			},
	
			// Formatted numbers
			function (d, settings) {
				var decimal = settings.oLanguage.sDecimal;
				return _isNumber(d, decimal, true) ? 'num-fmt' + decimal : null;
			},
	
			// HTML numeric
			function (d, settings) {
				var decimal = settings.oLanguage.sDecimal;
				return _htmlNumeric(d, decimal) ? 'html-num' + decimal : null;
			},
	
			// HTML numeric, formatted
			function (d, settings) {
				var decimal = settings.oLanguage.sDecimal;
				return _htmlNumeric(d, decimal, true) ? 'html-num-fmt' + decimal : null;
			},
	
			// HTML (this is strict checking - there must be html)
			function (d, settings) {
				return _empty(d) || typeof d === 'string' && d.indexOf('<') !== -1 ? 'html' : null;
			}]);
	
			// Filter formatting functions. See model.ext.ofnSearch for information about
			// what is required from these methods.
			// 
			// Note that additional search methods are added for the html numbers and
			// html formatted numbers by `_addNumericSort()` when we know what the decimal
			// place is
	
	
			$.extend(_DataTable.ext.type.search, {
				html: function html(data) {
					return _empty(data) ? data : typeof data === 'string' ? data.replace(_re_new_lines, " ").replace(_re_html, "") : '';
				},
	
				string: function string(data) {
					return _empty(data) ? data : typeof data === 'string' ? data.replace(_re_new_lines, " ") : data;
				}
			});
	
			var __numericReplace = function __numericReplace(d, decimalPlace, re1, re2) {
				if (d !== 0 && (!d || d === '-')) {
					return -Infinity;
				}
	
				// If a decimal place other than `.` is used, it needs to be given to the
				// function so we can detect it and replace with a `.` which is the only
				// decimal place Javascript recognises - it is not locale aware.
				if (decimalPlace) {
					d = _numToDecimal(d, decimalPlace);
				}
	
				if (d.replace) {
					if (re1) {
						d = d.replace(re1, '');
					}
	
					if (re2) {
						d = d.replace(re2, '');
					}
				}
	
				return d * 1;
			};
	
			// Add the numeric 'deformatting' functions for sorting and search. This is done
			// in a function to provide an easy ability for the language options to add
			// additional methods if a non-period decimal place is used.
			function _addNumericSort(decimalPlace) {
				$.each({
					// Plain numbers
					"num": function num(d) {
						return __numericReplace(d, decimalPlace);
					},
	
					// Formatted numbers
					"num-fmt": function numFmt(d) {
						return __numericReplace(d, decimalPlace, _re_formatted_numeric);
					},
	
					// HTML numeric
					"html-num": function htmlNum(d) {
						return __numericReplace(d, decimalPlace, _re_html);
					},
	
					// HTML numeric, formatted
					"html-num-fmt": function htmlNumFmt(d) {
						return __numericReplace(d, decimalPlace, _re_html, _re_formatted_numeric);
					}
				}, function (key, fn) {
					// Add the ordering method
					_ext.type.order[key + decimalPlace + '-pre'] = fn;
	
					// For HTML types add a search formatter that will strip the HTML
					if (key.match(/^html\-/)) {
						_ext.type.search[key + decimalPlace] = _ext.type.search.html;
					}
				});
			}
	
			// Default sort methods
			$.extend(_ext.type.order, {
				// Dates
				"date-pre": function datePre(d) {
					return Date.parse(d) || 0;
				},
	
				// html
				"html-pre": function htmlPre(a) {
					return _empty(a) ? '' : a.replace ? a.replace(/<.*?>/g, "").toLowerCase() : a + '';
				},
	
				// string
				"string-pre": function stringPre(a) {
					// This is a little complex, but faster than always calling toString,
					// http://jsperf.com/tostring-v-check
					return _empty(a) ? '' : typeof a === 'string' ? a.toLowerCase() : !a.toString ? '' : a.toString();
				},
	
				// string-asc and -desc are retained only for compatibility with the old
				// sort methods
				"string-asc": function stringAsc(x, y) {
					return x < y ? -1 : x > y ? 1 : 0;
				},
	
				"string-desc": function stringDesc(x, y) {
					return x < y ? 1 : x > y ? -1 : 0;
				}
			});
	
			// Numeric sorting types - order doesn't matter here
			_addNumericSort('');
	
			$.extend(true, _DataTable.ext.renderer, {
				header: {
					_: function _(settings, cell, column, classes) {
						// No additional mark-up required
						// Attach a sort listener to update on sort - note that using the
						// `DT` namespace will allow the event to be removed automatically
						// on destroy, while the `dt` namespaced event is the one we are
						// listening for
						$(settings.nTable).on('order.dt.DT', function (e, ctx, sorting, columns) {
							if (settings !== ctx) {
								// need to check this this is the host
								return; // table, not a nested one
							}
	
							var colIdx = column.idx;
	
							cell.removeClass(column.sSortingClass + ' ' + classes.sSortAsc + ' ' + classes.sSortDesc).addClass(columns[colIdx] == 'asc' ? classes.sSortAsc : columns[colIdx] == 'desc' ? classes.sSortDesc : column.sSortingClass);
						});
					},
	
					jqueryui: function jqueryui(settings, cell, column, classes) {
						$('<div/>').addClass(classes.sSortJUIWrapper).append(cell.contents()).append($('<span/>').addClass(classes.sSortIcon + ' ' + column.sSortingClassJUI)).appendTo(cell);
	
						// Attach a sort listener to update on sort
						$(settings.nTable).on('order.dt.DT', function (e, ctx, sorting, columns) {
							if (settings !== ctx) {
								return;
							}
	
							var colIdx = column.idx;
	
							cell.removeClass(classes.sSortAsc + " " + classes.sSortDesc).addClass(columns[colIdx] == 'asc' ? classes.sSortAsc : columns[colIdx] == 'desc' ? classes.sSortDesc : column.sSortingClass);
	
							cell.find('span.' + classes.sSortIcon).removeClass(classes.sSortJUIAsc + " " + classes.sSortJUIDesc + " " + classes.sSortJUI + " " + classes.sSortJUIAscAllowed + " " + classes.sSortJUIDescAllowed).addClass(columns[colIdx] == 'asc' ? classes.sSortJUIAsc : columns[colIdx] == 'desc' ? classes.sSortJUIDesc : column.sSortingClassJUI);
						});
					}
				}
			});
	
			/*
	   * Public helper functions. These aren't used internally by DataTables, or
	   * called by any of the options passed into DataTables, but they can be used
	   * externally by developers working with DataTables. They are helper functions
	   * to make working with DataTables a little bit easier.
	   */
	
			/**
	   * Helpers for `columns.render`.
	   *
	   * The options defined here can be used with the `columns.render` initialisation
	   * option to provide a display renderer. The following functions are defined:
	   *
	   * * `number` - Will format numeric data (defined by `columns.data`) for
	   *   display, retaining the original unformatted data for sorting and filtering.
	   *   It takes 4 parameters:
	   *   * `string` - Thousands grouping separator
	   *   * `string` - Decimal point indicator
	   *   * `integer` - Number of decimal points to show
	   *   * `string` (optional) - Prefix.
	   *
	   * @example
	   *   // Column definition using the number renderer
	   *   {
	   *     data: "salary",
	   *     render: $.fn.dataTable.render.number( '\'', '.', 0, '$' )
	   *   }
	   *
	   * @namespace
	   */
			_DataTable.render = {
				number: function number(thousands, decimal, precision, prefix) {
					return {
						display: function display(d) {
							var negative = d < 0 ? '-' : '';
							d = Math.abs(parseFloat(d));
	
							var intPart = parseInt(d, 10);
							var floatPart = precision ? decimal + (d - intPart).toFixed(precision).substring(2) : '';
	
							return negative + (prefix || '') + intPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + floatPart;
						}
					};
				}
			};
	
			/*
	   * This is really a good bit rubbish this method of exposing the internal methods
	   * publicly... - To be fixed in 2.0 using methods on the prototype
	   */
	
			/**
	   * Create a wrapper function for exporting an internal functions to an external API.
	   *  @param {string} fn API function name
	   *  @returns {function} wrapped function
	   *  @memberof DataTable#internal
	   */
			function _fnExternApiFunc(fn) {
				return function () {
					var args = [_fnSettingsFromNode(this[_DataTable.ext.iApiIndex])].concat(Array.prototype.slice.call(arguments));
					return _DataTable.ext.internal[fn].apply(this, args);
				};
			}
	
			/**
	   * Reference to internal functions for use by plug-in developers. Note that
	   * these methods are references to internal functions and are considered to be
	   * private. If you use these methods, be aware that they are liable to change
	   * between versions.
	   *  @namespace
	   */
			$.extend(_DataTable.ext.internal, {
				_fnExternApiFunc: _fnExternApiFunc,
				_fnBuildAjax: _fnBuildAjax,
				_fnAjaxUpdate: _fnAjaxUpdate,
				_fnAjaxParameters: _fnAjaxParameters,
				_fnAjaxUpdateDraw: _fnAjaxUpdateDraw,
				_fnAjaxDataSrc: _fnAjaxDataSrc,
				_fnAddColumn: _fnAddColumn,
				_fnColumnOptions: _fnColumnOptions,
				_fnAdjustColumnSizing: _fnAdjustColumnSizing,
				_fnVisibleToColumnIndex: _fnVisibleToColumnIndex,
				_fnColumnIndexToVisible: _fnColumnIndexToVisible,
				_fnVisbleColumns: _fnVisbleColumns,
				_fnGetColumns: _fnGetColumns,
				_fnColumnTypes: _fnColumnTypes,
				_fnApplyColumnDefs: _fnApplyColumnDefs,
				_fnHungarianMap: _fnHungarianMap,
				_fnCamelToHungarian: _fnCamelToHungarian,
				_fnLanguageCompat: _fnLanguageCompat,
				_fnBrowserDetect: _fnBrowserDetect,
				_fnAddData: _fnAddData,
				_fnAddTr: _fnAddTr,
				_fnNodeToDataIndex: _fnNodeToDataIndex,
				_fnNodeToColumnIndex: _fnNodeToColumnIndex,
				_fnGetCellData: _fnGetCellData,
				_fnSetCellData: _fnSetCellData,
				_fnSplitObjNotation: _fnSplitObjNotation,
				_fnGetObjectDataFn: _fnGetObjectDataFn,
				_fnSetObjectDataFn: _fnSetObjectDataFn,
				_fnGetDataMaster: _fnGetDataMaster,
				_fnClearTable: _fnClearTable,
				_fnDeleteIndex: _fnDeleteIndex,
				_fnInvalidate: _fnInvalidate,
				_fnGetRowElements: _fnGetRowElements,
				_fnCreateTr: _fnCreateTr,
				_fnBuildHead: _fnBuildHead,
				_fnDrawHead: _fnDrawHead,
				_fnDraw: _fnDraw,
				_fnReDraw: _fnReDraw,
				_fnAddOptionsHtml: _fnAddOptionsHtml,
				_fnDetectHeader: _fnDetectHeader,
				_fnGetUniqueThs: _fnGetUniqueThs,
				_fnFeatureHtmlFilter: _fnFeatureHtmlFilter,
				_fnFilterComplete: _fnFilterComplete,
				_fnFilterCustom: _fnFilterCustom,
				_fnFilterColumn: _fnFilterColumn,
				_fnFilter: _fnFilter,
				_fnFilterCreateSearch: _fnFilterCreateSearch,
				_fnEscapeRegex: _fnEscapeRegex,
				_fnFilterData: _fnFilterData,
				_fnFeatureHtmlInfo: _fnFeatureHtmlInfo,
				_fnUpdateInfo: _fnUpdateInfo,
				_fnInfoMacros: _fnInfoMacros,
				_fnInitialise: _fnInitialise,
				_fnInitComplete: _fnInitComplete,
				_fnLengthChange: _fnLengthChange,
				_fnFeatureHtmlLength: _fnFeatureHtmlLength,
				_fnFeatureHtmlPaginate: _fnFeatureHtmlPaginate,
				_fnPageChange: _fnPageChange,
				_fnFeatureHtmlProcessing: _fnFeatureHtmlProcessing,
				_fnProcessingDisplay: _fnProcessingDisplay,
				_fnFeatureHtmlTable: _fnFeatureHtmlTable,
				_fnScrollDraw: _fnScrollDraw,
				_fnApplyToChildren: _fnApplyToChildren,
				_fnCalculateColumnWidths: _fnCalculateColumnWidths,
				_fnThrottle: _fnThrottle,
				_fnConvertToWidth: _fnConvertToWidth,
				_fnScrollingWidthAdjust: _fnScrollingWidthAdjust,
				_fnGetWidestNode: _fnGetWidestNode,
				_fnGetMaxLenString: _fnGetMaxLenString,
				_fnStringToCss: _fnStringToCss,
				_fnScrollBarWidth: _fnScrollBarWidth,
				_fnSortFlatten: _fnSortFlatten,
				_fnSort: _fnSort,
				_fnSortAria: _fnSortAria,
				_fnSortListener: _fnSortListener,
				_fnSortAttachListener: _fnSortAttachListener,
				_fnSortingClasses: _fnSortingClasses,
				_fnSortData: _fnSortData,
				_fnSaveState: _fnSaveState,
				_fnLoadState: _fnLoadState,
				_fnSettingsFromNode: _fnSettingsFromNode,
				_fnLog: _fnLog,
				_fnMap: _fnMap,
				_fnBindAction: _fnBindAction,
				_fnCallbackReg: _fnCallbackReg,
				_fnCallbackFire: _fnCallbackFire,
				_fnLengthOverflow: _fnLengthOverflow,
				_fnRenderer: _fnRenderer,
				_fnDataSource: _fnDataSource,
				_fnRowAttributes: _fnRowAttributes,
				_fnCalculateEnd: function _fnCalculateEnd() {} // Used by a lot of plug-ins, but redundant
				// in 1.10, so this dead-end function is
				// added to prevent errors
			});
	
			// jQuery access
			$.fn.dataTable = _DataTable;
	
			// Legacy aliases
			$.fn.dataTableSettings = _DataTable.settings;
			$.fn.dataTableExt = _DataTable.ext;
	
			// With a capital `D` we return a DataTables API instance rather than a
			// jQuery object
			$.fn.DataTable = function (opts) {
				return $(this).dataTable(opts).api();
			};
	
			// All properties that are available to $.fn.dataTable should also be
			// available on $.fn.DataTable
			$.each(_DataTable, function (prop, val) {
				$.fn.DataTable[prop] = val;
			});
	
			// Information about events fired by DataTables - for documentation.
			/**
	   * Draw event, fired whenever the table is redrawn on the page, at the same
	   * point as fnDrawCallback. This may be useful for binding events or
	   * performing calculations when the table is altered at all.
	   *  @name DataTable#draw.dt
	   *  @event
	   *  @param {event} e jQuery event object
	   *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	   */
	
			/**
	   * Search event, fired when the searching applied to the table (using the
	   * built-in global search, or column filters) is altered.
	   *  @name DataTable#search.dt
	   *  @event
	   *  @param {event} e jQuery event object
	   *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	   */
	
			/**
	   * Page change event, fired when the paging of the table is altered.
	   *  @name DataTable#page.dt
	   *  @event
	   *  @param {event} e jQuery event object
	   *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	   */
	
			/**
	   * Order event, fired when the ordering applied to the table is altered.
	   *  @name DataTable#order.dt
	   *  @event
	   *  @param {event} e jQuery event object
	   *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	   */
	
			/**
	   * DataTables initialisation complete event, fired when the table is fully
	   * drawn, including Ajax data loaded, if Ajax data is required.
	   *  @name DataTable#init.dt
	   *  @event
	   *  @param {event} e jQuery event object
	   *  @param {object} oSettings DataTables settings object
	   *  @param {object} json The JSON object request from the server - only
	   *    present if client-side Ajax sourced data is used</li></ol>
	   */
	
			/**
	   * State save event, fired when the table has changed state a new state save
	   * is required. This event allows modification of the state saving object
	   * prior to actually doing the save, including addition or other state
	   * properties (for plug-ins) or modification of a DataTables core property.
	   *  @name DataTable#stateSaveParams.dt
	   *  @event
	   *  @param {event} e jQuery event object
	   *  @param {object} oSettings DataTables settings object
	   *  @param {object} json The state information to be saved
	   */
	
			/**
	   * State load event, fired when the table is loading state from the stored
	   * data, but prior to the settings object being modified by the saved state
	   * - allowing modification of the saved state is required or loading of
	   * state for a plug-in.
	   *  @name DataTable#stateLoadParams.dt
	   *  @event
	   *  @param {event} e jQuery event object
	   *  @param {object} oSettings DataTables settings object
	   *  @param {object} json The saved state information
	   */
	
			/**
	   * State loaded event, fired when state has been loaded from stored data and
	   * the settings object has been modified by the loaded data.
	   *  @name DataTable#stateLoaded.dt
	   *  @event
	   *  @param {event} e jQuery event object
	   *  @param {object} oSettings DataTables settings object
	   *  @param {object} json The saved state information
	   */
	
			/**
	   * Processing event, fired when DataTables is doing some kind of processing
	   * (be it, order, searcg or anything else). It can be used to indicate to
	   * the end user that there is something happening, or that something has
	   * finished.
	   *  @name DataTable#processing.dt
	   *  @event
	   *  @param {event} e jQuery event object
	   *  @param {object} oSettings DataTables settings object
	   *  @param {boolean} bShow Flag for if DataTables is doing processing or not
	   */
	
			/**
	   * Ajax (XHR) event, fired whenever an Ajax request is completed from a
	   * request to made to the server for new data. This event is called before
	   * DataTables processed the returned data, so it can also be used to pre-
	   * process the data returned from the server, if needed.
	   *
	   * Note that this trigger is called in `fnServerData`, if you override
	   * `fnServerData` and which to use this event, you need to trigger it in you
	   * success function.
	   *  @name DataTable#xhr.dt
	   *  @event
	   *  @param {event} e jQuery event object
	   *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	   *  @param {object} json JSON returned from the server
	   *
	   *  @example
	   *     // Use a custom property returned from the server in another DOM element
	   *     $('#table').dataTable().on('xhr.dt', function (e, settings, json) {
	   *       $('#status').html( json.status );
	   *     } );
	   *
	   *  @example
	   *     // Pre-process the data returned from the server
	   *     $('#table').dataTable().on('xhr.dt', function (e, settings, json) {
	   *       for ( var i=0, ien=json.aaData.length ; i<ien ; i++ ) {
	   *         json.aaData[i].sum = json.aaData[i].one + json.aaData[i].two;
	   *       }
	   *       // Note no return - manipulate the data directly in the JSON object.
	   *     } );
	   */
	
			/**
	   * Destroy event, fired when the DataTable is destroyed by calling fnDestroy
	   * or passing the bDestroy:true parameter in the initialisation object. This
	   * can be used to remove bound events, added DOM nodes, etc.
	   *  @name DataTable#destroy.dt
	   *  @event
	   *  @param {event} e jQuery event object
	   *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	   */
	
			/**
	   * Page length change event, fired when number of records to show on each
	   * page (the length) is changed.
	   *  @name DataTable#length.dt
	   *  @event
	   *  @param {event} e jQuery event object
	   *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	   *  @param {integer} len New length
	   */
	
			/**
	   * Column sizing has changed.
	   *  @name DataTable#column-sizing.dt
	   *  @event
	   *  @param {event} e jQuery event object
	   *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	   */
	
			/**
	   * Column visibility has changed.
	   *  @name DataTable#column-visibility.dt
	   *  @event
	   *  @param {event} e jQuery event object
	   *  @param {object} o DataTables settings object {@link DataTable.models.oSettings}
	   *  @param {int} column Column index
	   *  @param {bool} vis `false` if column now hidden, or `true` if visible
	   */
	
			return $.fn.dataTable;
		});
	})(window, document);

/***/ },
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(45);
	var toLength = __webpack_require__(25);
	var toAbsoluteIndex = __webpack_require__(81);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(13);
	var $export = __webpack_require__(8);
	var redefine = __webpack_require__(40);
	var redefineAll = __webpack_require__(79);
	var meta = __webpack_require__(69);
	var forOf = __webpack_require__(74);
	var anInstance = __webpack_require__(73);
	var isObject = __webpack_require__(18);
	var fails = __webpack_require__(17);
	var $iterDetect = __webpack_require__(121);
	var setToStringTag = __webpack_require__(90);
	var inheritIfRequired = __webpack_require__(159);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(264);
	var redefine = __webpack_require__(40);
	var hide = __webpack_require__(39);
	var fails = __webpack_require__(17);
	var defined = __webpack_require__(58);
	var wks = __webpack_require__(23);
	var regexpExec = __webpack_require__(167);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(48);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(18);
	var cof = __webpack_require__(48);
	var MATCH = __webpack_require__(23)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(23)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(68) || !__webpack_require__(17)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(13)[K];
	});


/***/ },
/* 123 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(88);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(8);
	var aFunction = __webpack_require__(37);
	var ctx = __webpack_require__(50);
	var forOf = __webpack_require__(74);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(8);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(52);
	var defined = __webpack_require__(58);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13);
	var hide = __webpack_require__(39);
	var uid = __webpack_require__(82);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ },
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(127)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(32);
	var toAbsoluteIndex = __webpack_require__(81);
	var toLength = __webpack_require__(25);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(854);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(29);
	var createDesc = __webpack_require__(78);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	var document = __webpack_require__(13).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 156 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(23)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(13).document;
	module.exports = document && document.documentElement;


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	var setPrototypeOf = __webpack_require__(168).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(89);
	var ITERATOR = __webpack_require__(23)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(75);
	var descriptor = __webpack_require__(78);
	var setToStringTag = __webpack_require__(90);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(39)(IteratorPrototype, __webpack_require__(23)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(68);
	var $export = __webpack_require__(8);
	var redefine = __webpack_require__(40);
	var hide = __webpack_require__(39);
	var Iterators = __webpack_require__(89);
	var $iterCreate = __webpack_require__(161);
	var setToStringTag = __webpack_require__(90);
	var getPrototypeOf = __webpack_require__(44);
	var ITERATOR = __webpack_require__(23)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 163 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ },
/* 164 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13);
	var macrotask = __webpack_require__(173).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(48)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(37);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(100);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(18);
	var anObject = __webpack_require__(12);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(50)(Function.call, __webpack_require__(43).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(103)('keys');
	var uid = __webpack_require__(82);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(120);
	var defined = __webpack_require__(58);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(52);
	var defined = __webpack_require__(58);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ },
/* 172 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(50);
	var invoke = __webpack_require__(242);
	var html = __webpack_require__(158);
	var cel = __webpack_require__(155);
	var global = __webpack_require__(13);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(48)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(13);
	var DESCRIPTORS = __webpack_require__(28);
	var LIBRARY = __webpack_require__(68);
	var $typed = __webpack_require__(128);
	var hide = __webpack_require__(39);
	var redefineAll = __webpack_require__(79);
	var fails = __webpack_require__(17);
	var anInstance = __webpack_require__(73);
	var toInteger = __webpack_require__(52);
	var toLength = __webpack_require__(25);
	var toIndex = __webpack_require__(261);
	var gOPN = __webpack_require__(76).f;
	var dP = __webpack_require__(29).f;
	var arrayFill = __webpack_require__(152);
	var setToStringTag = __webpack_require__(90);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13);
	var core = __webpack_require__(49);
	var LIBRARY = __webpack_require__(68);
	var wksExt = __webpack_require__(262);
	var defineProperty = __webpack_require__(29).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(88);
	var ITERATOR = __webpack_require__(23)('iterator');
	var Iterators = __webpack_require__(89);
	module.exports = __webpack_require__(49).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(67);
	var step = __webpack_require__(245);
	var Iterators = __webpack_require__(89);
	var toIObject = __webpack_require__(45);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(162)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery Validation Plugin v1.15.0
	 *
	 * http://jqueryvalidation.org/
	 *
	 * Copyright (c) 2016 Jörn Zaefferer
	 * Released under the MIT license
	 */
	(function( factory ) {
		if ( true ) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module === "object" && module.exports) {
			module.exports = factory( require( "jquery" ) );
		} else {
			factory( jQuery );
		}
	}(function( $ ) {
	
	$.extend( $.fn, {
	
		// http://jqueryvalidation.org/validate/
		validate: function( options ) {
	
			// If nothing is selected, return nothing; can't chain anyway
			if ( !this.length ) {
				if ( options && options.debug && window.console ) {
					console.warn( "Nothing selected, can't validate, returning nothing." );
				}
				return;
			}
	
			// Check if a validator for this form was already created
			var validator = $.data( this[ 0 ], "validator" );
			if ( validator ) {
				return validator;
			}
	
			// Add novalidate tag if HTML5.
			this.attr( "novalidate", "novalidate" );
	
			validator = new $.validator( options, this[ 0 ] );
			$.data( this[ 0 ], "validator", validator );
	
			if ( validator.settings.onsubmit ) {
	
				this.on( "click.validate", ":submit", function( event ) {
					if ( validator.settings.submitHandler ) {
						validator.submitButton = event.target;
					}
	
					// Allow suppressing validation by adding a cancel class to the submit button
					if ( $( this ).hasClass( "cancel" ) ) {
						validator.cancelSubmit = true;
					}
	
					// Allow suppressing validation by adding the html5 formnovalidate attribute to the submit button
					if ( $( this ).attr( "formnovalidate" ) !== undefined ) {
						validator.cancelSubmit = true;
					}
				} );
	
				// Validate the form on submit
				this.on( "submit.validate", function( event ) {
					if ( validator.settings.debug ) {
	
						// Prevent form submit to be able to see console output
						event.preventDefault();
					}
					function handle() {
						var hidden, result;
						if ( validator.settings.submitHandler ) {
							if ( validator.submitButton ) {
	
								// Insert a hidden input as a replacement for the missing submit button
								hidden = $( "<input type='hidden'/>" )
									.attr( "name", validator.submitButton.name )
									.val( $( validator.submitButton ).val() )
									.appendTo( validator.currentForm );
							}
							result = validator.settings.submitHandler.call( validator, validator.currentForm, event );
							if ( validator.submitButton ) {
	
								// And clean up afterwards; thanks to no-block-scope, hidden can be referenced
								hidden.remove();
							}
							if ( result !== undefined ) {
								return result;
							}
							return false;
						}
						return true;
					}
	
					// Prevent submit for invalid forms or custom submit handlers
					if ( validator.cancelSubmit ) {
						validator.cancelSubmit = false;
						return handle();
					}
					if ( validator.form() ) {
						if ( validator.pendingRequest ) {
							validator.formSubmitted = true;
							return false;
						}
						return handle();
					} else {
						validator.focusInvalid();
						return false;
					}
				} );
			}
	
			return validator;
		},
	
		// http://jqueryvalidation.org/valid/
		valid: function() {
			var valid, validator, errorList;
	
			if ( $( this[ 0 ] ).is( "form" ) ) {
				valid = this.validate().form();
			} else {
				errorList = [];
				valid = true;
				validator = $( this[ 0 ].form ).validate();
				this.each( function() {
					valid = validator.element( this ) && valid;
					if ( !valid ) {
						errorList = errorList.concat( validator.errorList );
					}
				} );
				validator.errorList = errorList;
			}
			return valid;
		},
	
		// http://jqueryvalidation.org/rules/
		rules: function( command, argument ) {
	
			// If nothing is selected, return nothing; can't chain anyway
			if ( !this.length ) {
				return;
			}
	
			var element = this[ 0 ],
				settings, staticRules, existingRules, data, param, filtered;
	
			if ( command ) {
				settings = $.data( element.form, "validator" ).settings;
				staticRules = settings.rules;
				existingRules = $.validator.staticRules( element );
				switch ( command ) {
				case "add":
					$.extend( existingRules, $.validator.normalizeRule( argument ) );
	
					// Remove messages from rules, but allow them to be set separately
					delete existingRules.messages;
					staticRules[ element.name ] = existingRules;
					if ( argument.messages ) {
						settings.messages[ element.name ] = $.extend( settings.messages[ element.name ], argument.messages );
					}
					break;
				case "remove":
					if ( !argument ) {
						delete staticRules[ element.name ];
						return existingRules;
					}
					filtered = {};
					$.each( argument.split( /\s/ ), function( index, method ) {
						filtered[ method ] = existingRules[ method ];
						delete existingRules[ method ];
						if ( method === "required" ) {
							$( element ).removeAttr( "aria-required" );
						}
					} );
					return filtered;
				}
			}
	
			data = $.validator.normalizeRules(
			$.extend(
				{},
				$.validator.classRules( element ),
				$.validator.attributeRules( element ),
				$.validator.dataRules( element ),
				$.validator.staticRules( element )
			), element );
	
			// Make sure required is at front
			if ( data.required ) {
				param = data.required;
				delete data.required;
				data = $.extend( { required: param }, data );
				$( element ).attr( "aria-required", "true" );
			}
	
			// Make sure remote is at back
			if ( data.remote ) {
				param = data.remote;
				delete data.remote;
				data = $.extend( data, { remote: param } );
			}
	
			return data;
		}
	} );
	
	// Custom selectors
	$.extend( $.expr[ ":" ], {
	
		// http://jqueryvalidation.org/blank-selector/
		blank: function( a ) {
			return !$.trim( "" + $( a ).val() );
		},
	
		// http://jqueryvalidation.org/filled-selector/
		filled: function( a ) {
			var val = $( a ).val();
			return val !== null && !!$.trim( "" + val );
		},
	
		// http://jqueryvalidation.org/unchecked-selector/
		unchecked: function( a ) {
			return !$( a ).prop( "checked" );
		}
	} );
	
	// Constructor for validator
	$.validator = function( options, form ) {
		this.settings = $.extend( true, {}, $.validator.defaults, options );
		this.currentForm = form;
		this.init();
	};
	
	// http://jqueryvalidation.org/jQuery.validator.format/
	$.validator.format = function( source, params ) {
		if ( arguments.length === 1 ) {
			return function() {
				var args = $.makeArray( arguments );
				args.unshift( source );
				return $.validator.format.apply( this, args );
			};
		}
		if ( params === undefined ) {
			return source;
		}
		if ( arguments.length > 2 && params.constructor !== Array  ) {
			params = $.makeArray( arguments ).slice( 1 );
		}
		if ( params.constructor !== Array ) {
			params = [ params ];
		}
		$.each( params, function( i, n ) {
			source = source.replace( new RegExp( "\\{" + i + "\\}", "g" ), function() {
				return n;
			} );
		} );
		return source;
	};
	
	$.extend( $.validator, {
	
		defaults: {
			messages: {},
			groups: {},
			rules: {},
			errorClass: "error",
			pendingClass: "pending",
			validClass: "valid",
			errorElement: "label",
			focusCleanup: false,
			focusInvalid: true,
			errorContainer: $( [] ),
			errorLabelContainer: $( [] ),
			onsubmit: true,
			ignore: ":hidden",
			ignoreTitle: false,
			onfocusin: function( element ) {
				this.lastActive = element;
	
				// Hide error label and remove error class on focus if enabled
				if ( this.settings.focusCleanup ) {
					if ( this.settings.unhighlight ) {
						this.settings.unhighlight.call( this, element, this.settings.errorClass, this.settings.validClass );
					}
					this.hideThese( this.errorsFor( element ) );
				}
			},
			onfocusout: function( element ) {
				if ( !this.checkable( element ) && ( element.name in this.submitted || !this.optional( element ) ) ) {
					this.element( element );
				}
			},
			onkeyup: function( element, event ) {
	
				// Avoid revalidate the field when pressing one of the following keys
				// Shift       => 16
				// Ctrl        => 17
				// Alt         => 18
				// Caps lock   => 20
				// End         => 35
				// Home        => 36
				// Left arrow  => 37
				// Up arrow    => 38
				// Right arrow => 39
				// Down arrow  => 40
				// Insert      => 45
				// Num lock    => 144
				// AltGr key   => 225
				var excludedKeys = [
					16, 17, 18, 20, 35, 36, 37,
					38, 39, 40, 45, 144, 225
				];
	
				if ( event.which === 9 && this.elementValue( element ) === "" || $.inArray( event.keyCode, excludedKeys ) !== -1 ) {
					return;
				} else if ( element.name in this.submitted || element.name in this.invalid ) {
					this.element( element );
				}
			},
			onclick: function( element ) {
	
				// Click on selects, radiobuttons and checkboxes
				if ( element.name in this.submitted ) {
					this.element( element );
	
				// Or option elements, check parent select in that case
				} else if ( element.parentNode.name in this.submitted ) {
					this.element( element.parentNode );
				}
			},
			highlight: function( element, errorClass, validClass ) {
				if ( element.type === "radio" ) {
					this.findByName( element.name ).addClass( errorClass ).removeClass( validClass );
				} else {
					$( element ).addClass( errorClass ).removeClass( validClass );
				}
			},
			unhighlight: function( element, errorClass, validClass ) {
				if ( element.type === "radio" ) {
					this.findByName( element.name ).removeClass( errorClass ).addClass( validClass );
				} else {
					$( element ).removeClass( errorClass ).addClass( validClass );
				}
			}
		},
	
		// http://jqueryvalidation.org/jQuery.validator.setDefaults/
		setDefaults: function( settings ) {
			$.extend( $.validator.defaults, settings );
		},
	
		messages: {
			required: "This field is required.",
			remote: "Please fix this field.",
			email: "Please enter a valid email address.",
			url: "Please enter a valid URL.",
			date: "Please enter a valid date.",
			dateISO: "Please enter a valid date ( ISO ).",
			number: "Please enter a valid number.",
			digits: "Please enter only digits.",
			equalTo: "Please enter the same value again.",
			maxlength: $.validator.format( "Please enter no more than {0} characters." ),
			minlength: $.validator.format( "Please enter at least {0} characters." ),
			rangelength: $.validator.format( "Please enter a value between {0} and {1} characters long." ),
			range: $.validator.format( "Please enter a value between {0} and {1}." ),
			max: $.validator.format( "Please enter a value less than or equal to {0}." ),
			min: $.validator.format( "Please enter a value greater than or equal to {0}." ),
			step: $.validator.format( "Please enter a multiple of {0}." )
		},
	
		autoCreateRanges: false,
	
		prototype: {
	
			init: function() {
				this.labelContainer = $( this.settings.errorLabelContainer );
				this.errorContext = this.labelContainer.length && this.labelContainer || $( this.currentForm );
				this.containers = $( this.settings.errorContainer ).add( this.settings.errorLabelContainer );
				this.submitted = {};
				this.valueCache = {};
				this.pendingRequest = 0;
				this.pending = {};
				this.invalid = {};
				this.reset();
	
				var groups = ( this.groups = {} ),
					rules;
				$.each( this.settings.groups, function( key, value ) {
					if ( typeof value === "string" ) {
						value = value.split( /\s/ );
					}
					$.each( value, function( index, name ) {
						groups[ name ] = key;
					} );
				} );
				rules = this.settings.rules;
				$.each( rules, function( key, value ) {
					rules[ key ] = $.validator.normalizeRule( value );
				} );
	
				function delegate( event ) {
					var validator = $.data( this.form, "validator" ),
						eventType = "on" + event.type.replace( /^validate/, "" ),
						settings = validator.settings;
					if ( settings[ eventType ] && !$( this ).is( settings.ignore ) ) {
						settings[ eventType ].call( validator, this, event );
					}
				}
	
				$( this.currentForm )
					.on( "focusin.validate focusout.validate keyup.validate",
						":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'], " +
						"[type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], " +
						"[type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'], " +
						"[type='radio'], [type='checkbox'], [contenteditable]", delegate )
	
					// Support: Chrome, oldIE
					// "select" is provided as event.target when clicking a option
					.on( "click.validate", "select, option, [type='radio'], [type='checkbox']", delegate );
	
				if ( this.settings.invalidHandler ) {
					$( this.currentForm ).on( "invalid-form.validate", this.settings.invalidHandler );
				}
	
				// Add aria-required to any Static/Data/Class required fields before first validation
				// Screen readers require this attribute to be present before the initial submission http://www.w3.org/TR/WCAG-TECHS/ARIA2.html
				$( this.currentForm ).find( "[required], [data-rule-required], .required" ).attr( "aria-required", "true" );
			},
	
			// http://jqueryvalidation.org/Validator.form/
			form: function() {
				this.checkForm();
				$.extend( this.submitted, this.errorMap );
				this.invalid = $.extend( {}, this.errorMap );
				if ( !this.valid() ) {
					$( this.currentForm ).triggerHandler( "invalid-form", [ this ] );
				}
				this.showErrors();
				return this.valid();
			},
	
			checkForm: function() {
				this.prepareForm();
				for ( var i = 0, elements = ( this.currentElements = this.elements() ); elements[ i ]; i++ ) {
					this.check( elements[ i ] );
				}
				return this.valid();
			},
	
			// http://jqueryvalidation.org/Validator.element/
			element: function( element ) {
				var cleanElement = this.clean( element ),
					checkElement = this.validationTargetFor( cleanElement ),
					v = this,
					result = true,
					rs, group;
	
				if ( checkElement === undefined ) {
					delete this.invalid[ cleanElement.name ];
				} else {
					this.prepareElement( checkElement );
					this.currentElements = $( checkElement );
	
					// If this element is grouped, then validate all group elements already
					// containing a value
					group = this.groups[ checkElement.name ];
					if ( group ) {
						$.each( this.groups, function( name, testgroup ) {
							if ( testgroup === group && name !== checkElement.name ) {
								cleanElement = v.validationTargetFor( v.clean( v.findByName( name ) ) );
								if ( cleanElement && cleanElement.name in v.invalid ) {
									v.currentElements.push( cleanElement );
									result = result && v.check( cleanElement );
								}
							}
						} );
					}
	
					rs = this.check( checkElement ) !== false;
					result = result && rs;
					if ( rs ) {
						this.invalid[ checkElement.name ] = false;
					} else {
						this.invalid[ checkElement.name ] = true;
					}
	
					if ( !this.numberOfInvalids() ) {
	
						// Hide error containers on last error
						this.toHide = this.toHide.add( this.containers );
					}
					this.showErrors();
	
					// Add aria-invalid status for screen readers
					$( element ).attr( "aria-invalid", !rs );
				}
	
				return result;
			},
	
			// http://jqueryvalidation.org/Validator.showErrors/
			showErrors: function( errors ) {
				if ( errors ) {
					var validator = this;
	
					// Add items to error list and map
					$.extend( this.errorMap, errors );
					this.errorList = $.map( this.errorMap, function( message, name ) {
						return {
							message: message,
							element: validator.findByName( name )[ 0 ]
						};
					} );
	
					// Remove items from success list
					this.successList = $.grep( this.successList, function( element ) {
						return !( element.name in errors );
					} );
				}
				if ( this.settings.showErrors ) {
					this.settings.showErrors.call( this, this.errorMap, this.errorList );
				} else {
					this.defaultShowErrors();
				}
			},
	
			// http://jqueryvalidation.org/Validator.resetForm/
			resetForm: function() {
				if ( $.fn.resetForm ) {
					$( this.currentForm ).resetForm();
				}
				this.invalid = {};
				this.submitted = {};
				this.prepareForm();
				this.hideErrors();
				var elements = this.elements()
					.removeData( "previousValue" )
					.removeAttr( "aria-invalid" );
	
				this.resetElements( elements );
			},
	
			resetElements: function( elements ) {
				var i;
	
				if ( this.settings.unhighlight ) {
					for ( i = 0; elements[ i ]; i++ ) {
						this.settings.unhighlight.call( this, elements[ i ],
							this.settings.errorClass, "" );
						this.findByName( elements[ i ].name ).removeClass( this.settings.validClass );
					}
				} else {
					elements
						.removeClass( this.settings.errorClass )
						.removeClass( this.settings.validClass );
				}
			},
	
			numberOfInvalids: function() {
				return this.objectLength( this.invalid );
			},
	
			objectLength: function( obj ) {
				/* jshint unused: false */
				var count = 0,
					i;
				for ( i in obj ) {
					if ( obj[ i ] ) {
						count++;
					}
				}
				return count;
			},
	
			hideErrors: function() {
				this.hideThese( this.toHide );
			},
	
			hideThese: function( errors ) {
				errors.not( this.containers ).text( "" );
				this.addWrapper( errors ).hide();
			},
	
			valid: function() {
				return this.size() === 0;
			},
	
			size: function() {
				return this.errorList.length;
			},
	
			focusInvalid: function() {
				if ( this.settings.focusInvalid ) {
					try {
						$( this.findLastActive() || this.errorList.length && this.errorList[ 0 ].element || [] )
						.filter( ":visible" )
						.focus()
	
						// Manually trigger focusin event; without it, focusin handler isn't called, findLastActive won't have anything to find
						.trigger( "focusin" );
					} catch ( e ) {
	
						// Ignore IE throwing errors when focusing hidden elements
					}
				}
			},
	
			findLastActive: function() {
				var lastActive = this.lastActive;
				return lastActive && $.grep( this.errorList, function( n ) {
					return n.element.name === lastActive.name;
				} ).length === 1 && lastActive;
			},
	
			elements: function() {
				var validator = this,
					rulesCache = {};
	
				// Select all valid inputs inside the form (no submit or reset buttons)
				return $( this.currentForm )
				.find( "input, select, textarea, [contenteditable]" )
				.not( ":submit, :reset, :image, :disabled" )
				.not( this.settings.ignore )
				.filter( function() {
					var name = this.name || $( this ).attr( "name" ); // For contenteditable
					if ( !name && validator.settings.debug && window.console ) {
						console.error( "%o has no name assigned", this );
					}
	
					// Set form expando on contenteditable
					if ( this.hasAttribute( "contenteditable" ) ) {
						this.form = $( this ).closest( "form" )[ 0 ];
					}
	
					// Select only the first element for each name, and only those with rules specified
					if ( name in rulesCache || !validator.objectLength( $( this ).rules() ) ) {
						return false;
					}
	
					rulesCache[ name ] = true;
					return true;
				} );
			},
	
			clean: function( selector ) {
				return $( selector )[ 0 ];
			},
	
			errors: function() {
				var errorClass = this.settings.errorClass.split( " " ).join( "." );
				return $( this.settings.errorElement + "." + errorClass, this.errorContext );
			},
	
			resetInternals: function() {
				this.successList = [];
				this.errorList = [];
				this.errorMap = {};
				this.toShow = $( [] );
				this.toHide = $( [] );
			},
	
			reset: function() {
				this.resetInternals();
				this.currentElements = $( [] );
			},
	
			prepareForm: function() {
				this.reset();
				this.toHide = this.errors().add( this.containers );
			},
	
			prepareElement: function( element ) {
				this.reset();
				this.toHide = this.errorsFor( element );
			},
	
			elementValue: function( element ) {
				var $element = $( element ),
					type = element.type,
					val, idx;
	
				if ( type === "radio" || type === "checkbox" ) {
					return this.findByName( element.name ).filter( ":checked" ).val();
				} else if ( type === "number" && typeof element.validity !== "undefined" ) {
					return element.validity.badInput ? "NaN" : $element.val();
				}
	
				if ( element.hasAttribute( "contenteditable" ) ) {
					val = $element.text();
				} else {
					val = $element.val();
				}
	
				if ( type === "file" ) {
	
					// Modern browser (chrome & safari)
					if ( val.substr( 0, 12 ) === "C:\\fakepath\\" ) {
						return val.substr( 12 );
					}
	
					// Legacy browsers
					// Unix-based path
					idx = val.lastIndexOf( "/" );
					if ( idx >= 0 ) {
						return val.substr( idx + 1 );
					}
	
					// Windows-based path
					idx = val.lastIndexOf( "\\" );
					if ( idx >= 0 ) {
						return val.substr( idx + 1 );
					}
	
					// Just the file name
					return val;
				}
	
				if ( typeof val === "string" ) {
					return val.replace( /\r/g, "" );
				}
				return val;
			},
	
			check: function( element ) {
				element = this.validationTargetFor( this.clean( element ) );
	
				var rules = $( element ).rules(),
					rulesCount = $.map( rules, function( n, i ) {
						return i;
					} ).length,
					dependencyMismatch = false,
					val = this.elementValue( element ),
					result, method, rule;
	
				// If a normalizer is defined for this element, then
				// call it to retreive the changed value instead
				// of using the real one.
				// Note that `this` in the normalizer is `element`.
				if ( typeof rules.normalizer === "function" ) {
					val = rules.normalizer.call( element, val );
	
					if ( typeof val !== "string" ) {
						throw new TypeError( "The normalizer should return a string value." );
					}
	
					// Delete the normalizer from rules to avoid treating
					// it as a pre-defined method.
					delete rules.normalizer;
				}
	
				for ( method in rules ) {
					rule = { method: method, parameters: rules[ method ] };
					try {
						result = $.validator.methods[ method ].call( this, val, element, rule.parameters );
	
						// If a method indicates that the field is optional and therefore valid,
						// don't mark it as valid when there are no other rules
						if ( result === "dependency-mismatch" && rulesCount === 1 ) {
							dependencyMismatch = true;
							continue;
						}
						dependencyMismatch = false;
	
						if ( result === "pending" ) {
							this.toHide = this.toHide.not( this.errorsFor( element ) );
							return;
						}
	
						if ( !result ) {
							this.formatAndAdd( element, rule );
							return false;
						}
					} catch ( e ) {
						if ( this.settings.debug && window.console ) {
							console.log( "Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.", e );
						}
						if ( e instanceof TypeError ) {
							e.message += ".  Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.";
						}
	
						throw e;
					}
				}
				if ( dependencyMismatch ) {
					return;
				}
				if ( this.objectLength( rules ) ) {
					this.successList.push( element );
				}
				return true;
			},
	
			// Return the custom message for the given element and validation method
			// specified in the element's HTML5 data attribute
			// return the generic message if present and no method specific message is present
			customDataMessage: function( element, method ) {
				return $( element ).data( "msg" + method.charAt( 0 ).toUpperCase() +
					method.substring( 1 ).toLowerCase() ) || $( element ).data( "msg" );
			},
	
			// Return the custom message for the given element name and validation method
			customMessage: function( name, method ) {
				var m = this.settings.messages[ name ];
				return m && ( m.constructor === String ? m : m[ method ] );
			},
	
			// Return the first defined argument, allowing empty strings
			findDefined: function() {
				for ( var i = 0; i < arguments.length; i++ ) {
					if ( arguments[ i ] !== undefined ) {
						return arguments[ i ];
					}
				}
				return undefined;
			},
	
			defaultMessage: function( element, rule ) {
				var message = this.findDefined(
						this.customMessage( element.name, rule.method ),
						this.customDataMessage( element, rule.method ),
	
						// 'title' is never undefined, so handle empty string as undefined
						!this.settings.ignoreTitle && element.title || undefined,
						$.validator.messages[ rule.method ],
						"<strong>Warning: No message defined for " + element.name + "</strong>"
					),
					theregex = /\$?\{(\d+)\}/g;
				if ( typeof message === "function" ) {
					message = message.call( this, rule.parameters, element );
				} else if ( theregex.test( message ) ) {
					message = $.validator.format( message.replace( theregex, "{$1}" ), rule.parameters );
				}
	
				return message;
			},
	
			formatAndAdd: function( element, rule ) {
				var message = this.defaultMessage( element, rule );
	
				this.errorList.push( {
					message: message,
					element: element,
					method: rule.method
				} );
	
				this.errorMap[ element.name ] = message;
				this.submitted[ element.name ] = message;
			},
	
			addWrapper: function( toToggle ) {
				if ( this.settings.wrapper ) {
					toToggle = toToggle.add( toToggle.parent( this.settings.wrapper ) );
				}
				return toToggle;
			},
	
			defaultShowErrors: function() {
				var i, elements, error;
				for ( i = 0; this.errorList[ i ]; i++ ) {
					error = this.errorList[ i ];
					if ( this.settings.highlight ) {
						this.settings.highlight.call( this, error.element, this.settings.errorClass, this.settings.validClass );
					}
					this.showLabel( error.element, error.message );
				}
				if ( this.errorList.length ) {
					this.toShow = this.toShow.add( this.containers );
				}
				if ( this.settings.success ) {
					for ( i = 0; this.successList[ i ]; i++ ) {
						this.showLabel( this.successList[ i ] );
					}
				}
				if ( this.settings.unhighlight ) {
					for ( i = 0, elements = this.validElements(); elements[ i ]; i++ ) {
						this.settings.unhighlight.call( this, elements[ i ], this.settings.errorClass, this.settings.validClass );
					}
				}
				this.toHide = this.toHide.not( this.toShow );
				this.hideErrors();
				this.addWrapper( this.toShow ).show();
			},
	
			validElements: function() {
				return this.currentElements.not( this.invalidElements() );
			},
	
			invalidElements: function() {
				return $( this.errorList ).map( function() {
					return this.element;
				} );
			},
	
			showLabel: function( element, message ) {
				var place, group, errorID, v,
					error = this.errorsFor( element ),
					elementID = this.idOrName( element ),
					describedBy = $( element ).attr( "aria-describedby" );
	
				if ( error.length ) {
	
					// Refresh error/success class
					error.removeClass( this.settings.validClass ).addClass( this.settings.errorClass );
	
					// Replace message on existing label
					error.html( message );
				} else {
	
					// Create error element
					error = $( "<" + this.settings.errorElement + ">" )
						.attr( "id", elementID + "-error" )
						.addClass( this.settings.errorClass )
						.html( message || "" );
	
					// Maintain reference to the element to be placed into the DOM
					place = error;
					if ( this.settings.wrapper ) {
	
						// Make sure the element is visible, even in IE
						// actually showing the wrapped element is handled elsewhere
						place = error.hide().show().wrap( "<" + this.settings.wrapper + "/>" ).parent();
					}
					if ( this.labelContainer.length ) {
						this.labelContainer.append( place );
					} else if ( this.settings.errorPlacement ) {
						this.settings.errorPlacement( place, $( element ) );
					} else {
						place.insertAfter( element );
					}
	
					// Link error back to the element
					if ( error.is( "label" ) ) {
	
						// If the error is a label, then associate using 'for'
						error.attr( "for", elementID );
	
						// If the element is not a child of an associated label, then it's necessary
						// to explicitly apply aria-describedby
					} else if ( error.parents( "label[for='" + this.escapeCssMeta( elementID ) + "']" ).length === 0 ) {
						errorID = error.attr( "id" );
	
						// Respect existing non-error aria-describedby
						if ( !describedBy ) {
							describedBy = errorID;
						} else if ( !describedBy.match( new RegExp( "\\b" + this.escapeCssMeta( errorID ) + "\\b" ) ) ) {
	
							// Add to end of list if not already present
							describedBy += " " + errorID;
						}
						$( element ).attr( "aria-describedby", describedBy );
	
						// If this element is grouped, then assign to all elements in the same group
						group = this.groups[ element.name ];
						if ( group ) {
							v = this;
							$.each( v.groups, function( name, testgroup ) {
								if ( testgroup === group ) {
									$( "[name='" + v.escapeCssMeta( name ) + "']", v.currentForm )
										.attr( "aria-describedby", error.attr( "id" ) );
								}
							} );
						}
					}
				}
				if ( !message && this.settings.success ) {
					error.text( "" );
					if ( typeof this.settings.success === "string" ) {
						error.addClass( this.settings.success );
					} else {
						this.settings.success( error, element );
					}
				}
				this.toShow = this.toShow.add( error );
			},
	
			errorsFor: function( element ) {
				var name = this.escapeCssMeta( this.idOrName( element ) ),
					describer = $( element ).attr( "aria-describedby" ),
					selector = "label[for='" + name + "'], label[for='" + name + "'] *";
	
				// 'aria-describedby' should directly reference the error element
				if ( describer ) {
					selector = selector + ", #" + this.escapeCssMeta( describer )
						.replace( /\s+/g, ", #" );
				}
	
				return this
					.errors()
					.filter( selector );
			},
	
			// See https://api.jquery.com/category/selectors/, for CSS
			// meta-characters that should be escaped in order to be used with JQuery
			// as a literal part of a name/id or any selector.
			escapeCssMeta: function( string ) {
				return string.replace( /([\\!"#$%&'()*+,./:;<=>?@\[\]^`{|}~])/g, "\\$1" );
			},
	
			idOrName: function( element ) {
				return this.groups[ element.name ] || ( this.checkable( element ) ? element.name : element.id || element.name );
			},
	
			validationTargetFor: function( element ) {
	
				// If radio/checkbox, validate first element in group instead
				if ( this.checkable( element ) ) {
					element = this.findByName( element.name );
				}
	
				// Always apply ignore filter
				return $( element ).not( this.settings.ignore )[ 0 ];
			},
	
			checkable: function( element ) {
				return ( /radio|checkbox/i ).test( element.type );
			},
	
			findByName: function( name ) {
				return $( this.currentForm ).find( "[name='" + this.escapeCssMeta( name ) + "']" );
			},
	
			getLength: function( value, element ) {
				switch ( element.nodeName.toLowerCase() ) {
				case "select":
					return $( "option:selected", element ).length;
				case "input":
					if ( this.checkable( element ) ) {
						return this.findByName( element.name ).filter( ":checked" ).length;
					}
				}
				return value.length;
			},
	
			depend: function( param, element ) {
				return this.dependTypes[ typeof param ] ? this.dependTypes[ typeof param ]( param, element ) : true;
			},
	
			dependTypes: {
				"boolean": function( param ) {
					return param;
				},
				"string": function( param, element ) {
					return !!$( param, element.form ).length;
				},
				"function": function( param, element ) {
					return param( element );
				}
			},
	
			optional: function( element ) {
				var val = this.elementValue( element );
				return !$.validator.methods.required.call( this, val, element ) && "dependency-mismatch";
			},
	
			startRequest: function( element ) {
				if ( !this.pending[ element.name ] ) {
					this.pendingRequest++;
					$( element ).addClass( this.settings.pendingClass );
					this.pending[ element.name ] = true;
				}
			},
	
			stopRequest: function( element, valid ) {
				this.pendingRequest--;
	
				// Sometimes synchronization fails, make sure pendingRequest is never < 0
				if ( this.pendingRequest < 0 ) {
					this.pendingRequest = 0;
				}
				delete this.pending[ element.name ];
				$( element ).removeClass( this.settings.pendingClass );
				if ( valid && this.pendingRequest === 0 && this.formSubmitted && this.form() ) {
					$( this.currentForm ).submit();
					this.formSubmitted = false;
				} else if ( !valid && this.pendingRequest === 0 && this.formSubmitted ) {
					$( this.currentForm ).triggerHandler( "invalid-form", [ this ] );
					this.formSubmitted = false;
				}
			},
	
			previousValue: function( element, method ) {
				return $.data( element, "previousValue" ) || $.data( element, "previousValue", {
					old: null,
					valid: true,
					message: this.defaultMessage( element, { method: method } )
				} );
			},
	
			// Cleans up all forms and elements, removes validator-specific events
			destroy: function() {
				this.resetForm();
	
				$( this.currentForm )
					.off( ".validate" )
					.removeData( "validator" )
					.find( ".validate-equalTo-blur" )
						.off( ".validate-equalTo" )
						.removeClass( "validate-equalTo-blur" );
			}
	
		},
	
		classRuleSettings: {
			required: { required: true },
			email: { email: true },
			url: { url: true },
			date: { date: true },
			dateISO: { dateISO: true },
			number: { number: true },
			digits: { digits: true },
			creditcard: { creditcard: true }
		},
	
		addClassRules: function( className, rules ) {
			if ( className.constructor === String ) {
				this.classRuleSettings[ className ] = rules;
			} else {
				$.extend( this.classRuleSettings, className );
			}
		},
	
		classRules: function( element ) {
			var rules = {},
				classes = $( element ).attr( "class" );
	
			if ( classes ) {
				$.each( classes.split( " " ), function() {
					if ( this in $.validator.classRuleSettings ) {
						$.extend( rules, $.validator.classRuleSettings[ this ] );
					}
				} );
			}
			return rules;
		},
	
		normalizeAttributeRule: function( rules, type, method, value ) {
	
			// Convert the value to a number for number inputs, and for text for backwards compability
			// allows type="date" and others to be compared as strings
			if ( /min|max|step/.test( method ) && ( type === null || /number|range|text/.test( type ) ) ) {
				value = Number( value );
	
				// Support Opera Mini, which returns NaN for undefined minlength
				if ( isNaN( value ) ) {
					value = undefined;
				}
			}
	
			if ( value || value === 0 ) {
				rules[ method ] = value;
			} else if ( type === method && type !== "range" ) {
	
				// Exception: the jquery validate 'range' method
				// does not test for the html5 'range' type
				rules[ method ] = true;
			}
		},
	
		attributeRules: function( element ) {
			var rules = {},
				$element = $( element ),
				type = element.getAttribute( "type" ),
				method, value;
	
			for ( method in $.validator.methods ) {
	
				// Support for <input required> in both html5 and older browsers
				if ( method === "required" ) {
					value = element.getAttribute( method );
	
					// Some browsers return an empty string for the required attribute
					// and non-HTML5 browsers might have required="" markup
					if ( value === "" ) {
						value = true;
					}
	
					// Force non-HTML5 browsers to return bool
					value = !!value;
				} else {
					value = $element.attr( method );
				}
	
				this.normalizeAttributeRule( rules, type, method, value );
			}
	
			// 'maxlength' may be returned as -1, 2147483647 ( IE ) and 524288 ( safari ) for text inputs
			if ( rules.maxlength && /-1|2147483647|524288/.test( rules.maxlength ) ) {
				delete rules.maxlength;
			}
	
			return rules;
		},
	
		dataRules: function( element ) {
			var rules = {},
				$element = $( element ),
				type = element.getAttribute( "type" ),
				method, value;
	
			for ( method in $.validator.methods ) {
				value = $element.data( "rule" + method.charAt( 0 ).toUpperCase() + method.substring( 1 ).toLowerCase() );
				this.normalizeAttributeRule( rules, type, method, value );
			}
			return rules;
		},
	
		staticRules: function( element ) {
			var rules = {},
				validator = $.data( element.form, "validator" );
	
			if ( validator.settings.rules ) {
				rules = $.validator.normalizeRule( validator.settings.rules[ element.name ] ) || {};
			}
			return rules;
		},
	
		normalizeRules: function( rules, element ) {
	
			// Handle dependency check
			$.each( rules, function( prop, val ) {
	
				// Ignore rule when param is explicitly false, eg. required:false
				if ( val === false ) {
					delete rules[ prop ];
					return;
				}
				if ( val.param || val.depends ) {
					var keepRule = true;
					switch ( typeof val.depends ) {
					case "string":
						keepRule = !!$( val.depends, element.form ).length;
						break;
					case "function":
						keepRule = val.depends.call( element, element );
						break;
					}
					if ( keepRule ) {
						rules[ prop ] = val.param !== undefined ? val.param : true;
					} else {
						$.data( element.form, "validator" ).resetElements( $( element ) );
						delete rules[ prop ];
					}
				}
			} );
	
			// Evaluate parameters
			$.each( rules, function( rule, parameter ) {
				rules[ rule ] = $.isFunction( parameter ) && rule !== "normalizer" ? parameter( element ) : parameter;
			} );
	
			// Clean number parameters
			$.each( [ "minlength", "maxlength" ], function() {
				if ( rules[ this ] ) {
					rules[ this ] = Number( rules[ this ] );
				}
			} );
			$.each( [ "rangelength", "range" ], function() {
				var parts;
				if ( rules[ this ] ) {
					if ( $.isArray( rules[ this ] ) ) {
						rules[ this ] = [ Number( rules[ this ][ 0 ] ), Number( rules[ this ][ 1 ] ) ];
					} else if ( typeof rules[ this ] === "string" ) {
						parts = rules[ this ].replace( /[\[\]]/g, "" ).split( /[\s,]+/ );
						rules[ this ] = [ Number( parts[ 0 ] ), Number( parts[ 1 ] ) ];
					}
				}
			} );
	
			if ( $.validator.autoCreateRanges ) {
	
				// Auto-create ranges
				if ( rules.min != null && rules.max != null ) {
					rules.range = [ rules.min, rules.max ];
					delete rules.min;
					delete rules.max;
				}
				if ( rules.minlength != null && rules.maxlength != null ) {
					rules.rangelength = [ rules.minlength, rules.maxlength ];
					delete rules.minlength;
					delete rules.maxlength;
				}
			}
	
			return rules;
		},
	
		// Converts a simple string to a {string: true} rule, e.g., "required" to {required:true}
		normalizeRule: function( data ) {
			if ( typeof data === "string" ) {
				var transformed = {};
				$.each( data.split( /\s/ ), function() {
					transformed[ this ] = true;
				} );
				data = transformed;
			}
			return data;
		},
	
		// http://jqueryvalidation.org/jQuery.validator.addMethod/
		addMethod: function( name, method, message ) {
			$.validator.methods[ name ] = method;
			$.validator.messages[ name ] = message !== undefined ? message : $.validator.messages[ name ];
			if ( method.length < 3 ) {
				$.validator.addClassRules( name, $.validator.normalizeRule( name ) );
			}
		},
	
		// http://jqueryvalidation.org/jQuery.validator.methods/
		methods: {
	
			// http://jqueryvalidation.org/required-method/
			required: function( value, element, param ) {
	
				// Check if dependency is met
				if ( !this.depend( param, element ) ) {
					return "dependency-mismatch";
				}
				if ( element.nodeName.toLowerCase() === "select" ) {
	
					// Could be an array for select-multiple or a string, both are fine this way
					var val = $( element ).val();
					return val && val.length > 0;
				}
				if ( this.checkable( element ) ) {
					return this.getLength( value, element ) > 0;
				}
				return value.length > 0;
			},
	
			// http://jqueryvalidation.org/email-method/
			email: function( value, element ) {
	
				// From https://html.spec.whatwg.org/multipage/forms.html#valid-e-mail-address
				// Retrieved 2014-01-14
				// If you have a problem with this implementation, report a bug against the above spec
				// Or use custom methods to implement your own email validation
				return this.optional( element ) || /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test( value );
			},
	
			// http://jqueryvalidation.org/url-method/
			url: function( value, element ) {
	
				// Copyright (c) 2010-2013 Diego Perini, MIT licensed
				// https://gist.github.com/dperini/729294
				// see also https://mathiasbynens.be/demo/url-regex
				// modified to allow protocol-relative URLs
				return this.optional( element ) || /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test( value );
			},
	
			// http://jqueryvalidation.org/date-method/
			date: function( value, element ) {
				return this.optional( element ) || !/Invalid|NaN/.test( new Date( value ).toString() );
			},
	
			// http://jqueryvalidation.org/dateISO-method/
			dateISO: function( value, element ) {
				return this.optional( element ) || /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test( value );
			},
	
			// http://jqueryvalidation.org/number-method/
			number: function( value, element ) {
				return this.optional( element ) || /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test( value );
			},
	
			// http://jqueryvalidation.org/digits-method/
			digits: function( value, element ) {
				return this.optional( element ) || /^\d+$/.test( value );
			},
	
			// http://jqueryvalidation.org/minlength-method/
			minlength: function( value, element, param ) {
				var length = $.isArray( value ) ? value.length : this.getLength( value, element );
				return this.optional( element ) || length >= param;
			},
	
			// http://jqueryvalidation.org/maxlength-method/
			maxlength: function( value, element, param ) {
				var length = $.isArray( value ) ? value.length : this.getLength( value, element );
				return this.optional( element ) || length <= param;
			},
	
			// http://jqueryvalidation.org/rangelength-method/
			rangelength: function( value, element, param ) {
				var length = $.isArray( value ) ? value.length : this.getLength( value, element );
				return this.optional( element ) || ( length >= param[ 0 ] && length <= param[ 1 ] );
			},
	
			// http://jqueryvalidation.org/min-method/
			min: function( value, element, param ) {
				return this.optional( element ) || value >= param;
			},
	
			// http://jqueryvalidation.org/max-method/
			max: function( value, element, param ) {
				return this.optional( element ) || value <= param;
			},
	
			// http://jqueryvalidation.org/range-method/
			range: function( value, element, param ) {
				return this.optional( element ) || ( value >= param[ 0 ] && value <= param[ 1 ] );
			},
	
			// http://jqueryvalidation.org/step-method/
			step: function( value, element, param ) {
				var type = $( element ).attr( "type" ),
					errorMessage = "Step attribute on input type " + type + " is not supported.",
					supportedTypes = [ "text", "number", "range" ],
					re = new RegExp( "\\b" + type + "\\b" ),
					notSupported = type && !re.test( supportedTypes.join() );
	
				// Works only for text, number and range input types
				// TODO find a way to support input types date, datetime, datetime-local, month, time and week
				if ( notSupported ) {
					throw new Error( errorMessage );
				}
				return this.optional( element ) || ( value % param === 0 );
			},
	
			// http://jqueryvalidation.org/equalTo-method/
			equalTo: function( value, element, param ) {
	
				// Bind to the blur event of the target in order to revalidate whenever the target field is updated
				var target = $( param );
				if ( this.settings.onfocusout && target.not( ".validate-equalTo-blur" ).length ) {
					target.addClass( "validate-equalTo-blur" ).on( "blur.validate-equalTo", function() {
						$( element ).valid();
					} );
				}
				return value === target.val();
			},
	
			// http://jqueryvalidation.org/remote-method/
			remote: function( value, element, param, method ) {
				if ( this.optional( element ) ) {
					return "dependency-mismatch";
				}
	
				method = typeof method === "string" && method || "remote";
	
				var previous = this.previousValue( element, method ),
					validator, data, optionDataString;
	
				if ( !this.settings.messages[ element.name ] ) {
					this.settings.messages[ element.name ] = {};
				}
				previous.originalMessage = previous.originalMessage || this.settings.messages[ element.name ][ method ];
				this.settings.messages[ element.name ][ method ] = previous.message;
	
				param = typeof param === "string" && { url: param } || param;
				optionDataString = $.param( $.extend( { data: value }, param.data ) );
				if ( previous.old === optionDataString ) {
					return previous.valid;
				}
	
				previous.old = optionDataString;
				validator = this;
				this.startRequest( element );
				data = {};
				data[ element.name ] = value;
				$.ajax( $.extend( true, {
					mode: "abort",
					port: "validate" + element.name,
					dataType: "json",
					data: data,
					context: validator.currentForm,
					success: function( response ) {
						var valid = response === true || response === "true",
							errors, message, submitted;
	
						validator.settings.messages[ element.name ][ method ] = previous.originalMessage;
						if ( valid ) {
							submitted = validator.formSubmitted;
							validator.resetInternals();
							validator.toHide = validator.errorsFor( element );
							validator.formSubmitted = submitted;
							validator.successList.push( element );
							validator.invalid[ element.name ] = false;
							validator.showErrors();
						} else {
							errors = {};
							message = response || validator.defaultMessage( element, { method: method, parameters: value } );
							errors[ element.name ] = previous.message = message;
							validator.invalid[ element.name ] = true;
							validator.showErrors( errors );
						}
						previous.valid = valid;
						validator.stopRequest( element, valid );
					}
				}, param ) );
				return "pending";
			}
		}
	
	} );
	
	// Ajax mode: abort
	// usage: $.ajax({ mode: "abort"[, port: "uniqueport"]});
	// if mode:"abort" is used, the previous request on that port (port can be undefined) is aborted via XMLHttpRequest.abort()
	
	var pendingRequests = {},
		ajax;
	
	// Use a prefilter if available (1.5+)
	if ( $.ajaxPrefilter ) {
		$.ajaxPrefilter( function( settings, _, xhr ) {
			var port = settings.port;
			if ( settings.mode === "abort" ) {
				if ( pendingRequests[ port ] ) {
					pendingRequests[ port ].abort();
				}
				pendingRequests[ port ] = xhr;
			}
		} );
	} else {
	
		// Proxy ajax
		ajax = $.ajax;
		$.ajax = function( settings ) {
			var mode = ( "mode" in settings ? settings : $.ajaxSettings ).mode,
				port = ( "port" in settings ? settings : $.ajaxSettings ).port;
			if ( mode === "abort" ) {
				if ( pendingRequests[ port ] ) {
					pendingRequests[ port ].abort();
				}
				pendingRequests[ port ] = ajax.apply( this, arguments );
				return pendingRequests[ port ];
			}
			return ajax.apply( this, arguments );
		};
	}
	
	}));

/***/ },
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(1052);
	
	__webpack_require__(847);
	
	__webpack_require__(853);
	
	/* eslint max-len: 0 */
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	// Should be removed in the next major release:
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery blockUI plugin
	 * Version 2.70.0-2014.11.23
	 * Requires jQuery v1.7 or later
	 *
	 * Examples at: http://malsup.com/jquery/block/
	 * Copyright (c) 2007-2013 M. Alsup
	 * Dual licensed under the MIT and GPL licenses:
	 * http://www.opensource.org/licenses/mit-license.php
	 * http://www.gnu.org/licenses/gpl.html
	 *
	 * Thanks to Amir-Hossein Sobhi for some excellent contributions!
	 */
	
	;(function() {
	/*jshint eqeqeq:false curly:false latedef:false */
	"use strict";
	
		function setup($) {
			$.fn._fadeIn = $.fn.fadeIn;
	
			var noOp = $.noop || function() {};
	
			// this bit is to ensure we don't call setExpression when we shouldn't (with extra muscle to handle
			// confusing userAgent strings on Vista)
			var msie = /MSIE/.test(navigator.userAgent);
			var ie6  = /MSIE 6.0/.test(navigator.userAgent) && ! /MSIE 8.0/.test(navigator.userAgent);
			var mode = document.documentMode || 0;
			var setExpr = $.isFunction( document.createElement('div').style.setExpression );
	
			// global $ methods for blocking/unblocking the entire page
			$.blockUI   = function(opts) { install(window, opts); };
			$.unblockUI = function(opts) { remove(window, opts); };
	
			// convenience method for quick growl-like notifications  (http://www.google.com/search?q=growl)
			$.growlUI = function(title, message, timeout, onClose) {
				var $m = $('<div class="growlUI"></div>');
				if (title) $m.append('<h1>'+title+'</h1>');
				if (message) $m.append('<h2>'+message+'</h2>');
				if (timeout === undefined) timeout = 3000;
	
				// Added by konapun: Set timeout to 30 seconds if this growl is moused over, like normal toast notifications
				var callBlock = function(opts) {
					opts = opts || {};
	
					$.blockUI({
						message: $m,
						fadeIn : typeof opts.fadeIn  !== 'undefined' ? opts.fadeIn  : 700,
						fadeOut: typeof opts.fadeOut !== 'undefined' ? opts.fadeOut : 1000,
						timeout: typeof opts.timeout !== 'undefined' ? opts.timeout : timeout,
						centerY: false,
						showOverlay: false,
						onUnblock: onClose,
						css: $.blockUI.defaults.growlCSS
					});
				};
	
				callBlock();
				var nonmousedOpacity = $m.css('opacity');
				$m.mouseover(function() {
					callBlock({
						fadeIn: 0,
						timeout: 30000
					});
	
					var displayBlock = $('.blockMsg');
					displayBlock.stop(); // cancel fadeout if it has started
					displayBlock.fadeTo(300, 1); // make it easier to read the message by removing transparency
				}).mouseout(function() {
					$('.blockMsg').fadeOut(1000);
				});
				// End konapun additions
			};
	
			// plugin method for blocking element content
			$.fn.block = function(opts) {
				if ( this[0] === window ) {
					$.blockUI( opts );
					return this;
				}
				var fullOpts = $.extend({}, $.blockUI.defaults, opts || {});
				this.each(function() {
					var $el = $(this);
					if (fullOpts.ignoreIfBlocked && $el.data('blockUI.isBlocked'))
						return;
					$el.unblock({ fadeOut: 0 });
				});
	
				return this.each(function() {
					if ($.css(this,'position') == 'static') {
						this.style.position = 'relative';
						$(this).data('blockUI.static', true);
					}
					this.style.zoom = 1; // force 'hasLayout' in ie
					install(this, opts);
				});
			};
	
			// plugin method for unblocking element content
			$.fn.unblock = function(opts) {
				if ( this[0] === window ) {
					$.unblockUI( opts );
					return this;
				}
				return this.each(function() {
					remove(this, opts);
				});
			};
	
			$.blockUI.version = 2.70; // 2nd generation blocking at no extra cost!
	
			// override these in your code to change the default behavior and style
			$.blockUI.defaults = {
				// message displayed when blocking (use null for no message)
				message:  '<h1>Please wait...</h1>',
	
				title: null,		// title string; only used when theme == true
				draggable: true,	// only used when theme == true (requires jquery-ui.js to be loaded)
	
				theme: false, // set to true to use with jQuery UI themes
	
				// styles for the message when blocking; if you wish to disable
				// these and use an external stylesheet then do this in your code:
				// $.blockUI.defaults.css = {};
				css: {
					padding:	0,
					margin:		0,
					width:		'30%',
					top:		'40%',
					left:		'35%',
					textAlign:	'center',
					color:		'#000',
					border:		'3px solid #aaa',
					backgroundColor:'#fff',
					cursor:		'wait'
				},
	
				// minimal style set used when themes are used
				themedCSS: {
					width:	'30%',
					top:	'40%',
					left:	'35%'
				},
	
				// styles for the overlay
				overlayCSS:  {
					backgroundColor:	'#000',
					opacity:			0.6,
					cursor:				'wait'
				},
	
				// style to replace wait cursor before unblocking to correct issue
				// of lingering wait cursor
				cursorReset: 'default',
	
				// styles applied when using $.growlUI
				growlCSS: {
					width:		'350px',
					top:		'10px',
					left:		'',
					right:		'10px',
					border:		'none',
					padding:	'5px',
					opacity:	0.6,
					cursor:		'default',
					color:		'#fff',
					backgroundColor: '#000',
					'-webkit-border-radius':'10px',
					'-moz-border-radius':	'10px',
					'border-radius':		'10px'
				},
	
				// IE issues: 'about:blank' fails on HTTPS and javascript:false is s-l-o-w
				// (hat tip to Jorge H. N. de Vasconcelos)
				/*jshint scripturl:true */
				iframeSrc: /^https/i.test(window.location.href || '') ? 'javascript:false' : 'about:blank',
	
				// force usage of iframe in non-IE browsers (handy for blocking applets)
				forceIframe: false,
	
				// z-index for the blocking overlay
				baseZ: 1000,
	
				// set these to true to have the message automatically centered
				centerX: true, // <-- only effects element blocking (page block controlled via css above)
				centerY: true,
	
				// allow body element to be stetched in ie6; this makes blocking look better
				// on "short" pages.  disable if you wish to prevent changes to the body height
				allowBodyStretch: true,
	
				// enable if you want key and mouse events to be disabled for content that is blocked
				bindEvents: true,
	
				// be default blockUI will supress tab navigation from leaving blocking content
				// (if bindEvents is true)
				constrainTabKey: true,
	
				// fadeIn time in millis; set to 0 to disable fadeIn on block
				fadeIn:  200,
	
				// fadeOut time in millis; set to 0 to disable fadeOut on unblock
				fadeOut:  400,
	
				// time in millis to wait before auto-unblocking; set to 0 to disable auto-unblock
				timeout: 0,
	
				// disable if you don't want to show the overlay
				showOverlay: true,
	
				// if true, focus will be placed in the first available input field when
				// page blocking
				focusInput: true,
	
	            // elements that can receive focus
	            focusableElements: ':input:enabled:visible',
	
				// suppresses the use of overlay styles on FF/Linux (due to performance issues with opacity)
				// no longer needed in 2012
				// applyPlatformOpacityRules: true,
	
				// callback method invoked when fadeIn has completed and blocking message is visible
				onBlock: null,
	
				// callback method invoked when unblocking has completed; the callback is
				// passed the element that has been unblocked (which is the window object for page
				// blocks) and the options that were passed to the unblock call:
				//	onUnblock(element, options)
				onUnblock: null,
	
				// callback method invoked when the overlay area is clicked.
				// setting this will turn the cursor to a pointer, otherwise cursor defined in overlayCss will be used.
				onOverlayClick: null,
	
				// don't ask; if you really must know: http://groups.google.com/group/jquery-en/browse_thread/thread/36640a8730503595/2f6a79a77a78e493#2f6a79a77a78e493
				quirksmodeOffsetHack: 4,
	
				// class name of the message block
				blockMsgClass: 'blockMsg',
	
				// if it is already blocked, then ignore it (don't unblock and reblock)
				ignoreIfBlocked: false
			};
	
			// private data and functions follow...
	
			var pageBlock = null;
			var pageBlockEls = [];
	
			function install(el, opts) {
				var css, themedCSS;
				var full = (el == window);
				var msg = (opts && opts.message !== undefined ? opts.message : undefined);
				opts = $.extend({}, $.blockUI.defaults, opts || {});
	
				if (opts.ignoreIfBlocked && $(el).data('blockUI.isBlocked'))
					return;
	
				opts.overlayCSS = $.extend({}, $.blockUI.defaults.overlayCSS, opts.overlayCSS || {});
				css = $.extend({}, $.blockUI.defaults.css, opts.css || {});
				if (opts.onOverlayClick)
					opts.overlayCSS.cursor = 'pointer';
	
				themedCSS = $.extend({}, $.blockUI.defaults.themedCSS, opts.themedCSS || {});
				msg = msg === undefined ? opts.message : msg;
	
				// remove the current block (if there is one)
				if (full && pageBlock)
					remove(window, {fadeOut:0});
	
				// if an existing element is being used as the blocking content then we capture
				// its current place in the DOM (and current display style) so we can restore
				// it when we unblock
				if (msg && typeof msg != 'string' && (msg.parentNode || msg.jquery)) {
					var node = msg.jquery ? msg[0] : msg;
					var data = {};
					$(el).data('blockUI.history', data);
					data.el = node;
					data.parent = node.parentNode;
					data.display = node.style.display;
					data.position = node.style.position;
					if (data.parent)
						data.parent.removeChild(node);
				}
	
				$(el).data('blockUI.onUnblock', opts.onUnblock);
				var z = opts.baseZ;
	
				// blockUI uses 3 layers for blocking, for simplicity they are all used on every platform;
				// layer1 is the iframe layer which is used to supress bleed through of underlying content
				// layer2 is the overlay layer which has opacity and a wait cursor (by default)
				// layer3 is the message content that is displayed while blocking
				var lyr1, lyr2, lyr3, s;
				if (msie || opts.forceIframe)
					lyr1 = $('<iframe class="blockUI" style="z-index:'+ (z++) +';display:none;border:none;margin:0;padding:0;position:absolute;width:100%;height:100%;top:0;left:0" src="'+opts.iframeSrc+'"></iframe>');
				else
					lyr1 = $('<div class="blockUI" style="display:none"></div>');
	
				if (opts.theme)
					lyr2 = $('<div class="blockUI blockOverlay ui-widget-overlay" style="z-index:'+ (z++) +';display:none"></div>');
				else
					lyr2 = $('<div class="blockUI blockOverlay" style="z-index:'+ (z++) +';display:none;border:none;margin:0;padding:0;width:100%;height:100%;top:0;left:0"></div>');
	
				if (opts.theme && full) {
					s = '<div class="blockUI ' + opts.blockMsgClass + ' blockPage ui-dialog ui-widget ui-corner-all" style="z-index:'+(z+10)+';display:none;position:fixed">';
					if ( opts.title ) {
						s += '<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">'+(opts.title || '&nbsp;')+'</div>';
					}
					s += '<div class="ui-widget-content ui-dialog-content"></div>';
					s += '</div>';
				}
				else if (opts.theme) {
					s = '<div class="blockUI ' + opts.blockMsgClass + ' blockElement ui-dialog ui-widget ui-corner-all" style="z-index:'+(z+10)+';display:none;position:absolute">';
					if ( opts.title ) {
						s += '<div class="ui-widget-header ui-dialog-titlebar ui-corner-all blockTitle">'+(opts.title || '&nbsp;')+'</div>';
					}
					s += '<div class="ui-widget-content ui-dialog-content"></div>';
					s += '</div>';
				}
				else if (full) {
					s = '<div class="blockUI ' + opts.blockMsgClass + ' blockPage" style="z-index:'+(z+10)+';display:none;position:fixed"></div>';
				}
				else {
					s = '<div class="blockUI ' + opts.blockMsgClass + ' blockElement" style="z-index:'+(z+10)+';display:none;position:absolute"></div>';
				}
				lyr3 = $(s);
	
				// if we have a message, style it
				if (msg) {
					if (opts.theme) {
						lyr3.css(themedCSS);
						lyr3.addClass('ui-widget-content');
					}
					else
						lyr3.css(css);
				}
	
				// style the overlay
				if (!opts.theme /*&& (!opts.applyPlatformOpacityRules)*/)
					lyr2.css(opts.overlayCSS);
				lyr2.css('position', full ? 'fixed' : 'absolute');
	
				// make iframe layer transparent in IE
				if (msie || opts.forceIframe)
					lyr1.css('opacity',0.0);
	
				//$([lyr1[0],lyr2[0],lyr3[0]]).appendTo(full ? 'body' : el);
				var layers = [lyr1,lyr2,lyr3], $par = full ? $('body') : $(el);
				$.each(layers, function() {
					this.appendTo($par);
				});
	
				if (opts.theme && opts.draggable && $.fn.draggable) {
					lyr3.draggable({
						handle: '.ui-dialog-titlebar',
						cancel: 'li'
					});
				}
	
				// ie7 must use absolute positioning in quirks mode and to account for activex issues (when scrolling)
				var expr = setExpr && (!$.support.boxModel || $('object,embed', full ? null : el).length > 0);
				if (ie6 || expr) {
					// give body 100% height
					if (full && opts.allowBodyStretch && $.support.boxModel)
						$('html,body').css('height','100%');
	
					// fix ie6 issue when blocked element has a border width
					if ((ie6 || !$.support.boxModel) && !full) {
						var t = sz(el,'borderTopWidth'), l = sz(el,'borderLeftWidth');
						var fixT = t ? '(0 - '+t+')' : 0;
						var fixL = l ? '(0 - '+l+')' : 0;
					}
	
					// simulate fixed position
					$.each(layers, function(i,o) {
						var s = o[0].style;
						s.position = 'absolute';
						if (i < 2) {
							if (full)
								s.setExpression('height','Math.max(document.body.scrollHeight, document.body.offsetHeight) - (jQuery.support.boxModel?0:'+opts.quirksmodeOffsetHack+') + "px"');
							else
								s.setExpression('height','this.parentNode.offsetHeight + "px"');
							if (full)
								s.setExpression('width','jQuery.support.boxModel && document.documentElement.clientWidth || document.body.clientWidth + "px"');
							else
								s.setExpression('width','this.parentNode.offsetWidth + "px"');
							if (fixL) s.setExpression('left', fixL);
							if (fixT) s.setExpression('top', fixT);
						}
						else if (opts.centerY) {
							if (full) s.setExpression('top','(document.documentElement.clientHeight || document.body.clientHeight) / 2 - (this.offsetHeight / 2) + (blah = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + "px"');
							s.marginTop = 0;
						}
						else if (!opts.centerY && full) {
							var top = (opts.css && opts.css.top) ? parseInt(opts.css.top, 10) : 0;
							var expression = '((document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop) + '+top+') + "px"';
							s.setExpression('top',expression);
						}
					});
				}
	
				// show the message
				if (msg) {
					if (opts.theme)
						lyr3.find('.ui-widget-content').append(msg);
					else
						lyr3.append(msg);
					if (msg.jquery || msg.nodeType)
						$(msg).show();
				}
	
				if ((msie || opts.forceIframe) && opts.showOverlay)
					lyr1.show(); // opacity is zero
				if (opts.fadeIn) {
					var cb = opts.onBlock ? opts.onBlock : noOp;
					var cb1 = (opts.showOverlay && !msg) ? cb : noOp;
					var cb2 = msg ? cb : noOp;
					if (opts.showOverlay)
						lyr2._fadeIn(opts.fadeIn, cb1);
					if (msg)
						lyr3._fadeIn(opts.fadeIn, cb2);
				}
				else {
					if (opts.showOverlay)
						lyr2.show();
					if (msg)
						lyr3.show();
					if (opts.onBlock)
						opts.onBlock.bind(lyr3)();
				}
	
				// bind key and mouse events
				bind(1, el, opts);
	
				if (full) {
					pageBlock = lyr3[0];
					pageBlockEls = $(opts.focusableElements,pageBlock);
					if (opts.focusInput)
						setTimeout(focus, 20);
				}
				else
					center(lyr3[0], opts.centerX, opts.centerY);
	
				if (opts.timeout) {
					// auto-unblock
					var to = setTimeout(function() {
						if (full)
							$.unblockUI(opts);
						else
							$(el).unblock(opts);
					}, opts.timeout);
					$(el).data('blockUI.timeout', to);
				}
			}
	
			// remove the block
			function remove(el, opts) {
				var count;
				var full = (el == window);
				var $el = $(el);
				var data = $el.data('blockUI.history');
				var to = $el.data('blockUI.timeout');
				if (to) {
					clearTimeout(to);
					$el.removeData('blockUI.timeout');
				}
				opts = $.extend({}, $.blockUI.defaults, opts || {});
				bind(0, el, opts); // unbind events
	
				if (opts.onUnblock === null) {
					opts.onUnblock = $el.data('blockUI.onUnblock');
					$el.removeData('blockUI.onUnblock');
				}
	
				var els;
				if (full) // crazy selector to handle odd field errors in ie6/7
					els = $('body').children().filter('.blockUI').add('body > .blockUI');
				else
					els = $el.find('>.blockUI');
	
				// fix cursor issue
				if ( opts.cursorReset ) {
					if ( els.length > 1 )
						els[1].style.cursor = opts.cursorReset;
					if ( els.length > 2 )
						els[2].style.cursor = opts.cursorReset;
				}
	
				if (full)
					pageBlock = pageBlockEls = null;
	
				if (opts.fadeOut) {
					count = els.length;
					els.stop().fadeOut(opts.fadeOut, function() {
						if ( --count === 0)
							reset(els,data,opts,el);
					});
				}
				else
					reset(els, data, opts, el);
			}
	
			// move blocking element back into the DOM where it started
			function reset(els,data,opts,el) {
				var $el = $(el);
				if ( $el.data('blockUI.isBlocked') )
					return;
	
				els.each(function(i,o) {
					// remove via DOM calls so we don't lose event handlers
					if (this.parentNode)
						this.parentNode.removeChild(this);
				});
	
				if (data && data.el) {
					data.el.style.display = data.display;
					data.el.style.position = data.position;
					data.el.style.cursor = 'default'; // #59
					if (data.parent)
						data.parent.appendChild(data.el);
					$el.removeData('blockUI.history');
				}
	
				if ($el.data('blockUI.static')) {
					$el.css('position', 'static'); // #22
				}
	
				if (typeof opts.onUnblock == 'function')
					opts.onUnblock(el,opts);
	
				// fix issue in Safari 6 where block artifacts remain until reflow
				var body = $(document.body), w = body.width(), cssW = body[0].style.width;
				body.width(w-1).width(w);
				body[0].style.width = cssW;
			}
	
			// bind/unbind the handler
			function bind(b, el, opts) {
				var full = el == window, $el = $(el);
	
				// don't bother unbinding if there is nothing to unbind
				if (!b && (full && !pageBlock || !full && !$el.data('blockUI.isBlocked')))
					return;
	
				$el.data('blockUI.isBlocked', b);
	
				// don't bind events when overlay is not in use or if bindEvents is false
				if (!full || !opts.bindEvents || (b && !opts.showOverlay))
					return;
	
				// bind anchors and inputs for mouse and key events
				var events = 'mousedown mouseup keydown keypress keyup touchstart touchend touchmove';
				if (b)
					$(document).bind(events, opts, handler);
				else
					$(document).unbind(events, handler);
	
			// former impl...
			//		var $e = $('a,:input');
			//		b ? $e.bind(events, opts, handler) : $e.unbind(events, handler);
			}
	
			// event handler to suppress keyboard/mouse events when blocking
			function handler(e) {
				// allow tab navigation (conditionally)
				if (e.type === 'keydown' && e.keyCode && e.keyCode == 9) {
					if (pageBlock && e.data.constrainTabKey) {
						var els = pageBlockEls;
						var fwd = !e.shiftKey && e.target === els[els.length-1];
						var back = e.shiftKey && e.target === els[0];
						if (fwd || back) {
							setTimeout(function(){focus(back);},10);
							return false;
						}
					}
				}
				var opts = e.data;
				var target = $(e.target);
				if (target.hasClass('blockOverlay') && opts.onOverlayClick)
					opts.onOverlayClick(e);
	
				// allow events within the message content
				if (target.parents('div.' + opts.blockMsgClass).length > 0)
					return true;
	
				// allow events for content that is not being blocked
				return target.parents().children().filter('div.blockUI').length === 0;
			}
	
			function focus(back) {
				if (!pageBlockEls)
					return;
				var e = pageBlockEls[back===true ? pageBlockEls.length-1 : 0];
				if (e)
					e.focus();
			}
	
			function center(el, x, y) {
				var p = el.parentNode, s = el.style;
				var l = ((p.offsetWidth - el.offsetWidth)/2) - sz(p,'borderLeftWidth');
				var t = ((p.offsetHeight - el.offsetHeight)/2) - sz(p,'borderTopWidth');
				if (x) s.left = l > 0 ? (l+'px') : '0';
				if (y) s.top  = t > 0 ? (t+'px') : '0';
			}
	
			function sz(el, p) {
				return parseInt($.css(el,p),10)||0;
			}
	
		}
	
	
		/*global define:true */
		if (true) {
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (setup), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			// Node/CommonJS
			setup(require('jquery'));
		} else {
			// Browser globals
			setup(jQuery);
		}
	
	})();


/***/ },
/* 231 */,
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(48);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(32);
	var toAbsoluteIndex = __webpack_require__(81);
	var toLength = __webpack_require__(25);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(74);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(37);
	var toObject = __webpack_require__(32);
	var IObject = __webpack_require__(101);
	var toLength = __webpack_require__(25);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(37);
	var isObject = __webpack_require__(18);
	var invoke = __webpack_require__(242);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(29).f;
	var create = __webpack_require__(75);
	var redefineAll = __webpack_require__(79);
	var ctx = __webpack_require__(50);
	var anInstance = __webpack_require__(73);
	var forOf = __webpack_require__(74);
	var $iterDefine = __webpack_require__(162);
	var step = __webpack_require__(245);
	var setSpecies = __webpack_require__(80);
	var DESCRIPTORS = __webpack_require__(28);
	var fastKey = __webpack_require__(69).fastKey;
	var validate = __webpack_require__(83);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(88);
	var from = __webpack_require__(234);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(79);
	var getWeak = __webpack_require__(69).getWeak;
	var anObject = __webpack_require__(12);
	var isObject = __webpack_require__(18);
	var anInstance = __webpack_require__(73);
	var forOf = __webpack_require__(74);
	var createArrayMethod = __webpack_require__(57);
	var $has = __webpack_require__(42);
	var validate = __webpack_require__(83);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(119);
	var isObject = __webpack_require__(18);
	var toLength = __webpack_require__(25);
	var ctx = __webpack_require__(50);
	var IS_CONCAT_SPREADABLE = __webpack_require__(23)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(28) && !__webpack_require__(17)(function () {
	  return Object.defineProperty(__webpack_require__(155)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 242 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(18);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(12);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 245 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(164);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ },
/* 247 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ },
/* 248 */
/***/ function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(28);
	var getKeys = __webpack_require__(77);
	var gOPS = __webpack_require__(123);
	var pIE = __webpack_require__(102);
	var toObject = __webpack_require__(32);
	var IObject = __webpack_require__(101);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(17)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(29);
	var anObject = __webpack_require__(12);
	var getKeys = __webpack_require__(77);
	
	module.exports = __webpack_require__(28) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(45);
	var gOPN = __webpack_require__(76).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(42);
	var toIObject = __webpack_require__(45);
	var arrayIndexOf = __webpack_require__(116)(false);
	var IE_PROTO = __webpack_require__(169)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(28);
	var getKeys = __webpack_require__(77);
	var toIObject = __webpack_require__(45);
	var isEnum = __webpack_require__(102).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(76);
	var gOPS = __webpack_require__(123);
	var anObject = __webpack_require__(12);
	var Reflect = __webpack_require__(13).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(13).parseFloat;
	var $trim = __webpack_require__(91).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(172) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(13).parseInt;
	var $trim = __webpack_require__(91).trim;
	var ws = __webpack_require__(172);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ },
/* 257 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(12);
	var isObject = __webpack_require__(18);
	var newPromiseCapability = __webpack_require__(166);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ },
/* 259 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(25);
	var repeat = __webpack_require__(171);
	var defined = __webpack_require__(58);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(52);
	var toLength = __webpack_require__(25);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(23);


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(237);
	var validate = __webpack_require__(83);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(117)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(167);
	__webpack_require__(8)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(28) && /./g.flags != 'g') __webpack_require__(29).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(100)
	});


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(237);
	var validate = __webpack_require__(83);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(117)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(13);
	var each = __webpack_require__(57)(0);
	var redefine = __webpack_require__(40);
	var meta = __webpack_require__(69);
	var assign = __webpack_require__(249);
	var weak = __webpack_require__(239);
	var isObject = __webpack_require__(18);
	var validate = __webpack_require__(83);
	var NATIVE_WEAK_MAP = __webpack_require__(83);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(117)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ },
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	* dependencyLibs/inputmask.dependencyLib.js
	* https://github.com/RobinHerbots/Inputmask
	* Copyright (c) 2010 - 2017 Robin Herbots
	* Licensed under the MIT license (http://www.opensource.org/licenses/mit-license.php)
	* Version: 3.3.7
	*/
	
	!function(factory) {
	     true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(320), __webpack_require__(319) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == typeof exports ? module.exports = factory(require("../global/window"), require("../global/document")) : window.dependencyLib = factory(window, document);
	}(function(window, document) {
	    function indexOf(list, elem) {
	        for (var i = 0, len = list.length; i < len; i++) if (list[i] === elem) return i;
	        return -1;
	    }
	    function type(obj) {
	        return null == obj ? obj + "" : "object" == typeof obj || "function" == typeof obj ? class2type[class2type.toString.call(obj)] || "object" : typeof obj;
	    }
	    function isWindow(obj) {
	        return null != obj && obj === obj.window;
	    }
	    function isArraylike(obj) {
	        var length = "length" in obj && obj.length, ltype = type(obj);
	        return "function" !== ltype && !isWindow(obj) && (!(1 !== obj.nodeType || !length) || ("array" === ltype || 0 === length || "number" == typeof length && length > 0 && length - 1 in obj));
	    }
	    function isValidElement(elem) {
	        return elem instanceof Element;
	    }
	    function DependencyLib(elem) {
	        return elem instanceof DependencyLib ? elem : this instanceof DependencyLib ? void (void 0 !== elem && null !== elem && elem !== window && (this[0] = elem.nodeName ? elem : void 0 !== elem[0] && elem[0].nodeName ? elem[0] : document.querySelector(elem), 
	        void 0 !== this[0] && null !== this[0] && (this[0].eventRegistry = this[0].eventRegistry || {}))) : new DependencyLib(elem);
	    }
	    for (var class2type = {}, classTypes = "Boolean Number String Function Array Date RegExp Object Error".split(" "), nameNdx = 0; nameNdx < classTypes.length; nameNdx++) class2type["[object " + classTypes[nameNdx] + "]"] = classTypes[nameNdx].toLowerCase();
	    return DependencyLib.prototype = {
	        on: function(events, handler) {
	            if (isValidElement(this[0])) for (var eventRegistry = this[0].eventRegistry, elem = this[0], _events = events.split(" "), endx = 0; endx < _events.length; endx++) {
	                var nsEvent = _events[endx].split("."), ev = nsEvent[0], namespace = nsEvent[1] || "global";
	                !function(ev, namespace) {
	                    elem.addEventListener ? elem.addEventListener(ev, handler, !1) : elem.attachEvent && elem.attachEvent("on" + ev, handler), 
	                    eventRegistry[ev] = eventRegistry[ev] || {}, eventRegistry[ev][namespace] = eventRegistry[ev][namespace] || [], 
	                    eventRegistry[ev][namespace].push(handler);
	                }(ev, namespace);
	            }
	            return this;
	        },
	        off: function(events, handler) {
	            if (isValidElement(this[0])) for (var eventRegistry = this[0].eventRegistry, elem = this[0], _events = events.split(" "), endx = 0; endx < _events.length; endx++) for (var nsEvent = _events[endx].split("."), offEvents = function(ev, namespace) {
	                var hndx, hndL, evts = [];
	                if (ev.length > 0) if (void 0 === handler) for (hndx = 0, hndL = eventRegistry[ev][namespace].length; hndx < hndL; hndx++) evts.push({
	                    ev: ev,
	                    namespace: namespace && namespace.length > 0 ? namespace : "global",
	                    handler: eventRegistry[ev][namespace][hndx]
	                }); else evts.push({
	                    ev: ev,
	                    namespace: namespace && namespace.length > 0 ? namespace : "global",
	                    handler: handler
	                }); else if (namespace.length > 0) for (var evNdx in eventRegistry) for (var nmsp in eventRegistry[evNdx]) if (nmsp === namespace) if (void 0 === handler) for (hndx = 0, 
	                hndL = eventRegistry[evNdx][nmsp].length; hndx < hndL; hndx++) evts.push({
	                    ev: evNdx,
	                    namespace: nmsp,
	                    handler: eventRegistry[evNdx][nmsp][hndx]
	                }); else evts.push({
	                    ev: evNdx,
	                    namespace: nmsp,
	                    handler: handler
	                });
	                return evts;
	            }(nsEvent[0], nsEvent[1]), i = 0, offEventsL = offEvents.length; i < offEventsL; i++) !function(ev, namespace, handler) {
	                if (ev in eventRegistry == 1) if (elem.removeEventListener ? elem.removeEventListener(ev, handler, !1) : elem.detachEvent && elem.detachEvent("on" + ev, handler), 
	                "global" === namespace) for (var nmsp in eventRegistry[ev]) eventRegistry[ev][nmsp].splice(eventRegistry[ev][nmsp].indexOf(handler), 1); else eventRegistry[ev][namespace].splice(eventRegistry[ev][namespace].indexOf(handler), 1);
	            }(offEvents[i].ev, offEvents[i].namespace, offEvents[i].handler);
	            return this;
	        },
	        trigger: function(events) {
	            if (isValidElement(this[0])) for (var eventRegistry = this[0].eventRegistry, elem = this[0], _events = "string" == typeof events ? events.split(" ") : [ events.type ], endx = 0; endx < _events.length; endx++) {
	                var nsEvent = _events[endx].split("."), ev = nsEvent[0], namespace = nsEvent[1] || "global";
	                if (void 0 !== document && "global" === namespace) {
	                    var evnt, i, params = {
	                        bubbles: !0,
	                        cancelable: !0,
	                        detail: Array.prototype.slice.call(arguments, 1)
	                    };
	                    if (document.createEvent) {
	                        try {
	                            evnt = new CustomEvent(ev, params);
	                        } catch (e) {
	                            evnt = document.createEvent("CustomEvent"), evnt.initCustomEvent(ev, params.bubbles, params.cancelable, params.detail);
	                        }
	                        events.type && DependencyLib.extend(evnt, events), elem.dispatchEvent(evnt);
	                    } else evnt = document.createEventObject(), evnt.eventType = ev, events.type && DependencyLib.extend(evnt, events), 
	                    elem.fireEvent("on" + evnt.eventType, evnt);
	                } else if (void 0 !== eventRegistry[ev]) if (arguments[0] = arguments[0].type ? arguments[0] : DependencyLib.Event(arguments[0]), 
	                "global" === namespace) for (var nmsp in eventRegistry[ev]) for (i = 0; i < eventRegistry[ev][nmsp].length; i++) eventRegistry[ev][nmsp][i].apply(elem, arguments); else for (i = 0; i < eventRegistry[ev][namespace].length; i++) eventRegistry[ev][namespace][i].apply(elem, arguments);
	            }
	            return this;
	        },
	        position: function() {
	            if (isValidElement(this[0])) return {
	                top: this[0].offsetTop,
	                left: this[0].offsetLeft
	            };
	        }
	    }, DependencyLib.isFunction = function(obj) {
	        return "function" === type(obj);
	    }, DependencyLib.noop = function() {}, DependencyLib.isArray = Array.isArray, DependencyLib.inArray = function(elem, arr, i) {
	        return null == arr ? -1 : indexOf(arr, elem);
	    }, DependencyLib.valHooks = void 0, DependencyLib.isPlainObject = function(obj) {
	        return "object" === type(obj) && !obj.nodeType && !isWindow(obj) && !(obj.constructor && !class2type.hasOwnProperty.call(obj.constructor.prototype, "isPrototypeOf"));
	    }, DependencyLib.extend = function() {
	        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = !1;
	        for ("boolean" == typeof target && (deep = target, target = arguments[i] || {}, 
	        i++), "object" == typeof target || DependencyLib.isFunction(target) || (target = {}), 
	        i === length && (target = this, i--); i < length; i++) if (null != (options = arguments[i])) for (name in options) src = target[name], 
	        copy = options[name], target !== copy && (deep && copy && (DependencyLib.isPlainObject(copy) || (copyIsArray = DependencyLib.isArray(copy))) ? (copyIsArray ? (copyIsArray = !1, 
	        clone = src && DependencyLib.isArray(src) ? src : []) : clone = src && DependencyLib.isPlainObject(src) ? src : {}, 
	        target[name] = DependencyLib.extend(deep, clone, copy)) : void 0 !== copy && (target[name] = copy));
	        return target;
	    }, DependencyLib.each = function(obj, callback) {
	        var i = 0;
	        if (isArraylike(obj)) for (var length = obj.length; i < length && !1 !== callback.call(obj[i], i, obj[i]); i++) ; else for (i in obj) if (!1 === callback.call(obj[i], i, obj[i])) break;
	        return obj;
	    }, DependencyLib.map = function(elems, callback) {
	        var value, i = 0, length = elems.length, isArray = isArraylike(elems), ret = [];
	        if (isArray) for (;i < length; i++) null != (value = callback(elems[i], i)) && ret.push(value); else for (i in elems) null != (value = callback(elems[i], i)) && ret.push(value);
	        return [].concat(ret);
	    }, DependencyLib.data = function(owner, key, value) {
	        if (void 0 === value) return owner.__data ? owner.__data[key] : null;
	        owner.__data = owner.__data || {}, owner.__data[key] = value;
	    }, DependencyLib.Event = function CustomEvent(event, params) {
	        params = params || {
	            bubbles: !1,
	            cancelable: !1,
	            detail: void 0
	        };
	        var evnt;
	        if (document.createEvent) try {
	            evnt = new CustomEvent(event, params);
	        } catch (e) {
	            evnt = document.createEvent("CustomEvent"), evnt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
	        } else evnt = document.createEventObject(), evnt.eventType = event;
	        return evnt;
	    }, DependencyLib.Event.prototype = window.Event.prototype, DependencyLib;
	});

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	* global/document.js
	* https://github.com/RobinHerbots/Inputmask
	* Copyright (c) 2010 - 2017 Robin Herbots
	* Licensed under the MIT license (http://www.opensource.org/licenses/mit-license.php)
	* Version: 3.3.7
	*/
	
	 true ? !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    return document;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == typeof exports && (module.exports = document);

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	* global/window.js
	* https://github.com/RobinHerbots/Inputmask
	* Copyright (c) 2010 - 2017 Robin Herbots
	* Licensed under the MIT license (http://www.opensource.org/licenses/mit-license.php)
	* Version: 3.3.7
	*/
	
	 true ? !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    return window;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == typeof exports && (module.exports = window);

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	* inputmask.js
	* https://github.com/RobinHerbots/Inputmask
	* Copyright (c) 2010 - 2017 Robin Herbots
	* Licensed under the MIT license (http://www.opensource.org/licenses/mit-license.php)
	* Version: 3.3.7
	*/
	
	!function(factory) {
	     true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(318), __webpack_require__(320), __webpack_require__(319) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == typeof exports ? module.exports = factory(require("./dependencyLibs/inputmask.dependencyLib"), require("./global/window"), require("./global/document")) : window.Inputmask = factory(window.dependencyLib || jQuery, window, document);
	}(function($, window, document, undefined) {
	    function Inputmask(alias, options, internal) {
	        if (!(this instanceof Inputmask)) return new Inputmask(alias, options, internal);
	        this.el = undefined, this.events = {}, this.maskset = undefined, this.refreshValue = !1, 
	        !0 !== internal && ($.isPlainObject(alias) ? options = alias : (options = options || {}, 
	        options.alias = alias), this.opts = $.extend(!0, {}, this.defaults, options), this.noMasksCache = options && options.definitions !== undefined, 
	        this.userOptions = options || {}, this.isRTL = this.opts.numericInput, resolveAlias(this.opts.alias, options, this.opts));
	    }
	    function resolveAlias(aliasStr, options, opts) {
	        var aliasDefinition = Inputmask.prototype.aliases[aliasStr];
	        return aliasDefinition ? (aliasDefinition.alias && resolveAlias(aliasDefinition.alias, undefined, opts), 
	        $.extend(!0, opts, aliasDefinition), $.extend(!0, opts, options), !0) : (null === opts.mask && (opts.mask = aliasStr), 
	        !1);
	    }
	    function generateMaskSet(opts, nocache) {
	        function generateMask(mask, metadata, opts) {
	            var regexMask = !1;
	            if (null !== mask && "" !== mask || (regexMask = null !== opts.regex, regexMask ? (mask = opts.regex, 
	            mask = mask.replace(/^(\^)(.*)(\$)$/, "$2")) : (regexMask = !0, mask = ".*")), 1 === mask.length && !1 === opts.greedy && 0 !== opts.repeat && (opts.placeholder = ""), 
	            opts.repeat > 0 || "*" === opts.repeat || "+" === opts.repeat) {
	                var repeatStart = "*" === opts.repeat ? 0 : "+" === opts.repeat ? 1 : opts.repeat;
	                mask = opts.groupmarker.start + mask + opts.groupmarker.end + opts.quantifiermarker.start + repeatStart + "," + opts.repeat + opts.quantifiermarker.end;
	            }
	            var masksetDefinition, maskdefKey = regexMask ? "regex_" + opts.regex : opts.numericInput ? mask.split("").reverse().join("") : mask;
	            return Inputmask.prototype.masksCache[maskdefKey] === undefined || !0 === nocache ? (masksetDefinition = {
	                mask: mask,
	                maskToken: Inputmask.prototype.analyseMask(mask, regexMask, opts),
	                validPositions: {},
	                _buffer: undefined,
	                buffer: undefined,
	                tests: {},
	                metadata: metadata,
	                maskLength: undefined
	            }, !0 !== nocache && (Inputmask.prototype.masksCache[maskdefKey] = masksetDefinition, 
	            masksetDefinition = $.extend(!0, {}, Inputmask.prototype.masksCache[maskdefKey]))) : masksetDefinition = $.extend(!0, {}, Inputmask.prototype.masksCache[maskdefKey]), 
	            masksetDefinition;
	        }
	        if ($.isFunction(opts.mask) && (opts.mask = opts.mask(opts)), $.isArray(opts.mask)) {
	            if (opts.mask.length > 1) {
	                opts.keepStatic = null === opts.keepStatic || opts.keepStatic;
	                var altMask = opts.groupmarker.start;
	                return $.each(opts.numericInput ? opts.mask.reverse() : opts.mask, function(ndx, msk) {
	                    altMask.length > 1 && (altMask += opts.groupmarker.end + opts.alternatormarker + opts.groupmarker.start), 
	                    msk.mask === undefined || $.isFunction(msk.mask) ? altMask += msk : altMask += msk.mask;
	                }), altMask += opts.groupmarker.end, generateMask(altMask, opts.mask, opts);
	            }
	            opts.mask = opts.mask.pop();
	        }
	        return opts.mask && opts.mask.mask !== undefined && !$.isFunction(opts.mask.mask) ? generateMask(opts.mask.mask, opts.mask, opts) : generateMask(opts.mask, opts.mask, opts);
	    }
	    function maskScope(actionObj, maskset, opts) {
	        function getMaskTemplate(baseOnInput, minimalPos, includeMode) {
	            minimalPos = minimalPos || 0;
	            var ndxIntlzr, test, testPos, maskTemplate = [], pos = 0, lvp = getLastValidPosition();
	            -1 === (maxLength = el !== undefined ? el.maxLength : undefined) && (maxLength = undefined);
	            do {
	                !0 === baseOnInput && getMaskSet().validPositions[pos] ? (testPos = getMaskSet().validPositions[pos], 
	                test = testPos.match, ndxIntlzr = testPos.locator.slice(), maskTemplate.push(!0 === includeMode ? testPos.input : !1 === includeMode ? test.nativeDef : getPlaceholder(pos, test))) : (testPos = getTestTemplate(pos, ndxIntlzr, pos - 1), 
	                test = testPos.match, ndxIntlzr = testPos.locator.slice(), (!1 === opts.jitMasking || pos < lvp || "number" == typeof opts.jitMasking && isFinite(opts.jitMasking) && opts.jitMasking > pos) && maskTemplate.push(!1 === includeMode ? test.nativeDef : getPlaceholder(pos, test))), 
	                pos++;
	            } while ((maxLength === undefined || pos < maxLength) && (null !== test.fn || "" !== test.def) || minimalPos > pos);
	            return "" === maskTemplate[maskTemplate.length - 1] && maskTemplate.pop(), getMaskSet().maskLength = pos + 1, 
	            maskTemplate;
	        }
	        function getMaskSet() {
	            return maskset;
	        }
	        function resetMaskSet(soft) {
	            var maskset = getMaskSet();
	            maskset.buffer = undefined, !0 !== soft && (maskset.validPositions = {}, maskset.p = 0);
	        }
	        function getLastValidPosition(closestTo, strict, validPositions) {
	            var before = -1, after = -1, valids = validPositions || getMaskSet().validPositions;
	            closestTo === undefined && (closestTo = -1);
	            for (var posNdx in valids) {
	                var psNdx = parseInt(posNdx);
	                valids[psNdx] && (strict || !0 !== valids[psNdx].generatedInput) && (psNdx <= closestTo && (before = psNdx), 
	                psNdx >= closestTo && (after = psNdx));
	            }
	            return -1 !== before && closestTo - before > 1 || after < closestTo ? before : after;
	        }
	        function stripValidPositions(start, end, nocheck, strict) {
	            var i, startPos = start, positionsClone = $.extend(!0, {}, getMaskSet().validPositions), needsValidation = !1;
	            for (getMaskSet().p = start, i = end - 1; i >= startPos; i--) getMaskSet().validPositions[i] !== undefined && (!0 !== nocheck && (!getMaskSet().validPositions[i].match.optionality && function(pos) {
	                var posMatch = getMaskSet().validPositions[pos];
	                if (posMatch !== undefined && null === posMatch.match.fn) {
	                    var prevMatch = getMaskSet().validPositions[pos - 1], nextMatch = getMaskSet().validPositions[pos + 1];
	                    return prevMatch !== undefined && nextMatch !== undefined;
	                }
	                return !1;
	            }(i) || !1 === opts.canClearPosition(getMaskSet(), i, getLastValidPosition(), strict, opts)) || delete getMaskSet().validPositions[i]);
	            for (resetMaskSet(!0), i = startPos + 1; i <= getLastValidPosition(); ) {
	                for (;getMaskSet().validPositions[startPos] !== undefined; ) startPos++;
	                if (i < startPos && (i = startPos + 1), getMaskSet().validPositions[i] === undefined && isMask(i)) i++; else {
	                    var t = getTestTemplate(i);
	                    !1 === needsValidation && positionsClone[startPos] && positionsClone[startPos].match.def === t.match.def ? (getMaskSet().validPositions[startPos] = $.extend(!0, {}, positionsClone[startPos]), 
	                    getMaskSet().validPositions[startPos].input = t.input, delete getMaskSet().validPositions[i], 
	                    i++) : positionCanMatchDefinition(startPos, t.match.def) ? !1 !== isValid(startPos, t.input || getPlaceholder(i), !0) && (delete getMaskSet().validPositions[i], 
	                    i++, needsValidation = !0) : isMask(i) || (i++, startPos--), startPos++;
	                }
	            }
	            resetMaskSet(!0);
	        }
	        function determineTestTemplate(tests, guessNextBest) {
	            for (var testPos, testPositions = tests, lvp = getLastValidPosition(), lvTest = getMaskSet().validPositions[lvp] || getTests(0)[0], lvTestAltArr = lvTest.alternation !== undefined ? lvTest.locator[lvTest.alternation].toString().split(",") : [], ndx = 0; ndx < testPositions.length && (testPos = testPositions[ndx], 
	            !(testPos.match && (opts.greedy && !0 !== testPos.match.optionalQuantifier || (!1 === testPos.match.optionality || !1 === testPos.match.newBlockMarker) && !0 !== testPos.match.optionalQuantifier) && (lvTest.alternation === undefined || lvTest.alternation !== testPos.alternation || testPos.locator[lvTest.alternation] !== undefined && checkAlternationMatch(testPos.locator[lvTest.alternation].toString().split(","), lvTestAltArr))) || !0 === guessNextBest && (null !== testPos.match.fn || /[0-9a-bA-Z]/.test(testPos.match.def))); ndx++) ;
	            return testPos;
	        }
	        function getTestTemplate(pos, ndxIntlzr, tstPs) {
	            return getMaskSet().validPositions[pos] || determineTestTemplate(getTests(pos, ndxIntlzr ? ndxIntlzr.slice() : ndxIntlzr, tstPs));
	        }
	        function getTest(pos) {
	            return getMaskSet().validPositions[pos] ? getMaskSet().validPositions[pos] : getTests(pos)[0];
	        }
	        function positionCanMatchDefinition(pos, def) {
	            for (var valid = !1, tests = getTests(pos), tndx = 0; tndx < tests.length; tndx++) if (tests[tndx].match && tests[tndx].match.def === def) {
	                valid = !0;
	                break;
	            }
	            return valid;
	        }
	        function getTests(pos, ndxIntlzr, tstPs) {
	            function resolveTestFromToken(maskToken, ndxInitializer, loopNdx, quantifierRecurse) {
	                function handleMatch(match, loopNdx, quantifierRecurse) {
	                    function isFirstMatch(latestMatch, tokenGroup) {
	                        var firstMatch = 0 === $.inArray(latestMatch, tokenGroup.matches);
	                        return firstMatch || $.each(tokenGroup.matches, function(ndx, match) {
	                            if (!0 === match.isQuantifier && (firstMatch = isFirstMatch(latestMatch, tokenGroup.matches[ndx - 1]))) return !1;
	                        }), firstMatch;
	                    }
	                    function resolveNdxInitializer(pos, alternateNdx, targetAlternation) {
	                        var bestMatch, indexPos;
	                        if (getMaskSet().validPositions[pos - 1] && targetAlternation && getMaskSet().tests[pos]) for (var vpAlternation = getMaskSet().validPositions[pos - 1].locator, tpAlternation = getMaskSet().tests[pos][0].locator, i = 0; i < targetAlternation; i++) if (vpAlternation[i] !== tpAlternation[i]) return vpAlternation.slice(targetAlternation + 1);
	                        return (getMaskSet().tests[pos] || getMaskSet().validPositions[pos]) && $.each(getMaskSet().tests[pos] || [ getMaskSet().validPositions[pos] ], function(ndx, lmnt) {
	                            var alternation = targetAlternation !== undefined ? targetAlternation : lmnt.alternation, ndxPos = lmnt.locator[alternation] !== undefined ? lmnt.locator[alternation].toString().indexOf(alternateNdx) : -1;
	                            (indexPos === undefined || ndxPos < indexPos) && -1 !== ndxPos && (bestMatch = lmnt, 
	                            indexPos = ndxPos);
	                        }), bestMatch ? bestMatch.locator.slice((targetAlternation !== undefined ? targetAlternation : bestMatch.alternation) + 1) : targetAlternation !== undefined ? resolveNdxInitializer(pos, alternateNdx) : undefined;
	                    }
	                    if (testPos > 1e4) throw "Inputmask: There is probably an error in your mask definition or in the code. Create an issue on github with an example of the mask you are using. " + getMaskSet().mask;
	                    if (testPos === pos && match.matches === undefined) return matches.push({
	                        match: match,
	                        locator: loopNdx.reverse(),
	                        cd: cacheDependency
	                    }), !0;
	                    if (match.matches !== undefined) {
	                        if (match.isGroup && quantifierRecurse !== match) {
	                            if (match = handleMatch(maskToken.matches[$.inArray(match, maskToken.matches) + 1], loopNdx)) return !0;
	                        } else if (match.isOptional) {
	                            var optionalToken = match;
	                            if (match = resolveTestFromToken(match, ndxInitializer, loopNdx, quantifierRecurse)) {
	                                if (latestMatch = matches[matches.length - 1].match, !isFirstMatch(latestMatch, optionalToken)) return !0;
	                                insertStop = !0, testPos = pos;
	                            }
	                        } else if (match.isAlternator) {
	                            var maltMatches, alternateToken = match, malternateMatches = [], currentMatches = matches.slice(), loopNdxCnt = loopNdx.length, altIndex = ndxInitializer.length > 0 ? ndxInitializer.shift() : -1;
	                            if (-1 === altIndex || "string" == typeof altIndex) {
	                                var amndx, currentPos = testPos, ndxInitializerClone = ndxInitializer.slice(), altIndexArr = [];
	                                if ("string" == typeof altIndex) altIndexArr = altIndex.split(","); else for (amndx = 0; amndx < alternateToken.matches.length; amndx++) altIndexArr.push(amndx);
	                                for (var ndx = 0; ndx < altIndexArr.length; ndx++) {
	                                    if (amndx = parseInt(altIndexArr[ndx]), matches = [], ndxInitializer = resolveNdxInitializer(testPos, amndx, loopNdxCnt) || ndxInitializerClone.slice(), 
	                                    !0 !== (match = handleMatch(alternateToken.matches[amndx] || maskToken.matches[amndx], [ amndx ].concat(loopNdx), quantifierRecurse) || match) && match !== undefined && altIndexArr[altIndexArr.length - 1] < alternateToken.matches.length) {
	                                        var ntndx = $.inArray(match, maskToken.matches) + 1;
	                                        maskToken.matches.length > ntndx && (match = handleMatch(maskToken.matches[ntndx], [ ntndx ].concat(loopNdx.slice(1, loopNdx.length)), quantifierRecurse)) && (altIndexArr.push(ntndx.toString()), 
	                                        $.each(matches, function(ndx, lmnt) {
	                                            lmnt.alternation = loopNdx.length - 1;
	                                        }));
	                                    }
	                                    maltMatches = matches.slice(), testPos = currentPos, matches = [];
	                                    for (var ndx1 = 0; ndx1 < maltMatches.length; ndx1++) {
	                                        var altMatch = maltMatches[ndx1], dropMatch = !1;
	                                        altMatch.alternation = altMatch.alternation || loopNdxCnt;
	                                        for (var ndx2 = 0; ndx2 < malternateMatches.length; ndx2++) {
	                                            var altMatch2 = malternateMatches[ndx2];
	                                            if ("string" != typeof altIndex || -1 !== $.inArray(altMatch.locator[altMatch.alternation].toString(), altIndexArr)) {
	                                                if (function(source, target) {
	                                                    return source.match.nativeDef === target.match.nativeDef || source.match.def === target.match.nativeDef || source.match.nativeDef === target.match.def;
	                                                }(altMatch, altMatch2)) {
	                                                    dropMatch = !0, altMatch.alternation === altMatch2.alternation && -1 === altMatch2.locator[altMatch2.alternation].toString().indexOf(altMatch.locator[altMatch.alternation]) && (altMatch2.locator[altMatch2.alternation] = altMatch2.locator[altMatch2.alternation] + "," + altMatch.locator[altMatch.alternation], 
	                                                    altMatch2.alternation = altMatch.alternation), altMatch.match.nativeDef === altMatch2.match.def && (altMatch.locator[altMatch.alternation] = altMatch2.locator[altMatch2.alternation], 
	                                                    malternateMatches.splice(malternateMatches.indexOf(altMatch2), 1, altMatch));
	                                                    break;
	                                                }
	                                                if (altMatch.match.def === altMatch2.match.def) {
	                                                    dropMatch = !1;
	                                                    break;
	                                                }
	                                                if (function(source, target) {
	                                                    return null === source.match.fn && null !== target.match.fn && target.match.fn.test(source.match.def, getMaskSet(), pos, !1, opts, !1);
	                                                }(altMatch, altMatch2) || function(source, target) {
	                                                    return null !== source.match.fn && null !== target.match.fn && target.match.fn.test(source.match.def.replace(/[\[\]]/g, ""), getMaskSet(), pos, !1, opts, !1);
	                                                }(altMatch, altMatch2)) {
	                                                    altMatch.alternation == altMatch2.alternation && -1 === altMatch.locator[altMatch.alternation].toString().indexOf(altMatch2.locator[altMatch2.alternation].toString().split("")[0]) && (altMatch.na = altMatch.na || altMatch.locator[altMatch.alternation].toString(), 
	                                                    -1 === altMatch.na.indexOf(altMatch.locator[altMatch.alternation].toString().split("")[0]) && (altMatch.na = altMatch.na + "," + altMatch.locator[altMatch2.alternation].toString().split("")[0]), 
	                                                    dropMatch = !0, altMatch.locator[altMatch.alternation] = altMatch2.locator[altMatch2.alternation].toString().split("")[0] + "," + altMatch.locator[altMatch.alternation], 
	                                                    malternateMatches.splice(malternateMatches.indexOf(altMatch2), 0, altMatch));
	                                                    break;
	                                                }
	                                            }
	                                        }
	                                        dropMatch || malternateMatches.push(altMatch);
	                                    }
	                                }
	                                "string" == typeof altIndex && (malternateMatches = $.map(malternateMatches, function(lmnt, ndx) {
	                                    if (isFinite(ndx)) {
	                                        var alternation = lmnt.alternation, altLocArr = lmnt.locator[alternation].toString().split(",");
	                                        lmnt.locator[alternation] = undefined, lmnt.alternation = undefined;
	                                        for (var alndx = 0; alndx < altLocArr.length; alndx++) -1 !== $.inArray(altLocArr[alndx], altIndexArr) && (lmnt.locator[alternation] !== undefined ? (lmnt.locator[alternation] += ",", 
	                                        lmnt.locator[alternation] += altLocArr[alndx]) : lmnt.locator[alternation] = parseInt(altLocArr[alndx]), 
	                                        lmnt.alternation = alternation);
	                                        if (lmnt.locator[alternation] !== undefined) return lmnt;
	                                    }
	                                })), matches = currentMatches.concat(malternateMatches), testPos = pos, insertStop = matches.length > 0, 
	                                match = malternateMatches.length > 0, ndxInitializer = ndxInitializerClone.slice();
	                            } else match = handleMatch(alternateToken.matches[altIndex] || maskToken.matches[altIndex], [ altIndex ].concat(loopNdx), quantifierRecurse);
	                            if (match) return !0;
	                        } else if (match.isQuantifier && quantifierRecurse !== maskToken.matches[$.inArray(match, maskToken.matches) - 1]) for (var qt = match, qndx = ndxInitializer.length > 0 ? ndxInitializer.shift() : 0; qndx < (isNaN(qt.quantifier.max) ? qndx + 1 : qt.quantifier.max) && testPos <= pos; qndx++) {
	                            var tokenGroup = maskToken.matches[$.inArray(qt, maskToken.matches) - 1];
	                            if (match = handleMatch(tokenGroup, [ qndx ].concat(loopNdx), tokenGroup)) {
	                                if (latestMatch = matches[matches.length - 1].match, latestMatch.optionalQuantifier = qndx > qt.quantifier.min - 1, 
	                                isFirstMatch(latestMatch, tokenGroup)) {
	                                    if (qndx > qt.quantifier.min - 1) {
	                                        insertStop = !0, testPos = pos;
	                                        break;
	                                    }
	                                    return !0;
	                                }
	                                return !0;
	                            }
	                        } else if (match = resolveTestFromToken(match, ndxInitializer, loopNdx, quantifierRecurse)) return !0;
	                    } else testPos++;
	                }
	                for (var tndx = ndxInitializer.length > 0 ? ndxInitializer.shift() : 0; tndx < maskToken.matches.length; tndx++) if (!0 !== maskToken.matches[tndx].isQuantifier) {
	                    var match = handleMatch(maskToken.matches[tndx], [ tndx ].concat(loopNdx), quantifierRecurse);
	                    if (match && testPos === pos) return match;
	                    if (testPos > pos) break;
	                }
	            }
	            function filterTests(tests) {
	                if (opts.keepStatic && pos > 0 && tests.length > 1 + ("" === tests[tests.length - 1].match.def ? 1 : 0) && !0 !== tests[0].match.optionality && !0 !== tests[0].match.optionalQuantifier && null === tests[0].match.fn && !/[0-9a-bA-Z]/.test(tests[0].match.def)) {
	                    if (getMaskSet().validPositions[pos - 1] === undefined) return [ determineTestTemplate(tests) ];
	                    if (getMaskSet().validPositions[pos - 1].alternation === tests[0].alternation) return [ determineTestTemplate(tests) ];
	                    if (getMaskSet().validPositions[pos - 1]) return [ determineTestTemplate(tests) ];
	                }
	                return tests;
	            }
	            var latestMatch, maskTokens = getMaskSet().maskToken, testPos = ndxIntlzr ? tstPs : 0, ndxInitializer = ndxIntlzr ? ndxIntlzr.slice() : [ 0 ], matches = [], insertStop = !1, cacheDependency = ndxIntlzr ? ndxIntlzr.join("") : "";
	            if (pos > -1) {
	                if (ndxIntlzr === undefined) {
	                    for (var test, previousPos = pos - 1; (test = getMaskSet().validPositions[previousPos] || getMaskSet().tests[previousPos]) === undefined && previousPos > -1; ) previousPos--;
	                    test !== undefined && previousPos > -1 && (ndxInitializer = function(tests) {
	                        var locator = [];
	                        return $.isArray(tests) || (tests = [ tests ]), tests.length > 0 && (tests[0].alternation === undefined ? (locator = determineTestTemplate(tests.slice()).locator.slice(), 
	                        0 === locator.length && (locator = tests[0].locator.slice())) : $.each(tests, function(ndx, tst) {
	                            if ("" !== tst.def) if (0 === locator.length) locator = tst.locator.slice(); else for (var i = 0; i < locator.length; i++) tst.locator[i] && -1 === locator[i].toString().indexOf(tst.locator[i]) && (locator[i] += "," + tst.locator[i]);
	                        })), locator;
	                    }(test), cacheDependency = ndxInitializer.join(""), testPos = previousPos);
	                }
	                if (getMaskSet().tests[pos] && getMaskSet().tests[pos][0].cd === cacheDependency) return filterTests(getMaskSet().tests[pos]);
	                for (var mtndx = ndxInitializer.shift(); mtndx < maskTokens.length; mtndx++) {
	                    if (resolveTestFromToken(maskTokens[mtndx], ndxInitializer, [ mtndx ]) && testPos === pos || testPos > pos) break;
	                }
	            }
	            return (0 === matches.length || insertStop) && matches.push({
	                match: {
	                    fn: null,
	                    cardinality: 0,
	                    optionality: !0,
	                    casing: null,
	                    def: "",
	                    placeholder: ""
	                },
	                locator: [],
	                cd: cacheDependency
	            }), ndxIntlzr !== undefined && getMaskSet().tests[pos] ? filterTests($.extend(!0, [], matches)) : (getMaskSet().tests[pos] = $.extend(!0, [], matches), 
	            filterTests(getMaskSet().tests[pos]));
	        }
	        function getBufferTemplate() {
	            return getMaskSet()._buffer === undefined && (getMaskSet()._buffer = getMaskTemplate(!1, 1), 
	            getMaskSet().buffer === undefined && (getMaskSet().buffer = getMaskSet()._buffer.slice())), 
	            getMaskSet()._buffer;
	        }
	        function getBuffer(noCache) {
	            return getMaskSet().buffer !== undefined && !0 !== noCache || (getMaskSet().buffer = getMaskTemplate(!0, getLastValidPosition(), !0)), 
	            getMaskSet().buffer;
	        }
	        function refreshFromBuffer(start, end, buffer) {
	            var i, p;
	            if (!0 === start) resetMaskSet(), start = 0, end = buffer.length; else for (i = start; i < end; i++) delete getMaskSet().validPositions[i];
	            for (p = start, i = start; i < end; i++) if (resetMaskSet(!0), buffer[i] !== opts.skipOptionalPartCharacter) {
	                var valResult = isValid(p, buffer[i], !0, !0);
	                !1 !== valResult && (resetMaskSet(!0), p = valResult.caret !== undefined ? valResult.caret : valResult.pos + 1);
	            }
	        }
	        function casing(elem, test, pos) {
	            switch (opts.casing || test.casing) {
	              case "upper":
	                elem = elem.toUpperCase();
	                break;
	
	              case "lower":
	                elem = elem.toLowerCase();
	                break;
	
	              case "title":
	                var posBefore = getMaskSet().validPositions[pos - 1];
	                elem = 0 === pos || posBefore && posBefore.input === String.fromCharCode(Inputmask.keyCode.SPACE) ? elem.toUpperCase() : elem.toLowerCase();
	                break;
	
	              default:
	                if ($.isFunction(opts.casing)) {
	                    var args = Array.prototype.slice.call(arguments);
	                    args.push(getMaskSet().validPositions), elem = opts.casing.apply(this, args);
	                }
	            }
	            return elem;
	        }
	        function checkAlternationMatch(altArr1, altArr2, na) {
	            for (var naNdx, altArrC = opts.greedy ? altArr2 : altArr2.slice(0, 1), isMatch = !1, naArr = na !== undefined ? na.split(",") : [], i = 0; i < naArr.length; i++) -1 !== (naNdx = altArr1.indexOf(naArr[i])) && altArr1.splice(naNdx, 1);
	            for (var alndx = 0; alndx < altArr1.length; alndx++) if (-1 !== $.inArray(altArr1[alndx], altArrC)) {
	                isMatch = !0;
	                break;
	            }
	            return isMatch;
	        }
	        function isValid(pos, c, strict, fromSetValid, fromAlternate) {
	            function isSelection(posObj) {
	                var selection = isRTL ? posObj.begin - posObj.end > 1 || posObj.begin - posObj.end == 1 : posObj.end - posObj.begin > 1 || posObj.end - posObj.begin == 1;
	                return selection && 0 === posObj.begin && posObj.end === getMaskSet().maskLength ? "full" : selection;
	            }
	            function _isValid(position, c, strict) {
	                var rslt = !1;
	                return $.each(getTests(position), function(ndx, tst) {
	                    for (var test = tst.match, loopend = c ? 1 : 0, chrs = "", i = test.cardinality; i > loopend; i--) chrs += getBufferElement(position - (i - 1));
	                    if (c && (chrs += c), getBuffer(!0), !1 !== (rslt = null != test.fn ? test.fn.test(chrs, getMaskSet(), position, strict, opts, isSelection(pos)) : (c === test.def || c === opts.skipOptionalPartCharacter) && "" !== test.def && {
	                        c: getPlaceholder(position, test, !0) || test.def,
	                        pos: position
	                    })) {
	                        var elem = rslt.c !== undefined ? rslt.c : c;
	                        elem = elem === opts.skipOptionalPartCharacter && null === test.fn ? getPlaceholder(position, test, !0) || test.def : elem;
	                        var validatedPos = position, possibleModifiedBuffer = getBuffer();
	                        if (rslt.remove !== undefined && ($.isArray(rslt.remove) || (rslt.remove = [ rslt.remove ]), 
	                        $.each(rslt.remove.sort(function(a, b) {
	                            return b - a;
	                        }), function(ndx, lmnt) {
	                            stripValidPositions(lmnt, lmnt + 1, !0);
	                        })), rslt.insert !== undefined && ($.isArray(rslt.insert) || (rslt.insert = [ rslt.insert ]), 
	                        $.each(rslt.insert.sort(function(a, b) {
	                            return a - b;
	                        }), function(ndx, lmnt) {
	                            isValid(lmnt.pos, lmnt.c, !0, fromSetValid);
	                        })), rslt.refreshFromBuffer) {
	                            var refresh = rslt.refreshFromBuffer;
	                            if (refreshFromBuffer(!0 === refresh ? refresh : refresh.start, refresh.end, possibleModifiedBuffer), 
	                            rslt.pos === undefined && rslt.c === undefined) return rslt.pos = getLastValidPosition(), 
	                            !1;
	                            if ((validatedPos = rslt.pos !== undefined ? rslt.pos : position) !== position) return rslt = $.extend(rslt, isValid(validatedPos, elem, !0, fromSetValid)), 
	                            !1;
	                        } else if (!0 !== rslt && rslt.pos !== undefined && rslt.pos !== position && (validatedPos = rslt.pos, 
	                        refreshFromBuffer(position, validatedPos, getBuffer().slice()), validatedPos !== position)) return rslt = $.extend(rslt, isValid(validatedPos, elem, !0)), 
	                        !1;
	                        return (!0 === rslt || rslt.pos !== undefined || rslt.c !== undefined) && (ndx > 0 && resetMaskSet(!0), 
	                        setValidPosition(validatedPos, $.extend({}, tst, {
	                            input: casing(elem, test, validatedPos)
	                        }), fromSetValid, isSelection(pos)) || (rslt = !1), !1);
	                    }
	                }), rslt;
	            }
	            function setValidPosition(pos, validTest, fromSetValid, isSelection) {
	                if (isSelection || opts.insertMode && getMaskSet().validPositions[pos] !== undefined && fromSetValid === undefined) {
	                    var i, positionsClone = $.extend(!0, {}, getMaskSet().validPositions), lvp = getLastValidPosition(undefined, !0);
	                    for (i = pos; i <= lvp; i++) delete getMaskSet().validPositions[i];
	                    getMaskSet().validPositions[pos] = $.extend(!0, {}, validTest);
	                    var j, valid = !0, vps = getMaskSet().validPositions, needsValidation = !1, initialLength = getMaskSet().maskLength;
	                    for (i = j = pos; i <= lvp; i++) {
	                        var t = positionsClone[i];
	                        if (t !== undefined) for (var posMatch = j; posMatch < getMaskSet().maskLength && (null === t.match.fn && vps[i] && (!0 === vps[i].match.optionalQuantifier || !0 === vps[i].match.optionality) || null != t.match.fn); ) {
	                            if (posMatch++, !1 === needsValidation && positionsClone[posMatch] && positionsClone[posMatch].match.def === t.match.def) getMaskSet().validPositions[posMatch] = $.extend(!0, {}, positionsClone[posMatch]), 
	                            getMaskSet().validPositions[posMatch].input = t.input, fillMissingNonMask(posMatch), 
	                            j = posMatch, valid = !0; else if (positionCanMatchDefinition(posMatch, t.match.def)) {
	                                var result = isValid(posMatch, t.input, !0, !0);
	                                valid = !1 !== result, j = result.caret || result.insert ? getLastValidPosition() : posMatch, 
	                                needsValidation = !0;
	                            } else if (!(valid = !0 === t.generatedInput) && posMatch >= getMaskSet().maskLength - 1) break;
	                            if (getMaskSet().maskLength < initialLength && (getMaskSet().maskLength = initialLength), 
	                            valid) break;
	                        }
	                        if (!valid) break;
	                    }
	                    if (!valid) return getMaskSet().validPositions = $.extend(!0, {}, positionsClone), 
	                    resetMaskSet(!0), !1;
	                } else getMaskSet().validPositions[pos] = $.extend(!0, {}, validTest);
	                return resetMaskSet(!0), !0;
	            }
	            function fillMissingNonMask(maskPos) {
	                for (var pndx = maskPos - 1; pndx > -1 && !getMaskSet().validPositions[pndx]; pndx--) ;
	                var testTemplate, testsFromPos;
	                for (pndx++; pndx < maskPos; pndx++) getMaskSet().validPositions[pndx] === undefined && (!1 === opts.jitMasking || opts.jitMasking > pndx) && (testsFromPos = getTests(pndx, getTestTemplate(pndx - 1).locator, pndx - 1).slice(), 
	                "" === testsFromPos[testsFromPos.length - 1].match.def && testsFromPos.pop(), (testTemplate = determineTestTemplate(testsFromPos)) && (testTemplate.match.def === opts.radixPointDefinitionSymbol || !isMask(pndx, !0) || $.inArray(opts.radixPoint, getBuffer()) < pndx && testTemplate.match.fn && testTemplate.match.fn.test(getPlaceholder(pndx), getMaskSet(), pndx, !1, opts)) && !1 !== (result = _isValid(pndx, getPlaceholder(pndx, testTemplate.match, !0) || (null == testTemplate.match.fn ? testTemplate.match.def : "" !== getPlaceholder(pndx) ? getPlaceholder(pndx) : getBuffer()[pndx]), !0)) && (getMaskSet().validPositions[result.pos || pndx].generatedInput = !0));
	            }
	            strict = !0 === strict;
	            var maskPos = pos;
	            pos.begin !== undefined && (maskPos = isRTL && !isSelection(pos) ? pos.end : pos.begin);
	            var result = !0, positionsClone = $.extend(!0, {}, getMaskSet().validPositions);
	            if ($.isFunction(opts.preValidation) && !strict && !0 !== fromSetValid && (result = opts.preValidation(getBuffer(), maskPos, c, isSelection(pos), opts)), 
	            !0 === result) {
	                if (fillMissingNonMask(maskPos), isSelection(pos) && (handleRemove(undefined, Inputmask.keyCode.DELETE, pos, !0), 
	                maskPos = getMaskSet().p), maskPos < getMaskSet().maskLength && (maxLength === undefined || maskPos < maxLength) && (result = _isValid(maskPos, c, strict), 
	                (!strict || !0 === fromSetValid) && !1 === result)) {
	                    var currentPosValid = getMaskSet().validPositions[maskPos];
	                    if (!currentPosValid || null !== currentPosValid.match.fn || currentPosValid.match.def !== c && c !== opts.skipOptionalPartCharacter) {
	                        if ((opts.insertMode || getMaskSet().validPositions[seekNext(maskPos)] === undefined) && !isMask(maskPos, !0)) for (var nPos = maskPos + 1, snPos = seekNext(maskPos); nPos <= snPos; nPos++) if (!1 !== (result = _isValid(nPos, c, strict))) {
	                            !function(originalPos, newPos) {
	                                var vp = getMaskSet().validPositions[newPos];
	                                if (vp) for (var targetLocator = vp.locator, tll = targetLocator.length, ps = originalPos; ps < newPos; ps++) if (getMaskSet().validPositions[ps] === undefined && !isMask(ps, !0)) {
	                                    var tests = getTests(ps).slice(), bestMatch = determineTestTemplate(tests, !0), equality = -1;
	                                    "" === tests[tests.length - 1].match.def && tests.pop(), $.each(tests, function(ndx, tst) {
	                                        for (var i = 0; i < tll; i++) {
	                                            if (tst.locator[i] === undefined || !checkAlternationMatch(tst.locator[i].toString().split(","), targetLocator[i].toString().split(","), tst.na)) {
	                                                var targetAI = targetLocator[i], bestMatchAI = bestMatch.locator[i], tstAI = tst.locator[i];
	                                                targetAI - bestMatchAI > Math.abs(targetAI - tstAI) && (bestMatch = tst);
	                                                break;
	                                            }
	                                            equality < i && (equality = i, bestMatch = tst);
	                                        }
	                                    }), bestMatch = $.extend({}, bestMatch, {
	                                        input: getPlaceholder(ps, bestMatch.match, !0) || bestMatch.match.def
	                                    }), bestMatch.generatedInput = !0, setValidPosition(ps, bestMatch, !0), getMaskSet().validPositions[newPos] = undefined, 
	                                    _isValid(newPos, vp.input, !0);
	                                }
	                            }(maskPos, result.pos !== undefined ? result.pos : nPos), maskPos = nPos;
	                            break;
	                        }
	                    } else result = {
	                        caret: seekNext(maskPos)
	                    };
	                }
	                !1 === result && opts.keepStatic && !strict && !0 !== fromAlternate && (result = function(pos, c, strict) {
	                    var lastAlt, alternation, altPos, prevAltPos, i, validPos, altNdxs, decisionPos, validPsClone = $.extend(!0, {}, getMaskSet().validPositions), isValidRslt = !1, lAltPos = getLastValidPosition();
	                    for (prevAltPos = getMaskSet().validPositions[lAltPos]; lAltPos >= 0; lAltPos--) if ((altPos = getMaskSet().validPositions[lAltPos]) && altPos.alternation !== undefined) {
	                        if (lastAlt = lAltPos, alternation = getMaskSet().validPositions[lastAlt].alternation, 
	                        prevAltPos.locator[altPos.alternation] !== altPos.locator[altPos.alternation]) break;
	                        prevAltPos = altPos;
	                    }
	                    if (alternation !== undefined) {
	                        decisionPos = parseInt(lastAlt);
	                        var decisionTaker = prevAltPos.locator[prevAltPos.alternation || alternation] !== undefined ? prevAltPos.locator[prevAltPos.alternation || alternation] : altNdxs[0];
	                        decisionTaker.length > 0 && (decisionTaker = decisionTaker.split(",")[0]);
	                        var possibilityPos = getMaskSet().validPositions[decisionPos], prevPos = getMaskSet().validPositions[decisionPos - 1];
	                        $.each(getTests(decisionPos, prevPos ? prevPos.locator : undefined, decisionPos - 1), function(ndx, test) {
	                            altNdxs = test.locator[alternation] ? test.locator[alternation].toString().split(",") : [];
	                            for (var mndx = 0; mndx < altNdxs.length; mndx++) {
	                                var validInputs = [], staticInputsBeforePos = 0, staticInputsBeforePosAlternate = 0, verifyValidInput = !1;
	                                if (decisionTaker < altNdxs[mndx] && (test.na === undefined || -1 === $.inArray(altNdxs[mndx], test.na.split(",")) || -1 === $.inArray(decisionTaker.toString(), altNdxs))) {
	                                    getMaskSet().validPositions[decisionPos] = $.extend(!0, {}, test);
	                                    var possibilities = getMaskSet().validPositions[decisionPos].locator;
	                                    for (getMaskSet().validPositions[decisionPos].locator[alternation] = parseInt(altNdxs[mndx]), 
	                                    null == test.match.fn ? (possibilityPos.input !== test.match.def && (verifyValidInput = !0, 
	                                    !0 !== possibilityPos.generatedInput && validInputs.push(possibilityPos.input)), 
	                                    staticInputsBeforePosAlternate++, getMaskSet().validPositions[decisionPos].generatedInput = !/[0-9a-bA-Z]/.test(test.match.def), 
	                                    getMaskSet().validPositions[decisionPos].input = test.match.def) : getMaskSet().validPositions[decisionPos].input = possibilityPos.input, 
	                                    i = decisionPos + 1; i < getLastValidPosition(undefined, !0) + 1; i++) validPos = getMaskSet().validPositions[i], 
	                                    validPos && !0 !== validPos.generatedInput && /[0-9a-bA-Z]/.test(validPos.input) ? validInputs.push(validPos.input) : i < pos && staticInputsBeforePos++, 
	                                    delete getMaskSet().validPositions[i];
	                                    for (verifyValidInput && validInputs[0] === test.match.def && validInputs.shift(), 
	                                    resetMaskSet(!0), isValidRslt = !0; validInputs.length > 0; ) {
	                                        var input = validInputs.shift();
	                                        if (input !== opts.skipOptionalPartCharacter && !(isValidRslt = isValid(getLastValidPosition(undefined, !0) + 1, input, !1, fromSetValid, !0))) break;
	                                    }
	                                    if (isValidRslt) {
	                                        getMaskSet().validPositions[decisionPos].locator = possibilities;
	                                        var targetLvp = getLastValidPosition(pos) + 1;
	                                        for (i = decisionPos + 1; i < getLastValidPosition() + 1; i++) ((validPos = getMaskSet().validPositions[i]) === undefined || null == validPos.match.fn) && i < pos + (staticInputsBeforePosAlternate - staticInputsBeforePos) && staticInputsBeforePosAlternate++;
	                                        pos += staticInputsBeforePosAlternate - staticInputsBeforePos, isValidRslt = isValid(pos > targetLvp ? targetLvp : pos, c, strict, fromSetValid, !0);
	                                    }
	                                    if (isValidRslt) return !1;
	                                    resetMaskSet(), getMaskSet().validPositions = $.extend(!0, {}, validPsClone);
	                                }
	                            }
	                        });
	                    }
	                    return isValidRslt;
	                }(maskPos, c, strict)), !0 === result && (result = {
	                    pos: maskPos
	                });
	            }
	            if ($.isFunction(opts.postValidation) && !1 !== result && !strict && !0 !== fromSetValid) {
	                var postResult = opts.postValidation(getBuffer(!0), result, opts);
	                if (postResult.refreshFromBuffer && postResult.buffer) {
	                    var refresh = postResult.refreshFromBuffer;
	                    refreshFromBuffer(!0 === refresh ? refresh : refresh.start, refresh.end, postResult.buffer);
	                }
	                result = !0 === postResult ? result : postResult;
	            }
	            return result && result.pos === undefined && (result.pos = maskPos), !1 === result && (resetMaskSet(!0), 
	            getMaskSet().validPositions = $.extend(!0, {}, positionsClone)), result;
	        }
	        function isMask(pos, strict) {
	            var test = getTestTemplate(pos).match;
	            if ("" === test.def && (test = getTest(pos).match), null != test.fn) return test.fn;
	            if (!0 !== strict && pos > -1) {
	                var tests = getTests(pos);
	                return tests.length > 1 + ("" === tests[tests.length - 1].match.def ? 1 : 0);
	            }
	            return !1;
	        }
	        function seekNext(pos, newBlock) {
	            var maskL = getMaskSet().maskLength;
	            if (pos >= maskL) return maskL;
	            var position = pos;
	            for (getTests(maskL + 1).length > 1 && (getMaskTemplate(!0, maskL + 1, !0), maskL = getMaskSet().maskLength); ++position < maskL && (!0 === newBlock && (!0 !== getTest(position).match.newBlockMarker || !isMask(position)) || !0 !== newBlock && !isMask(position)); ) ;
	            return position;
	        }
	        function seekPrevious(pos, newBlock) {
	            var tests, position = pos;
	            if (position <= 0) return 0;
	            for (;--position > 0 && (!0 === newBlock && !0 !== getTest(position).match.newBlockMarker || !0 !== newBlock && !isMask(position) && (tests = getTests(position), 
	            tests.length < 2 || 2 === tests.length && "" === tests[1].match.def)); ) ;
	            return position;
	        }
	        function getBufferElement(position) {
	            return getMaskSet().validPositions[position] === undefined ? getPlaceholder(position) : getMaskSet().validPositions[position].input;
	        }
	        function writeBuffer(input, buffer, caretPos, event, triggerInputEvent) {
	            if (event && $.isFunction(opts.onBeforeWrite)) {
	                var result = opts.onBeforeWrite(event, buffer, caretPos, opts);
	                if (result) {
	                    if (result.refreshFromBuffer) {
	                        var refresh = result.refreshFromBuffer;
	                        refreshFromBuffer(!0 === refresh ? refresh : refresh.start, refresh.end, result.buffer || buffer), 
	                        buffer = getBuffer(!0);
	                    }
	                    caretPos !== undefined && (caretPos = result.caret !== undefined ? result.caret : caretPos);
	                }
	            }
	            input !== undefined && (input.inputmask._valueSet(buffer.join("")), caretPos === undefined || event !== undefined && "blur" === event.type ? renderColorMask(input, buffer, caretPos) : android && "input" === event.type ? setTimeout(function() {
	                caret(input, caretPos);
	            }, 0) : caret(input, caretPos), !0 === triggerInputEvent && (skipInputEvent = !0, 
	            $(input).trigger("input")));
	        }
	        function getPlaceholder(pos, test, returnPL) {
	            if (test = test || getTest(pos).match, test.placeholder !== undefined || !0 === returnPL) return $.isFunction(test.placeholder) ? test.placeholder(opts) : test.placeholder;
	            if (null === test.fn) {
	                if (pos > -1 && getMaskSet().validPositions[pos] === undefined) {
	                    var prevTest, tests = getTests(pos), staticAlternations = [];
	                    if (tests.length > 1 + ("" === tests[tests.length - 1].match.def ? 1 : 0)) for (var i = 0; i < tests.length; i++) if (!0 !== tests[i].match.optionality && !0 !== tests[i].match.optionalQuantifier && (null === tests[i].match.fn || prevTest === undefined || !1 !== tests[i].match.fn.test(prevTest.match.def, getMaskSet(), pos, !0, opts)) && (staticAlternations.push(tests[i]), 
	                    null === tests[i].match.fn && (prevTest = tests[i]), staticAlternations.length > 1 && /[0-9a-bA-Z]/.test(staticAlternations[0].match.def))) return opts.placeholder.charAt(pos % opts.placeholder.length);
	                }
	                return test.def;
	            }
	            return opts.placeholder.charAt(pos % opts.placeholder.length);
	        }
	        function checkVal(input, writeOut, strict, nptvl, initiatingEvent) {
	            function isTemplateMatch(ndx, charCodes) {
	                return -1 !== getBufferTemplate().slice(ndx, seekNext(ndx)).join("").indexOf(charCodes) && !isMask(ndx) && getTest(ndx).match.nativeDef === charCodes.charAt(charCodes.length - 1);
	            }
	            var inputValue = nptvl.slice(), charCodes = "", initialNdx = 0, result = undefined;
	            if (resetMaskSet(), getMaskSet().p = seekNext(-1), !strict) if (!0 !== opts.autoUnmask) {
	                var staticInput = getBufferTemplate().slice(0, seekNext(-1)).join(""), matches = inputValue.join("").match(new RegExp("^" + Inputmask.escapeRegex(staticInput), "g"));
	                matches && matches.length > 0 && (inputValue.splice(0, matches.length * staticInput.length), 
	                initialNdx = seekNext(initialNdx));
	            } else initialNdx = seekNext(initialNdx);
	            if ($.each(inputValue, function(ndx, charCode) {
	                if (charCode !== undefined) {
	                    var keypress = new $.Event("_checkval");
	                    keypress.which = charCode.charCodeAt(0), charCodes += charCode;
	                    var lvp = getLastValidPosition(undefined, !0), lvTest = getMaskSet().validPositions[lvp], nextTest = getTestTemplate(lvp + 1, lvTest ? lvTest.locator.slice() : undefined, lvp);
	                    if (!isTemplateMatch(initialNdx, charCodes) || strict || opts.autoUnmask) {
	                        var pos = strict ? ndx : null == nextTest.match.fn && nextTest.match.optionality && lvp + 1 < getMaskSet().p ? lvp + 1 : getMaskSet().p;
	                        result = EventHandlers.keypressEvent.call(input, keypress, !0, !1, strict, pos), 
	                        initialNdx = pos + 1, charCodes = "";
	                    } else result = EventHandlers.keypressEvent.call(input, keypress, !0, !1, !0, lvp + 1);
	                    if (!1 !== result && !strict && $.isFunction(opts.onBeforeWrite)) {
	                        var fp = result.forwardPosition;
	                        if (result = opts.onBeforeWrite(keypress, getBuffer(), result.forwardPosition, opts), 
	                        result.forwardPosition = fp, result && result.refreshFromBuffer) {
	                            var refresh = result.refreshFromBuffer;
	                            refreshFromBuffer(!0 === refresh ? refresh : refresh.start, refresh.end, result.buffer), 
	                            resetMaskSet(!0), result.caret && (getMaskSet().p = result.caret, result.forwardPosition = result.caret);
	                        }
	                    }
	                }
	            }), writeOut) {
	                var caretPos = undefined;
	                document.activeElement === input && result && (caretPos = opts.numericInput ? seekPrevious(result.forwardPosition) : result.forwardPosition), 
	                writeBuffer(input, getBuffer(), caretPos, initiatingEvent || new $.Event("checkval"), initiatingEvent && "input" === initiatingEvent.type);
	            }
	        }
	        function unmaskedvalue(input) {
	            if (input) {
	                if (input.inputmask === undefined) return input.value;
	                input.inputmask && input.inputmask.refreshValue && EventHandlers.setValueEvent.call(input);
	            }
	            var umValue = [], vps = getMaskSet().validPositions;
	            for (var pndx in vps) vps[pndx].match && null != vps[pndx].match.fn && umValue.push(vps[pndx].input);
	            var unmaskedValue = 0 === umValue.length ? "" : (isRTL ? umValue.reverse() : umValue).join("");
	            if ($.isFunction(opts.onUnMask)) {
	                var bufferValue = (isRTL ? getBuffer().slice().reverse() : getBuffer()).join("");
	                unmaskedValue = opts.onUnMask(bufferValue, unmaskedValue, opts);
	            }
	            return unmaskedValue;
	        }
	        function caret(input, begin, end, notranslate) {
	            function translatePosition(pos) {
	                if (!0 !== notranslate && isRTL && "number" == typeof pos && (!opts.greedy || "" !== opts.placeholder)) {
	                    pos = getBuffer().join("").length - pos;
	                }
	                return pos;
	            }
	            var range;
	            if (begin === undefined) return input.setSelectionRange ? (begin = input.selectionStart, 
	            end = input.selectionEnd) : window.getSelection ? (range = window.getSelection().getRangeAt(0), 
	            range.commonAncestorContainer.parentNode !== input && range.commonAncestorContainer !== input || (begin = range.startOffset, 
	            end = range.endOffset)) : document.selection && document.selection.createRange && (range = document.selection.createRange(), 
	            begin = 0 - range.duplicate().moveStart("character", -input.inputmask._valueGet().length), 
	            end = begin + range.text.length), {
	                begin: translatePosition(begin),
	                end: translatePosition(end)
	            };
	            if (begin.begin !== undefined && (end = begin.end, begin = begin.begin), "number" == typeof begin) {
	                begin = translatePosition(begin), end = translatePosition(end), end = "number" == typeof end ? end : begin;
	                var scrollCalc = parseInt(((input.ownerDocument.defaultView || window).getComputedStyle ? (input.ownerDocument.defaultView || window).getComputedStyle(input, null) : input.currentStyle).fontSize) * end;
	                if (input.scrollLeft = scrollCalc > input.scrollWidth ? scrollCalc : 0, mobile || !1 !== opts.insertMode || begin !== end || end++, 
	                input.setSelectionRange) input.selectionStart = begin, input.selectionEnd = end; else if (window.getSelection) {
	                    if (range = document.createRange(), input.firstChild === undefined || null === input.firstChild) {
	                        var textNode = document.createTextNode("");
	                        input.appendChild(textNode);
	                    }
	                    range.setStart(input.firstChild, begin < input.inputmask._valueGet().length ? begin : input.inputmask._valueGet().length), 
	                    range.setEnd(input.firstChild, end < input.inputmask._valueGet().length ? end : input.inputmask._valueGet().length), 
	                    range.collapse(!0);
	                    var sel = window.getSelection();
	                    sel.removeAllRanges(), sel.addRange(range);
	                } else input.createTextRange && (range = input.createTextRange(), range.collapse(!0), 
	                range.moveEnd("character", end), range.moveStart("character", begin), range.select());
	                renderColorMask(input, undefined, {
	                    begin: begin,
	                    end: end
	                });
	            }
	        }
	        function determineLastRequiredPosition(returnDefinition) {
	            var pos, testPos, buffer = getBuffer(), bl = buffer.length, lvp = getLastValidPosition(), positions = {}, lvTest = getMaskSet().validPositions[lvp], ndxIntlzr = lvTest !== undefined ? lvTest.locator.slice() : undefined;
	            for (pos = lvp + 1; pos < buffer.length; pos++) testPos = getTestTemplate(pos, ndxIntlzr, pos - 1), 
	            ndxIntlzr = testPos.locator.slice(), positions[pos] = $.extend(!0, {}, testPos);
	            var lvTestAlt = lvTest && lvTest.alternation !== undefined ? lvTest.locator[lvTest.alternation] : undefined;
	            for (pos = bl - 1; pos > lvp && (testPos = positions[pos], (testPos.match.optionality || testPos.match.optionalQuantifier && testPos.match.newBlockMarker || lvTestAlt && (lvTestAlt !== positions[pos].locator[lvTest.alternation] && null != testPos.match.fn || null === testPos.match.fn && testPos.locator[lvTest.alternation] && checkAlternationMatch(testPos.locator[lvTest.alternation].toString().split(","), lvTestAlt.toString().split(",")) && "" !== getTests(pos)[0].def)) && buffer[pos] === getPlaceholder(pos, testPos.match)); pos--) bl--;
	            return returnDefinition ? {
	                l: bl,
	                def: positions[bl] ? positions[bl].match : undefined
	            } : bl;
	        }
	        function clearOptionalTail(buffer) {
	            for (var validPos, rl = determineLastRequiredPosition(), bl = buffer.length, lv = getMaskSet().validPositions[getLastValidPosition()]; rl < bl && !isMask(rl, !0) && (validPos = lv !== undefined ? getTestTemplate(rl, lv.locator.slice(""), lv) : getTest(rl)) && !0 !== validPos.match.optionality && (!0 !== validPos.match.optionalQuantifier && !0 !== validPos.match.newBlockMarker || rl + 1 === bl && "" === (lv !== undefined ? getTestTemplate(rl + 1, lv.locator.slice(""), lv) : getTest(rl + 1)).match.def); ) rl++;
	            for (;(validPos = getMaskSet().validPositions[rl - 1]) && validPos && validPos.match.optionality && validPos.input === opts.skipOptionalPartCharacter; ) rl--;
	            return buffer.splice(rl), buffer;
	        }
	        function isComplete(buffer) {
	            if ($.isFunction(opts.isComplete)) return opts.isComplete(buffer, opts);
	            if ("*" === opts.repeat) return undefined;
	            var complete = !1, lrp = determineLastRequiredPosition(!0), aml = seekPrevious(lrp.l);
	            if (lrp.def === undefined || lrp.def.newBlockMarker || lrp.def.optionality || lrp.def.optionalQuantifier) {
	                complete = !0;
	                for (var i = 0; i <= aml; i++) {
	                    var test = getTestTemplate(i).match;
	                    if (null !== test.fn && getMaskSet().validPositions[i] === undefined && !0 !== test.optionality && !0 !== test.optionalQuantifier || null === test.fn && buffer[i] !== getPlaceholder(i, test)) {
	                        complete = !1;
	                        break;
	                    }
	                }
	            }
	            return complete;
	        }
	        function handleRemove(input, k, pos, strict, fromIsValid) {
	            if ((opts.numericInput || isRTL) && (k === Inputmask.keyCode.BACKSPACE ? k = Inputmask.keyCode.DELETE : k === Inputmask.keyCode.DELETE && (k = Inputmask.keyCode.BACKSPACE), 
	            isRTL)) {
	                var pend = pos.end;
	                pos.end = pos.begin, pos.begin = pend;
	            }
	            k === Inputmask.keyCode.BACKSPACE && (pos.end - pos.begin < 1 || !1 === opts.insertMode) ? (pos.begin = seekPrevious(pos.begin), 
	            getMaskSet().validPositions[pos.begin] !== undefined && getMaskSet().validPositions[pos.begin].input === opts.groupSeparator && pos.begin--) : k === Inputmask.keyCode.DELETE && pos.begin === pos.end && (pos.end = isMask(pos.end, !0) && getMaskSet().validPositions[pos.end] && getMaskSet().validPositions[pos.end].input !== opts.radixPoint ? pos.end + 1 : seekNext(pos.end) + 1, 
	            getMaskSet().validPositions[pos.begin] !== undefined && getMaskSet().validPositions[pos.begin].input === opts.groupSeparator && pos.end++), 
	            stripValidPositions(pos.begin, pos.end, !1, strict), !0 !== strict && function() {
	                if (opts.keepStatic) {
	                    for (var validInputs = [], lastAlt = getLastValidPosition(-1, !0), positionsClone = $.extend(!0, {}, getMaskSet().validPositions), prevAltPos = getMaskSet().validPositions[lastAlt]; lastAlt >= 0; lastAlt--) {
	                        var altPos = getMaskSet().validPositions[lastAlt];
	                        if (altPos) {
	                            if (!0 !== altPos.generatedInput && /[0-9a-bA-Z]/.test(altPos.input) && validInputs.push(altPos.input), 
	                            delete getMaskSet().validPositions[lastAlt], altPos.alternation !== undefined && altPos.locator[altPos.alternation] !== prevAltPos.locator[altPos.alternation]) break;
	                            prevAltPos = altPos;
	                        }
	                    }
	                    if (lastAlt > -1) for (getMaskSet().p = seekNext(getLastValidPosition(-1, !0)); validInputs.length > 0; ) {
	                        var keypress = new $.Event("keypress");
	                        keypress.which = validInputs.pop().charCodeAt(0), EventHandlers.keypressEvent.call(input, keypress, !0, !1, !1, getMaskSet().p);
	                    } else getMaskSet().validPositions = $.extend(!0, {}, positionsClone);
	                }
	            }();
	            var lvp = getLastValidPosition(pos.begin, !0);
	            if (lvp < pos.begin) getMaskSet().p = seekNext(lvp); else if (!0 !== strict && (getMaskSet().p = pos.begin, 
	            !0 !== fromIsValid)) for (;getMaskSet().p < lvp && getMaskSet().validPositions[getMaskSet().p] === undefined; ) getMaskSet().p++;
	        }
	        function initializeColorMask(input) {
	            function findCaretPos(clientx) {
	                var caretPos, e = document.createElement("span");
	                for (var style in computedStyle) isNaN(style) && -1 !== style.indexOf("font") && (e.style[style] = computedStyle[style]);
	                e.style.textTransform = computedStyle.textTransform, e.style.letterSpacing = computedStyle.letterSpacing, 
	                e.style.position = "absolute", e.style.height = "auto", e.style.width = "auto", 
	                e.style.visibility = "hidden", e.style.whiteSpace = "nowrap", document.body.appendChild(e);
	                var itl, inputText = input.inputmask._valueGet(), previousWidth = 0;
	                for (caretPos = 0, itl = inputText.length; caretPos <= itl; caretPos++) {
	                    if (e.innerHTML += inputText.charAt(caretPos) || "_", e.offsetWidth >= clientx) {
	                        var offset1 = clientx - previousWidth, offset2 = e.offsetWidth - clientx;
	                        e.innerHTML = inputText.charAt(caretPos), offset1 -= e.offsetWidth / 3, caretPos = offset1 < offset2 ? caretPos - 1 : caretPos;
	                        break;
	                    }
	                    previousWidth = e.offsetWidth;
	                }
	                return document.body.removeChild(e), caretPos;
	            }
	            function position() {
	                colorMask.style.position = "absolute", colorMask.style.top = offset.top + "px", 
	                colorMask.style.left = offset.left + "px", colorMask.style.width = parseInt(input.offsetWidth) - parseInt(computedStyle.paddingLeft) - parseInt(computedStyle.paddingRight) - parseInt(computedStyle.borderLeftWidth) - parseInt(computedStyle.borderRightWidth) + "px", 
	                colorMask.style.height = parseInt(input.offsetHeight) - parseInt(computedStyle.paddingTop) - parseInt(computedStyle.paddingBottom) - parseInt(computedStyle.borderTopWidth) - parseInt(computedStyle.borderBottomWidth) + "px", 
	                colorMask.style.lineHeight = colorMask.style.height, colorMask.style.zIndex = isNaN(computedStyle.zIndex) ? -1 : computedStyle.zIndex - 1, 
	                colorMask.style.webkitAppearance = "textfield", colorMask.style.mozAppearance = "textfield", 
	                colorMask.style.Appearance = "textfield";
	            }
	            var offset = $(input).position(), computedStyle = (input.ownerDocument.defaultView || window).getComputedStyle(input, null);
	            colorMask = document.createElement("div"), document.body.appendChild(colorMask);
	            for (var style in computedStyle) computedStyle.hasOwnProperty(style) && isNaN(style) && "cssText" !== style && -1 == style.indexOf("webkit") && (colorMask.style[style] = computedStyle[style]);
	            input.style.backgroundColor = "transparent", input.style.color = "transparent", 
	            input.style.webkitAppearance = "caret", input.style.mozAppearance = "caret", input.style.Appearance = "caret", 
	            position(), $(window).on("resize", function(e) {
	                offset = $(input).position(), computedStyle = (input.ownerDocument.defaultView || window).getComputedStyle(input, null), 
	                position();
	            }), $(input).on("click", function(e) {
	                return caret(input, findCaretPos(e.clientX)), EventHandlers.clickEvent.call(this, [ e ]);
	            }), $(input).on("keydown", function(e) {
	                e.shiftKey || !1 === opts.insertMode || setTimeout(function() {
	                    renderColorMask(input);
	                }, 0);
	            });
	        }
	        function renderColorMask(input, buffer, caretPos) {
	            function handleStatic() {
	                isStatic || null !== test.fn && testPos.input !== undefined ? isStatic && null !== test.fn && testPos.input !== undefined && (isStatic = !1, 
	                maskTemplate += "</span>") : (isStatic = !0, maskTemplate += "<span class='im-static''>");
	            }
	            if (colorMask !== undefined) {
	                buffer = buffer || getBuffer(), caretPos === undefined ? caretPos = caret(input) : caretPos.begin === undefined && (caretPos = {
	                    begin: caretPos,
	                    end: caretPos
	                });
	                var maskTemplate = "", isStatic = !1;
	                if ("" != buffer) {
	                    var ndxIntlzr, test, testPos, pos = 0, lvp = getLastValidPosition();
	                    do {
	                        pos === caretPos.begin && document.activeElement === input && (maskTemplate += "<span class='im-caret' style='border-right-width: 1px;border-right-style: solid;'></span>"), 
	                        getMaskSet().validPositions[pos] ? (testPos = getMaskSet().validPositions[pos], 
	                        test = testPos.match, ndxIntlzr = testPos.locator.slice(), handleStatic(), maskTemplate += testPos.input) : (testPos = getTestTemplate(pos, ndxIntlzr, pos - 1), 
	                        test = testPos.match, ndxIntlzr = testPos.locator.slice(), (!1 === opts.jitMasking || pos < lvp || "number" == typeof opts.jitMasking && isFinite(opts.jitMasking) && opts.jitMasking > pos) && (handleStatic(), 
	                        maskTemplate += getPlaceholder(pos, test))), pos++;
	                    } while ((maxLength === undefined || pos < maxLength) && (null !== test.fn || "" !== test.def) || lvp > pos);
	                }
	                colorMask.innerHTML = maskTemplate;
	            }
	        }
	        maskset = maskset || this.maskset, opts = opts || this.opts;
	        var undoValue, $el, maxLength, colorMask, valueBuffer, el = this.el, isRTL = this.isRTL, skipKeyPressEvent = !1, skipInputEvent = !1, ignorable = !1, mouseEnter = !1, EventRuler = {
	            on: function(input, eventName, eventHandler) {
	                var ev = function(e) {
	                    if (this.inputmask === undefined && "FORM" !== this.nodeName) {
	                        var imOpts = $.data(this, "_inputmask_opts");
	                        imOpts ? new Inputmask(imOpts).mask(this) : EventRuler.off(this);
	                    } else {
	                        if ("setvalue" === e.type || "FORM" === this.nodeName || !(this.disabled || this.readOnly && !("keydown" === e.type && e.ctrlKey && 67 === e.keyCode || !1 === opts.tabThrough && e.keyCode === Inputmask.keyCode.TAB))) {
	                            switch (e.type) {
	                              case "input":
	                                if (!0 === skipInputEvent) return skipInputEvent = !1, e.preventDefault();
	                                break;
	
	                              case "keydown":
	                                skipKeyPressEvent = !1, skipInputEvent = !1;
	                                break;
	
	                              case "keypress":
	                                if (!0 === skipKeyPressEvent) return e.preventDefault();
	                                skipKeyPressEvent = !0;
	                                break;
	
	                              case "click":
	                                if (iemobile || iphone) {
	                                    var that = this, args = arguments;
	                                    return setTimeout(function() {
	                                        eventHandler.apply(that, args);
	                                    }, 0), !1;
	                                }
	                            }
	                            var returnVal = eventHandler.apply(this, arguments);
	                            return !1 === returnVal && (e.preventDefault(), e.stopPropagation()), returnVal;
	                        }
	                        e.preventDefault();
	                    }
	                };
	                input.inputmask.events[eventName] = input.inputmask.events[eventName] || [], input.inputmask.events[eventName].push(ev), 
	                -1 !== $.inArray(eventName, [ "submit", "reset" ]) ? null != input.form && $(input.form).on(eventName, ev) : $(input).on(eventName, ev);
	            },
	            off: function(input, event) {
	                if (input.inputmask && input.inputmask.events) {
	                    var events;
	                    event ? (events = [], events[event] = input.inputmask.events[event]) : events = input.inputmask.events, 
	                    $.each(events, function(eventName, evArr) {
	                        for (;evArr.length > 0; ) {
	                            var ev = evArr.pop();
	                            -1 !== $.inArray(eventName, [ "submit", "reset" ]) ? null != input.form && $(input.form).off(eventName, ev) : $(input).off(eventName, ev);
	                        }
	                        delete input.inputmask.events[eventName];
	                    });
	                }
	            }
	        }, EventHandlers = {
	            keydownEvent: function(e) {
	                var input = this, $input = $(input), k = e.keyCode, pos = caret(input);
	                if (k === Inputmask.keyCode.BACKSPACE || k === Inputmask.keyCode.DELETE || iphone && k === Inputmask.keyCode.BACKSPACE_SAFARI || e.ctrlKey && k === Inputmask.keyCode.X && !function(eventName) {
	                    var el = document.createElement("input"), evName = "on" + eventName, isSupported = evName in el;
	                    return isSupported || (el.setAttribute(evName, "return;"), isSupported = "function" == typeof el[evName]), 
	                    el = null, isSupported;
	                }("cut")) e.preventDefault(), handleRemove(input, k, pos), writeBuffer(input, getBuffer(!0), getMaskSet().p, e, input.inputmask._valueGet() !== getBuffer().join("")), 
	                input.inputmask._valueGet() === getBufferTemplate().join("") ? $input.trigger("cleared") : !0 === isComplete(getBuffer()) && $input.trigger("complete"); else if (k === Inputmask.keyCode.END || k === Inputmask.keyCode.PAGE_DOWN) {
	                    e.preventDefault();
	                    var caretPos = seekNext(getLastValidPosition());
	                    opts.insertMode || caretPos !== getMaskSet().maskLength || e.shiftKey || caretPos--, 
	                    caret(input, e.shiftKey ? pos.begin : caretPos, caretPos, !0);
	                } else k === Inputmask.keyCode.HOME && !e.shiftKey || k === Inputmask.keyCode.PAGE_UP ? (e.preventDefault(), 
	                caret(input, 0, e.shiftKey ? pos.begin : 0, !0)) : (opts.undoOnEscape && k === Inputmask.keyCode.ESCAPE || 90 === k && e.ctrlKey) && !0 !== e.altKey ? (checkVal(input, !0, !1, undoValue.split("")), 
	                $input.trigger("click")) : k !== Inputmask.keyCode.INSERT || e.shiftKey || e.ctrlKey ? !0 === opts.tabThrough && k === Inputmask.keyCode.TAB ? (!0 === e.shiftKey ? (null === getTest(pos.begin).match.fn && (pos.begin = seekNext(pos.begin)), 
	                pos.end = seekPrevious(pos.begin, !0), pos.begin = seekPrevious(pos.end, !0)) : (pos.begin = seekNext(pos.begin, !0), 
	                pos.end = seekNext(pos.begin, !0), pos.end < getMaskSet().maskLength && pos.end--), 
	                pos.begin < getMaskSet().maskLength && (e.preventDefault(), caret(input, pos.begin, pos.end))) : e.shiftKey || !1 === opts.insertMode && (k === Inputmask.keyCode.RIGHT ? setTimeout(function() {
	                    var caretPos = caret(input);
	                    caret(input, caretPos.begin);
	                }, 0) : k === Inputmask.keyCode.LEFT && setTimeout(function() {
	                    var caretPos = caret(input);
	                    caret(input, isRTL ? caretPos.begin + 1 : caretPos.begin - 1);
	                }, 0)) : (opts.insertMode = !opts.insertMode, caret(input, opts.insertMode || pos.begin !== getMaskSet().maskLength ? pos.begin : pos.begin - 1));
	                opts.onKeyDown.call(this, e, getBuffer(), caret(input).begin, opts), ignorable = -1 !== $.inArray(k, opts.ignorables);
	            },
	            keypressEvent: function(e, checkval, writeOut, strict, ndx) {
	                var input = this, $input = $(input), k = e.which || e.charCode || e.keyCode;
	                if (!(!0 === checkval || e.ctrlKey && e.altKey) && (e.ctrlKey || e.metaKey || ignorable)) return k === Inputmask.keyCode.ENTER && undoValue !== getBuffer().join("") && (undoValue = getBuffer().join(""), 
	                setTimeout(function() {
	                    $input.trigger("change");
	                }, 0)), !0;
	                if (k) {
	                    46 === k && !1 === e.shiftKey && "" !== opts.radixPoint && (k = opts.radixPoint.charCodeAt(0));
	                    var forwardPosition, pos = checkval ? {
	                        begin: ndx,
	                        end: ndx
	                    } : caret(input), c = String.fromCharCode(k);
	                    getMaskSet().writeOutBuffer = !0;
	                    var valResult = isValid(pos, c, strict);
	                    if (!1 !== valResult && (resetMaskSet(!0), forwardPosition = valResult.caret !== undefined ? valResult.caret : checkval ? valResult.pos + 1 : seekNext(valResult.pos), 
	                    getMaskSet().p = forwardPosition), !1 !== writeOut && (setTimeout(function() {
	                        opts.onKeyValidation.call(input, k, valResult, opts);
	                    }, 0), getMaskSet().writeOutBuffer && !1 !== valResult)) {
	                        var buffer = getBuffer();
	                        writeBuffer(input, buffer, opts.numericInput && valResult.caret === undefined ? seekPrevious(forwardPosition) : forwardPosition, e, !0 !== checkval), 
	                        !0 !== checkval && setTimeout(function() {
	                            !0 === isComplete(buffer) && $input.trigger("complete");
	                        }, 0);
	                    }
	                    if (e.preventDefault(), checkval) return !1 !== valResult && (valResult.forwardPosition = forwardPosition), 
	                    valResult;
	                }
	            },
	            pasteEvent: function(e) {
	                var tempValue, input = this, ev = e.originalEvent || e, $input = $(input), inputValue = input.inputmask._valueGet(!0), caretPos = caret(input);
	                isRTL && (tempValue = caretPos.end, caretPos.end = caretPos.begin, caretPos.begin = tempValue);
	                var valueBeforeCaret = inputValue.substr(0, caretPos.begin), valueAfterCaret = inputValue.substr(caretPos.end, inputValue.length);
	                if (valueBeforeCaret === (isRTL ? getBufferTemplate().reverse() : getBufferTemplate()).slice(0, caretPos.begin).join("") && (valueBeforeCaret = ""), 
	                valueAfterCaret === (isRTL ? getBufferTemplate().reverse() : getBufferTemplate()).slice(caretPos.end).join("") && (valueAfterCaret = ""), 
	                isRTL && (tempValue = valueBeforeCaret, valueBeforeCaret = valueAfterCaret, valueAfterCaret = tempValue), 
	                window.clipboardData && window.clipboardData.getData) inputValue = valueBeforeCaret + window.clipboardData.getData("Text") + valueAfterCaret; else {
	                    if (!ev.clipboardData || !ev.clipboardData.getData) return !0;
	                    inputValue = valueBeforeCaret + ev.clipboardData.getData("text/plain") + valueAfterCaret;
	                }
	                var pasteValue = inputValue;
	                if ($.isFunction(opts.onBeforePaste)) {
	                    if (!1 === (pasteValue = opts.onBeforePaste(inputValue, opts))) return e.preventDefault();
	                    pasteValue || (pasteValue = inputValue);
	                }
	                return checkVal(input, !1, !1, isRTL ? pasteValue.split("").reverse() : pasteValue.toString().split("")), 
	                writeBuffer(input, getBuffer(), seekNext(getLastValidPosition()), e, undoValue !== getBuffer().join("")), 
	                !0 === isComplete(getBuffer()) && $input.trigger("complete"), e.preventDefault();
	            },
	            inputFallBackEvent: function(e) {
	                var input = this, inputValue = input.inputmask._valueGet();
	                if (getBuffer().join("") !== inputValue) {
	                    var caretPos = caret(input);
	                    if ("." === inputValue.charAt(caretPos.begin - 1) && "" !== opts.radixPoint && (inputValue = inputValue.split(""), 
	                    inputValue[caretPos.begin - 1] = opts.radixPoint.charAt(0), inputValue = inputValue.join("")), 
	                    inputValue.charAt(caretPos.begin - 1) === opts.radixPoint && inputValue.length > getBuffer().length) {
	                        var keypress = new $.Event("keypress");
	                        return keypress.which = opts.radixPoint.charCodeAt(0), EventHandlers.keypressEvent.call(input, keypress, !0, !0, !1, caretPos.begin), 
	                        !1;
	                    }
	                    if (inputValue = inputValue.replace(new RegExp("(" + Inputmask.escapeRegex(getBufferTemplate().join("")) + ")*"), ""), 
	                    iemobile) {
	                        var inputChar = inputValue.replace(getBuffer().join(""), "");
	                        if (1 === inputChar.length) {
	                            var keypress = new $.Event("keypress");
	                            return keypress.which = inputChar.charCodeAt(0), EventHandlers.keypressEvent.call(input, keypress, !0, !0, !1, getMaskSet().validPositions[caretPos.begin - 1] ? caretPos.begin : caretPos.begin - 1), 
	                            !1;
	                        }
	                    }
	                    if (caretPos.begin > inputValue.length && (caret(input, inputValue.length), caretPos = caret(input)), 
	                    getBuffer().length - inputValue.length != 1 || inputValue.charAt(caretPos.begin) === getBuffer()[caretPos.begin] || inputValue.charAt(caretPos.begin + 1) === getBuffer()[caretPos.begin] || isMask(caretPos.begin)) {
	                        var stickyParts = [], bufferTemplate = getBufferTemplate().join("");
	                        for (stickyParts.push(inputValue.substr(0, caretPos.begin)), stickyParts.push(inputValue.substr(caretPos.begin)); null === inputValue.match(Inputmask.escapeRegex(bufferTemplate) + "$"); ) bufferTemplate = bufferTemplate.slice(1);
	                        inputValue = inputValue.replace(bufferTemplate, ""), $.isFunction(opts.onBeforeMask) && (inputValue = opts.onBeforeMask(inputValue, opts) || inputValue), 
	                        checkVal(input, !0, !1, inputValue.split(""), e), function(input, frontPart, backPart) {
	                            var targetPos = caret(input).begin, currentValue = input.inputmask._valueGet(), pos = currentValue.indexOf(frontPart), currentPos = targetPos;
	                            if (0 === pos && targetPos !== frontPart.length) targetPos = frontPart.length; else {
	                                for (;null === currentValue.match(Inputmask.escapeRegex(backPart) + "$"); ) backPart = backPart.substr(1);
	                                var pos2 = currentValue.indexOf(backPart);
	                                -1 !== pos2 && "" !== backPart && targetPos > pos2 && pos2 > pos && (targetPos = pos2);
	                            }
	                            isMask(targetPos) || (targetPos = seekNext(targetPos)), currentPos !== targetPos && (caret(input, targetPos), 
	                            android && setTimeout(function() {
	                                caret(input, targetPos);
	                            }, 0));
	                        }(input, stickyParts[0], stickyParts[1]), !0 === isComplete(getBuffer()) && $(input).trigger("complete");
	                    } else e.keyCode = Inputmask.keyCode.BACKSPACE, EventHandlers.keydownEvent.call(input, e);
	                    e.preventDefault();
	                }
	            },
	            setValueEvent: function(e) {
	                this.inputmask.refreshValue = !1;
	                var input = this, value = input.inputmask._valueGet(!0);
	                $.isFunction(opts.onBeforeMask) && (value = opts.onBeforeMask(value, opts) || value), 
	                value = value.split(""), checkVal(input, !0, !1, isRTL ? value.reverse() : value), 
	                undoValue = getBuffer().join(""), (opts.clearMaskOnLostFocus || opts.clearIncomplete) && input.inputmask._valueGet() === getBufferTemplate().join("") && input.inputmask._valueSet("");
	            },
	            focusEvent: function(e) {
	                var input = this, nptValue = input.inputmask._valueGet();
	                opts.showMaskOnFocus && (!opts.showMaskOnHover || opts.showMaskOnHover && "" === nptValue) && (input.inputmask._valueGet() !== getBuffer().join("") ? writeBuffer(input, getBuffer(), seekNext(getLastValidPosition())) : !1 === mouseEnter && caret(input, seekNext(getLastValidPosition()))), 
	                !0 === opts.positionCaretOnTab && !1 === mouseEnter && (writeBuffer(input, getBuffer(), caret(input)), 
	                EventHandlers.clickEvent.apply(input, [ e, !0 ])), undoValue = getBuffer().join("");
	            },
	            mouseleaveEvent: function(e) {
	                var input = this;
	                if (mouseEnter = !1, opts.clearMaskOnLostFocus && document.activeElement !== input) {
	                    var buffer = getBuffer().slice(), nptValue = input.inputmask._valueGet();
	                    nptValue !== input.getAttribute("placeholder") && "" !== nptValue && (-1 === getLastValidPosition() && nptValue === getBufferTemplate().join("") ? buffer = [] : clearOptionalTail(buffer), 
	                    writeBuffer(input, buffer));
	                }
	            },
	            clickEvent: function(e, tabbed) {
	                function doRadixFocus(clickPos) {
	                    if ("" !== opts.radixPoint) {
	                        var vps = getMaskSet().validPositions;
	                        if (vps[clickPos] === undefined || vps[clickPos].input === getPlaceholder(clickPos)) {
	                            if (clickPos < seekNext(-1)) return !0;
	                            var radixPos = $.inArray(opts.radixPoint, getBuffer());
	                            if (-1 !== radixPos) {
	                                for (var vp in vps) if (radixPos < vp && vps[vp].input !== getPlaceholder(vp)) return !1;
	                                return !0;
	                            }
	                        }
	                    }
	                    return !1;
	                }
	                var input = this;
	                setTimeout(function() {
	                    if (document.activeElement === input) {
	                        var selectedCaret = caret(input);
	                        if (tabbed && (isRTL ? selectedCaret.end = selectedCaret.begin : selectedCaret.begin = selectedCaret.end), 
	                        selectedCaret.begin === selectedCaret.end) switch (opts.positionCaretOnClick) {
	                          case "none":
	                            break;
	
	                          case "radixFocus":
	                            if (doRadixFocus(selectedCaret.begin)) {
	                                var radixPos = getBuffer().join("").indexOf(opts.radixPoint);
	                                caret(input, opts.numericInput ? seekNext(radixPos) : radixPos);
	                                break;
	                            }
	
	                          default:
	                            var clickPosition = selectedCaret.begin, lvclickPosition = getLastValidPosition(clickPosition, !0), lastPosition = seekNext(lvclickPosition);
	                            if (clickPosition < lastPosition) caret(input, isMask(clickPosition) || isMask(clickPosition - 1) ? clickPosition : seekNext(clickPosition)); else {
	                                var placeholder = getPlaceholder(lastPosition), lvp = getMaskSet().validPositions[lvclickPosition], tt = getTestTemplate(lastPosition, lvp ? lvp.match.locator : undefined, lvp);
	                                if ("" !== placeholder && getBuffer()[lastPosition] !== placeholder && !0 !== tt.match.optionalQuantifier || !isMask(lastPosition) && tt.match.def === placeholder) {
	                                    var newPos = seekNext(lastPosition);
	                                    clickPosition >= newPos && (lastPosition = newPos);
	                                }
	                                caret(input, lastPosition);
	                            }
	                        }
	                    }
	                }, 0);
	            },
	            dblclickEvent: function(e) {
	                var input = this;
	                setTimeout(function() {
	                    caret(input, 0, seekNext(getLastValidPosition()));
	                }, 0);
	            },
	            cutEvent: function(e) {
	                var input = this, $input = $(input), pos = caret(input), ev = e.originalEvent || e, clipboardData = window.clipboardData || ev.clipboardData, clipData = isRTL ? getBuffer().slice(pos.end, pos.begin) : getBuffer().slice(pos.begin, pos.end);
	                clipboardData.setData("text", isRTL ? clipData.reverse().join("") : clipData.join("")), 
	                document.execCommand && document.execCommand("copy"), handleRemove(input, Inputmask.keyCode.DELETE, pos), 
	                writeBuffer(input, getBuffer(), getMaskSet().p, e, undoValue !== getBuffer().join("")), 
	                input.inputmask._valueGet() === getBufferTemplate().join("") && $input.trigger("cleared");
	            },
	            blurEvent: function(e) {
	                var $input = $(this), input = this;
	                if (input.inputmask) {
	                    var nptValue = input.inputmask._valueGet(), buffer = getBuffer().slice();
	                    "" !== nptValue && (opts.clearMaskOnLostFocus && (-1 === getLastValidPosition() && nptValue === getBufferTemplate().join("") ? buffer = [] : clearOptionalTail(buffer)), 
	                    !1 === isComplete(buffer) && (setTimeout(function() {
	                        $input.trigger("incomplete");
	                    }, 0), opts.clearIncomplete && (resetMaskSet(), buffer = opts.clearMaskOnLostFocus ? [] : getBufferTemplate().slice())), 
	                    writeBuffer(input, buffer, undefined, e)), undoValue !== getBuffer().join("") && (undoValue = buffer.join(""), 
	                    $input.trigger("change"));
	                }
	            },
	            mouseenterEvent: function(e) {
	                var input = this;
	                mouseEnter = !0, document.activeElement !== input && opts.showMaskOnHover && input.inputmask._valueGet() !== getBuffer().join("") && writeBuffer(input, getBuffer());
	            },
	            submitEvent: function(e) {
	                undoValue !== getBuffer().join("") && $el.trigger("change"), opts.clearMaskOnLostFocus && -1 === getLastValidPosition() && el.inputmask._valueGet && el.inputmask._valueGet() === getBufferTemplate().join("") && el.inputmask._valueSet(""), 
	                opts.removeMaskOnSubmit && (el.inputmask._valueSet(el.inputmask.unmaskedvalue(), !0), 
	                setTimeout(function() {
	                    writeBuffer(el, getBuffer());
	                }, 0));
	            },
	            resetEvent: function(e) {
	                el.inputmask.refreshValue = !0, setTimeout(function() {
	                    $el.trigger("setvalue");
	                }, 0);
	            }
	        };
	        if (actionObj !== undefined) switch (actionObj.action) {
	          case "isComplete":
	            return el = actionObj.el, isComplete(getBuffer());
	
	          case "unmaskedvalue":
	            return el !== undefined && actionObj.value === undefined || (valueBuffer = actionObj.value, 
	            valueBuffer = ($.isFunction(opts.onBeforeMask) ? opts.onBeforeMask(valueBuffer, opts) || valueBuffer : valueBuffer).split(""), 
	            checkVal(undefined, !1, !1, isRTL ? valueBuffer.reverse() : valueBuffer), $.isFunction(opts.onBeforeWrite) && opts.onBeforeWrite(undefined, getBuffer(), 0, opts)), 
	            unmaskedvalue(el);
	
	          case "mask":
	            !function(elem) {
	                EventRuler.off(elem);
	                var isSupported = function(input, opts) {
	                    var elementType = input.getAttribute("type"), isSupported = "INPUT" === input.tagName && -1 !== $.inArray(elementType, opts.supportsInputType) || input.isContentEditable || "TEXTAREA" === input.tagName;
	                    if (!isSupported) if ("INPUT" === input.tagName) {
	                        var el = document.createElement("input");
	                        el.setAttribute("type", elementType), isSupported = "text" === el.type, el = null;
	                    } else isSupported = "partial";
	                    return !1 !== isSupported && function(npt) {
	                        function getter() {
	                            return this.inputmask ? this.inputmask.opts.autoUnmask ? this.inputmask.unmaskedvalue() : -1 !== getLastValidPosition() || !0 !== opts.nullable ? document.activeElement === this && opts.clearMaskOnLostFocus ? (isRTL ? clearOptionalTail(getBuffer().slice()).reverse() : clearOptionalTail(getBuffer().slice())).join("") : valueGet.call(this) : "" : valueGet.call(this);
	                        }
	                        function setter(value) {
	                            valueSet.call(this, value), this.inputmask && $(this).trigger("setvalue");
	                        }
	                        var valueGet, valueSet;
	                        if (!npt.inputmask.__valueGet) {
	                            if (!0 !== opts.noValuePatching) {
	                                if (Object.getOwnPropertyDescriptor) {
	                                    "function" != typeof Object.getPrototypeOf && (Object.getPrototypeOf = "object" == typeof "test".__proto__ ? function(object) {
	                                        return object.__proto__;
	                                    } : function(object) {
	                                        return object.constructor.prototype;
	                                    });
	                                    var valueProperty = Object.getPrototypeOf ? Object.getOwnPropertyDescriptor(Object.getPrototypeOf(npt), "value") : undefined;
	                                    valueProperty && valueProperty.get && valueProperty.set ? (valueGet = valueProperty.get, 
	                                    valueSet = valueProperty.set, Object.defineProperty(npt, "value", {
	                                        get: getter,
	                                        set: setter,
	                                        configurable: !0
	                                    })) : "INPUT" !== npt.tagName && (valueGet = function() {
	                                        return this.textContent;
	                                    }, valueSet = function(value) {
	                                        this.textContent = value;
	                                    }, Object.defineProperty(npt, "value", {
	                                        get: getter,
	                                        set: setter,
	                                        configurable: !0
	                                    }));
	                                } else document.__lookupGetter__ && npt.__lookupGetter__("value") && (valueGet = npt.__lookupGetter__("value"), 
	                                valueSet = npt.__lookupSetter__("value"), npt.__defineGetter__("value", getter), 
	                                npt.__defineSetter__("value", setter));
	                                npt.inputmask.__valueGet = valueGet, npt.inputmask.__valueSet = valueSet;
	                            }
	                            npt.inputmask._valueGet = function(overruleRTL) {
	                                return isRTL && !0 !== overruleRTL ? valueGet.call(this.el).split("").reverse().join("") : valueGet.call(this.el);
	                            }, npt.inputmask._valueSet = function(value, overruleRTL) {
	                                valueSet.call(this.el, null === value || value === undefined ? "" : !0 !== overruleRTL && isRTL ? value.split("").reverse().join("") : value);
	                            }, valueGet === undefined && (valueGet = function() {
	                                return this.value;
	                            }, valueSet = function(value) {
	                                this.value = value;
	                            }, function(type) {
	                                if ($.valHooks && ($.valHooks[type] === undefined || !0 !== $.valHooks[type].inputmaskpatch)) {
	                                    var valhookGet = $.valHooks[type] && $.valHooks[type].get ? $.valHooks[type].get : function(elem) {
	                                        return elem.value;
	                                    }, valhookSet = $.valHooks[type] && $.valHooks[type].set ? $.valHooks[type].set : function(elem, value) {
	                                        return elem.value = value, elem;
	                                    };
	                                    $.valHooks[type] = {
	                                        get: function(elem) {
	                                            if (elem.inputmask) {
	                                                if (elem.inputmask.opts.autoUnmask) return elem.inputmask.unmaskedvalue();
	                                                var result = valhookGet(elem);
	                                                return -1 !== getLastValidPosition(undefined, undefined, elem.inputmask.maskset.validPositions) || !0 !== opts.nullable ? result : "";
	                                            }
	                                            return valhookGet(elem);
	                                        },
	                                        set: function(elem, value) {
	                                            var result, $elem = $(elem);
	                                            return result = valhookSet(elem, value), elem.inputmask && $elem.trigger("setvalue"), 
	                                            result;
	                                        },
	                                        inputmaskpatch: !0
	                                    };
	                                }
	                            }(npt.type), function(npt) {
	                                EventRuler.on(npt, "mouseenter", function(event) {
	                                    var $input = $(this);
	                                    this.inputmask._valueGet() !== getBuffer().join("") && $input.trigger("setvalue");
	                                });
	                            }(npt));
	                        }
	                    }(input), isSupported;
	                }(elem, opts);
	                if (!1 !== isSupported && (el = elem, $el = $(el), !0 === opts.colorMask && initializeColorMask(el), 
	                android && (el.hasOwnProperty("inputmode") && (el.inputmode = opts.inputmode, el.setAttribute("inputmode", opts.inputmode)), 
	                "rtfm" === opts.androidHack && (!0 !== opts.colorMask && initializeColorMask(el), 
	                el.type = "password")), !0 === isSupported && (EventRuler.on(el, "submit", EventHandlers.submitEvent), 
	                EventRuler.on(el, "reset", EventHandlers.resetEvent), EventRuler.on(el, "mouseenter", EventHandlers.mouseenterEvent), 
	                EventRuler.on(el, "blur", EventHandlers.blurEvent), EventRuler.on(el, "focus", EventHandlers.focusEvent), 
	                EventRuler.on(el, "mouseleave", EventHandlers.mouseleaveEvent), !0 !== opts.colorMask && EventRuler.on(el, "click", EventHandlers.clickEvent), 
	                EventRuler.on(el, "dblclick", EventHandlers.dblclickEvent), EventRuler.on(el, "paste", EventHandlers.pasteEvent), 
	                EventRuler.on(el, "dragdrop", EventHandlers.pasteEvent), EventRuler.on(el, "drop", EventHandlers.pasteEvent), 
	                EventRuler.on(el, "cut", EventHandlers.cutEvent), EventRuler.on(el, "complete", opts.oncomplete), 
	                EventRuler.on(el, "incomplete", opts.onincomplete), EventRuler.on(el, "cleared", opts.oncleared), 
	                android || !0 === opts.inputEventOnly || (EventRuler.on(el, "keydown", EventHandlers.keydownEvent), 
	                EventRuler.on(el, "keypress", EventHandlers.keypressEvent)), EventRuler.on(el, "compositionstart", $.noop), 
	                EventRuler.on(el, "compositionupdate", $.noop), EventRuler.on(el, "compositionend", $.noop), 
	                EventRuler.on(el, "keyup", $.noop), EventRuler.on(el, "input", EventHandlers.inputFallBackEvent), 
	                EventRuler.on(el, "beforeinput", $.noop)), EventRuler.on(el, "setvalue", EventHandlers.setValueEvent), 
	                undoValue = getBufferTemplate().join(""), "" !== el.inputmask._valueGet(!0) || !1 === opts.clearMaskOnLostFocus || document.activeElement === el)) {
	                    var initialValue = $.isFunction(opts.onBeforeMask) ? opts.onBeforeMask(el.inputmask._valueGet(!0), opts) || el.inputmask._valueGet(!0) : el.inputmask._valueGet(!0);
	                    "" !== initialValue && checkVal(el, !0, !1, isRTL ? initialValue.split("").reverse() : initialValue.split(""));
	                    var buffer = getBuffer().slice();
	                    undoValue = buffer.join(""), !1 === isComplete(buffer) && opts.clearIncomplete && resetMaskSet(), 
	                    opts.clearMaskOnLostFocus && document.activeElement !== el && (-1 === getLastValidPosition() ? buffer = [] : clearOptionalTail(buffer)), 
	                    writeBuffer(el, buffer), document.activeElement === el && caret(el, seekNext(getLastValidPosition()));
	                }
	            }(el);
	            break;
	
	          case "format":
	            return valueBuffer = ($.isFunction(opts.onBeforeMask) ? opts.onBeforeMask(actionObj.value, opts) || actionObj.value : actionObj.value).split(""), 
	            checkVal(undefined, !0, !1, isRTL ? valueBuffer.reverse() : valueBuffer), actionObj.metadata ? {
	                value: isRTL ? getBuffer().slice().reverse().join("") : getBuffer().join(""),
	                metadata: maskScope.call(this, {
	                    action: "getmetadata"
	                }, maskset, opts)
	            } : isRTL ? getBuffer().slice().reverse().join("") : getBuffer().join("");
	
	          case "isValid":
	            actionObj.value ? (valueBuffer = actionObj.value.split(""), checkVal(undefined, !0, !0, isRTL ? valueBuffer.reverse() : valueBuffer)) : actionObj.value = getBuffer().join("");
	            for (var buffer = getBuffer(), rl = determineLastRequiredPosition(), lmib = buffer.length - 1; lmib > rl && !isMask(lmib); lmib--) ;
	            return buffer.splice(rl, lmib + 1 - rl), isComplete(buffer) && actionObj.value === getBuffer().join("");
	
	          case "getemptymask":
	            return getBufferTemplate().join("");
	
	          case "remove":
	            if (el && el.inputmask) {
	                $el = $(el), el.inputmask._valueSet(opts.autoUnmask ? unmaskedvalue(el) : el.inputmask._valueGet(!0)), 
	                EventRuler.off(el);
	                Object.getOwnPropertyDescriptor && Object.getPrototypeOf ? Object.getOwnPropertyDescriptor(Object.getPrototypeOf(el), "value") && el.inputmask.__valueGet && Object.defineProperty(el, "value", {
	                    get: el.inputmask.__valueGet,
	                    set: el.inputmask.__valueSet,
	                    configurable: !0
	                }) : document.__lookupGetter__ && el.__lookupGetter__("value") && el.inputmask.__valueGet && (el.__defineGetter__("value", el.inputmask.__valueGet), 
	                el.__defineSetter__("value", el.inputmask.__valueSet)), el.inputmask = undefined;
	            }
	            return el;
	
	          case "getmetadata":
	            if ($.isArray(maskset.metadata)) {
	                var maskTarget = getMaskTemplate(!0, 0, !1).join("");
	                return $.each(maskset.metadata, function(ndx, mtdt) {
	                    if (mtdt.mask === maskTarget) return maskTarget = mtdt, !1;
	                }), maskTarget;
	            }
	            return maskset.metadata;
	        }
	    }
	    var ua = navigator.userAgent, mobile = /mobile/i.test(ua), iemobile = /iemobile/i.test(ua), iphone = /iphone/i.test(ua) && !iemobile, android = /android/i.test(ua) && !iemobile;
	    return Inputmask.prototype = {
	        dataAttribute: "data-inputmask",
	        defaults: {
	            placeholder: "_",
	            optionalmarker: {
	                start: "[",
	                end: "]"
	            },
	            quantifiermarker: {
	                start: "{",
	                end: "}"
	            },
	            groupmarker: {
	                start: "(",
	                end: ")"
	            },
	            alternatormarker: "|",
	            escapeChar: "\\",
	            mask: null,
	            regex: null,
	            oncomplete: $.noop,
	            onincomplete: $.noop,
	            oncleared: $.noop,
	            repeat: 0,
	            greedy: !0,
	            autoUnmask: !1,
	            removeMaskOnSubmit: !1,
	            clearMaskOnLostFocus: !0,
	            insertMode: !0,
	            clearIncomplete: !1,
	            alias: null,
	            onKeyDown: $.noop,
	            onBeforeMask: null,
	            onBeforePaste: function(pastedValue, opts) {
	                return $.isFunction(opts.onBeforeMask) ? opts.onBeforeMask(pastedValue, opts) : pastedValue;
	            },
	            onBeforeWrite: null,
	            onUnMask: null,
	            showMaskOnFocus: !0,
	            showMaskOnHover: !0,
	            onKeyValidation: $.noop,
	            skipOptionalPartCharacter: " ",
	            numericInput: !1,
	            rightAlign: !1,
	            undoOnEscape: !0,
	            radixPoint: "",
	            radixPointDefinitionSymbol: undefined,
	            groupSeparator: "",
	            keepStatic: null,
	            positionCaretOnTab: !0,
	            tabThrough: !1,
	            supportsInputType: [ "text", "tel", "password" ],
	            ignorables: [ 8, 9, 13, 19, 27, 33, 34, 35, 36, 37, 38, 39, 40, 45, 46, 93, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 0, 229 ],
	            isComplete: null,
	            canClearPosition: $.noop,
	            preValidation: null,
	            postValidation: null,
	            staticDefinitionSymbol: undefined,
	            jitMasking: !1,
	            nullable: !0,
	            inputEventOnly: !1,
	            noValuePatching: !1,
	            positionCaretOnClick: "lvp",
	            casing: null,
	            inputmode: "verbatim",
	            colorMask: !1,
	            androidHack: !1
	        },
	        definitions: {
	            "9": {
	                validator: "[0-9]",
	                cardinality: 1,
	                definitionSymbol: "*"
	            },
	            a: {
	                validator: "[A-Za-z\u0410-\u044f\u0401\u0451\xc0-\xff\xb5]",
	                cardinality: 1,
	                definitionSymbol: "*"
	            },
	            "*": {
	                validator: "[0-9A-Za-z\u0410-\u044f\u0401\u0451\xc0-\xff\xb5]",
	                cardinality: 1
	            }
	        },
	        aliases: {},
	        masksCache: {},
	        mask: function(elems) {
	            function importAttributeOptions(npt, opts, userOptions, dataAttribute) {
	                function importOption(option, optionData) {
	                    null !== (optionData = optionData !== undefined ? optionData : npt.getAttribute(dataAttribute + "-" + option)) && ("string" == typeof optionData && (0 === option.indexOf("on") ? optionData = window[optionData] : "false" === optionData ? optionData = !1 : "true" === optionData && (optionData = !0)), 
	                    userOptions[option] = optionData);
	                }
	                ("rtl" === npt.dir || opts.rightAlign) && (npt.style.textAlign = "right"), ("rtl" === npt.dir || opts.numericInput) && (npt.dir = "ltr", 
	                npt.removeAttribute("dir"), opts.isRTL = !0);
	                var option, dataoptions, optionData, p, attrOptions = npt.getAttribute(dataAttribute);
	                if (attrOptions && "" !== attrOptions && (attrOptions = attrOptions.replace(new RegExp("'", "g"), '"'), 
	                dataoptions = JSON.parse("{" + attrOptions + "}")), dataoptions) {
	                    optionData = undefined;
	                    for (p in dataoptions) if ("alias" === p.toLowerCase()) {
	                        optionData = dataoptions[p];
	                        break;
	                    }
	                }
	                importOption("alias", optionData), userOptions.alias && resolveAlias(userOptions.alias, userOptions, opts);
	                for (option in opts) {
	                    if (dataoptions) {
	                        optionData = undefined;
	                        for (p in dataoptions) if (p.toLowerCase() === option.toLowerCase()) {
	                            optionData = dataoptions[p];
	                            break;
	                        }
	                    }
	                    importOption(option, optionData);
	                }
	                return $.extend(!0, opts, userOptions), opts;
	            }
	            var that = this;
	            return "string" == typeof elems && (elems = document.getElementById(elems) || document.querySelectorAll(elems)), 
	            elems = elems.nodeName ? [ elems ] : elems, $.each(elems, function(ndx, el) {
	                var scopedOpts = $.extend(!0, {}, that.opts);
	                importAttributeOptions(el, scopedOpts, $.extend(!0, {}, that.userOptions), that.dataAttribute);
	                var maskset = generateMaskSet(scopedOpts, that.noMasksCache);
	                maskset !== undefined && (el.inputmask !== undefined && el.inputmask.remove(), el.inputmask = new Inputmask(undefined, undefined, !0), 
	                el.inputmask.opts = scopedOpts, el.inputmask.noMasksCache = that.noMasksCache, el.inputmask.userOptions = $.extend(!0, {}, that.userOptions), 
	                el.inputmask.isRTL = scopedOpts.isRTL, el.inputmask.el = el, el.inputmask.maskset = maskset, 
	                $.data(el, "_inputmask_opts", scopedOpts), maskScope.call(el.inputmask, {
	                    action: "mask"
	                }));
	            }), elems && elems[0] ? elems[0].inputmask || this : this;
	        },
	        option: function(options, noremask) {
	            return "string" == typeof options ? this.opts[options] : "object" == typeof options ? ($.extend(this.userOptions, options), 
	            this.el && !0 !== noremask && this.mask(this.el), this) : void 0;
	        },
	        unmaskedvalue: function(value) {
	            return this.maskset = this.maskset || generateMaskSet(this.opts, this.noMasksCache), 
	            maskScope.call(this, {
	                action: "unmaskedvalue",
	                value: value
	            });
	        },
	        remove: function() {
	            return maskScope.call(this, {
	                action: "remove"
	            });
	        },
	        getemptymask: function() {
	            return this.maskset = this.maskset || generateMaskSet(this.opts, this.noMasksCache), 
	            maskScope.call(this, {
	                action: "getemptymask"
	            });
	        },
	        hasMaskedValue: function() {
	            return !this.opts.autoUnmask;
	        },
	        isComplete: function() {
	            return this.maskset = this.maskset || generateMaskSet(this.opts, this.noMasksCache), 
	            maskScope.call(this, {
	                action: "isComplete"
	            });
	        },
	        getmetadata: function() {
	            return this.maskset = this.maskset || generateMaskSet(this.opts, this.noMasksCache), 
	            maskScope.call(this, {
	                action: "getmetadata"
	            });
	        },
	        isValid: function(value) {
	            return this.maskset = this.maskset || generateMaskSet(this.opts, this.noMasksCache), 
	            maskScope.call(this, {
	                action: "isValid",
	                value: value
	            });
	        },
	        format: function(value, metadata) {
	            return this.maskset = this.maskset || generateMaskSet(this.opts, this.noMasksCache), 
	            maskScope.call(this, {
	                action: "format",
	                value: value,
	                metadata: metadata
	            });
	        },
	        analyseMask: function(mask, regexMask, opts) {
	            function MaskToken(isGroup, isOptional, isQuantifier, isAlternator) {
	                this.matches = [], this.openGroup = isGroup || !1, this.alternatorGroup = !1, this.isGroup = isGroup || !1, 
	                this.isOptional = isOptional || !1, this.isQuantifier = isQuantifier || !1, this.isAlternator = isAlternator || !1, 
	                this.quantifier = {
	                    min: 1,
	                    max: 1
	                };
	            }
	            function insertTestDefinition(mtoken, element, position) {
	                position = position !== undefined ? position : mtoken.matches.length;
	                var prevMatch = mtoken.matches[position - 1];
	                if (regexMask) 0 === element.indexOf("[") || escaped ? mtoken.matches.splice(position++, 0, {
	                    fn: new RegExp(element, opts.casing ? "i" : ""),
	                    cardinality: 1,
	                    optionality: mtoken.isOptional,
	                    newBlockMarker: prevMatch === undefined || prevMatch.def !== element,
	                    casing: null,
	                    def: element,
	                    placeholder: undefined,
	                    nativeDef: element
	                }) : $.each(element.split(""), function(ndx, lmnt) {
	                    prevMatch = mtoken.matches[position - 1], mtoken.matches.splice(position++, 0, {
	                        fn: null,
	                        cardinality: 0,
	                        optionality: mtoken.isOptional,
	                        newBlockMarker: prevMatch === undefined || prevMatch.def !== lmnt && null !== prevMatch.fn,
	                        casing: null,
	                        def: opts.staticDefinitionSymbol || lmnt,
	                        placeholder: opts.staticDefinitionSymbol !== undefined ? lmnt : undefined,
	                        nativeDef: lmnt
	                    });
	                }), escaped = !1; else {
	                    var maskdef = (opts.definitions ? opts.definitions[element] : undefined) || Inputmask.prototype.definitions[element];
	                    if (maskdef && !escaped) {
	                        for (var prevalidators = maskdef.prevalidator, prevalidatorsL = prevalidators ? prevalidators.length : 0, i = 1; i < maskdef.cardinality; i++) {
	                            var prevalidator = prevalidatorsL >= i ? prevalidators[i - 1] : [], validator = prevalidator.validator, cardinality = prevalidator.cardinality;
	                            mtoken.matches.splice(position++, 0, {
	                                fn: validator ? "string" == typeof validator ? new RegExp(validator, opts.casing ? "i" : "") : new function() {
	                                    this.test = validator;
	                                }() : new RegExp("."),
	                                cardinality: cardinality || 1,
	                                optionality: mtoken.isOptional,
	                                newBlockMarker: prevMatch === undefined || prevMatch.def !== (maskdef.definitionSymbol || element),
	                                casing: maskdef.casing,
	                                def: maskdef.definitionSymbol || element,
	                                placeholder: maskdef.placeholder,
	                                nativeDef: element
	                            }), prevMatch = mtoken.matches[position - 1];
	                        }
	                        mtoken.matches.splice(position++, 0, {
	                            fn: maskdef.validator ? "string" == typeof maskdef.validator ? new RegExp(maskdef.validator, opts.casing ? "i" : "") : new function() {
	                                this.test = maskdef.validator;
	                            }() : new RegExp("."),
	                            cardinality: maskdef.cardinality,
	                            optionality: mtoken.isOptional,
	                            newBlockMarker: prevMatch === undefined || prevMatch.def !== (maskdef.definitionSymbol || element),
	                            casing: maskdef.casing,
	                            def: maskdef.definitionSymbol || element,
	                            placeholder: maskdef.placeholder,
	                            nativeDef: element
	                        });
	                    } else mtoken.matches.splice(position++, 0, {
	                        fn: null,
	                        cardinality: 0,
	                        optionality: mtoken.isOptional,
	                        newBlockMarker: prevMatch === undefined || prevMatch.def !== element && null !== prevMatch.fn,
	                        casing: null,
	                        def: opts.staticDefinitionSymbol || element,
	                        placeholder: opts.staticDefinitionSymbol !== undefined ? element : undefined,
	                        nativeDef: element
	                    }), escaped = !1;
	                }
	            }
	            function verifyGroupMarker(maskToken) {
	                maskToken && maskToken.matches && $.each(maskToken.matches, function(ndx, token) {
	                    var nextToken = maskToken.matches[ndx + 1];
	                    (nextToken === undefined || nextToken.matches === undefined || !1 === nextToken.isQuantifier) && token && token.isGroup && (token.isGroup = !1, 
	                    regexMask || (insertTestDefinition(token, opts.groupmarker.start, 0), !0 !== token.openGroup && insertTestDefinition(token, opts.groupmarker.end))), 
	                    verifyGroupMarker(token);
	                });
	            }
	            function defaultCase() {
	                if (openenings.length > 0) {
	                    if (currentOpeningToken = openenings[openenings.length - 1], insertTestDefinition(currentOpeningToken, m), 
	                    currentOpeningToken.isAlternator) {
	                        alternator = openenings.pop();
	                        for (var mndx = 0; mndx < alternator.matches.length; mndx++) alternator.matches[mndx].isGroup = !1;
	                        openenings.length > 0 ? (currentOpeningToken = openenings[openenings.length - 1], 
	                        currentOpeningToken.matches.push(alternator)) : currentToken.matches.push(alternator);
	                    }
	                } else insertTestDefinition(currentToken, m);
	            }
	            function reverseTokens(maskToken) {
	                maskToken.matches = maskToken.matches.reverse();
	                for (var match in maskToken.matches) if (maskToken.matches.hasOwnProperty(match)) {
	                    var intMatch = parseInt(match);
	                    if (maskToken.matches[match].isQuantifier && maskToken.matches[intMatch + 1] && maskToken.matches[intMatch + 1].isGroup) {
	                        var qt = maskToken.matches[match];
	                        maskToken.matches.splice(match, 1), maskToken.matches.splice(intMatch + 1, 0, qt);
	                    }
	                    maskToken.matches[match].matches !== undefined ? maskToken.matches[match] = reverseTokens(maskToken.matches[match]) : maskToken.matches[match] = function(st) {
	                        return st === opts.optionalmarker.start ? st = opts.optionalmarker.end : st === opts.optionalmarker.end ? st = opts.optionalmarker.start : st === opts.groupmarker.start ? st = opts.groupmarker.end : st === opts.groupmarker.end && (st = opts.groupmarker.start), 
	                        st;
	                    }(maskToken.matches[match]);
	                }
	                return maskToken;
	            }
	            var match, m, openingToken, currentOpeningToken, alternator, lastMatch, groupToken, tokenizer = /(?:[?*+]|\{[0-9\+\*]+(?:,[0-9\+\*]*)?\})|[^.?*+^${[]()|\\]+|./g, regexTokenizer = /\[\^?]?(?:[^\\\]]+|\\[\S\s]?)*]?|\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9][0-9]*|x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4}|c[A-Za-z]|[\S\s]?)|\((?:\?[:=!]?)?|(?:[?*+]|\{[0-9]+(?:,[0-9]*)?\})\??|[^.?*+^${[()|\\]+|./g, escaped = !1, currentToken = new MaskToken(), openenings = [], maskTokens = [];
	            for (regexMask && (opts.optionalmarker.start = undefined, opts.optionalmarker.end = undefined); match = regexMask ? regexTokenizer.exec(mask) : tokenizer.exec(mask); ) {
	                if (m = match[0], regexMask && !0 !== escaped) switch (m.charAt(0)) {
	                  case "?":
	                    m = "{0,1}";
	                    break;
	
	                  case "+":
	                  case "*":
	                    m = "{" + m + "}";
	                }
	                if (escaped) defaultCase(); else switch (m.charAt(0)) {
	                  case opts.escapeChar:
	                    escaped = !0, regexMask && defaultCase();
	                    break;
	
	                  case opts.optionalmarker.end:
	                  case opts.groupmarker.end:
	                    if (openingToken = openenings.pop(), openingToken.openGroup = !1, openingToken !== undefined) if (openenings.length > 0) {
	                        if (currentOpeningToken = openenings[openenings.length - 1], currentOpeningToken.matches.push(openingToken), 
	                        currentOpeningToken.isAlternator) {
	                            alternator = openenings.pop();
	                            for (var mndx = 0; mndx < alternator.matches.length; mndx++) alternator.matches[mndx].isGroup = !1, 
	                            alternator.matches[mndx].alternatorGroup = !1;
	                            openenings.length > 0 ? (currentOpeningToken = openenings[openenings.length - 1], 
	                            currentOpeningToken.matches.push(alternator)) : currentToken.matches.push(alternator);
	                        }
	                    } else currentToken.matches.push(openingToken); else defaultCase();
	                    break;
	
	                  case opts.optionalmarker.start:
	                    openenings.push(new MaskToken(!1, !0));
	                    break;
	
	                  case opts.groupmarker.start:
	                    openenings.push(new MaskToken(!0));
	                    break;
	
	                  case opts.quantifiermarker.start:
	                    var quantifier = new MaskToken(!1, !1, !0);
	                    m = m.replace(/[{}]/g, "");
	                    var mq = m.split(","), mq0 = isNaN(mq[0]) ? mq[0] : parseInt(mq[0]), mq1 = 1 === mq.length ? mq0 : isNaN(mq[1]) ? mq[1] : parseInt(mq[1]);
	                    if ("*" !== mq1 && "+" !== mq1 || (mq0 = "*" === mq1 ? 0 : 1), quantifier.quantifier = {
	                        min: mq0,
	                        max: mq1
	                    }, openenings.length > 0) {
	                        var matches = openenings[openenings.length - 1].matches;
	                        match = matches.pop(), match.isGroup || (groupToken = new MaskToken(!0), groupToken.matches.push(match), 
	                        match = groupToken), matches.push(match), matches.push(quantifier);
	                    } else match = currentToken.matches.pop(), match.isGroup || (regexMask && null === match.fn && "." === match.def && (match.fn = new RegExp(match.def, opts.casing ? "i" : "")), 
	                    groupToken = new MaskToken(!0), groupToken.matches.push(match), match = groupToken), 
	                    currentToken.matches.push(match), currentToken.matches.push(quantifier);
	                    break;
	
	                  case opts.alternatormarker:
	                    if (openenings.length > 0) {
	                        currentOpeningToken = openenings[openenings.length - 1];
	                        var subToken = currentOpeningToken.matches[currentOpeningToken.matches.length - 1];
	                        lastMatch = currentOpeningToken.openGroup && (subToken.matches === undefined || !1 === subToken.isGroup && !1 === subToken.isAlternator) ? openenings.pop() : currentOpeningToken.matches.pop();
	                    } else lastMatch = currentToken.matches.pop();
	                    if (lastMatch.isAlternator) openenings.push(lastMatch); else if (lastMatch.alternatorGroup ? (alternator = openenings.pop(), 
	                    lastMatch.alternatorGroup = !1) : alternator = new MaskToken(!1, !1, !1, !0), alternator.matches.push(lastMatch), 
	                    openenings.push(alternator), lastMatch.openGroup) {
	                        lastMatch.openGroup = !1;
	                        var alternatorGroup = new MaskToken(!0);
	                        alternatorGroup.alternatorGroup = !0, openenings.push(alternatorGroup);
	                    }
	                    break;
	
	                  default:
	                    defaultCase();
	                }
	            }
	            for (;openenings.length > 0; ) openingToken = openenings.pop(), currentToken.matches.push(openingToken);
	            return currentToken.matches.length > 0 && (verifyGroupMarker(currentToken), maskTokens.push(currentToken)), 
	            (opts.numericInput || opts.isRTL) && reverseTokens(maskTokens[0]), maskTokens;
	        }
	    }, Inputmask.extendDefaults = function(options) {
	        $.extend(!0, Inputmask.prototype.defaults, options);
	    }, Inputmask.extendDefinitions = function(definition) {
	        $.extend(!0, Inputmask.prototype.definitions, definition);
	    }, Inputmask.extendAliases = function(alias) {
	        $.extend(!0, Inputmask.prototype.aliases, alias);
	    }, Inputmask.format = function(value, options, metadata) {
	        return Inputmask(options).format(value, metadata);
	    }, Inputmask.unmask = function(value, options) {
	        return Inputmask(options).unmaskedvalue(value);
	    }, Inputmask.isValid = function(value, options) {
	        return Inputmask(options).isValid(value);
	    }, Inputmask.remove = function(elems) {
	        $.each(elems, function(ndx, el) {
	            el.inputmask && el.inputmask.remove();
	        });
	    }, Inputmask.escapeRegex = function(str) {
	        var specials = [ "/", ".", "*", "+", "?", "|", "(", ")", "[", "]", "{", "}", "\\", "$", "^" ];
	        return str.replace(new RegExp("(\\" + specials.join("|\\") + ")", "gim"), "\\$1");
	    }, Inputmask.keyCode = {
	        ALT: 18,
	        BACKSPACE: 8,
	        BACKSPACE_SAFARI: 127,
	        CAPS_LOCK: 20,
	        COMMA: 188,
	        COMMAND: 91,
	        COMMAND_LEFT: 91,
	        COMMAND_RIGHT: 93,
	        CONTROL: 17,
	        DELETE: 46,
	        DOWN: 40,
	        END: 35,
	        ENTER: 13,
	        ESCAPE: 27,
	        HOME: 36,
	        INSERT: 45,
	        LEFT: 37,
	        MENU: 93,
	        NUMPAD_ADD: 107,
	        NUMPAD_DECIMAL: 110,
	        NUMPAD_DIVIDE: 111,
	        NUMPAD_ENTER: 108,
	        NUMPAD_MULTIPLY: 106,
	        NUMPAD_SUBTRACT: 109,
	        PAGE_DOWN: 34,
	        PAGE_UP: 33,
	        PERIOD: 190,
	        RIGHT: 39,
	        SHIFT: 16,
	        SPACE: 32,
	        TAB: 9,
	        UP: 38,
	        WINDOWS: 91,
	        X: 88
	    }, Inputmask;
	});

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	* inputmask.numeric.extensions.js
	* https://github.com/RobinHerbots/Inputmask
	* Copyright (c) 2010 - 2017 Robin Herbots
	* Licensed under the MIT license (http://www.opensource.org/licenses/mit-license.php)
	* Version: 3.3.7
	*/
	
	!function(factory) {
	     true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(318), __webpack_require__(321) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == typeof exports ? module.exports = factory(require("./dependencyLibs/inputmask.dependencyLib"), require("./inputmask")) : factory(window.dependencyLib || jQuery, window.Inputmask);
	}(function($, Inputmask, undefined) {
	    function autoEscape(txt, opts) {
	        for (var escapedTxt = "", i = 0; i < txt.length; i++) Inputmask.prototype.definitions[txt.charAt(i)] || opts.definitions[txt.charAt(i)] || opts.optionalmarker.start === txt.charAt(i) || opts.optionalmarker.end === txt.charAt(i) || opts.quantifiermarker.start === txt.charAt(i) || opts.quantifiermarker.end === txt.charAt(i) || opts.groupmarker.start === txt.charAt(i) || opts.groupmarker.end === txt.charAt(i) || opts.alternatormarker === txt.charAt(i) ? escapedTxt += "\\" + txt.charAt(i) : escapedTxt += txt.charAt(i);
	        return escapedTxt;
	    }
	    return Inputmask.extendAliases({
	        numeric: {
	            mask: function(opts) {
	                if (0 !== opts.repeat && isNaN(opts.integerDigits) && (opts.integerDigits = opts.repeat), 
	                opts.repeat = 0, opts.groupSeparator === opts.radixPoint && ("." === opts.radixPoint ? opts.groupSeparator = "," : "," === opts.radixPoint ? opts.groupSeparator = "." : opts.groupSeparator = ""), 
	                " " === opts.groupSeparator && (opts.skipOptionalPartCharacter = undefined), opts.autoGroup = opts.autoGroup && "" !== opts.groupSeparator, 
	                opts.autoGroup && ("string" == typeof opts.groupSize && isFinite(opts.groupSize) && (opts.groupSize = parseInt(opts.groupSize)), 
	                isFinite(opts.integerDigits))) {
	                    var seps = Math.floor(opts.integerDigits / opts.groupSize), mod = opts.integerDigits % opts.groupSize;
	                    opts.integerDigits = parseInt(opts.integerDigits) + (0 === mod ? seps - 1 : seps), 
	                    opts.integerDigits < 1 && (opts.integerDigits = "*");
	                }
	                opts.placeholder.length > 1 && (opts.placeholder = opts.placeholder.charAt(0)), 
	                "radixFocus" === opts.positionCaretOnClick && "" === opts.placeholder && !1 === opts.integerOptional && (opts.positionCaretOnClick = "lvp"), 
	                opts.definitions[";"] = opts.definitions["~"], opts.definitions[";"].definitionSymbol = "~", 
	                !0 === opts.numericInput && (opts.positionCaretOnClick = "radixFocus" === opts.positionCaretOnClick ? "lvp" : opts.positionCaretOnClick, 
	                opts.digitsOptional = !1, isNaN(opts.digits) && (opts.digits = 2), opts.decimalProtect = !1);
	                var mask = "[+]";
	                if (mask += autoEscape(opts.prefix, opts), !0 === opts.integerOptional ? mask += "~{1," + opts.integerDigits + "}" : mask += "~{" + opts.integerDigits + "}", 
	                opts.digits !== undefined) {
	                    opts.radixPointDefinitionSymbol = opts.decimalProtect ? ":" : opts.radixPoint;
	                    var dq = opts.digits.toString().split(",");
	                    isFinite(dq[0] && dq[1] && isFinite(dq[1])) ? mask += opts.radixPointDefinitionSymbol + ";{" + opts.digits + "}" : (isNaN(opts.digits) || parseInt(opts.digits) > 0) && (opts.digitsOptional ? mask += "[" + opts.radixPointDefinitionSymbol + ";{1," + opts.digits + "}]" : mask += opts.radixPointDefinitionSymbol + ";{" + opts.digits + "}");
	                }
	                return mask += autoEscape(opts.suffix, opts), mask += "[-]", opts.greedy = !1, mask;
	            },
	            placeholder: "",
	            greedy: !1,
	            digits: "*",
	            digitsOptional: !0,
	            enforceDigitsOnBlur: !1,
	            radixPoint: ".",
	            positionCaretOnClick: "radixFocus",
	            groupSize: 3,
	            groupSeparator: "",
	            autoGroup: !1,
	            allowMinus: !0,
	            negationSymbol: {
	                front: "-",
	                back: ""
	            },
	            integerDigits: "+",
	            integerOptional: !0,
	            prefix: "",
	            suffix: "",
	            rightAlign: !0,
	            decimalProtect: !0,
	            min: null,
	            max: null,
	            step: 1,
	            insertMode: !0,
	            autoUnmask: !1,
	            unmaskAsNumber: !1,
	            inputmode: "numeric",
	            preValidation: function(buffer, pos, c, isSelection, opts) {
	                if ("-" === c || c == opts.negationSymbol.front) return !0 === opts.allowMinus && (opts.isNegative = opts.isNegative === undefined || !opts.isNegative, 
	                "" === buffer.join("") || {
	                    caret: pos,
	                    dopost: !0
	                });
	                if (!1 === isSelection && c === opts.radixPoint && opts.digits !== undefined && (isNaN(opts.digits) || parseInt(opts.digits) > 0)) {
	                    var radixPos = $.inArray(opts.radixPoint, buffer);
	                    if (-1 !== radixPos) return !0 === opts.numericInput ? pos === radixPos : {
	                        caret: radixPos + 1
	                    };
	                }
	                return !0;
	            },
	            postValidation: function(buffer, currentResult, opts) {
	                var suffix = opts.suffix.split(""), prefix = opts.prefix.split("");
	                if (currentResult.pos == undefined && currentResult.caret !== undefined && !0 !== currentResult.dopost) return currentResult;
	                var caretPos = currentResult.caret != undefined ? currentResult.caret : currentResult.pos, maskedValue = buffer.slice();
	                opts.numericInput && (caretPos = maskedValue.length - caretPos - 1, maskedValue = maskedValue.reverse());
	                var charAtPos = maskedValue[caretPos];
	                if (charAtPos === opts.groupSeparator && (caretPos += 1, charAtPos = maskedValue[caretPos]), 
	                caretPos == maskedValue.length - opts.suffix.length - 1 && charAtPos === opts.radixPoint) return currentResult;
	                charAtPos !== undefined && charAtPos !== opts.radixPoint && charAtPos !== opts.negationSymbol.front && charAtPos !== opts.negationSymbol.back && (maskedValue[caretPos] = "?", 
	                opts.prefix.length > 0 && caretPos >= (!1 === opts.isNegative ? 1 : 0) && caretPos < opts.prefix.length - 1 + (!1 === opts.isNegative ? 1 : 0) ? prefix[caretPos - (!1 === opts.isNegative ? 1 : 0)] = "?" : opts.suffix.length > 0 && caretPos >= maskedValue.length - opts.suffix.length - (!1 === opts.isNegative ? 1 : 0) && (suffix[caretPos - (maskedValue.length - opts.suffix.length - (!1 === opts.isNegative ? 1 : 0))] = "?")), 
	                prefix = prefix.join(""), suffix = suffix.join("");
	                var processValue = maskedValue.join("").replace(prefix, "");
	                if (processValue = processValue.replace(suffix, ""), processValue = processValue.replace(new RegExp(Inputmask.escapeRegex(opts.groupSeparator), "g"), ""), 
	                processValue = processValue.replace(new RegExp("[-" + Inputmask.escapeRegex(opts.negationSymbol.front) + "]", "g"), ""), 
	                processValue = processValue.replace(new RegExp(Inputmask.escapeRegex(opts.negationSymbol.back) + "$"), ""), 
	                isNaN(opts.placeholder) && (processValue = processValue.replace(new RegExp(Inputmask.escapeRegex(opts.placeholder), "g"), "")), 
	                processValue.length > 1 && 1 !== processValue.indexOf(opts.radixPoint) && ("0" == charAtPos && (processValue = processValue.replace(/^\?/g, "")), 
	                processValue = processValue.replace(/^0/g, "")), processValue.charAt(0) === opts.radixPoint && "" !== opts.radixPoint && !0 !== opts.numericInput && (processValue = "0" + processValue), 
	                "" !== processValue) {
	                    if (processValue = processValue.split(""), (!opts.digitsOptional || opts.enforceDigitsOnBlur && "blur" === currentResult.event) && isFinite(opts.digits)) {
	                        var radixPosition = $.inArray(opts.radixPoint, processValue), rpb = $.inArray(opts.radixPoint, maskedValue);
	                        -1 === radixPosition && (processValue.push(opts.radixPoint), radixPosition = processValue.length - 1);
	                        for (var i = 1; i <= opts.digits; i++) opts.digitsOptional && (!opts.enforceDigitsOnBlur || "blur" !== currentResult.event) || processValue[radixPosition + i] !== undefined && processValue[radixPosition + i] !== opts.placeholder.charAt(0) ? -1 !== rpb && maskedValue[rpb + i] !== undefined && (processValue[radixPosition + i] = processValue[radixPosition + i] || maskedValue[rpb + i]) : processValue[radixPosition + i] = currentResult.placeholder || opts.placeholder.charAt(0);
	                    }
	                    !0 !== opts.autoGroup || "" === opts.groupSeparator || charAtPos === opts.radixPoint && currentResult.pos === undefined && !currentResult.dopost ? processValue = processValue.join("") : (processValue = Inputmask(function(buffer, opts) {
	                        var postMask = "";
	                        if (postMask += "(" + opts.groupSeparator + "*{" + opts.groupSize + "}){*}", "" !== opts.radixPoint) {
	                            var radixSplit = buffer.join("").split(opts.radixPoint);
	                            radixSplit[1] && (postMask += opts.radixPoint + "*{" + radixSplit[1].match(/^\d*\??\d*/)[0].length + "}");
	                        }
	                        return postMask;
	                    }(processValue, opts), {
	                        numericInput: !0,
	                        jitMasking: !0,
	                        definitions: {
	                            "*": {
	                                validator: "[0-9?]",
	                                cardinality: 1
	                            }
	                        }
	                    }).format(processValue.join("")), processValue.charAt(0) === opts.groupSeparator && processValue.substr(1));
	                }
	                if (opts.isNegative && "blur" === currentResult.event && (opts.isNegative = "0" !== processValue), 
	                processValue = prefix + processValue, processValue += suffix, opts.isNegative && (processValue = opts.negationSymbol.front + processValue, 
	                processValue += opts.negationSymbol.back), processValue = processValue.split(""), 
	                charAtPos !== undefined) if (charAtPos !== opts.radixPoint && charAtPos !== opts.negationSymbol.front && charAtPos !== opts.negationSymbol.back) caretPos = $.inArray("?", processValue), 
	                caretPos > -1 ? processValue[caretPos] = charAtPos : caretPos = currentResult.caret || 0; else if (charAtPos === opts.radixPoint || charAtPos === opts.negationSymbol.front || charAtPos === opts.negationSymbol.back) {
	                    var newCaretPos = $.inArray(charAtPos, processValue);
	                    -1 !== newCaretPos && (caretPos = newCaretPos);
	                }
	                opts.numericInput && (caretPos = processValue.length - caretPos - 1, processValue = processValue.reverse());
	                var rslt = {
	                    caret: charAtPos === undefined || currentResult.pos !== undefined ? caretPos + (opts.numericInput ? -1 : 1) : caretPos,
	                    buffer: processValue,
	                    refreshFromBuffer: currentResult.dopost || buffer.join("") !== processValue.join("")
	                };
	                return rslt.refreshFromBuffer ? rslt : currentResult;
	            },
	            onBeforeWrite: function(e, buffer, caretPos, opts) {
	                if (e) switch (e.type) {
	                  case "keydown":
	                    return opts.postValidation(buffer, {
	                        caret: caretPos,
	                        dopost: !0
	                    }, opts);
	
	                  case "blur":
	                  case "checkval":
	                    var unmasked;
	                    if (function(opts) {
	                        opts.parseMinMaxOptions === undefined && (null !== opts.min && (opts.min = opts.min.toString().replace(new RegExp(Inputmask.escapeRegex(opts.groupSeparator), "g"), ""), 
	                        "," === opts.radixPoint && (opts.min = opts.min.replace(opts.radixPoint, ".")), 
	                        opts.min = isFinite(opts.min) ? parseFloat(opts.min) : NaN, isNaN(opts.min) && (opts.min = Number.MIN_VALUE)), 
	                        null !== opts.max && (opts.max = opts.max.toString().replace(new RegExp(Inputmask.escapeRegex(opts.groupSeparator), "g"), ""), 
	                        "," === opts.radixPoint && (opts.max = opts.max.replace(opts.radixPoint, ".")), 
	                        opts.max = isFinite(opts.max) ? parseFloat(opts.max) : NaN, isNaN(opts.max) && (opts.max = Number.MAX_VALUE)), 
	                        opts.parseMinMaxOptions = "done");
	                    }(opts), null !== opts.min || null !== opts.max) {
	                        if (unmasked = opts.onUnMask(buffer.join(""), undefined, $.extend({}, opts, {
	                            unmaskAsNumber: !0
	                        })), null !== opts.min && unmasked < opts.min) return opts.isNegative = opts.min < 0, 
	                        opts.postValidation(opts.min.toString().replace(".", opts.radixPoint).split(""), {
	                            caret: caretPos,
	                            dopost: !0,
	                            placeholder: "0"
	                        }, opts);
	                        if (null !== opts.max && unmasked > opts.max) return opts.isNegative = opts.max < 0, 
	                        opts.postValidation(opts.max.toString().replace(".", opts.radixPoint).split(""), {
	                            caret: caretPos,
	                            dopost: !0,
	                            placeholder: "0"
	                        }, opts);
	                    }
	                    return opts.postValidation(buffer, {
	                        caret: caretPos,
	                        dopost: !0,
	                        placeholder: "0",
	                        event: "blur"
	                    }, opts);
	
	                  case "_checkval":
	                    return {
	                        caret: caretPos
	                    };
	                }
	            },
	            regex: {
	                integerPart: function(opts, emptyCheck) {
	                    return emptyCheck ? new RegExp("[" + Inputmask.escapeRegex(opts.negationSymbol.front) + "+]?") : new RegExp("[" + Inputmask.escapeRegex(opts.negationSymbol.front) + "+]?\\d+");
	                },
	                integerNPart: function(opts) {
	                    return new RegExp("[\\d" + Inputmask.escapeRegex(opts.groupSeparator) + Inputmask.escapeRegex(opts.placeholder.charAt(0)) + "]+");
	                }
	            },
	            definitions: {
	                "~": {
	                    validator: function(chrs, maskset, pos, strict, opts, isSelection) {
	                        var isValid = strict ? new RegExp("[0-9" + Inputmask.escapeRegex(opts.groupSeparator) + "]").test(chrs) : new RegExp("[0-9]").test(chrs);
	                        if (!0 === isValid) {
	                            if (!0 !== opts.numericInput && maskset.validPositions[pos] !== undefined && "~" === maskset.validPositions[pos].match.def && !isSelection) {
	                                var processValue = maskset.buffer.join("");
	                                processValue = processValue.replace(new RegExp("[-" + Inputmask.escapeRegex(opts.negationSymbol.front) + "]", "g"), ""), 
	                                processValue = processValue.replace(new RegExp(Inputmask.escapeRegex(opts.negationSymbol.back) + "$"), "");
	                                var pvRadixSplit = processValue.split(opts.radixPoint);
	                                pvRadixSplit.length > 1 && (pvRadixSplit[1] = pvRadixSplit[1].replace(/0/g, opts.placeholder.charAt(0))), 
	                                "0" === pvRadixSplit[0] && (pvRadixSplit[0] = pvRadixSplit[0].replace(/0/g, opts.placeholder.charAt(0))), 
	                                processValue = pvRadixSplit[0] + opts.radixPoint + pvRadixSplit[1] || "";
	                                var bufferTemplate = maskset._buffer.join("");
	                                for (processValue === opts.radixPoint && (processValue = bufferTemplate); null === processValue.match(Inputmask.escapeRegex(bufferTemplate) + "$"); ) bufferTemplate = bufferTemplate.slice(1);
	                                processValue = processValue.replace(bufferTemplate, ""), processValue = processValue.split(""), 
	                                isValid = processValue[pos] === undefined ? {
	                                    pos: pos,
	                                    remove: pos
	                                } : {
	                                    pos: pos
	                                };
	                            }
	                        } else strict || chrs !== opts.radixPoint || maskset.validPositions[pos - 1] !== undefined || (maskset.buffer[pos] = "0", 
	                        isValid = {
	                            pos: pos + 1
	                        });
	                        return isValid;
	                    },
	                    cardinality: 1
	                },
	                "+": {
	                    validator: function(chrs, maskset, pos, strict, opts) {
	                        return opts.allowMinus && ("-" === chrs || chrs === opts.negationSymbol.front);
	                    },
	                    cardinality: 1,
	                    placeholder: ""
	                },
	                "-": {
	                    validator: function(chrs, maskset, pos, strict, opts) {
	                        return opts.allowMinus && chrs === opts.negationSymbol.back;
	                    },
	                    cardinality: 1,
	                    placeholder: ""
	                },
	                ":": {
	                    validator: function(chrs, maskset, pos, strict, opts) {
	                        var radix = "[" + Inputmask.escapeRegex(opts.radixPoint) + "]", isValid = new RegExp(radix).test(chrs);
	                        return isValid && maskset.validPositions[pos] && maskset.validPositions[pos].match.placeholder === opts.radixPoint && (isValid = {
	                            caret: pos + 1
	                        }), isValid;
	                    },
	                    cardinality: 1,
	                    placeholder: function(opts) {
	                        return opts.radixPoint;
	                    }
	                }
	            },
	            onUnMask: function(maskedValue, unmaskedValue, opts) {
	                if ("" === unmaskedValue && !0 === opts.nullable) return unmaskedValue;
	                var processValue = maskedValue.replace(opts.prefix, "");
	                return processValue = processValue.replace(opts.suffix, ""), processValue = processValue.replace(new RegExp(Inputmask.escapeRegex(opts.groupSeparator), "g"), ""), 
	                "" !== opts.placeholder.charAt(0) && (processValue = processValue.replace(new RegExp(opts.placeholder.charAt(0), "g"), "0")), 
	                opts.unmaskAsNumber ? ("" !== opts.radixPoint && -1 !== processValue.indexOf(opts.radixPoint) && (processValue = processValue.replace(Inputmask.escapeRegex.call(this, opts.radixPoint), ".")), 
	                processValue = processValue.replace(new RegExp("^" + Inputmask.escapeRegex(opts.negationSymbol.front)), "-"), 
	                processValue = processValue.replace(new RegExp(Inputmask.escapeRegex(opts.negationSymbol.back) + "$"), ""), 
	                Number(processValue)) : processValue;
	            },
	            isComplete: function(buffer, opts) {
	                var maskedValue = buffer.join("");
	                if (buffer.slice().join("") !== maskedValue) return !1;
	                var processValue = maskedValue.replace(opts.prefix, "");
	                return processValue = processValue.replace(opts.suffix, ""), processValue = processValue.replace(new RegExp(Inputmask.escapeRegex(opts.groupSeparator), "g"), ""), 
	                "," === opts.radixPoint && (processValue = processValue.replace(Inputmask.escapeRegex(opts.radixPoint), ".")), 
	                isFinite(processValue);
	            },
	            onBeforeMask: function(initialValue, opts) {
	                if (opts.isNegative = undefined, initialValue = initialValue.toString().charAt(initialValue.length - 1) === opts.radixPoint ? initialValue.toString().substr(0, initialValue.length - 1) : initialValue.toString(), 
	                "" !== opts.radixPoint && isFinite(initialValue)) {
	                    var vs = initialValue.split("."), groupSize = "" !== opts.groupSeparator ? parseInt(opts.groupSize) : 0;
	                    2 === vs.length && (vs[0].length > groupSize || vs[1].length > groupSize || vs[0].length <= groupSize && vs[1].length < groupSize) && (initialValue = initialValue.replace(".", opts.radixPoint));
	                }
	                var kommaMatches = initialValue.match(/,/g), dotMatches = initialValue.match(/\./g);
	                if (dotMatches && kommaMatches ? dotMatches.length > kommaMatches.length ? (initialValue = initialValue.replace(/\./g, ""), 
	                initialValue = initialValue.replace(",", opts.radixPoint)) : kommaMatches.length > dotMatches.length ? (initialValue = initialValue.replace(/,/g, ""), 
	                initialValue = initialValue.replace(".", opts.radixPoint)) : initialValue = initialValue.indexOf(".") < initialValue.indexOf(",") ? initialValue.replace(/\./g, "") : initialValue = initialValue.replace(/,/g, "") : initialValue = initialValue.replace(new RegExp(Inputmask.escapeRegex(opts.groupSeparator), "g"), ""), 
	                0 === opts.digits && (-1 !== initialValue.indexOf(".") ? initialValue = initialValue.substring(0, initialValue.indexOf(".")) : -1 !== initialValue.indexOf(",") && (initialValue = initialValue.substring(0, initialValue.indexOf(",")))), 
	                "" !== opts.radixPoint && isFinite(opts.digits) && -1 !== initialValue.indexOf(opts.radixPoint)) {
	                    var valueParts = initialValue.split(opts.radixPoint), decPart = valueParts[1].match(new RegExp("\\d*"))[0];
	                    if (parseInt(opts.digits) < decPart.toString().length) {
	                        var digitsFactor = Math.pow(10, parseInt(opts.digits));
	                        initialValue = initialValue.replace(Inputmask.escapeRegex(opts.radixPoint), "."), 
	                        initialValue = Math.round(parseFloat(initialValue) * digitsFactor) / digitsFactor, 
	                        initialValue = initialValue.toString().replace(".", opts.radixPoint);
	                    }
	                }
	                return initialValue;
	            },
	            canClearPosition: function(maskset, position, lvp, strict, opts) {
	                var vp = maskset.validPositions[position], canClear = vp.input !== opts.radixPoint || null !== maskset.validPositions[position].match.fn && !1 === opts.decimalProtect || vp.input === opts.radixPoint && maskset.validPositions[position + 1] && null === maskset.validPositions[position + 1].match.fn || isFinite(vp.input) || position === lvp || vp.input === opts.groupSeparator || vp.input === opts.negationSymbol.front || vp.input === opts.negationSymbol.back;
	                return !canClear || "+" != vp.match.nativeDef && "-" != vp.match.nativeDef || (opts.isNegative = !1), 
	                canClear;
	            },
	            onKeyDown: function(e, buffer, caretPos, opts) {
	                var $input = $(this);
	                if (e.ctrlKey) switch (e.keyCode) {
	                  case Inputmask.keyCode.UP:
	                    $input.val(parseFloat(this.inputmask.unmaskedvalue()) + parseInt(opts.step)), $input.trigger("setvalue");
	                    break;
	
	                  case Inputmask.keyCode.DOWN:
	                    $input.val(parseFloat(this.inputmask.unmaskedvalue()) - parseInt(opts.step)), $input.trigger("setvalue");
	                }
	            }
	        },
	        currency: {
	            prefix: "$ ",
	            groupSeparator: ",",
	            alias: "numeric",
	            placeholder: "0",
	            autoGroup: !0,
	            digits: 2,
	            digitsOptional: !1,
	            clearMaskOnLostFocus: !1
	        },
	        decimal: {
	            alias: "numeric"
	        },
	        integer: {
	            alias: "numeric",
	            digits: 0,
	            radixPoint: ""
	        },
	        percentage: {
	            alias: "numeric",
	            digits: 2,
	            digitsOptional: !0,
	            radixPoint: ".",
	            placeholder: "0",
	            autoGroup: !1,
	            min: 0,
	            max: 100,
	            suffix: " %",
	            allowMinus: !1
	        }
	    }), Inputmask;
	});

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	* jquery.inputmask.js
	* https://github.com/RobinHerbots/Inputmask
	* Copyright (c) 2010 - 2017 Robin Herbots
	* Licensed under the MIT license (http://www.opensource.org/licenses/mit-license.php)
	* Version: 3.3.7
	*/
	
	!function(factory) {
	     true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1), __webpack_require__(321) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == typeof exports ? module.exports = factory(require("jquery"), require("./inputmask")) : factory(jQuery, window.Inputmask);
	}(function($, Inputmask) {
	    return void 0 === $.fn.inputmask && ($.fn.inputmask = function(fn, options) {
	        var nptmask, input = this[0];
	        if (void 0 === options && (options = {}), "string" == typeof fn) switch (fn) {
	          case "unmaskedvalue":
	            return input && input.inputmask ? input.inputmask.unmaskedvalue() : $(input).val();
	
	          case "remove":
	            return this.each(function() {
	                this.inputmask && this.inputmask.remove();
	            });
	
	          case "getemptymask":
	            return input && input.inputmask ? input.inputmask.getemptymask() : "";
	
	          case "hasMaskedValue":
	            return !(!input || !input.inputmask) && input.inputmask.hasMaskedValue();
	
	          case "isComplete":
	            return !input || !input.inputmask || input.inputmask.isComplete();
	
	          case "getmetadata":
	            return input && input.inputmask ? input.inputmask.getmetadata() : void 0;
	
	          case "setvalue":
	            $(input).val(options), input && void 0 === input.inputmask && $(input).triggerHandler("setvalue");
	            break;
	
	          case "option":
	            if ("string" != typeof options) return this.each(function() {
	                if (void 0 !== this.inputmask) return this.inputmask.option(options);
	            });
	            if (input && void 0 !== input.inputmask) return input.inputmask.option(options);
	            break;
	
	          default:
	            return options.alias = fn, nptmask = new Inputmask(options), this.each(function() {
	                nptmask.mask(this);
	            });
	        } else {
	            if ("object" == typeof fn) return nptmask = new Inputmask(fn), void 0 === fn.mask && void 0 === fn.alias ? this.each(function() {
	                if (void 0 !== this.inputmask) return this.inputmask.option(fn);
	                nptmask.mask(this);
	            }) : this.each(function() {
	                nptmask.mask(this);
	            });
	            if (void 0 === fn) return this.each(function() {
	                nptmask = new Inputmask(options), nptmask.mask(this);
	            });
	        }
	    }), $.fn.inputmask;
	});

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	(function(deparam){
	    if (true) {
	        try {
	            var jquery = __webpack_require__(1);
	        } catch (e) {
	        }
	        module.exports = deparam(jquery);
	    } else if (typeof define === 'function' && define.amd){
	        define(['jquery'], function(jquery){
	            return deparam(jquery);
	        });
	    } else {
	        var global;
	        try {
	          global = (false || eval)('this'); // best cross-browser way to determine global for < ES5
	        } catch (e) {
	          global = window; // fails only if browser (https://developer.mozilla.org/en-US/docs/Web/Security/CSP/CSP_policy_directives)
	        }
	        global.deparam = deparam(global.jQuery); // assume jQuery is in global namespace
	    }
	})(function ($) {
	    var deparam = function( params, coerce ) {
	        var obj = {},
	        coerce_types = { 'true': !0, 'false': !1, 'null': null };
	
	        // Iterate over all name=value pairs.
	        params.replace(/\+/g, ' ').split('&').forEach(function(v){
	            var param = v.split( '=' ),
	            key = decodeURIComponent( param[0] ),
	            val,
	            cur = obj,
	            i = 0,
	
	            // If key is more complex than 'foo', like 'a[]' or 'a[b][c]', split it
	            // into its component parts.
	            keys = key.split( '][' ),
	            keys_last = keys.length - 1;
	
	            // If the first keys part contains [ and the last ends with ], then []
	            // are correctly balanced.
	            if ( /\[/.test( keys[0] ) && /\]$/.test( keys[ keys_last ] ) ) {
	                // Remove the trailing ] from the last keys part.
	                keys[ keys_last ] = keys[ keys_last ].replace( /\]$/, '' );
	
	                // Split first keys part into two parts on the [ and add them back onto
	                // the beginning of the keys array.
	                keys = keys.shift().split('[').concat( keys );
	
	                keys_last = keys.length - 1;
	            } else {
	                // Basic 'foo' style key.
	                keys_last = 0;
	            }
	
	            // Are we dealing with a name=value pair, or just a name?
	            if ( param.length === 2 ) {
	                val = decodeURIComponent( param[1] );
	
	                // Coerce values.
	                if ( coerce ) {
	                    val = val && !isNaN(val) && ((+val + '') === val) ? +val        // number
	                    : val === 'undefined'                       ? undefined         // undefined
	                    : coerce_types[val] !== undefined           ? coerce_types[val] // true, false, null
	                    : val;                                                          // string
	                }
	
	                if ( keys_last ) {
	                    // Complex key, build deep object structure based on a few rules:
	                    // * The 'cur' pointer starts at the object top-level.
	                    // * [] = array push (n is set to array length), [n] = array if n is
	                    //   numeric, otherwise object.
	                    // * If at the last keys part, set the value.
	                    // * For each keys part, if the current level is undefined create an
	                    //   object or array based on the type of the next keys part.
	                    // * Move the 'cur' pointer to the next level.
	                    // * Rinse & repeat.
	                    for ( ; i <= keys_last; i++ ) {
	                        key = keys[i] === '' ? cur.length : keys[i];
	                        cur = cur[key] = i < keys_last
	                        ? cur[key] || ( keys[i+1] && isNaN( keys[i+1] ) ? {} : [] )
	                        : val;
	                    }
	
	                } else {
	                    // Simple key, even simpler rules, since only scalars and shallow
	                    // arrays are allowed.
	
	                    if ( Object.prototype.toString.call( obj[key] ) === '[object Array]' ) {
	                        // val is already an array, so push on the next value.
	                        obj[key].push( val );
	
	                    } else if ( {}.hasOwnProperty.call(obj, key) ) {
	                        // val isn't an array, but since a second value has been specified,
	                        // convert val into an array.
	                        obj[key] = [ obj[key], val ];
	
	                    } else {
	                        // val is a scalar.
	                        obj[key] = val;
	                    }
	                }
	
	            } else if ( key ) {
	                // No value was defined, so set something meaningful.
	                obj[key] = coerce
	                ? undefined
	                : '';
	            }
	        });
	
	        return obj;
	    };
	    if ($) {
	      $.prototype.deparam = $.deparam = deparam;
	    }
	    return deparam;
	});


/***/ },
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value instanceof AwaitArgument) {
	          return Promise.resolve(value.arg).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = arg;
	
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(193)))

/***/ },
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(860);
	module.exports = __webpack_require__(49).RegExp.escape;


/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	var isArray = __webpack_require__(119);
	var SPECIES = __webpack_require__(23)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(17);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(12);
	var toPrimitive = __webpack_require__(60);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(77);
	var gOPS = __webpack_require__(123);
	var pIE = __webpack_require__(102);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(103)('native-function-to-string', Function.toString);


/***/ },
/* 859 */
/***/ function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(8);
	var $re = __webpack_require__(859)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(233) });
	
	__webpack_require__(67)('copyWithin');


/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $every = __webpack_require__(57)(4);
	
	$export($export.P + $export.F * !__webpack_require__(51)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Array', { fill: __webpack_require__(152) });
	
	__webpack_require__(67)('fill');


/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $filter = __webpack_require__(57)(2);
	
	$export($export.P + $export.F * !__webpack_require__(51)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(8);
	var $find = __webpack_require__(57)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(67)(KEY);


/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(8);
	var $find = __webpack_require__(57)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(67)(KEY);


/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $forEach = __webpack_require__(57)(0);
	var STRICT = __webpack_require__(51)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(50);
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(32);
	var call = __webpack_require__(244);
	var isArrayIter = __webpack_require__(160);
	var toLength = __webpack_require__(25);
	var createProperty = __webpack_require__(154);
	var getIterFn = __webpack_require__(176);
	
	$export($export.S + $export.F * !__webpack_require__(121)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $indexOf = __webpack_require__(116)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(51)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(119) });


/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(8);
	var toIObject = __webpack_require__(45);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(101) != Object || !__webpack_require__(51)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toIObject = __webpack_require__(45);
	var toInteger = __webpack_require__(52);
	var toLength = __webpack_require__(25);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(51)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $map = __webpack_require__(57)(1);
	
	$export($export.P + $export.F * !__webpack_require__(51)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var createProperty = __webpack_require__(154);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(17)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $reduce = __webpack_require__(235);
	
	$export($export.P + $export.F * !__webpack_require__(51)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $reduce = __webpack_require__(235);
	
	$export($export.P + $export.F * !__webpack_require__(51)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var html = __webpack_require__(158);
	var cof = __webpack_require__(48);
	var toAbsoluteIndex = __webpack_require__(81);
	var toLength = __webpack_require__(25);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(17)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $some = __webpack_require__(57)(3);
	
	$export($export.P + $export.F * !__webpack_require__(51)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var aFunction = __webpack_require__(37);
	var toObject = __webpack_require__(32);
	var fails = __webpack_require__(17);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(51)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(80)('Array');


/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(8);
	var toISOString = __webpack_require__(855);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(32);
	var toPrimitive = __webpack_require__(60);
	
	$export($export.P + $export.F * __webpack_require__(17)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(23)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(39)(proto, TO_PRIMITIVE, __webpack_require__(856));


/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(40)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Function', { bind: __webpack_require__(236) });


/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(18);
	var getPrototypeOf = __webpack_require__(44);
	var HAS_INSTANCE = __webpack_require__(23)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(29).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(29).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(28) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(8);
	var log1p = __webpack_require__(247);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(8);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(8);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(8);
	var sign = __webpack_require__(164);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(8);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(8);
	var $expm1 = __webpack_require__(163);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { fround: __webpack_require__(246) });


/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(8);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(8);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(17)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(247) });


/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { sign: __webpack_require__(164) });


/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(8);
	var expm1 = __webpack_require__(163);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(17)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(8);
	var expm1 = __webpack_require__(163);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(13);
	var has = __webpack_require__(42);
	var cof = __webpack_require__(48);
	var inheritIfRequired = __webpack_require__(159);
	var toPrimitive = __webpack_require__(60);
	var fails = __webpack_require__(17);
	var gOPN = __webpack_require__(76).f;
	var gOPD = __webpack_require__(43).f;
	var dP = __webpack_require__(29).f;
	var $trim = __webpack_require__(91).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(75)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(28) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(40)(global, NUMBER, $Number);
	}


/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(8);
	var _isFinite = __webpack_require__(13).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(243) });


/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(8);
	var isInteger = __webpack_require__(243);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $parseFloat = __webpack_require__(255);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $parseInt = __webpack_require__(256);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toInteger = __webpack_require__(52);
	var aNumberValue = __webpack_require__(232);
	var repeat = __webpack_require__(171);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(17)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $fails = __webpack_require__(17);
	var aNumberValue = __webpack_require__(232);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(8);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(249) });


/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(75) });


/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(28), 'Object', { defineProperties: __webpack_require__(250) });


/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(28), 'Object', { defineProperty: __webpack_require__(29).f });


/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(18);
	var meta = __webpack_require__(69).onFreeze;
	
	__webpack_require__(59)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(45);
	var $getOwnPropertyDescriptor = __webpack_require__(43).f;
	
	__webpack_require__(59)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(59)('getOwnPropertyNames', function () {
	  return __webpack_require__(251).f;
	});


/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(32);
	var $getPrototypeOf = __webpack_require__(44);
	
	__webpack_require__(59)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(18);
	
	__webpack_require__(59)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(18);
	
	__webpack_require__(59)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(18);
	
	__webpack_require__(59)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(8);
	$export($export.S, 'Object', { is: __webpack_require__(259) });


/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(32);
	var $keys = __webpack_require__(77);
	
	__webpack_require__(59)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(18);
	var meta = __webpack_require__(69).onFreeze;
	
	__webpack_require__(59)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(18);
	var meta = __webpack_require__(69).onFreeze;
	
	__webpack_require__(59)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(8);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(168).set });


/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(88);
	var test = {};
	test[__webpack_require__(23)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(40)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $parseFloat = __webpack_require__(255);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $parseInt = __webpack_require__(256);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(68);
	var global = __webpack_require__(13);
	var ctx = __webpack_require__(50);
	var classof = __webpack_require__(88);
	var $export = __webpack_require__(8);
	var isObject = __webpack_require__(18);
	var aFunction = __webpack_require__(37);
	var anInstance = __webpack_require__(73);
	var forOf = __webpack_require__(74);
	var speciesConstructor = __webpack_require__(104);
	var task = __webpack_require__(173).set;
	var microtask = __webpack_require__(165)();
	var newPromiseCapabilityModule = __webpack_require__(166);
	var perform = __webpack_require__(257);
	var userAgent = __webpack_require__(129);
	var promiseResolve = __webpack_require__(258);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(23)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(79)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(90)($Promise, PROMISE);
	__webpack_require__(80)(PROMISE);
	Wrapper = __webpack_require__(49)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(121)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(8);
	var aFunction = __webpack_require__(37);
	var anObject = __webpack_require__(12);
	var rApply = (__webpack_require__(13).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(17)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(8);
	var create = __webpack_require__(75);
	var aFunction = __webpack_require__(37);
	var anObject = __webpack_require__(12);
	var isObject = __webpack_require__(18);
	var fails = __webpack_require__(17);
	var bind = __webpack_require__(236);
	var rConstruct = (__webpack_require__(13).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(29);
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(12);
	var toPrimitive = __webpack_require__(60);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(17)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(8);
	var gOPD = __webpack_require__(43).f;
	var anObject = __webpack_require__(12);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(12);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(161)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(43);
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(12);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(8);
	var getProto = __webpack_require__(44);
	var anObject = __webpack_require__(12);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(43);
	var getPrototypeOf = __webpack_require__(44);
	var has = __webpack_require__(42);
	var $export = __webpack_require__(8);
	var isObject = __webpack_require__(18);
	var anObject = __webpack_require__(12);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(12);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(254) });


/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(12);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(8);
	var setProto = __webpack_require__(168);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(29);
	var gOPD = __webpack_require__(43);
	var getPrototypeOf = __webpack_require__(44);
	var has = __webpack_require__(42);
	var $export = __webpack_require__(8);
	var createDesc = __webpack_require__(78);
	var anObject = __webpack_require__(12);
	var isObject = __webpack_require__(18);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(13);
	var inheritIfRequired = __webpack_require__(159);
	var dP = __webpack_require__(29).f;
	var gOPN = __webpack_require__(76).f;
	var isRegExp = __webpack_require__(120);
	var $flags = __webpack_require__(100);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(28) && (!CORRECT_NEW || __webpack_require__(17)(function () {
	  re2[__webpack_require__(23)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(40)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(80)('RegExp');


/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(12);
	var toLength = __webpack_require__(25);
	var advanceStringIndex = __webpack_require__(151);
	var regExpExec = __webpack_require__(124);
	
	// @@match logic
	__webpack_require__(118)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(12);
	var toObject = __webpack_require__(32);
	var toLength = __webpack_require__(25);
	var toInteger = __webpack_require__(52);
	var advanceStringIndex = __webpack_require__(151);
	var regExpExec = __webpack_require__(124);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(118)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(12);
	var sameValue = __webpack_require__(259);
	var regExpExec = __webpack_require__(124);
	
	// @@search logic
	__webpack_require__(118)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(120);
	var anObject = __webpack_require__(12);
	var speciesConstructor = __webpack_require__(104);
	var advanceStringIndex = __webpack_require__(151);
	var toLength = __webpack_require__(25);
	var callRegExpExec = __webpack_require__(124);
	var regexpExec = __webpack_require__(167);
	var fails = __webpack_require__(17);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(118)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(265);
	var anObject = __webpack_require__(12);
	var $flags = __webpack_require__(100);
	var DESCRIPTORS = __webpack_require__(28);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(40)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(17)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(41)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(41)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(41)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(41)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $at = __webpack_require__(127)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(8);
	var toLength = __webpack_require__(25);
	var context = __webpack_require__(170);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(157)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(41)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(41)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(41)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var toAbsoluteIndex = __webpack_require__(81);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(8);
	var context = __webpack_require__(170);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(157)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(41)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(127)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(162)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(41)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var toIObject = __webpack_require__(45);
	var toLength = __webpack_require__(25);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(171)
	});


/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(41)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(8);
	var toLength = __webpack_require__(25);
	var context = __webpack_require__(170);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(157)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(41)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(41)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(41)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(91)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(13);
	var has = __webpack_require__(42);
	var DESCRIPTORS = __webpack_require__(28);
	var $export = __webpack_require__(8);
	var redefine = __webpack_require__(40);
	var META = __webpack_require__(69).KEY;
	var $fails = __webpack_require__(17);
	var shared = __webpack_require__(103);
	var setToStringTag = __webpack_require__(90);
	var uid = __webpack_require__(82);
	var wks = __webpack_require__(23);
	var wksExt = __webpack_require__(262);
	var wksDefine = __webpack_require__(175);
	var enumKeys = __webpack_require__(857);
	var isArray = __webpack_require__(119);
	var anObject = __webpack_require__(12);
	var isObject = __webpack_require__(18);
	var toObject = __webpack_require__(32);
	var toIObject = __webpack_require__(45);
	var toPrimitive = __webpack_require__(60);
	var createDesc = __webpack_require__(78);
	var _create = __webpack_require__(75);
	var gOPNExt = __webpack_require__(251);
	var $GOPD = __webpack_require__(43);
	var $GOPS = __webpack_require__(123);
	var $DP = __webpack_require__(29);
	var $keys = __webpack_require__(77);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(76).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(102).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(68)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(39)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $typed = __webpack_require__(128);
	var buffer = __webpack_require__(174);
	var anObject = __webpack_require__(12);
	var toAbsoluteIndex = __webpack_require__(81);
	var toLength = __webpack_require__(25);
	var isObject = __webpack_require__(18);
	var ArrayBuffer = __webpack_require__(13).ArrayBuffer;
	var speciesConstructor = __webpack_require__(104);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(17)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(80)(ARRAY_BUFFER);


/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	$export($export.G + $export.W + $export.F * !__webpack_require__(128).ABV, {
	  DataView: __webpack_require__(174).DataView
	});


/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(62)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(62)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(62)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(62)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(62)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(62)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(62)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(62)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(62)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(239);
	var validate = __webpack_require__(83);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(117)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(8);
	var flattenIntoArray = __webpack_require__(240);
	var toObject = __webpack_require__(32);
	var toLength = __webpack_require__(25);
	var aFunction = __webpack_require__(37);
	var arraySpeciesCreate = __webpack_require__(153);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(67)('flatMap');


/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(8);
	var flattenIntoArray = __webpack_require__(240);
	var toObject = __webpack_require__(32);
	var toLength = __webpack_require__(25);
	var toInteger = __webpack_require__(52);
	var arraySpeciesCreate = __webpack_require__(153);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(67)('flatten');


/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(8);
	var $includes = __webpack_require__(116)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(67)('includes');


/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(8);
	var microtask = __webpack_require__(165)();
	var process = __webpack_require__(13).process;
	var isNode = __webpack_require__(48)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(8);
	var cof = __webpack_require__(48);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(8);
	
	$export($export.G, { global: __webpack_require__(13) });


/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(125)('Map');


/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(126)('Map');


/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(8);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(238)('Map') });


/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	var scale = __webpack_require__(248);
	var fround = __webpack_require__(246);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { scale: __webpack_require__(248) });


/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(32);
	var aFunction = __webpack_require__(37);
	var $defineProperty = __webpack_require__(29);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(28) && $export($export.P + __webpack_require__(122), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(32);
	var aFunction = __webpack_require__(37);
	var $defineProperty = __webpack_require__(29);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(28) && $export($export.P + __webpack_require__(122), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(8);
	var $entries = __webpack_require__(253)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(8);
	var ownKeys = __webpack_require__(254);
	var toIObject = __webpack_require__(45);
	var gOPD = __webpack_require__(43);
	var createProperty = __webpack_require__(154);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(32);
	var toPrimitive = __webpack_require__(60);
	var getPrototypeOf = __webpack_require__(44);
	var getOwnPropertyDescriptor = __webpack_require__(43).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(28) && $export($export.P + __webpack_require__(122), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(32);
	var toPrimitive = __webpack_require__(60);
	var getPrototypeOf = __webpack_require__(44);
	var getOwnPropertyDescriptor = __webpack_require__(43).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(28) && $export($export.P + __webpack_require__(122), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(8);
	var $values = __webpack_require__(253)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(8);
	var global = __webpack_require__(13);
	var core = __webpack_require__(49);
	var microtask = __webpack_require__(165)();
	var OBSERVABLE = __webpack_require__(23)('observable');
	var aFunction = __webpack_require__(37);
	var anObject = __webpack_require__(12);
	var anInstance = __webpack_require__(73);
	var redefineAll = __webpack_require__(79);
	var hide = __webpack_require__(39);
	var forOf = __webpack_require__(74);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(80)('Observable');


/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(8);
	var core = __webpack_require__(49);
	var global = __webpack_require__(13);
	var speciesConstructor = __webpack_require__(104);
	var promiseResolve = __webpack_require__(258);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(8);
	var newPromiseCapability = __webpack_require__(166);
	var perform = __webpack_require__(257);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(61);
	var anObject = __webpack_require__(12);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(61);
	var anObject = __webpack_require__(12);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(266);
	var from = __webpack_require__(234);
	var metadata = __webpack_require__(61);
	var anObject = __webpack_require__(12);
	var getPrototypeOf = __webpack_require__(44);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(61);
	var anObject = __webpack_require__(12);
	var getPrototypeOf = __webpack_require__(44);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(61);
	var anObject = __webpack_require__(12);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(61);
	var anObject = __webpack_require__(12);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(61);
	var anObject = __webpack_require__(12);
	var getPrototypeOf = __webpack_require__(44);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(61);
	var anObject = __webpack_require__(12);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(61);
	var anObject = __webpack_require__(12);
	var aFunction = __webpack_require__(37);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(125)('Set');


/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(126)('Set');


/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(8);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(238)('Set') });


/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(8);
	var $at = __webpack_require__(127)(true);
	var $fails = __webpack_require__(17);
	
	var FORCED = $fails(function () {
	  return '𠮷'.at(0) !== '𠮷';
	});
	
	$export($export.P + $export.F * FORCED, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(8);
	var defined = __webpack_require__(58);
	var toLength = __webpack_require__(25);
	var isRegExp = __webpack_require__(120);
	var getFlags = __webpack_require__(100);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(161)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(8);
	var $pad = __webpack_require__(260);
	var userAgent = __webpack_require__(129);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(8);
	var $pad = __webpack_require__(260);
	var userAgent = __webpack_require__(129);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(91)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(91)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(175)('asyncIterator');


/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(175)('observable');


/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(8);
	
	$export($export.S, 'System', { global: __webpack_require__(13) });


/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(125)('WeakMap');


/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(126)('WeakMap');


/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(125)('WeakSet');


/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(126)('WeakSet');


/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(177);
	var getKeys = __webpack_require__(77);
	var redefine = __webpack_require__(40);
	var global = __webpack_require__(13);
	var hide = __webpack_require__(39);
	var Iterators = __webpack_require__(89);
	var wks = __webpack_require__(23);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $task = __webpack_require__(173);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(13);
	var $export = __webpack_require__(8);
	var userAgent = __webpack_require__(129);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(980);
	__webpack_require__(919);
	__webpack_require__(921);
	__webpack_require__(920);
	__webpack_require__(923);
	__webpack_require__(925);
	__webpack_require__(930);
	__webpack_require__(924);
	__webpack_require__(922);
	__webpack_require__(932);
	__webpack_require__(931);
	__webpack_require__(927);
	__webpack_require__(928);
	__webpack_require__(926);
	__webpack_require__(918);
	__webpack_require__(929);
	__webpack_require__(933);
	__webpack_require__(934);
	__webpack_require__(886);
	__webpack_require__(888);
	__webpack_require__(887);
	__webpack_require__(936);
	__webpack_require__(935);
	__webpack_require__(906);
	__webpack_require__(916);
	__webpack_require__(917);
	__webpack_require__(907);
	__webpack_require__(908);
	__webpack_require__(909);
	__webpack_require__(910);
	__webpack_require__(911);
	__webpack_require__(912);
	__webpack_require__(913);
	__webpack_require__(914);
	__webpack_require__(915);
	__webpack_require__(889);
	__webpack_require__(890);
	__webpack_require__(891);
	__webpack_require__(892);
	__webpack_require__(893);
	__webpack_require__(894);
	__webpack_require__(895);
	__webpack_require__(896);
	__webpack_require__(897);
	__webpack_require__(898);
	__webpack_require__(899);
	__webpack_require__(900);
	__webpack_require__(901);
	__webpack_require__(902);
	__webpack_require__(903);
	__webpack_require__(904);
	__webpack_require__(905);
	__webpack_require__(967);
	__webpack_require__(972);
	__webpack_require__(979);
	__webpack_require__(970);
	__webpack_require__(962);
	__webpack_require__(963);
	__webpack_require__(968);
	__webpack_require__(973);
	__webpack_require__(975);
	__webpack_require__(958);
	__webpack_require__(959);
	__webpack_require__(960);
	__webpack_require__(961);
	__webpack_require__(964);
	__webpack_require__(965);
	__webpack_require__(966);
	__webpack_require__(969);
	__webpack_require__(971);
	__webpack_require__(974);
	__webpack_require__(976);
	__webpack_require__(977);
	__webpack_require__(978);
	__webpack_require__(881);
	__webpack_require__(883);
	__webpack_require__(882);
	__webpack_require__(885);
	__webpack_require__(884);
	__webpack_require__(870);
	__webpack_require__(868);
	__webpack_require__(874);
	__webpack_require__(871);
	__webpack_require__(877);
	__webpack_require__(879);
	__webpack_require__(867);
	__webpack_require__(873);
	__webpack_require__(864);
	__webpack_require__(878);
	__webpack_require__(862);
	__webpack_require__(876);
	__webpack_require__(875);
	__webpack_require__(869);
	__webpack_require__(872);
	__webpack_require__(861);
	__webpack_require__(863);
	__webpack_require__(866);
	__webpack_require__(865);
	__webpack_require__(880);
	__webpack_require__(177);
	__webpack_require__(952);
	__webpack_require__(264);
	__webpack_require__(957);
	__webpack_require__(265);
	__webpack_require__(953);
	__webpack_require__(954);
	__webpack_require__(955);
	__webpack_require__(956);
	__webpack_require__(937);
	__webpack_require__(263);
	__webpack_require__(266);
	__webpack_require__(267);
	__webpack_require__(992);
	__webpack_require__(981);
	__webpack_require__(982);
	__webpack_require__(987);
	__webpack_require__(990);
	__webpack_require__(991);
	__webpack_require__(985);
	__webpack_require__(988);
	__webpack_require__(986);
	__webpack_require__(989);
	__webpack_require__(983);
	__webpack_require__(984);
	__webpack_require__(938);
	__webpack_require__(939);
	__webpack_require__(940);
	__webpack_require__(941);
	__webpack_require__(942);
	__webpack_require__(945);
	__webpack_require__(943);
	__webpack_require__(944);
	__webpack_require__(946);
	__webpack_require__(947);
	__webpack_require__(948);
	__webpack_require__(949);
	__webpack_require__(951);
	__webpack_require__(950);
	__webpack_require__(995);
	__webpack_require__(993);
	__webpack_require__(994);
	__webpack_require__(1036);
	__webpack_require__(1039);
	__webpack_require__(1038);
	__webpack_require__(1040);
	__webpack_require__(1041);
	__webpack_require__(1037);
	__webpack_require__(1042);
	__webpack_require__(1043);
	__webpack_require__(1017);
	__webpack_require__(1020);
	__webpack_require__(1016);
	__webpack_require__(1014);
	__webpack_require__(1015);
	__webpack_require__(1018);
	__webpack_require__(1019);
	__webpack_require__(1001);
	__webpack_require__(1035);
	__webpack_require__(1000);
	__webpack_require__(1034);
	__webpack_require__(1046);
	__webpack_require__(1048);
	__webpack_require__(999);
	__webpack_require__(1033);
	__webpack_require__(1045);
	__webpack_require__(1047);
	__webpack_require__(998);
	__webpack_require__(1044);
	__webpack_require__(997);
	__webpack_require__(1002);
	__webpack_require__(1003);
	__webpack_require__(1004);
	__webpack_require__(1005);
	__webpack_require__(1006);
	__webpack_require__(1008);
	__webpack_require__(1007);
	__webpack_require__(1009);
	__webpack_require__(1010);
	__webpack_require__(1011);
	__webpack_require__(1013);
	__webpack_require__(1012);
	__webpack_require__(1022);
	__webpack_require__(1023);
	__webpack_require__(1024);
	__webpack_require__(1025);
	__webpack_require__(1027);
	__webpack_require__(1026);
	__webpack_require__(1029);
	__webpack_require__(1028);
	__webpack_require__(1030);
	__webpack_require__(1031);
	__webpack_require__(1032);
	__webpack_require__(996);
	__webpack_require__(1021);
	__webpack_require__(1051);
	__webpack_require__(1050);
	__webpack_require__(1049);
	module.exports = __webpack_require__(49);


/***/ },
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	* dependencyLibs/inputmask.dependencyLib.jquery.js
	* https://github.com/RobinHerbots/Inputmask
	* Copyright (c) 2010 - 2017 Robin Herbots
	* Licensed under the MIT license (http://www.opensource.org/licenses/mit-license.php)
	* Version: 3.3.7
	*/
	
	!function(factory) {
	     true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == typeof exports ? module.exports = factory(require("jquery")) : window.dependencyLib = factory(jQuery);
	}(function($) {
	    return $;
	});

/***/ }
]);


// WEBPACK FOOTER //
// js/frontend/bundle-de44e9c639bf270f84f3.js